/* eslint-disable */
import axios from 'axios'
import qs from 'qs'
import storage from 'store'
//////////////////////////////////////////////////////////
const urlStr = process.env.NODE_ENV === 'production' ? '/marjan/portal' : process.env.VUE_APP_BASEURL
import { JSEncrypt } from 'jsencrypt'
const encryptedData = function (data) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCodu6J3woOZeIv+viH2CYbCRfVwuRG+bLZP3welc3s3f842ut000F4BTcVfJpwn0xYnwpqQhjQI3LmWupgnZTs8YbbosqYLQNEtF7STBaQm8UJxBi0YvLvsbkuvCGnq83z1usxnN2jl0J3FkC9oVkxhhZ7XDrF6rOtWxvW5QMH3wIDAQAB')
  return encryptor.encrypt(data)
}
/////////////////////////////////////////////////////////
axios.defaults.baseURL = urlStr
axios.defaults.timeout = 6000
axios.interceptors.request.use(
  (config) => {
    const token = storage.get('Access-Token');
    if (token) {
      config.headers['Authorization'] = token;
      const code = encryptedData(token.substr(7, 20) + config.url.substring(urlStr.length));
      config.headers['_verifycode'] = code
    }
    if(config.url.includes('download')){
      config.responseType = 'blob'
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
axios.interceptors.response.use(
  (response) => {
    if (response.status == 401) {
      return location.replace(
        `${location.origin}/user/sso/login?from=${location.href}`
      )
    } else if(response.config.responseType == 'blob') {
      const blob = new Blob([response.data]);
      const href = window.URL.createObjectURL(blob);
      return href;
    }else{
      return response.data
    }
  },
  (error) => {
    if(error.response.status == 401){
      return location.replace(
        `${location.origin}/user/sso/login?from=${location.href}`
      )
    }
    return Promise.reject(error)
  }
)
let domain = ''
export const getDomain = () => {
  return domain
}
export const setDomain = ($domain) => {
  domain = $domain
}
export const request = (method, url, body, queryParameters, form, config) => {
  method = method.toLowerCase()
  let keys = Object.keys(queryParameters)
  let queryUrl = url
  if (keys.length > 0) {
    queryUrl = url + '?' + qs.stringify(queryParameters)
  }
  // let queryUrl = url+(keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
  if (body) {
    return axios[method](queryUrl, body, config)
  } else if (method === 'get') {
    return axios[method](queryUrl, {
      params: form
    }, config)
  } else {
    return axios[method](queryUrl, qs.stringify(form), config)
  }
}
/*==========================================================
 *                    Marjar API
 ==========================================================*/
/**
 * findByPath
 * request: findByPathUsingGET
 * url: findByPathUsingGETURL
 * method: findByPathUsingGET_TYPE
 * raw_url: findByPathUsingGET_RAW_URL
 * @param modulepath - modulepath
 */
export const findByPathUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['modulepath'] !== undefined) {
    queryParameters['modulepath'] = parameters['modulepath']
  }
  if (parameters['modulepath'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulepath'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const findByPathUsingGET_RAW_URL = function() {
  return '/api/v1/'
}
export const findByPathUsingGET_TYPE = function() {
  return 'get'
}
export const findByPathUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/'
  if (parameters['modulepath'] !== undefined) {
    queryParameters['modulepath'] = parameters['modulepath']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findByPath
 * request: findByPathUsingHEAD
 * url: findByPathUsingHEADURL
 * method: findByPathUsingHEAD_TYPE
 * raw_url: findByPathUsingHEAD_RAW_URL
 * @param modulepath - modulepath
 */
export const findByPathUsingHEAD = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['modulepath'] !== undefined) {
    queryParameters['modulepath'] = parameters['modulepath']
  }
  if (parameters['modulepath'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulepath'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('head', domain + path, body, queryParameters, form, config)
}
export const findByPathUsingHEAD_RAW_URL = function() {
  return '/api/v1/'
}
export const findByPathUsingHEAD_TYPE = function() {
  return 'head'
}
export const findByPathUsingHEADURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/'
  if (parameters['modulepath'] !== undefined) {
    queryParameters['modulepath'] = parameters['modulepath']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findByPath
 * request: findByPathUsingPOST
 * url: findByPathUsingPOSTURL
 * method: findByPathUsingPOST_TYPE
 * raw_url: findByPathUsingPOST_RAW_URL
 * @param modulepath - modulepath
 */
export const findByPathUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['modulepath'] !== undefined) {
    queryParameters['modulepath'] = parameters['modulepath']
  }
  if (parameters['modulepath'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulepath'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findByPathUsingPOST_RAW_URL = function() {
  return '/api/v1/'
}
export const findByPathUsingPOST_TYPE = function() {
  return 'post'
}
export const findByPathUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/'
  if (parameters['modulepath'] !== undefined) {
    queryParameters['modulepath'] = parameters['modulepath']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findByPath
 * request: findByPathUsingPUT
 * url: findByPathUsingPUTURL
 * method: findByPathUsingPUT_TYPE
 * raw_url: findByPathUsingPUT_RAW_URL
 * @param modulepath - modulepath
 */
export const findByPathUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['modulepath'] !== undefined) {
    queryParameters['modulepath'] = parameters['modulepath']
  }
  if (parameters['modulepath'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulepath'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const findByPathUsingPUT_RAW_URL = function() {
  return '/api/v1/'
}
export const findByPathUsingPUT_TYPE = function() {
  return 'put'
}
export const findByPathUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/'
  if (parameters['modulepath'] !== undefined) {
    queryParameters['modulepath'] = parameters['modulepath']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findByPath
 * request: findByPathUsingDELETE
 * url: findByPathUsingDELETEURL
 * method: findByPathUsingDELETE_TYPE
 * raw_url: findByPathUsingDELETE_RAW_URL
 * @param modulepath - modulepath
 */
export const findByPathUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['modulepath'] !== undefined) {
    queryParameters['modulepath'] = parameters['modulepath']
  }
  if (parameters['modulepath'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulepath'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const findByPathUsingDELETE_RAW_URL = function() {
  return '/api/v1/'
}
export const findByPathUsingDELETE_TYPE = function() {
  return 'delete'
}
export const findByPathUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/'
  if (parameters['modulepath'] !== undefined) {
    queryParameters['modulepath'] = parameters['modulepath']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findByPath
 * request: findByPathUsingOPTIONS
 * url: findByPathUsingOPTIONSURL
 * method: findByPathUsingOPTIONS_TYPE
 * raw_url: findByPathUsingOPTIONS_RAW_URL
 * @param modulepath - modulepath
 */
export const findByPathUsingOPTIONS = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['modulepath'] !== undefined) {
    queryParameters['modulepath'] = parameters['modulepath']
  }
  if (parameters['modulepath'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulepath'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('options', domain + path, body, queryParameters, form, config)
}
export const findByPathUsingOPTIONS_RAW_URL = function() {
  return '/api/v1/'
}
export const findByPathUsingOPTIONS_TYPE = function() {
  return 'options'
}
export const findByPathUsingOPTIONSURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/'
  if (parameters['modulepath'] !== undefined) {
    queryParameters['modulepath'] = parameters['modulepath']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findByPath
 * request: findByPathUsingPATCH
 * url: findByPathUsingPATCHURL
 * method: findByPathUsingPATCH_TYPE
 * raw_url: findByPathUsingPATCH_RAW_URL
 * @param modulepath - modulepath
 */
export const findByPathUsingPATCH = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['modulepath'] !== undefined) {
    queryParameters['modulepath'] = parameters['modulepath']
  }
  if (parameters['modulepath'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulepath'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('patch', domain + path, body, queryParameters, form, config)
}
export const findByPathUsingPATCH_RAW_URL = function() {
  return '/api/v1/'
}
export const findByPathUsingPATCH_TYPE = function() {
  return 'patch'
}
export const findByPathUsingPATCHURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/'
  if (parameters['modulepath'] !== undefined) {
    queryParameters['modulepath'] = parameters['modulepath']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 新增供应商 ，addSupplier
 * request: addSupplierUsingPOST
 * url: addSupplierUsingPOSTURL
 * method: addSupplierUsingPOST_TYPE
 * raw_url: addSupplierUsingPOST_RAW_URL
 * @param name - 
 * @param vo - vo
 */
export const addSupplierUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/Supplier/addSupplier'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addSupplierUsingPOST_RAW_URL = function() {
  return '/api/v1/Supplier/addSupplier'
}
export const addSupplierUsingPOST_TYPE = function() {
  return 'post'
}
export const addSupplierUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/Supplier/addSupplier'
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 供应商Page，findSupplierByPage
 * request: findSupplierByPageUsingPOST
 * url: findSupplierByPageUsingPOSTURL
 * method: findSupplierByPageUsingPOST_TYPE
 * raw_url: findSupplierByPageUsingPOST_RAW_URL
 * @param name - 
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findSupplierByPageUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/Supplier/datalist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findSupplierByPageUsingPOST_RAW_URL = function() {
  return '/api/v1/Supplier/datalist'
}
export const findSupplierByPageUsingPOST_TYPE = function() {
  return 'post'
}
export const findSupplierByPageUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/Supplier/datalist'
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除供应商 ，deleteSupplier
 * request: deleteSupplierUsingDELETE
 * url: deleteSupplierUsingDELETEURL
 * method: deleteSupplierUsingDELETE_TYPE
 * raw_url: deleteSupplierUsingDELETE_RAW_URL
 * @param ids - ids
 */
export const deleteSupplierUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/Supplier/deleteSupplier/{ids}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{ids}', `${parameters['ids']}`)
  if (parameters['ids'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: ids'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSupplierUsingDELETE_RAW_URL = function() {
  return '/api/v1/Supplier/deleteSupplier/{ids}'
}
export const deleteSupplierUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSupplierUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/Supplier/deleteSupplier/{ids}'
  path = path.replace('{ids}', `${parameters['ids']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 查看供应商，getSupplier
 * request: getSupplierUsingGET
 * url: getSupplierUsingGETURL
 * method: getSupplierUsingGET_TYPE
 * raw_url: getSupplierUsingGET_RAW_URL
 * @param id - id
 */
export const getSupplierUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/Supplier/getSupplier/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSupplierUsingGET_RAW_URL = function() {
  return '/api/v1/Supplier/getSupplier/{id}'
}
export const getSupplierUsingGET_TYPE = function() {
  return 'get'
}
export const getSupplierUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/Supplier/getSupplier/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 同步供应商 ，syncSupplier
 * request: syncSupplierUsingPOST
 * url: syncSupplierUsingPOSTURL
 * method: syncSupplierUsingPOST_TYPE
 * raw_url: syncSupplierUsingPOST_RAW_URL
 */
export const syncSupplierUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/Supplier/syncSupplier'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const syncSupplierUsingPOST_RAW_URL = function() {
  return '/api/v1/Supplier/syncSupplier'
}
export const syncSupplierUsingPOST_TYPE = function() {
  return 'post'
}
export const syncSupplierUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/Supplier/syncSupplier'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改供应商 ，updateSupplier
 * request: updateSupplierUsingPOST
 * url: updateSupplierUsingPOSTURL
 * method: updateSupplierUsingPOST_TYPE
 * raw_url: updateSupplierUsingPOST_RAW_URL
 * @param id - id
 * @param id - id
 * @param name - 
 * @param vo - vo
 */
export const updateSupplierUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/Supplier/updateSupplier/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateSupplierUsingPOST_RAW_URL = function() {
  return '/api/v1/Supplier/updateSupplier/{id}'
}
export const updateSupplierUsingPOST_TYPE = function() {
  return 'post'
}
export const updateSupplierUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/Supplier/updateSupplier/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * index
 * request: indexUsingGET
 * url: indexUsingGETURL
 * method: indexUsingGET_TYPE
 * raw_url: indexUsingGET_RAW_URL
 * @param name - 
 */
export const indexUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/account'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const indexUsingGET_RAW_URL = function() {
  return '/api/v1/account'
}
export const indexUsingGET_TYPE = function() {
  return 'get'
}
export const indexUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/account'
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取有权限的用户菜单
 * request: getUserMenusUsingGET
 * url: getUserMenusUsingGETURL
 * method: getUserMenusUsingGET_TYPE
 * raw_url: getUserMenusUsingGET_RAW_URL
 * @param local - local
 * @param modulename - modulename
 * @param name - 
 */
export const getUserMenusUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/account/{modulename}/usermenus'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['local'] !== undefined) {
    queryParameters['local'] = parameters['local']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUserMenusUsingGET_RAW_URL = function() {
  return '/api/v1/account/{modulename}/usermenus'
}
export const getUserMenusUsingGET_TYPE = function() {
  return 'get'
}
export const getUserMenusUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/account/{modulename}/usermenus'
  if (parameters['local'] !== undefined) {
    queryParameters['local'] = parameters['local']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 增加用户部门，addUserOrg
 * request: addUserOrgUsingPOST
 * url: addUserOrgUsingPOSTURL
 * method: addUserOrgUsingPOST_TYPE
 * raw_url: addUserOrgUsingPOST_RAW_URL
 * @param id - id
 * @param orgs - orgs
 */
export const addUserOrgUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/adduserorgs/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['orgs'] !== undefined) {
    body = parameters['orgs']
  }
  if (parameters['orgs'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: orgs'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addUserOrgUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/adduserorgs/{id}'
}
export const addUserOrgUsingPOST_TYPE = function() {
  return 'post'
}
export const addUserOrgUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/adduserorgs/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 增加用户角色，addUserRole
 * request: addUserRoleUsingPOST
 * url: addUserRoleUsingPOSTURL
 * method: addUserRoleUsingPOST_TYPE
 * raw_url: addUserRoleUsingPOST_RAW_URL
 * @param id - id
 * @param roles - roles
 */
export const addUserRoleUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/adduserroles/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['roles'] !== undefined) {
    body = parameters['roles']
  }
  if (parameters['roles'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: roles'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addUserRoleUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/adduserroles/{id}'
}
export const addUserRoleUsingPOST_TYPE = function() {
  return 'post'
}
export const addUserRoleUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/adduserroles/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * CopyOrganization
 * request: CopyOrganizationUsingPOST
 * url: CopyOrganizationUsingPOSTURL
 * method: CopyOrganizationUsingPOST_TYPE
 * raw_url: CopyOrganizationUsingPOST_RAW_URL
 * @param id - id
 * @param name - 
 * @param orgparam - orgparam
 */
export const CopyOrganizationUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/copyorganization/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['orgparam'] !== undefined) {
    body = parameters['orgparam']
  }
  if (parameters['orgparam'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: orgparam'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const CopyOrganizationUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/copyorganization/{id}'
}
export const CopyOrganizationUsingPOST_TYPE = function() {
  return 'post'
}
export const CopyOrganizationUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/copyorganization/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * CopyProject
 * request: CopyProjectUsingPOST
 * url: CopyProjectUsingPOSTURL
 * method: CopyProjectUsingPOST_TYPE
 * raw_url: CopyProjectUsingPOST_RAW_URL
 * @param id - id
 * @param name - 
 * @param projectparam - projectparam
 */
export const CopyProjectUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/copyproject/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['projectparam'] !== undefined) {
    body = parameters['projectparam']
  }
  if (parameters['projectparam'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectparam'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const CopyProjectUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/copyproject/{id}'
}
export const CopyProjectUsingPOST_TYPE = function() {
  return 'post'
}
export const CopyProjectUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/copyproject/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导出所选的工作空间下的功能点（包括功能点，菜单，角色，权限）
 * request: daochuUsingPOST
 * url: daochuUsingPOSTURL
 * method: daochuUsingPOST_TYPE
 * raw_url: daochuUsingPOST_RAW_URL
 * @param deployids - deployids
 */
export const daochuUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/daochu'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['deployids'] !== undefined) {
    body = parameters['deployids']
  }
  if (parameters['deployids'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: deployids'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const daochuUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/daochu'
}
export const daochuUsingPOST_TYPE = function() {
  return 'post'
}
export const daochuUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/daochu'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导入工作空间下的功能点文件（包括功能点，菜单，角色，权限）
 * request: daoruUsingPOST
 * url: daoruUsingPOSTURL
 * method: daoruUsingPOST_TYPE
 * raw_url: daoruUsingPOST_RAW_URL
 * @param file - file
 * @param ids - ids
 * @param name - 
 */
export const daoruUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/daoru'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['file'] !== undefined) {
    form['file'] = parameters['file']
  }
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const daoruUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/daoru'
}
export const daoruUsingPOST_TYPE = function() {
  return 'post'
}
export const daoruUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/daoru'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导入工作空间下的功能点文件（包括功能点，菜单，角色，权限）
 * request: daoru2UsingPOST
 * url: daoru2UsingPOSTURL
 * method: daoru2UsingPOST_TYPE
 * raw_url: daoru2UsingPOST_RAW_URL
 * @param file - file
 * @param ids - ids
 * @param name - 
 */
export const daoru2UsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/daoru2'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['file'] !== undefined) {
    form['file'] = parameters['file']
  }
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const daoru2UsingPOST_RAW_URL = function() {
  return '/api/v1/admin/daoru2'
}
export const daoru2UsingPOST_TYPE = function() {
  return 'post'
}
export const daoru2UsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/daoru2'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导入工作空间下的功能点文件（包括功能点，菜单，角色，权限）——四建专用
 * request: daoru3UsingPOST
 * url: daoru3UsingPOSTURL
 * method: daoru3UsingPOST_TYPE
 * raw_url: daoru3UsingPOST_RAW_URL
 * @param file - file
 * @param ids - ids
 * @param name - 
 */
export const daoru3UsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/daoru3'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['file'] !== undefined) {
    form['file'] = parameters['file']
  }
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const daoru3UsingPOST_RAW_URL = function() {
  return '/api/v1/admin/daoru3'
}
export const daoru3UsingPOST_TYPE = function() {
  return 'post'
}
export const daoru3UsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/daoru3'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addDic
 * request: addDicUsingPOST
 * url: addDicUsingPOSTURL
 * method: addDicUsingPOST_TYPE
 * raw_url: addDicUsingPOST_RAW_URL
 * @param dic - dic
 */
export const addDicUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/dic'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['dic'] !== undefined) {
    body = parameters['dic']
  }
  if (parameters['dic'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dic'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addDicUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/dic'
}
export const addDicUsingPOST_TYPE = function() {
  return 'post'
}
export const addDicUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/dic'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findDics
 * request: findDicsUsingPOST
 * url: findDicsUsingPOSTURL
 * method: findDicsUsingPOST_TYPE
 * raw_url: findDicsUsingPOST_RAW_URL
 * @param dicparam - dicparam
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findDicsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/dic/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['dicparam'] !== undefined) {
    body = parameters['dicparam']
  }
  if (parameters['dicparam'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dicparam'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findDicsUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/dic/'
}
export const findDicsUsingPOST_TYPE = function() {
  return 'post'
}
export const findDicsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/dic/'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectDic
 * request: deleteSelectDicUsingDELETE
 * url: deleteSelectDicUsingDELETEURL
 * method: deleteSelectDicUsingDELETE_TYPE
 * raw_url: deleteSelectDicUsingDELETE_RAW_URL
 * @param ids - ids
 */
export const deleteSelectDicUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/dic/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectDicUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/dic/'
}
export const deleteSelectDicUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectDicUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/dic/'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findDicByType
 * request: findDicByTypeUsingGET
 * url: findDicByTypeUsingGETURL
 * method: findDicByTypeUsingGET_TYPE
 * raw_url: findDicByTypeUsingGET_RAW_URL
 * @param local - local
 * @param type - type
 */
export const findDicByTypeUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/dic/type/{type}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['local'] !== undefined) {
    queryParameters['local'] = parameters['local']
  }
  path = path.replace('{type}', `${parameters['type']}`)
  if (parameters['type'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: type'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const findDicByTypeUsingGET_RAW_URL = function() {
  return '/api/v1/admin/dic/type/{type}'
}
export const findDicByTypeUsingGET_TYPE = function() {
  return 'get'
}
export const findDicByTypeUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/dic/type/{type}'
  if (parameters['local'] !== undefined) {
    queryParameters['local'] = parameters['local']
  }
  path = path.replace('{type}', `${parameters['type']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getDic
 * request: getDicUsingGET
 * url: getDicUsingGETURL
 * method: getDicUsingGET_TYPE
 * raw_url: getDicUsingGET_RAW_URL
 * @param id - id
 */
export const getDicUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/dic/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDicUsingGET_RAW_URL = function() {
  return '/api/v1/admin/dic/{id}'
}
export const getDicUsingGET_TYPE = function() {
  return 'get'
}
export const getDicUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/dic/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateDic
 * request: updateDicUsingPOST
 * url: updateDicUsingPOSTURL
 * method: updateDicUsingPOST_TYPE
 * raw_url: updateDicUsingPOST_RAW_URL
 * @param dic - dic
 * @param id - id
 */
export const updateDicUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/dic/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['dic'] !== undefined) {
    body = parameters['dic']
  }
  if (parameters['dic'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dic'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateDicUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/dic/{id}'
}
export const updateDicUsingPOST_TYPE = function() {
  return 'post'
}
export const updateDicUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/dic/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteDic
 * request: deleteDicUsingDELETE
 * url: deleteDicUsingDELETEURL
 * method: deleteDicUsingDELETE_TYPE
 * raw_url: deleteDicUsingDELETE_RAW_URL
 * @param id - id
 */
export const deleteDicUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/dic/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteDicUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/dic/{id}'
}
export const deleteDicUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteDicUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/dic/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addEntryPoint
 * request: addEntryPointUsingPOST
 * url: addEntryPointUsingPOSTURL
 * method: addEntryPointUsingPOST_TYPE
 * raw_url: addEntryPointUsingPOST_RAW_URL
 * @param epvo - epvo
 * @param name - 
 */
export const addEntryPointUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/entrypoint'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['epvo'] !== undefined) {
    body = parameters['epvo']
  }
  if (parameters['epvo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: epvo'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addEntryPointUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/entrypoint'
}
export const addEntryPointUsingPOST_TYPE = function() {
  return 'post'
}
export const addEntryPointUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/entrypoint'
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findEntryPoints
 * request: findEntryPointsUsingPOST
 * url: findEntryPointsUsingPOSTURL
 * method: findEntryPointsUsingPOST_TYPE
 * raw_url: findEntryPointsUsingPOST_RAW_URL
 * @param page - 请求页数
 * @param param - param
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findEntryPointsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/entrypoint/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['param'] !== undefined) {
    body = parameters['param']
  }
  if (parameters['param'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: param'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findEntryPointsUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/entrypoint/'
}
export const findEntryPointsUsingPOST_TYPE = function() {
  return 'post'
}
export const findEntryPointsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/entrypoint/'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectEntryPoint
 * request: deleteSelectEntryPointUsingDELETE
 * url: deleteSelectEntryPointUsingDELETEURL
 * method: deleteSelectEntryPointUsingDELETE_TYPE
 * raw_url: deleteSelectEntryPointUsingDELETE_RAW_URL
 * @param ids - ids
 */
export const deleteSelectEntryPointUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/entrypoint/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectEntryPointUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/entrypoint/'
}
export const deleteSelectEntryPointUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectEntryPointUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/entrypoint/'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getEntryPoint
 * request: getEntryPointUsingGET
 * url: getEntryPointUsingGETURL
 * method: getEntryPointUsingGET_TYPE
 * raw_url: getEntryPointUsingGET_RAW_URL
 * @param id - id
 */
export const getEntryPointUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/entrypoint/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getEntryPointUsingGET_RAW_URL = function() {
  return '/api/v1/admin/entrypoint/{id}'
}
export const getEntryPointUsingGET_TYPE = function() {
  return 'get'
}
export const getEntryPointUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/entrypoint/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateEntryPoint
 * request: updateEntryPointUsingPOST
 * url: updateEntryPointUsingPOSTURL
 * method: updateEntryPointUsingPOST_TYPE
 * raw_url: updateEntryPointUsingPOST_RAW_URL
 * @param epvo - epvo
 * @param id - id
 * @param name - 
 */
export const updateEntryPointUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/entrypoint/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['epvo'] !== undefined) {
    body = parameters['epvo']
  }
  if (parameters['epvo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: epvo'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateEntryPointUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/entrypoint/{id}'
}
export const updateEntryPointUsingPOST_TYPE = function() {
  return 'post'
}
export const updateEntryPointUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/entrypoint/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteEntryPoint
 * request: deleteEntryPointUsingDELETE
 * url: deleteEntryPointUsingDELETEURL
 * method: deleteEntryPointUsingDELETE_TYPE
 * raw_url: deleteEntryPointUsingDELETE_RAW_URL
 * @param id - id
 */
export const deleteEntryPointUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/entrypoint/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteEntryPointUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/entrypoint/{id}'
}
export const deleteEntryPointUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteEntryPointUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/entrypoint/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addListdesign
 * request: addListdesignUsingPOST
 * url: addListdesignUsingPOSTURL
 * method: addListdesignUsingPOST_TYPE
 * raw_url: addListdesignUsingPOST_RAW_URL
 * @param listdesign - listdesign
 * @param modulename - modulename
 */
export const addListdesignUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/listdesign/{modulename}/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['listdesign'] !== undefined) {
    body = parameters['listdesign']
  }
  if (parameters['listdesign'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: listdesign'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addListdesignUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/listdesign/{modulename}/'
}
export const addListdesignUsingPOST_TYPE = function() {
  return 'post'
}
export const addListdesignUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/listdesign/{modulename}/'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectListdesign
 * request: deleteSelectListdesignUsingDELETE
 * url: deleteSelectListdesignUsingDELETEURL
 * method: deleteSelectListdesignUsingDELETE_TYPE
 * raw_url: deleteSelectListdesignUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectListdesignUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/listdesign/{modulename}/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectListdesignUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/listdesign/{modulename}/'
}
export const deleteSelectListdesignUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectListdesignUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/listdesign/{modulename}/'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * cloneListdesign
 * request: cloneListdesignUsingPOST
 * url: cloneListdesignUsingPOSTURL
 * method: cloneListdesignUsingPOST_TYPE
 * raw_url: cloneListdesignUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const cloneListdesignUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/listdesign/{modulename}/clone/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const cloneListdesignUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/listdesign/{modulename}/clone/{id}'
}
export const cloneListdesignUsingPOST_TYPE = function() {
  return 'post'
}
export const cloneListdesignUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/listdesign/{modulename}/clone/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getListDesignOnchangejsByKey
 * request: getListDesignOnchangejsByKeyUsingGET
 * url: getListDesignOnchangejsByKeyUsingGETURL
 * method: getListDesignOnchangejsByKeyUsingGET_TYPE
 * raw_url: getListDesignOnchangejsByKeyUsingGET_RAW_URL
 * @param key - key
 * @param modulename - modulename
 */
export const getListDesignOnchangejsByKeyUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/listdesign/{modulename}/key/onchangejs/{key}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getListDesignOnchangejsByKeyUsingGET_RAW_URL = function() {
  return '/api/v1/admin/listdesign/{modulename}/key/onchangejs/{key}'
}
export const getListDesignOnchangejsByKeyUsingGET_TYPE = function() {
  return 'get'
}
export const getListDesignOnchangejsByKeyUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/listdesign/{modulename}/key/onchangejs/{key}'
  path = path.replace('{key}', `${parameters['key']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getListdesignByKey
 * request: getListdesignByKeyUsingGET
 * url: getListdesignByKeyUsingGETURL
 * method: getListdesignByKeyUsingGET_TYPE
 * raw_url: getListdesignByKeyUsingGET_RAW_URL
 * @param key - key
 * @param modulename - modulename
 */
export const getListdesignByKeyUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/listdesign/{modulename}/key/{key}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getListdesignByKeyUsingGET_RAW_URL = function() {
  return '/api/v1/admin/listdesign/{modulename}/key/{key}'
}
export const getListdesignByKeyUsingGET_TYPE = function() {
  return 'get'
}
export const getListdesignByKeyUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/listdesign/{modulename}/key/{key}'
  path = path.replace('{key}', `${parameters['key']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findListdesigns
 * request: findListdesignsUsingPOST
 * url: findListdesignsUsingPOSTURL
 * method: findListdesignsUsingPOST_TYPE
 * raw_url: findListdesignsUsingPOST_RAW_URL
 * @param listdesignparam - listdesignparam
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findListdesignsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/listdesign/{modulename}/list'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['listdesignparam'] !== undefined) {
    body = parameters['listdesignparam']
  }
  if (parameters['listdesignparam'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: listdesignparam'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findListdesignsUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/listdesign/{modulename}/list'
}
export const findListdesignsUsingPOST_TYPE = function() {
  return 'post'
}
export const findListdesignsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/listdesign/{modulename}/list'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getListdesign
 * request: getListdesignUsingGET
 * url: getListdesignUsingGETURL
 * method: getListdesignUsingGET_TYPE
 * raw_url: getListdesignUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getListdesignUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/listdesign/{modulename}/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getListdesignUsingGET_RAW_URL = function() {
  return '/api/v1/admin/listdesign/{modulename}/{id}'
}
export const getListdesignUsingGET_TYPE = function() {
  return 'get'
}
export const getListdesignUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/listdesign/{modulename}/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateListdesign
 * request: updateListdesignUsingPOST
 * url: updateListdesignUsingPOSTURL
 * method: updateListdesignUsingPOST_TYPE
 * raw_url: updateListdesignUsingPOST_RAW_URL
 * @param id - id
 * @param listdesign - listdesign
 * @param modulename - modulename
 */
export const updateListdesignUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/listdesign/{modulename}/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['listdesign'] !== undefined) {
    body = parameters['listdesign']
  }
  if (parameters['listdesign'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: listdesign'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateListdesignUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/listdesign/{modulename}/{id}'
}
export const updateListdesignUsingPOST_TYPE = function() {
  return 'post'
}
export const updateListdesignUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/listdesign/{modulename}/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteListdesign
 * request: deleteListdesignUsingDELETE
 * url: deleteListdesignUsingDELETEURL
 * method: deleteListdesignUsingDELETE_TYPE
 * raw_url: deleteListdesignUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteListdesignUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/listdesign/{modulename}/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteListdesignUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/listdesign/{modulename}/{id}'
}
export const deleteListdesignUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteListdesignUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/listdesign/{modulename}/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateListdesignJson
 * request: updateListdesignJsonUsingPUT
 * url: updateListdesignJsonUsingPUTURL
 * method: updateListdesignJsonUsingPUT_TYPE
 * raw_url: updateListdesignJsonUsingPUT_RAW_URL
 * @param id - id
 * @param listdesign - listdesign
 * @param modulename - modulename
 * @param type - type
 */
export const updateListdesignJsonUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/listdesign/{modulename}/{id}/{type}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['listdesign'] !== undefined) {
    body = parameters['listdesign']
  }
  if (parameters['listdesign'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: listdesign'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{type}', `${parameters['type']}`)
  if (parameters['type'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: type'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateListdesignJsonUsingPUT_RAW_URL = function() {
  return '/api/v1/admin/listdesign/{modulename}/{id}/{type}'
}
export const updateListdesignJsonUsingPUT_TYPE = function() {
  return 'put'
}
export const updateListdesignJsonUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/listdesign/{modulename}/{id}/{type}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{type}', `${parameters['type']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 新增，addModule
 * request: addModuleUsingPOST
 * url: addModuleUsingPOSTURL
 * method: addModuleUsingPOST_TYPE
 * raw_url: addModuleUsingPOST_RAW_URL
 * @param vo - vo
 */
export const addModuleUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/module'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addModuleUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/module'
}
export const addModuleUsingPOST_TYPE = function() {
  return 'post'
}
export const addModuleUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/module'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 增加模块用户，addModuleUser
 * request: addModuleUserUsingPOST
 * url: addModuleUserUsingPOSTURL
 * method: addModuleUserUsingPOST_TYPE
 * raw_url: addModuleUserUsingPOST_RAW_URL
 * @param id - id
 * @param users - users
 */
export const addModuleUserUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/module/addmoduleusers/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['users'] !== undefined) {
    body = parameters['users']
  }
  if (parameters['users'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: users'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addModuleUserUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/module/addmoduleusers/{id}'
}
export const addModuleUserUsingPOST_TYPE = function() {
  return 'post'
}
export const addModuleUserUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/module/addmoduleusers/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 查询模块Page，findModulePage
 * request: findModulePageUsingPOST
 * url: findModulePageUsingPOSTURL
 * method: findModulePageUsingPOST_TYPE
 * raw_url: findModulePageUsingPOST_RAW_URL
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findModulePageUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/module/datalist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findModulePageUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/module/datalist'
}
export const findModulePageUsingPOST_TYPE = function() {
  return 'post'
}
export const findModulePageUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/module/datalist'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除选中，deleteSelectModule
 * request: deleteSelectModuleUsingDELETE
 * url: deleteSelectModuleUsingDELETEURL
 * method: deleteSelectModuleUsingDELETE_TYPE
 * raw_url: deleteSelectModuleUsingDELETE_RAW_URL
 * @param ids - ids
 */
export const deleteSelectModuleUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/module/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectModuleUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/module/delete'
}
export const deleteSelectModuleUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectModuleUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/module/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 驾驶舱获取参数
 * request: getModuleUsingGET
 * url: getModuleUsingGETURL
 * method: getModuleUsingGET_TYPE
 * raw_url: getModuleUsingGET_RAW_URL
 * @param modulename - modulename
 */
export const getModuleUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/module/drive/{modulename}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getModuleUsingGET_RAW_URL = function() {
  return '/api/v1/admin/module/drive/{modulename}'
}
export const getModuleUsingGET_TYPE = function() {
  return 'get'
}
export const getModuleUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/module/drive/{modulename}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 通过子模块modulename获取title以及父模块title，getModuleLabelBySubName
 * request: getModuleLabelBySubNameUsingGET
 * url: getModuleLabelBySubNameUsingGETURL
 * method: getModuleLabelBySubNameUsingGET_TYPE
 * raw_url: getModuleLabelBySubNameUsingGET_RAW_URL
 * @param modulename - modulename
 */
export const getModuleLabelBySubNameUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/module/label'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['modulename'] !== undefined) {
    queryParameters['modulename'] = parameters['modulename']
  }
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getModuleLabelBySubNameUsingGET_RAW_URL = function() {
  return '/api/v1/admin/module/label'
}
export const getModuleLabelBySubNameUsingGET_TYPE = function() {
  return 'get'
}
export const getModuleLabelBySubNameUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/module/label'
  if (parameters['modulename'] !== undefined) {
    queryParameters['modulename'] = parameters['modulename']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 通过子模块ID获取title以及父模块title，getModuleLabelBySub
 * request: getModuleLabelBySubUsingGET
 * url: getModuleLabelBySubUsingGETURL
 * method: getModuleLabelBySubUsingGET_TYPE
 * raw_url: getModuleLabelBySubUsingGET_RAW_URL
 * @param id - id
 */
export const getModuleLabelBySubUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/module/label/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getModuleLabelBySubUsingGET_RAW_URL = function() {
  return '/api/v1/admin/module/label/{id}'
}
export const getModuleLabelBySubUsingGET_TYPE = function() {
  return 'get'
}
export const getModuleLabelBySubUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/module/label/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取每个功能点名称，包含子项目
 * request: getModuleNameByCodeOrSubIdUsingPOST
 * url: getModuleNameByCodeOrSubIdUsingPOSTURL
 * method: getModuleNameByCodeOrSubIdUsingPOST_TYPE
 * raw_url: getModuleNameByCodeOrSubIdUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param vo - vo
 */
export const getModuleNameByCodeOrSubIdUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/module/moduleLable'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['modulename'] !== undefined) {
    queryParameters['modulename'] = parameters['modulename']
  }
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getModuleNameByCodeOrSubIdUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/module/moduleLable'
}
export const getModuleNameByCodeOrSubIdUsingPOST_TYPE = function() {
  return 'post'
}
export const getModuleNameByCodeOrSubIdUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/module/moduleLable'
  if (parameters['modulename'] !== undefined) {
    queryParameters['modulename'] = parameters['modulename']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取模块用户，getModuleUsers
 * request: getModuleUsersUsingGET
 * url: getModuleUsersUsingGETURL
 * method: getModuleUsersUsingGET_TYPE
 * raw_url: getModuleUsersUsingGET_RAW_URL
 * @param id - id
 */
export const getModuleUsersUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/module/moduleusers/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getModuleUsersUsingGET_RAW_URL = function() {
  return '/api/v1/admin/module/moduleusers/{id}'
}
export const getModuleUsersUsingGET_TYPE = function() {
  return 'get'
}
export const getModuleUsersUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/module/moduleusers/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除模块用户，removeModuleUser
 * request: removeModuleUserUsingPOST
 * url: removeModuleUserUsingPOSTURL
 * method: removeModuleUserUsingPOST_TYPE
 * raw_url: removeModuleUserUsingPOST_RAW_URL
 * @param id - id
 * @param user - user
 */
export const removeModuleUserUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/module/removemoduleusers/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['user'] !== undefined) {
    body = parameters['user']
  }
  if (parameters['user'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: user'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const removeModuleUserUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/module/removemoduleusers/{id}'
}
export const removeModuleUserUsingPOST_TYPE = function() {
  return 'post'
}
export const removeModuleUserUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/module/removemoduleusers/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * self，getModule
 * request: getModuleUsingGET_1
 * url: getModuleUsingGET_1URL
 * method: getModuleUsingGET_1_TYPE
 * raw_url: getModuleUsingGET_1_RAW_URL
 * @param id - id
 */
export const getModuleUsingGET_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/module/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getModuleUsingGET_1_RAW_URL = function() {
  return '/api/v1/admin/module/{id}'
}
export const getModuleUsingGET_1_TYPE = function() {
  return 'get'
}
export const getModuleUsingGET_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/module/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改，modifyModule
 * request: modifyModuleUsingPUT
 * url: modifyModuleUsingPUTURL
 * method: modifyModuleUsingPUT_TYPE
 * raw_url: modifyModuleUsingPUT_RAW_URL
 * @param id - id
 * @param vo - vo
 */
export const modifyModuleUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/module/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const modifyModuleUsingPUT_RAW_URL = function() {
  return '/api/v1/admin/module/{id}'
}
export const modifyModuleUsingPUT_TYPE = function() {
  return 'put'
}
export const modifyModuleUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/module/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除，deleteModule
 * request: deleteModuleUsingDELETE
 * url: deleteModuleUsingDELETEURL
 * method: deleteModuleUsingDELETE_TYPE
 * raw_url: deleteModuleUsingDELETE_RAW_URL
 * @param id - id
 */
export const deleteModuleUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/module/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteModuleUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/module/{id}'
}
export const deleteModuleUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteModuleUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/module/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addProjectInfo
 * request: addProjectInfoUsingPOST
 * url: addProjectInfoUsingPOSTURL
 * method: addProjectInfoUsingPOST_TYPE
 * raw_url: addProjectInfoUsingPOST_RAW_URL
 * @param project - project
 */
export const addProjectInfoUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/project'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['project'] !== undefined) {
    body = parameters['project']
  }
  if (parameters['project'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: project'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addProjectInfoUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/project'
}
export const addProjectInfoUsingPOST_TYPE = function() {
  return 'post'
}
export const addProjectInfoUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/project'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findProjectInfos
 * request: findProjectInfosUsingPOST
 * url: findProjectInfosUsingPOSTURL
 * method: findProjectInfosUsingPOST_TYPE
 * raw_url: findProjectInfosUsingPOST_RAW_URL
 * @param page - 请求页数
 * @param projectparam - projectparam
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findProjectInfosUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/project/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['projectparam'] !== undefined) {
    body = parameters['projectparam']
  }
  if (parameters['projectparam'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectparam'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findProjectInfosUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/project/'
}
export const findProjectInfosUsingPOST_TYPE = function() {
  return 'post'
}
export const findProjectInfosUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/project/'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectProjectInfo
 * request: deleteSelectProjectInfoUsingDELETE
 * url: deleteSelectProjectInfoUsingDELETEURL
 * method: deleteSelectProjectInfoUsingDELETE_TYPE
 * raw_url: deleteSelectProjectInfoUsingDELETE_RAW_URL
 * @param ids - ids
 */
export const deleteSelectProjectInfoUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/project/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectProjectInfoUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/project/'
}
export const deleteSelectProjectInfoUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectProjectInfoUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/project/'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getProjectInfo
 * request: getProjectInfoUsingGET
 * url: getProjectInfoUsingGETURL
 * method: getProjectInfoUsingGET_TYPE
 * raw_url: getProjectInfoUsingGET_RAW_URL
 * @param id - id
 */
export const getProjectInfoUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/project/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProjectInfoUsingGET_RAW_URL = function() {
  return '/api/v1/admin/project/{id}'
}
export const getProjectInfoUsingGET_TYPE = function() {
  return 'get'
}
export const getProjectInfoUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/project/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateProjectInfo
 * request: updateProjectInfoUsingPOST
 * url: updateProjectInfoUsingPOSTURL
 * method: updateProjectInfoUsingPOST_TYPE
 * raw_url: updateProjectInfoUsingPOST_RAW_URL
 * @param id - id
 * @param project - project
 */
export const updateProjectInfoUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/project/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['project'] !== undefined) {
    body = parameters['project']
  }
  if (parameters['project'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: project'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateProjectInfoUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/project/{id}'
}
export const updateProjectInfoUsingPOST_TYPE = function() {
  return 'post'
}
export const updateProjectInfoUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/project/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteProjectInfo
 * request: deleteProjectInfoUsingDELETE
 * url: deleteProjectInfoUsingDELETEURL
 * method: deleteProjectInfoUsingDELETE_TYPE
 * raw_url: deleteProjectInfoUsingDELETE_RAW_URL
 * @param id - id
 */
export const deleteProjectInfoUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/project/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteProjectInfoUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/project/{id}'
}
export const deleteProjectInfoUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteProjectInfoUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/project/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除用户部门，removeUserOrg
 * request: removeUserOrgUsingPOST
 * url: removeUserOrgUsingPOSTURL
 * method: removeUserOrgUsingPOST_TYPE
 * raw_url: removeUserOrgUsingPOST_RAW_URL
 * @param id - id
 * @param org - org
 */
export const removeUserOrgUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/removeuserorg/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['org'] !== undefined) {
    body = parameters['org']
  }
  if (parameters['org'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: org'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const removeUserOrgUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/removeuserorg/{id}'
}
export const removeUserOrgUsingPOST_TYPE = function() {
  return 'post'
}
export const removeUserOrgUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/removeuserorg/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除用户角色，removeUserRole
 * request: removeUserRoleUsingPOST
 * url: removeUserRoleUsingPOSTURL
 * method: removeUserRoleUsingPOST_TYPE
 * raw_url: removeUserRoleUsingPOST_RAW_URL
 * @param id - id
 * @param role - role
 */
export const removeUserRoleUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/removeuserrole/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['role'] !== undefined) {
    body = parameters['role']
  }
  if (parameters['role'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: role'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const removeUserRoleUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/removeuserrole/{id}'
}
export const removeUserRoleUsingPOST_TYPE = function() {
  return 'post'
}
export const removeUserRoleUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/removeuserrole/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 更新头像图片，BindAvatar
 * request: BindAvatarUsingPOST
 * url: BindAvatarUsingPOSTURL
 * method: BindAvatarUsingPOST_TYPE
 * raw_url: BindAvatarUsingPOST_RAW_URL
 * @param attid - attid
 * @param id - id
 */
export const BindAvatarUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/bindavatar/{id}/{attid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{attid}', `${parameters['attid']}`)
  if (parameters['attid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: attid'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const BindAvatarUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/service/bindavatar/{id}/{attid}'
}
export const BindAvatarUsingPOST_TYPE = function() {
  return 'post'
}
export const BindAvatarUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/bindavatar/{id}/{attid}'
  path = path.replace('{attid}', `${parameters['attid']}`)
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 添加签名图片，BindSignpic
 * request: BindSignpicUsingPOST
 * url: BindSignpicUsingPOSTURL
 * method: BindSignpicUsingPOST_TYPE
 * raw_url: BindSignpicUsingPOST_RAW_URL
 * @param attid - attid
 * @param id - id
 */
export const BindSignpicUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/bindsignpic/{id}/{attid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{attid}', `${parameters['attid']}`)
  if (parameters['attid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: attid'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const BindSignpicUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/service/bindsignpic/{id}/{attid}'
}
export const BindSignpicUsingPOST_TYPE = function() {
  return 'post'
}
export const BindSignpicUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/bindsignpic/{id}/{attid}'
  path = path.replace('{attid}', `${parameters['attid']}`)
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除头像图片，DeleteAvatat
 * request: DeleteAvatatUsingDELETE
 * url: DeleteAvatatUsingDELETEURL
 * method: DeleteAvatatUsingDELETE_TYPE
 * raw_url: DeleteAvatatUsingDELETE_RAW_URL
 * @param id - id
 */
export const DeleteAvatatUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/deleteavatat/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const DeleteAvatatUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/service/deleteavatat/{id}'
}
export const DeleteAvatatUsingDELETE_TYPE = function() {
  return 'delete'
}
export const DeleteAvatatUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/deleteavatat/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除签名图片，DeleteAvatat
 * request: DeleteSignpicUsingDELETE
 * url: DeleteSignpicUsingDELETEURL
 * method: DeleteSignpicUsingDELETE_TYPE
 * raw_url: DeleteSignpicUsingDELETE_RAW_URL
 * @param id - id
 */
export const DeleteSignpicUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/deletesignpic/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const DeleteSignpicUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/service/deletesignpic/{id}'
}
export const DeleteSignpicUsingDELETE_TYPE = function() {
  return 'delete'
}
export const DeleteSignpicUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/deletesignpic/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findOperlog
 * request: findOperlogUsingPOST
 * url: findOperlogUsingPOSTURL
 * method: findOperlogUsingPOST_TYPE
 * raw_url: findOperlogUsingPOST_RAW_URL
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findOperlogUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/operlog/getlist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findOperlogUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/service/operlog/getlist'
}
export const findOperlogUsingPOST_TYPE = function() {
  return 'post'
}
export const findOperlogUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/operlog/getlist'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addPassword
 * request: addPasswordUsingPOST
 * url: addPasswordUsingPOSTURL
 * method: addPasswordUsingPOST_TYPE
 * raw_url: addPasswordUsingPOST_RAW_URL
 * @param password - password
 * @param userid - userid
 */
export const addPasswordUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/password/{userid}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['password'] !== undefined) {
    queryParameters['password'] = parameters['password']
  }
  path = path.replace('{userid}', `${parameters['userid']}`)
  if (parameters['userid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: userid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addPasswordUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/service/password/{userid}'
}
export const addPasswordUsingPOST_TYPE = function() {
  return 'post'
}
export const addPasswordUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/password/{userid}'
  if (parameters['password'] !== undefined) {
    queryParameters['password'] = parameters['password']
  }
  path = path.replace('{userid}', `${parameters['userid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 找回密码，getPasswordMail
 * request: resetPasswordMailUsingPOST
 * url: resetPasswordMailUsingPOSTURL
 * method: resetPasswordMailUsingPOST_TYPE
 * raw_url: resetPasswordMailUsingPOST_RAW_URL
 * @param vo - vo
 */
export const resetPasswordMailUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/resetPasswordMail'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const resetPasswordMailUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/service/resetPasswordMail'
}
export const resetPasswordMailUsingPOST_TYPE = function() {
  return 'post'
}
export const resetPasswordMailUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/resetPasswordMail'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 找回密码，getPasswordMail
 * request: getPasswordMailUsingPOST
 * url: getPasswordMailUsingPOSTURL
 * method: getPasswordMailUsingPOST_TYPE
 * raw_url: getPasswordMailUsingPOST_RAW_URL
 * @param email - email
 * @param loginname - loginname
 */
export const getPasswordMailUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/retrievepassword'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['email'] !== undefined) {
    queryParameters['email'] = parameters['email']
  }
  if (parameters['loginname'] !== undefined) {
    queryParameters['loginname'] = parameters['loginname']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getPasswordMailUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/service/retrievepassword'
}
export const getPasswordMailUsingPOST_TYPE = function() {
  return 'post'
}
export const getPasswordMailUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/retrievepassword'
  if (parameters['email'] !== undefined) {
    queryParameters['email'] = parameters['email']
  }
  if (parameters['loginname'] !== undefined) {
    queryParameters['loginname'] = parameters['loginname']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * UpdatePassword
 * request: UpdatePasswordUsingPOST
 * url: UpdatePasswordUsingPOSTURL
 * method: UpdatePasswordUsingPOST_TYPE
 * raw_url: UpdatePasswordUsingPOST_RAW_URL
 * @param newpassword1 - newpassword1
 * @param password1 - password1
 * @param username1 - username1
 */
export const UpdatePasswordUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/updatepassword'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['newpassword1'] !== undefined) {
    queryParameters['newpassword1'] = parameters['newpassword1']
  }
  if (parameters['password1'] !== undefined) {
    queryParameters['password1'] = parameters['password1']
  }
  if (parameters['username1'] !== undefined) {
    queryParameters['username1'] = parameters['username1']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const UpdatePasswordUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/service/updatepassword'
}
export const UpdatePasswordUsingPOST_TYPE = function() {
  return 'post'
}
export const UpdatePasswordUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/updatepassword'
  if (parameters['newpassword1'] !== undefined) {
    queryParameters['newpassword1'] = parameters['newpassword1']
  }
  if (parameters['password1'] !== undefined) {
    queryParameters['password1'] = parameters['password1']
  }
  if (parameters['username1'] !== undefined) {
    queryParameters['username1'] = parameters['username1']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addUser
 * request: addUserUsingPOST
 * url: addUserUsingPOSTURL
 * method: addUserUsingPOST_TYPE
 * raw_url: addUserUsingPOST_RAW_URL
 * @param user - user
 */
export const addUserUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/user'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['user'] !== undefined) {
    body = parameters['user']
  }
  if (parameters['user'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: user'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addUserUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/service/user'
}
export const addUserUsingPOST_TYPE = function() {
  return 'post'
}
export const addUserUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/user'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 通过用户ID给用户新增部门，addOrgByUserid
 * request: addOrgByUseridUsingPOST
 * url: addOrgByUseridUsingPOSTURL
 * method: addOrgByUseridUsingPOST_TYPE
 * raw_url: addOrgByUseridUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param vo - vo
 */
export const addOrgByUseridUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/user/addorgbyuserid/{modulename}/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addOrgByUseridUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/service/user/addorgbyuserid/{modulename}/{id}'
}
export const addOrgByUseridUsingPOST_TYPE = function() {
  return 'post'
}
export const addOrgByUseridUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/user/addorgbyuserid/{modulename}/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 通过用户ID给用户新增角色，addRoleByUserid
 * request: addRoleByUseridUsingPOST
 * url: addRoleByUseridUsingPOSTURL
 * method: addRoleByUseridUsingPOST_TYPE
 * raw_url: addRoleByUseridUsingPOST_RAW_URL
 * @param id - id
 * @param vo - vo
 */
export const addRoleByUseridUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/user/addrolebyuserid/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addRoleByUseridUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/service/user/addrolebyuserid/{id}'
}
export const addRoleByUseridUsingPOST_TYPE = function() {
  return 'post'
}
export const addRoleByUseridUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/user/addrolebyuserid/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * BindClientid
 * request: BindClientidUsingPOST
 * url: BindClientidUsingPOSTURL
 * method: BindClientidUsingPOST_TYPE
 * raw_url: BindClientidUsingPOST_RAW_URL
 * @param clientid - clientid
 * @param id - id
 */
export const BindClientidUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/user/bindclientid/{id}/{clientid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{clientid}', `${parameters['clientid']}`)
  if (parameters['clientid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: clientid'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const BindClientidUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/service/user/bindclientid/{id}/{clientid}'
}
export const BindClientidUsingPOST_TYPE = function() {
  return 'post'
}
export const BindClientidUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/user/bindclientid/{id}/{clientid}'
  path = path.replace('{clientid}', `${parameters['clientid']}`)
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectUser
 * request: deleteSelectUserUsingDELETE
 * url: deleteSelectUserUsingDELETEURL
 * method: deleteSelectUserUsingDELETE_TYPE
 * raw_url: deleteSelectUserUsingDELETE_RAW_URL
 * @param ids - ids
 */
export const deleteSelectUserUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/user/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectUserUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/service/user/delete'
}
export const deleteSelectUserUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectUserUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/user/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteUser
 * request: deleteUserUsingDELETE
 * url: deleteUserUsingDELETEURL
 * method: deleteUserUsingDELETE_TYPE
 * raw_url: deleteUserUsingDELETE_RAW_URL
 * @param id - id
 */
export const deleteUserUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/user/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteUserUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/service/user/delete/{id}'
}
export const deleteUserUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteUserUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/user/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findUsers
 * request: findUsersUsingPOST
 * url: findUsersUsingPOSTURL
 * method: findUsersUsingPOST_TYPE
 * raw_url: findUsersUsingPOST_RAW_URL
 * @param modelname - modelname
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param userparam - userparam
 */
export const findUsersUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/user/getlist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['modelname'] !== undefined) {
    queryParameters['modelname'] = parameters['modelname']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['userparam'] !== undefined) {
    body = parameters['userparam']
  }
  if (parameters['userparam'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: userparam'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findUsersUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/service/user/getlist'
}
export const findUsersUsingPOST_TYPE = function() {
  return 'post'
}
export const findUsersUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/user/getlist'
  if (parameters['modelname'] !== undefined) {
    queryParameters['modelname'] = parameters['modelname']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 通过用户ID获取部门树状图，getOrgByUserid
 * request: getOrgByUseridUsingGET
 * url: getOrgByUseridUsingGETURL
 * method: getOrgByUseridUsingGET_TYPE
 * raw_url: getOrgByUseridUsingGET_RAW_URL
 * @param id - id
 */
export const getOrgByUseridUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/user/getorgbyuserid/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getOrgByUseridUsingGET_RAW_URL = function() {
  return '/api/v1/admin/service/user/getorgbyuserid/{id}'
}
export const getOrgByUseridUsingGET_TYPE = function() {
  return 'get'
}
export const getOrgByUseridUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/user/getorgbyuserid/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 通过用户ID获取按模块分组的角色列表，getRoleByUserid
 * request: getRoleByUseridUsingGET
 * url: getRoleByUseridUsingGETURL
 * method: getRoleByUseridUsingGET_TYPE
 * raw_url: getRoleByUseridUsingGET_RAW_URL
 * @param id - id
 */
export const getRoleByUseridUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/user/getrolebyuserid/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRoleByUseridUsingGET_RAW_URL = function() {
  return '/api/v1/admin/service/user/getrolebyuserid/{id}'
}
export const getRoleByUseridUsingGET_TYPE = function() {
  return 'get'
}
export const getRoleByUseridUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/user/getrolebyuserid/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 通过用户ID移除指定部门，removeOrgByUserid
 * request: removeOrgByUseridUsingPOST
 * url: removeOrgByUseridUsingPOSTURL
 * method: removeOrgByUseridUsingPOST_TYPE
 * raw_url: removeOrgByUseridUsingPOST_RAW_URL
 * @param id - id
 * @param vo - vo
 */
export const removeOrgByUseridUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/user/removeorgbyuserid/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const removeOrgByUseridUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/service/user/removeorgbyuserid/{id}'
}
export const removeOrgByUseridUsingPOST_TYPE = function() {
  return 'post'
}
export const removeOrgByUseridUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/user/removeorgbyuserid/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 通过用户ID移除指定角色，removeRoleByUserid
 * request: removeRoleByUseridUsingPOST
 * url: removeRoleByUseridUsingPOSTURL
 * method: removeRoleByUseridUsingPOST_TYPE
 * raw_url: removeRoleByUseridUsingPOST_RAW_URL
 * @param id - id
 * @param vo - vo
 */
export const removeRoleByUseridUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/user/removerolebyuserid/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const removeRoleByUseridUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/service/user/removerolebyuserid/{id}'
}
export const removeRoleByUseridUsingPOST_TYPE = function() {
  return 'post'
}
export const removeRoleByUseridUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/user/removerolebyuserid/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateUser
 * request: updateUserUsingPOST
 * url: updateUserUsingPOSTURL
 * method: updateUserUsingPOST_TYPE
 * raw_url: updateUserUsingPOST_RAW_URL
 * @param id - id
 * @param user - user
 */
export const updateUserUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/user/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['user'] !== undefined) {
    body = parameters['user']
  }
  if (parameters['user'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: user'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateUserUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/service/user/update/{id}'
}
export const updateUserUsingPOST_TYPE = function() {
  return 'post'
}
export const updateUserUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/user/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getUser
 * request: getUserUsingGET
 * url: getUserUsingGETURL
 * method: getUserUsingGET_TYPE
 * raw_url: getUserUsingGET_RAW_URL
 * @param id - id
 */
export const getUserUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/service/user/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUserUsingGET_RAW_URL = function() {
  return '/api/v1/admin/service/user/{id}'
}
export const getUserUsingGET_TYPE = function() {
  return 'get'
}
export const getUserUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/service/user/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 增加模块用户岗位，addModuleUserObs
 * request: addModuleUserObsUsingPOST
 * url: addModuleUserObsUsingPOSTURL
 * method: addModuleUserObsUsingPOST_TYPE
 * raw_url: addModuleUserObsUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param obsIds - obsIds
 */
export const addModuleUserObsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/addmoduleuserobs/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['obsIds'] !== undefined) {
    body = parameters['obsIds']
  }
  if (parameters['obsIds'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: obsIds'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addModuleUserObsUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/addmoduleuserobs/{id}'
}
export const addModuleUserObsUsingPOST_TYPE = function() {
  return 'post'
}
export const addModuleUserObsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/addmoduleuserobs/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 增加模块用户指定组织机构的岗位，addModuleUserOrgObs
 * request: addModuleUserOrgObsUsingPOST
 * url: addModuleUserOrgObsUsingPOSTURL
 * method: addModuleUserOrgObsUsingPOST_TYPE
 * raw_url: addModuleUserOrgObsUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param obsIds - obsIds
 * @param orgId - orgId
 */
export const addModuleUserOrgObsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/addmoduleuserorgobs/{id}/{orgId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['obsIds'] !== undefined) {
    body = parameters['obsIds']
  }
  if (parameters['obsIds'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: obsIds'))
  }
  path = path.replace('{orgId}', `${parameters['orgId']}`)
  if (parameters['orgId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: orgId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addModuleUserOrgObsUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/addmoduleuserorgobs/{id}/{orgId}'
}
export const addModuleUserOrgObsUsingPOST_TYPE = function() {
  return 'post'
}
export const addModuleUserOrgObsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/addmoduleuserorgobs/{id}/{orgId}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{orgId}', `${parameters['orgId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 增加模块用户部门，addModuleUserOrg
 * request: addModuleUserOrgUsingPOST
 * url: addModuleUserOrgUsingPOSTURL
 * method: addModuleUserOrgUsingPOST_TYPE
 * raw_url: addModuleUserOrgUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param orgs - orgs
 */
export const addModuleUserOrgUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/addmoduleuserorgs/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['orgs'] !== undefined) {
    body = parameters['orgs']
  }
  if (parameters['orgs'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: orgs'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addModuleUserOrgUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/addmoduleuserorgs/{id}'
}
export const addModuleUserOrgUsingPOST_TYPE = function() {
  return 'post'
}
export const addModuleUserOrgUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/addmoduleuserorgs/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 添加组织机构用户，addOrgUser
 * request: addOrgUserUsingPOST
 * url: addOrgUserUsingPOSTURL
 * method: addOrgUserUsingPOST_TYPE
 * raw_url: addOrgUserUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param users - users
 */
export const addOrgUserUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/addorguser/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['users'] !== undefined) {
    body = parameters['users']
  }
  if (parameters['users'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: users'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addOrgUserUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/addorguser/{id}'
}
export const addOrgUserUsingPOST_TYPE = function() {
  return 'post'
}
export const addOrgUserUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/addorguser/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 增加角色用户，addRoleUser
 * request: addRoleUserUsingPOST
 * url: addRoleUserUsingPOSTURL
 * method: addRoleUserUsingPOST_TYPE
 * raw_url: addRoleUserUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param users - users
 */
export const addRoleUserUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/addroleusers/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['users'] !== undefined) {
    body = parameters['users']
  }
  if (parameters['users'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: users'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addRoleUserUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/addroleusers/{id}'
}
export const addRoleUserUsingPOST_TYPE = function() {
  return 'post'
}
export const addRoleUserUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/addroleusers/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 新增动态属性，addDyProperty
 * request: addDyPropertyUsingPOST
 * url: addDyPropertyUsingPOSTURL
 * method: addDyPropertyUsingPOST_TYPE
 * raw_url: addDyPropertyUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param vo - vo
 */
export const addDyPropertyUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/dyproperty/service'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addDyPropertyUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/dyproperty/service'
}
export const addDyPropertyUsingPOST_TYPE = function() {
  return 'post'
}
export const addDyPropertyUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/dyproperty/service'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除选中，deleteSelectDyProperty
 * request: deleteSelectDyPropertyUsingDELETE
 * url: deleteSelectDyPropertyUsingDELETEURL
 * method: deleteSelectDyPropertyUsingDELETE_TYPE
 * raw_url: deleteSelectDyPropertyUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectDyPropertyUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/dyproperty/service'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectDyPropertyUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/dyproperty/service'
}
export const deleteSelectDyPropertyUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectDyPropertyUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/dyproperty/service'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据entityMeta查询动态属性，getDyPropertyByEntityMeta
 * request: getDyPropertyByEntityMetaUsingGET
 * url: getDyPropertyByEntityMetaUsingGETURL
 * method: getDyPropertyByEntityMetaUsingGET_TYPE
 * raw_url: getDyPropertyByEntityMetaUsingGET_RAW_URL
 * @param entityMetaId - entityMetaId
 * @param modulename - modulename
 */
export const getDyPropertyByEntityMetaUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/dyproperty/service/entityMeta/{entityMetaId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{entityMetaId}', `${parameters['entityMetaId']}`)
  if (parameters['entityMetaId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entityMetaId'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDyPropertyByEntityMetaUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/dyproperty/service/entityMeta/{entityMetaId}'
}
export const getDyPropertyByEntityMetaUsingGET_TYPE = function() {
  return 'get'
}
export const getDyPropertyByEntityMetaUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/dyproperty/service/entityMeta/{entityMetaId}'
  path = path.replace('{entityMetaId}', `${parameters['entityMetaId']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * entityMeta主表新增动态属性，addDyPropertyByEntityMeta
 * request: addDyPropertyByEntityMetaUsingPOST
 * url: addDyPropertyByEntityMetaUsingPOSTURL
 * method: addDyPropertyByEntityMetaUsingPOST_TYPE
 * raw_url: addDyPropertyByEntityMetaUsingPOST_RAW_URL
 * @param entityMetaId - entityMetaId
 * @param modulename - modulename
 * @param vo - vo
 */
export const addDyPropertyByEntityMetaUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/dyproperty/service/entityMeta/{entityMetaId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{entityMetaId}', `${parameters['entityMetaId']}`)
  if (parameters['entityMetaId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entityMetaId'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addDyPropertyByEntityMetaUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/dyproperty/service/entityMeta/{entityMetaId}'
}
export const addDyPropertyByEntityMetaUsingPOST_TYPE = function() {
  return 'post'
}
export const addDyPropertyByEntityMetaUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/dyproperty/service/entityMeta/{entityMetaId}'
  path = path.replace('{entityMetaId}', `${parameters['entityMetaId']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据实体类型查询动态属性，getDyPropertyByEntityType
 * request: getDyPropertyByEntityTypeUsingGET
 * url: getDyPropertyByEntityTypeUsingGETURL
 * method: getDyPropertyByEntityTypeUsingGET_TYPE
 * raw_url: getDyPropertyByEntityTypeUsingGET_RAW_URL
 * @param entityType - entityType
 * @param modulename - modulename
 */
export const getDyPropertyByEntityTypeUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/dyproperty/service/entitytype/{entityType}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{entityType}', `${parameters['entityType']}`)
  if (parameters['entityType'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entityType'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDyPropertyByEntityTypeUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/dyproperty/service/entitytype/{entityType}'
}
export const getDyPropertyByEntityTypeUsingGET_TYPE = function() {
  return 'get'
}
export const getDyPropertyByEntityTypeUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/dyproperty/service/entitytype/{entityType}'
  path = path.replace('{entityType}', `${parameters['entityType']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据FormRouter查询动态属性，getDyPropertyByFormRouter
 * request: getDyPropertyByFormRouterUsingGET
 * url: getDyPropertyByFormRouterUsingGETURL
 * method: getDyPropertyByFormRouterUsingGET_TYPE
 * raw_url: getDyPropertyByFormRouterUsingGET_RAW_URL
 * @param modulename - modulename
 * @param router - router
 */
export const getDyPropertyByFormRouterUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/dyproperty/service/formMeta/router'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['router'] !== undefined) {
    queryParameters['router'] = parameters['router']
  }
  if (parameters['router'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: router'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDyPropertyByFormRouterUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/dyproperty/service/formMeta/router'
}
export const getDyPropertyByFormRouterUsingGET_TYPE = function() {
  return 'get'
}
export const getDyPropertyByFormRouterUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/dyproperty/service/formMeta/router'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['router'] !== undefined) {
    queryParameters['router'] = parameters['router']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据FormRouter和操作集查询动态属性，getDyPropertyByFormRouterAndOperSet
 * request: getDyPropertyByFormRouterAndOperSetUsingGET
 * url: getDyPropertyByFormRouterAndOperSetUsingGETURL
 * method: getDyPropertyByFormRouterAndOperSetUsingGET_TYPE
 * raw_url: getDyPropertyByFormRouterAndOperSetUsingGET_RAW_URL
 * @param modulename - modulename
 * @param router - router
 * @param stateset - stateset
 */
export const getDyPropertyByFormRouterAndOperSetUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/dyproperty/service/formMeta/router/{stateset}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['router'] !== undefined) {
    queryParameters['router'] = parameters['router']
  }
  if (parameters['router'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: router'))
  }
  path = path.replace('{stateset}', `${parameters['stateset']}`)
  if (parameters['stateset'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: stateset'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDyPropertyByFormRouterAndOperSetUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/dyproperty/service/formMeta/router/{stateset}'
}
export const getDyPropertyByFormRouterAndOperSetUsingGET_TYPE = function() {
  return 'get'
}
export const getDyPropertyByFormRouterAndOperSetUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/dyproperty/service/formMeta/router/{stateset}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['router'] !== undefined) {
    queryParameters['router'] = parameters['router']
  }
  path = path.replace('{stateset}', `${parameters['stateset']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findDyPropertys
 * request: findDyPropertysUsingPOST
 * url: findDyPropertysUsingPOSTURL
 * method: findDyPropertysUsingPOST_TYPE
 * raw_url: findDyPropertysUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findDyPropertysUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/dyproperty/service/list'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findDyPropertysUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/dyproperty/service/list'
}
export const findDyPropertysUsingPOST_TYPE = function() {
  return 'post'
}
export const findDyPropertysUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/dyproperty/service/list'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 查询动态属性，getDyProperty
 * request: getDyPropertyUsingGET
 * url: getDyPropertyUsingGETURL
 * method: getDyPropertyUsingGET_TYPE
 * raw_url: getDyPropertyUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getDyPropertyUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/dyproperty/service/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDyPropertyUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/dyproperty/service/{id}'
}
export const getDyPropertyUsingGET_TYPE = function() {
  return 'get'
}
export const getDyPropertyUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/dyproperty/service/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改动态属性，updateDyProperty
 * request: updateDyPropertyUsingPOST
 * url: updateDyPropertyUsingPOSTURL
 * method: updateDyPropertyUsingPOST_TYPE
 * raw_url: updateDyPropertyUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param vo - vo
 */
export const updateDyPropertyUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/dyproperty/service/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateDyPropertyUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/dyproperty/service/{id}'
}
export const updateDyPropertyUsingPOST_TYPE = function() {
  return 'post'
}
export const updateDyPropertyUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/dyproperty/service/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除，deleteDyProperty
 * request: deleteDyPropertyUsingDELETE
 * url: deleteDyPropertyUsingDELETEURL
 * method: deleteDyPropertyUsingDELETE_TYPE
 * raw_url: deleteDyPropertyUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteDyPropertyUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/dyproperty/service/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteDyPropertyUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/dyproperty/service/{id}'
}
export const deleteDyPropertyUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteDyPropertyUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/dyproperty/service/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * entityMeta主表修改动态属性，updateDyPropertyByEntityMeta
 * request: updateDyPropertyByEntityMetaUsingPOST
 * url: updateDyPropertyByEntityMetaUsingPOSTURL
 * method: updateDyPropertyByEntityMetaUsingPOST_TYPE
 * raw_url: updateDyPropertyByEntityMetaUsingPOST_RAW_URL
 * @param entityMetaId - entityMetaId
 * @param id - id
 * @param modulename - modulename
 * @param vo - vo
 */
export const updateDyPropertyByEntityMetaUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/dyproperty/service/{id}/entityMeta/{entityMetaId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{entityMetaId}', `${parameters['entityMetaId']}`)
  if (parameters['entityMetaId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entityMetaId'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateDyPropertyByEntityMetaUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/dyproperty/service/{id}/entityMeta/{entityMetaId}'
}
export const updateDyPropertyByEntityMetaUsingPOST_TYPE = function() {
  return 'post'
}
export const updateDyPropertyByEntityMetaUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/dyproperty/service/{id}/entityMeta/{entityMetaId}'
  path = path.replace('{entityMetaId}', `${parameters['entityMetaId']}`)
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 新增实体类元数据，addEntityMeta
 * request: addEntityMetaUsingPOST
 * url: addEntityMetaUsingPOSTURL
 * method: addEntityMetaUsingPOST_TYPE
 * raw_url: addEntityMetaUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param vo - vo
 */
export const addEntityMetaUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/entitymeta/service'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addEntityMetaUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/entitymeta/service'
}
export const addEntityMetaUsingPOST_TYPE = function() {
  return 'post'
}
export const addEntityMetaUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/entitymeta/service'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除选中，deleteSelectEntityMeta
 * request: deleteSelectEntityMetaUsingDELETE
 * url: deleteSelectEntityMetaUsingDELETEURL
 * method: deleteSelectEntityMetaUsingDELETE_TYPE
 * raw_url: deleteSelectEntityMetaUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectEntityMetaUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/entitymeta/service'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectEntityMetaUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/entitymeta/service'
}
export const deleteSelectEntityMetaUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectEntityMetaUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/entitymeta/service'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findEntityMetas
 * request: findEntityMetasUsingPOST
 * url: findEntityMetasUsingPOSTURL
 * method: findEntityMetasUsingPOST_TYPE
 * raw_url: findEntityMetasUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findEntityMetasUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/entitymeta/service/list'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findEntityMetasUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/entitymeta/service/list'
}
export const findEntityMetasUsingPOST_TYPE = function() {
  return 'post'
}
export const findEntityMetasUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/entitymeta/service/list'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取矩阵表头,getMatrixTableCols
 * request: getMatrixTableColsUsingGET
 * url: getMatrixTableColsUsingGETURL
 * method: getMatrixTableColsUsingGET_TYPE
 * raw_url: getMatrixTableColsUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getMatrixTableColsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/entitymeta/service/matrix/cols/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getMatrixTableColsUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/entitymeta/service/matrix/cols/{id}'
}
export const getMatrixTableColsUsingGET_TYPE = function() {
  return 'get'
}
export const getMatrixTableColsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/entitymeta/service/matrix/cols/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取矩阵数据,getMatrixTableDatas
 * request: getMatrixTableDatasUsingGET
 * url: getMatrixTableDatasUsingGETURL
 * method: getMatrixTableDatasUsingGET_TYPE
 * raw_url: getMatrixTableDatasUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getMatrixTableDatasUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/entitymeta/service/matrix/datas/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getMatrixTableDatasUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/entitymeta/service/matrix/datas/{id}'
}
export const getMatrixTableDatasUsingGET_TYPE = function() {
  return 'get'
}
export const getMatrixTableDatasUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/entitymeta/service/matrix/datas/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改矩阵操作，updateMatrixOperate
 * request: updateMatrixOperateUsingPUT
 * url: updateMatrixOperateUsingPUTURL
 * method: updateMatrixOperateUsingPUT_TYPE
 * raw_url: updateMatrixOperateUsingPUT_RAW_URL
 * @param dyPropertyId - dyPropertyId
 * @param formMetaId - formMetaId
 * @param operate - operate
 */
export const updateMatrixOperateUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/entitymeta/service/matrix/{formMetaId}/{dyPropertyId}/{operate}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{dyPropertyId}', `${parameters['dyPropertyId']}`)
  if (parameters['dyPropertyId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dyPropertyId'))
  }
  path = path.replace('{formMetaId}', `${parameters['formMetaId']}`)
  if (parameters['formMetaId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: formMetaId'))
  }
  path = path.replace('{operate}', `${parameters['operate']}`)
  if (parameters['operate'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: operate'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateMatrixOperateUsingPUT_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/entitymeta/service/matrix/{formMetaId}/{dyPropertyId}/{operate}'
}
export const updateMatrixOperateUsingPUT_TYPE = function() {
  return 'put'
}
export const updateMatrixOperateUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/entitymeta/service/matrix/{formMetaId}/{dyPropertyId}/{operate}'
  path = path.replace('{dyPropertyId}', `${parameters['dyPropertyId']}`)
  path = path.replace('{formMetaId}', `${parameters['formMetaId']}`)
  path = path.replace('{operate}', `${parameters['operate']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 查询实体类元数据，getEntityMeta
 * request: getEntityMetaUsingGET
 * url: getEntityMetaUsingGETURL
 * method: getEntityMetaUsingGET_TYPE
 * raw_url: getEntityMetaUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getEntityMetaUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/entitymeta/service/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getEntityMetaUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/entitymeta/service/{id}'
}
export const getEntityMetaUsingGET_TYPE = function() {
  return 'get'
}
export const getEntityMetaUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/entitymeta/service/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改实体类元数据，updateEntityMeta
 * request: updateEntityMetaUsingPOST
 * url: updateEntityMetaUsingPOSTURL
 * method: updateEntityMetaUsingPOST_TYPE
 * raw_url: updateEntityMetaUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param vo - vo
 */
export const updateEntityMetaUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/entitymeta/service/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateEntityMetaUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/entitymeta/service/{id}'
}
export const updateEntityMetaUsingPOST_TYPE = function() {
  return 'post'
}
export const updateEntityMetaUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/entitymeta/service/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除，deleteEntityMeta
 * request: deleteEntityMetaUsingDELETE
 * url: deleteEntityMetaUsingDELETEURL
 * method: deleteEntityMetaUsingDELETE_TYPE
 * raw_url: deleteEntityMetaUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteEntityMetaUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/entitymeta/service/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteEntityMetaUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/entitymeta/service/{id}'
}
export const deleteEntityMetaUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteEntityMetaUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/entitymeta/service/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 新增FormMeta，addFormMeta
 * request: addFormMetaUsingPOST
 * url: addFormMetaUsingPOSTURL
 * method: addFormMetaUsingPOST_TYPE
 * raw_url: addFormMetaUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param vo - vo
 */
export const addFormMetaUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/formMeta/service'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addFormMetaUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/formMeta/service'
}
export const addFormMetaUsingPOST_TYPE = function() {
  return 'post'
}
export const addFormMetaUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/formMeta/service'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除选中，deleteSelectFormMeta
 * request: deleteSelectFormMetaUsingDELETE
 * url: deleteSelectFormMetaUsingDELETEURL
 * method: deleteSelectFormMetaUsingDELETE_TYPE
 * raw_url: deleteSelectFormMetaUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectFormMetaUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/formMeta/service'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectFormMetaUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/formMeta/service'
}
export const deleteSelectFormMetaUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectFormMetaUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/formMeta/service'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据entityMeta查询动态属性，getFormMetaByEntityMeta
 * request: getFormMetaByEntityMetaUsingGET
 * url: getFormMetaByEntityMetaUsingGETURL
 * method: getFormMetaByEntityMetaUsingGET_TYPE
 * raw_url: getFormMetaByEntityMetaUsingGET_RAW_URL
 * @param entityMetaId - entityMetaId
 * @param modulename - modulename
 */
export const getFormMetaByEntityMetaUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/formMeta/service/entityMeta/{entityMetaId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{entityMetaId}', `${parameters['entityMetaId']}`)
  if (parameters['entityMetaId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entityMetaId'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getFormMetaByEntityMetaUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/formMeta/service/entityMeta/{entityMetaId}'
}
export const getFormMetaByEntityMetaUsingGET_TYPE = function() {
  return 'get'
}
export const getFormMetaByEntityMetaUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/formMeta/service/entityMeta/{entityMetaId}'
  path = path.replace('{entityMetaId}', `${parameters['entityMetaId']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * entityMeta主表新增动态属性，addFormMetaByEntityMeta
 * request: addFormMetaByEntityMetaUsingPOST
 * url: addFormMetaByEntityMetaUsingPOSTURL
 * method: addFormMetaByEntityMetaUsingPOST_TYPE
 * raw_url: addFormMetaByEntityMetaUsingPOST_RAW_URL
 * @param entityMetaId - entityMetaId
 * @param modulename - modulename
 * @param vo - vo
 */
export const addFormMetaByEntityMetaUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/formMeta/service/entityMeta/{entityMetaId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{entityMetaId}', `${parameters['entityMetaId']}`)
  if (parameters['entityMetaId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entityMetaId'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addFormMetaByEntityMetaUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/formMeta/service/entityMeta/{entityMetaId}'
}
export const addFormMetaByEntityMetaUsingPOST_TYPE = function() {
  return 'post'
}
export const addFormMetaByEntityMetaUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/formMeta/service/entityMeta/{entityMetaId}'
  path = path.replace('{entityMetaId}', `${parameters['entityMetaId']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findFormMetas
 * request: findFormMetasUsingPOST
 * url: findFormMetasUsingPOSTURL
 * method: findFormMetasUsingPOST_TYPE
 * raw_url: findFormMetasUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findFormMetasUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/formMeta/service/list'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findFormMetasUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/formMeta/service/list'
}
export const findFormMetasUsingPOST_TYPE = function() {
  return 'post'
}
export const findFormMetasUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/formMeta/service/list'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 查询vue定义，getFormMeta
 * request: getFormMetaUsingGET
 * url: getFormMetaUsingGETURL
 * method: getFormMetaUsingGET_TYPE
 * raw_url: getFormMetaUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getFormMetaUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/formMeta/service/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getFormMetaUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/formMeta/service/{id}'
}
export const getFormMetaUsingGET_TYPE = function() {
  return 'get'
}
export const getFormMetaUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/formMeta/service/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改formMeta，updateFormMeta
 * request: updateFormMetaUsingPOST
 * url: updateFormMetaUsingPOSTURL
 * method: updateFormMetaUsingPOST_TYPE
 * raw_url: updateFormMetaUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param vo - vo
 */
export const updateFormMetaUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/formMeta/service/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateFormMetaUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/formMeta/service/{id}'
}
export const updateFormMetaUsingPOST_TYPE = function() {
  return 'post'
}
export const updateFormMetaUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/formMeta/service/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除，deleteFormMeta
 * request: deleteFormMetaUsingDELETE
 * url: deleteFormMetaUsingDELETEURL
 * method: deleteFormMetaUsingDELETE_TYPE
 * raw_url: deleteFormMetaUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteFormMetaUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/formMeta/service/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteFormMetaUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/formMeta/service/{id}'
}
export const deleteFormMetaUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteFormMetaUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/formMeta/service/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * entityMeta主表修改动态属性，updateFormMetaByEntityMeta
 * request: updateFormMetaByEntityMetaUsingPOST
 * url: updateFormMetaByEntityMetaUsingPOSTURL
 * method: updateFormMetaByEntityMetaUsingPOST_TYPE
 * raw_url: updateFormMetaByEntityMetaUsingPOST_RAW_URL
 * @param entityMetaId - entityMetaId
 * @param id - id
 * @param modulename - modulename
 * @param vo - vo
 */
export const updateFormMetaByEntityMetaUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/formMeta/service/{id}/entityMeta/{entityMetaId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{entityMetaId}', `${parameters['entityMetaId']}`)
  if (parameters['entityMetaId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entityMetaId'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateFormMetaByEntityMetaUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/formMeta/service/{id}/entityMeta/{entityMetaId}'
}
export const updateFormMetaByEntityMetaUsingPOST_TYPE = function() {
  return 'post'
}
export const updateFormMetaByEntityMetaUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/formMeta/service/{id}/entityMeta/{entityMetaId}'
  path = path.replace('{entityMetaId}', `${parameters['entityMetaId']}`)
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取模块用户，getModuleUserOrg
 * request: getModuleUserOrgUsingGET
 * url: getModuleUserOrgUsingGETURL
 * method: getModuleUserOrgUsingGET_TYPE
 * raw_url: getModuleUserOrgUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getModuleUserOrgUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/getModuleUserOrg/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getModuleUserOrgUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/getModuleUserOrg/{id}'
}
export const getModuleUserOrgUsingGET_TYPE = function() {
  return 'get'
}
export const getModuleUserOrgUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/getModuleUserOrg/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取模块用户以及属性，getModuleUserProps
 * request: getModuleUserPropsUsingGET
 * url: getModuleUserPropsUsingGETURL
 * method: getModuleUserPropsUsingGET_TYPE
 * raw_url: getModuleUserPropsUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getModuleUserPropsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/getModuleUserProps/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getModuleUserPropsUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/getModuleUserProps/{id}'
}
export const getModuleUserPropsUsingGET_TYPE = function() {
  return 'get'
}
export const getModuleUserPropsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/getModuleUserProps/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取模块用户岗位，getModuleUserObs
 * request: getModuleUserObsUsingGET
 * url: getModuleUserObsUsingGETURL
 * method: getModuleUserObsUsingGET_TYPE
 * raw_url: getModuleUserObsUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getModuleUserObsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/getmoduleuserobs/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getModuleUserObsUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/getmoduleuserobs/{id}'
}
export const getModuleUserObsUsingGET_TYPE = function() {
  return 'get'
}
export const getModuleUserObsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/getmoduleuserobs/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除模块用户部门，removeModuleUserOrg
 * request: removeModuleUserOrgUsingPOST
 * url: removeModuleUserOrgUsingPOSTURL
 * method: removeModuleUserOrgUsingPOST_TYPE
 * raw_url: removeModuleUserOrgUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param org - org
 */
export const removeModuleUserOrgUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/removemoduleuserorg/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['org'] !== undefined) {
    body = parameters['org']
  }
  if (parameters['org'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: org'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const removeModuleUserOrgUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/removemoduleuserorg/{id}'
}
export const removeModuleUserOrgUsingPOST_TYPE = function() {
  return 'post'
}
export const removeModuleUserOrgUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/removemoduleuserorg/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除组织机构用户，removeOrgUser
 * request: removeOrgUserUsingPOST
 * url: removeOrgUserUsingPOSTURL
 * method: removeOrgUserUsingPOST_TYPE
 * raw_url: removeOrgUserUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param user - user
 */
export const removeOrgUserUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/removeorguser/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['user'] !== undefined) {
    body = parameters['user']
  }
  if (parameters['user'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: user'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const removeOrgUserUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/removeorguser/{id}'
}
export const removeOrgUserUsingPOST_TYPE = function() {
  return 'post'
}
export const removeOrgUserUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/removeorguser/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除角色用户，removeRoleUser
 * request: removeRoleUserUsingPOST
 * url: removeRoleUserUsingPOSTURL
 * method: removeRoleUserUsingPOST_TYPE
 * raw_url: removeRoleUserUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param user - user
 */
export const removeRoleUserUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/removeroleuser/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['user'] !== undefined) {
    body = parameters['user']
  }
  if (parameters['user'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: user'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const removeRoleUserUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/removeroleuser/{id}'
}
export const removeRoleUserUsingPOST_TYPE = function() {
  return 'post'
}
export const removeRoleUserUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/removeroleuser/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取角色用户，getRoleUsers
 * request: getRoleUsersUsingGET
 * url: getRoleUsersUsingGETURL
 * method: getRoleUsersUsingGET_TYPE
 * raw_url: getRoleUsersUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getRoleUsersUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/roleusers/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRoleUsersUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/roleusers/{id}'
}
export const getRoleUsersUsingGET_TYPE = function() {
  return 'get'
}
export const getRoleUsersUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/roleusers/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据角色code获取角色用户，getRoleUsersByCode
 * request: getRoleUsersByCodeUsingGET
 * url: getRoleUsersByCodeUsingGETURL
 * method: getRoleUsersByCodeUsingGET_TYPE
 * raw_url: getRoleUsersByCodeUsingGET_RAW_URL
 * @param code - code
 * @param modulename - modulename
 */
export const getRoleUsersByCodeUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/roleusersbycode/{code}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{code}', `${parameters['code']}`)
  if (parameters['code'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: code'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRoleUsersByCodeUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/roleusersbycode/{code}'
}
export const getRoleUsersByCodeUsingGET_TYPE = function() {
  return 'get'
}
export const getRoleUsersByCodeUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/roleusersbycode/{code}'
  path = path.replace('{code}', `${parameters['code']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据角色code获取角色用户2(作业许可发起用)，getRoleUsersByCode2
 * request: getRoleUsersByCode2UsingGET
 * url: getRoleUsersByCode2UsingGETURL
 * method: getRoleUsersByCode2UsingGET_TYPE
 * raw_url: getRoleUsersByCode2UsingGET_RAW_URL
 * @param code - code
 * @param modulename - modulename
 * @param name - 
 */
export const getRoleUsersByCode2UsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/roleusersbycode2/{code}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{code}', `${parameters['code']}`)
  if (parameters['code'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: code'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRoleUsersByCode2UsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/roleusersbycode2/{code}'
}
export const getRoleUsersByCode2UsingGET_TYPE = function() {
  return 'get'
}
export const getRoleUsersByCode2UsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/roleusersbycode2/{code}'
  path = path.replace('{code}', `${parameters['code']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据角色code获取角色用户3(作业许可发起用)，getRoleUsersByCode3
 * request: getRoleUsersByCode3UsingGET
 * url: getRoleUsersByCode3UsingGETURL
 * method: getRoleUsersByCode3UsingGET_TYPE
 * raw_url: getRoleUsersByCode3UsingGET_RAW_URL
 * @param code - code
 * @param modulename - modulename
 * @param userid - userid
 */
export const getRoleUsersByCode3UsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/roleusersbycode3/{code}/{userid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{code}', `${parameters['code']}`)
  if (parameters['code'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: code'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{userid}', `${parameters['userid']}`)
  if (parameters['userid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: userid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRoleUsersByCode3UsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/roleusersbycode3/{code}/{userid}'
}
export const getRoleUsersByCode3UsingGET_TYPE = function() {
  return 'get'
}
export const getRoleUsersByCode3UsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/roleusersbycode3/{code}/{userid}'
  path = path.replace('{code}', `${parameters['code']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{userid}', `${parameters['userid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取所有模块businesscfg
 * request: getAllBusinessCfgUsingGET
 * url: getAllBusinessCfgUsingGETURL
 * method: getAllBusinessCfgUsingGET_TYPE
 * raw_url: getAllBusinessCfgUsingGET_RAW_URL
 * @param local - local
 * @param modulename - modulename
 */
export const getAllBusinessCfgUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/allchildbusinesscfg'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['local'] !== undefined) {
    queryParameters['local'] = parameters['local']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllBusinessCfgUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/allchildbusinesscfg'
}
export const getAllBusinessCfgUsingGET_TYPE = function() {
  return 'get'
}
export const getAllBusinessCfgUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/allchildbusinesscfg'
  if (parameters['local'] !== undefined) {
    queryParameters['local'] = parameters['local']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取所有模块Menu
 * request: getAllMenusUsingGET
 * url: getAllMenusUsingGETURL
 * method: getAllMenusUsingGET_TYPE
 * raw_url: getAllMenusUsingGET_RAW_URL
 * @param local - local
 * @param modulename - modulename
 */
export const getAllMenusUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/allchildmenu'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['local'] !== undefined) {
    queryParameters['local'] = parameters['local']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllMenusUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/allchildmenu'
}
export const getAllMenusUsingGET_TYPE = function() {
  return 'get'
}
export const getAllMenusUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/allchildmenu'
  if (parameters['local'] !== undefined) {
    queryParameters['local'] = parameters['local']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 新增根节点，addBusinessCfg
 * request: addBusinessCfgUsingPOST_1
 * url: addBusinessCfgUsingPOST_1URL
 * method: addBusinessCfgUsingPOST_1_TYPE
 * raw_url: addBusinessCfgUsingPOST_1_RAW_URL
 * @param modulename - modulename
 * @param vo - vo
 */
export const addBusinessCfgUsingPOST_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/businesscfg'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addBusinessCfgUsingPOST_1_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/businesscfg'
}
export const addBusinessCfgUsingPOST_1_TYPE = function() {
  return 'post'
}
export const addBusinessCfgUsingPOST_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/businesscfg'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除选中，deleteSelectBusinessCfg
 * request: deleteSelectBusinessCfgUsingDELETE
 * url: deleteSelectBusinessCfgUsingDELETEURL
 * method: deleteSelectBusinessCfgUsingDELETE_TYPE
 * raw_url: deleteSelectBusinessCfgUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectBusinessCfgUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/businesscfg/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectBusinessCfgUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/businesscfg/'
}
export const deleteSelectBusinessCfgUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectBusinessCfgUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/businesscfg/'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 移动到后,moveAfterBusinessCfg
 * request: moveAfterBusinessCfgUsingPOST
 * url: moveAfterBusinessCfgUsingPOSTURL
 * method: moveAfterBusinessCfgUsingPOST_TYPE
 * raw_url: moveAfterBusinessCfgUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param parentid - parentid
 * @param targetid - targetid
 */
export const moveAfterBusinessCfgUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/businesscfg/moveafter/{id}/{parentid}/{targetid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters['parentid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: parentid'))
  }
  path = path.replace('{targetid}', `${parameters['targetid']}`)
  if (parameters['targetid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: targetid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const moveAfterBusinessCfgUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/businesscfg/moveafter/{id}/{parentid}/{targetid}'
}
export const moveAfterBusinessCfgUsingPOST_TYPE = function() {
  return 'post'
}
export const moveAfterBusinessCfgUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/businesscfg/moveafter/{id}/{parentid}/{targetid}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  path = path.replace('{targetid}', `${parameters['targetid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 移动到前,moveBeforeBusinessCfg
 * request: moveBeforeBusinessCfgUsingPOST
 * url: moveBeforeBusinessCfgUsingPOSTURL
 * method: moveBeforeBusinessCfgUsingPOST_TYPE
 * raw_url: moveBeforeBusinessCfgUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param parentid - parentid
 * @param targetid - targetid
 */
export const moveBeforeBusinessCfgUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/businesscfg/movebefore/{id}/{parentid}/{targetid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters['parentid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: parentid'))
  }
  path = path.replace('{targetid}', `${parameters['targetid']}`)
  if (parameters['targetid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: targetid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const moveBeforeBusinessCfgUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/businesscfg/movebefore/{id}/{parentid}/{targetid}'
}
export const moveBeforeBusinessCfgUsingPOST_TYPE = function() {
  return 'post'
}
export const moveBeforeBusinessCfgUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/businesscfg/movebefore/{id}/{parentid}/{targetid}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  path = path.replace('{targetid}', `${parameters['targetid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * self，getBusinessCfg
 * request: getBusinessCfgUsingGET
 * url: getBusinessCfgUsingGETURL
 * method: getBusinessCfgUsingGET_TYPE
 * raw_url: getBusinessCfgUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getBusinessCfgUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/businesscfg/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getBusinessCfgUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/businesscfg/{id}'
}
export const getBusinessCfgUsingGET_TYPE = function() {
  return 'get'
}
export const getBusinessCfgUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/businesscfg/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改，updateBusinessCfg
 * request: updateBusinessCfgUsingPOST
 * url: updateBusinessCfgUsingPOSTURL
 * method: updateBusinessCfgUsingPOST_TYPE
 * raw_url: updateBusinessCfgUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param vo - vo
 */
export const updateBusinessCfgUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/businesscfg/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateBusinessCfgUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/businesscfg/{id}'
}
export const updateBusinessCfgUsingPOST_TYPE = function() {
  return 'post'
}
export const updateBusinessCfgUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/businesscfg/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除，deleteBusinessCfg
 * request: deleteBusinessCfgUsingDELETE
 * url: deleteBusinessCfgUsingDELETEURL
 * method: deleteBusinessCfgUsingDELETE_TYPE
 * raw_url: deleteBusinessCfgUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteBusinessCfgUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/businesscfg/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteBusinessCfgUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/businesscfg/{id}'
}
export const deleteBusinessCfgUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteBusinessCfgUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/businesscfg/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 新增子节点，addBusinessCfg
 * request: addBusinessCfgUsingPOST
 * url: addBusinessCfgUsingPOSTURL
 * method: addBusinessCfgUsingPOST_TYPE
 * raw_url: addBusinessCfgUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param parentid - parentid
 * @param vo - vo
 */
export const addBusinessCfgUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/businesscfg/{parentid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters['parentid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: parentid'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addBusinessCfgUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/businesscfg/{parentid}'
}
export const addBusinessCfgUsingPOST_TYPE = function() {
  return 'post'
}
export const addBusinessCfgUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/businesscfg/{parentid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取模块的子busicfgnode
 * request: getChildBusiCfgNodeUsingGET
 * url: getChildBusiCfgNodeUsingGETURL
 * method: getChildBusiCfgNodeUsingGET_TYPE
 * raw_url: getChildBusiCfgNodeUsingGET_RAW_URL
 * @param modulename - modulename
 * @param parentid - parentid
 */
export const getChildBusiCfgNodeUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/childbusicfgnode/{parentid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters['parentid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: parentid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getChildBusiCfgNodeUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/childbusicfgnode/{parentid}'
}
export const getChildBusiCfgNodeUsingGET_TYPE = function() {
  return 'get'
}
export const getChildBusiCfgNodeUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/childbusicfgnode/{parentid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取模块的子businesscfg
 * request: getChildBusinessCfgUsingGET
 * url: getChildBusinessCfgUsingGETURL
 * method: getChildBusinessCfgUsingGET_TYPE
 * raw_url: getChildBusinessCfgUsingGET_RAW_URL
 * @param modulename - modulename
 * @param parentid - parentid
 */
export const getChildBusinessCfgUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/childbusinesscfg/{parentid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters['parentid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: parentid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getChildBusinessCfgUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/childbusinesscfg/{parentid}'
}
export const getChildBusinessCfgUsingGET_TYPE = function() {
  return 'get'
}
export const getChildBusinessCfgUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/childbusinesscfg/{parentid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取模块的子Menu
 * request: getChildMenusUsingGET
 * url: getChildMenusUsingGETURL
 * method: getChildMenusUsingGET_TYPE
 * raw_url: getChildMenusUsingGET_RAW_URL
 * @param modulename - modulename
 * @param parentid - parentid
 */
export const getChildMenusUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/childmenu/{parentid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters['parentid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: parentid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getChildMenusUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/childmenu/{parentid}'
}
export const getChildMenusUsingGET_TYPE = function() {
  return 'get'
}
export const getChildMenusUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/childmenu/{parentid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 新增子节点，addMenu
 * request: addMenuUsingPOST
 * url: addMenuUsingPOSTURL
 * method: addMenuUsingPOST_TYPE
 * raw_url: addMenuUsingPOST_RAW_URL
 * @param menuvo - menuvo
 * @param modulename - modulename
 * @param parentid - parentid
 */
export const addMenuUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/cmenu/{parentid}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['menuvo'] !== undefined) {
    body = parameters['menuvo']
  }
  if (parameters['menuvo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: menuvo'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters['parentid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: parentid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addMenuUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/cmenu/{parentid}'
}
export const addMenuUsingPOST_TYPE = function() {
  return 'post'
}
export const addMenuUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/cmenu/{parentid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 复制节点,copyMenu
 * request: copyMenuUsingPOST
 * url: copyMenuUsingPOSTURL
 * method: copyMenuUsingPOST_TYPE
 * raw_url: copyMenuUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 */
export const copyMenuUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/copymenu/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const copyMenuUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/copymenu/{id}'
}
export const copyMenuUsingPOST_TYPE = function() {
  return 'post'
}
export const copyMenuUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/copymenu/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Down BusinessCfg,downBusinessCfg
 * request: downBusinessCfgUsingPOST
 * url: downBusinessCfgUsingPOSTURL
 * method: downBusinessCfgUsingPOST_TYPE
 * raw_url: downBusinessCfgUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const downBusinessCfgUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/downbusinesscfg/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const downBusinessCfgUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/downbusinesscfg/{id}'
}
export const downBusinessCfgUsingPOST_TYPE = function() {
  return 'post'
}
export const downBusinessCfgUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/downbusinesscfg/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Down Menu,downMenu
 * request: downMenuUsingPOST
 * url: downMenuUsingPOSTURL
 * method: downMenuUsingPOST_TYPE
 * raw_url: downMenuUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const downMenuUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/downmenu/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const downMenuUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/downmenu/{id}'
}
export const downMenuUsingPOST_TYPE = function() {
  return 'post'
}
export const downMenuUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/downmenu/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 新增根节点，addMenu
 * request: addMenuUsingPOST_1
 * url: addMenuUsingPOST_1URL
 * method: addMenuUsingPOST_1_TYPE
 * raw_url: addMenuUsingPOST_1_RAW_URL
 * @param menuvo - menuvo
 * @param modulename - modulename
 */
export const addMenuUsingPOST_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/menu'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['menuvo'] !== undefined) {
    body = parameters['menuvo']
  }
  if (parameters['menuvo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: menuvo'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addMenuUsingPOST_1_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/menu'
}
export const addMenuUsingPOST_1_TYPE = function() {
  return 'post'
}
export const addMenuUsingPOST_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/menu'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除选中，deleteSelectMenu
 * request: deleteSelectMenuUsingDELETE
 * url: deleteSelectMenuUsingDELETEURL
 * method: deleteSelectMenuUsingDELETE_TYPE
 * raw_url: deleteSelectMenuUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectMenuUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/menu/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectMenuUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/menu/'
}
export const deleteSelectMenuUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectMenuUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/menu/'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * self，getMenu
 * request: getMenuUsingGET
 * url: getMenuUsingGETURL
 * method: getMenuUsingGET_TYPE
 * raw_url: getMenuUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getMenuUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/menu/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getMenuUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/menu/{id}'
}
export const getMenuUsingGET_TYPE = function() {
  return 'get'
}
export const getMenuUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/menu/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改，updateMenu
 * request: updateMenuUsingPOST
 * url: updateMenuUsingPOSTURL
 * method: updateMenuUsingPOST_TYPE
 * raw_url: updateMenuUsingPOST_RAW_URL
 * @param id - id
 * @param menuvo - menuvo
 * @param modulename - modulename
 */
export const updateMenuUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/menu/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['menuvo'] !== undefined) {
    body = parameters['menuvo']
  }
  if (parameters['menuvo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: menuvo'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateMenuUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/menu/{id}'
}
export const updateMenuUsingPOST_TYPE = function() {
  return 'post'
}
export const updateMenuUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/menu/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除，deleteMenu
 * request: deleteMenuUsingDELETE
 * url: deleteMenuUsingDELETEURL
 * method: deleteMenuUsingDELETE_TYPE
 * raw_url: deleteMenuUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteMenuUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/menu/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteMenuUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/menu/{id}'
}
export const deleteMenuUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteMenuUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/menu/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回模块用户，findModuleUsers
 * request: findModuleUsersUsingPOST
 * url: findModuleUsersUsingPOSTURL
 * method: findModuleUsersUsingPOST_TYPE
 * raw_url: findModuleUsersUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param userparam - userparam
 */
export const findModuleUsersUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/moduleuser/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['userparam'] !== undefined) {
    body = parameters['userparam']
  }
  if (parameters['userparam'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: userparam'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findModuleUsersUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/moduleuser/getlist'
}
export const findModuleUsersUsingPOST_TYPE = function() {
  return 'post'
}
export const findModuleUsersUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/moduleuser/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 移动到后,moveAfter
 * request: moveAfterUsingPOST
 * url: moveAfterUsingPOSTURL
 * method: moveAfterUsingPOST_TYPE
 * raw_url: moveAfterUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param parentid - parentid
 * @param targetid - targetid
 */
export const moveAfterUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/moveafter/{id}/{parentid}/{targetid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters['parentid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: parentid'))
  }
  path = path.replace('{targetid}', `${parameters['targetid']}`)
  if (parameters['targetid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: targetid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const moveAfterUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/moveafter/{id}/{parentid}/{targetid}'
}
export const moveAfterUsingPOST_TYPE = function() {
  return 'post'
}
export const moveAfterUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/moveafter/{id}/{parentid}/{targetid}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  path = path.replace('{targetid}', `${parameters['targetid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 移动到前,moveBefore
 * request: moveBeforeUsingPOST
 * url: moveBeforeUsingPOSTURL
 * method: moveBeforeUsingPOST_TYPE
 * raw_url: moveBeforeUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param parentid - parentid
 * @param targetid - targetid
 */
export const moveBeforeUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/movebefore/{id}/{parentid}/{targetid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters['parentid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: parentid'))
  }
  path = path.replace('{targetid}', `${parameters['targetid']}`)
  if (parameters['targetid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: targetid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const moveBeforeUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/movebefore/{id}/{parentid}/{targetid}'
}
export const moveBeforeUsingPOST_TYPE = function() {
  return 'post'
}
export const moveBeforeUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/movebefore/{id}/{parentid}/{targetid}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  path = path.replace('{targetid}', `${parameters['targetid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addObs
 * request: addObsUsingPOST
 * url: addObsUsingPOSTURL
 * method: addObsUsingPOST_TYPE
 * raw_url: addObsUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param orgId - orgId
 * @param vo - vo
 */
export const addObsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/obs/add/{orgId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{orgId}', `${parameters['orgId']}`)
  if (parameters['orgId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: orgId'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addObsUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/obs/add/{orgId}'
}
export const addObsUsingPOST_TYPE = function() {
  return 'post'
}
export const addObsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/obs/add/{orgId}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{orgId}', `${parameters['orgId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 添加岗位用户，addObsUser
 * request: addObsUserUsingPOST
 * url: addObsUserUsingPOSTURL
 * method: addObsUserUsingPOST_TYPE
 * raw_url: addObsUserUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param users - users
 */
export const addObsUserUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/obs/addobsuser/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['users'] !== undefined) {
    body = parameters['users']
  }
  if (parameters['users'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: users'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addObsUserUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/obs/addobsuser/{id}'
}
export const addObsUserUsingPOST_TYPE = function() {
  return 'post'
}
export const addObsUserUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/obs/addobsuser/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 岗位列表，GetObsPage
 * request: GetObsPageUsingPOST
 * url: GetObsPageUsingPOSTURL
 * method: GetObsPageUsingPOST_TYPE
 * raw_url: GetObsPageUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param vo - vo
 */
export const GetObsPageUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/obs/datalist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const GetObsPageUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/obs/datalist'
}
export const GetObsPageUsingPOST_TYPE = function() {
  return 'post'
}
export const GetObsPageUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/obs/datalist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 岗位列表，findObsPage
 * request: findObsPageUsingPOST
 * url: findObsPageUsingPOSTURL
 * method: findObsPageUsingPOST_TYPE
 * raw_url: findObsPageUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param orgId - orgId
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findObsPageUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/obs/datalist/{orgId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{orgId}', `${parameters['orgId']}`)
  if (parameters['orgId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: orgId'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findObsPageUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/obs/datalist/{orgId}'
}
export const findObsPageUsingPOST_TYPE = function() {
  return 'post'
}
export const findObsPageUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/obs/datalist/{orgId}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{orgId}', `${parameters['orgId']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteObs
 * request: deleteObsUsingDELETE
 * url: deleteObsUsingDELETEURL
 * method: deleteObsUsingDELETE_TYPE
 * raw_url: deleteObsUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteObsUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/obs/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteObsUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/obs/delete'
}
export const deleteObsUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteObsUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/obs/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取组织机构岗位，findObsByOrgId
 * request: getObsByOrgIdUsingPOST
 * url: getObsByOrgIdUsingPOSTURL
 * method: getObsByOrgIdUsingPOST_TYPE
 * raw_url: getObsByOrgIdUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param orgId - orgId
 */
export const getObsByOrgIdUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/obs/findByOrgId/{orgId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{orgId}', `${parameters['orgId']}`)
  if (parameters['orgId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: orgId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getObsByOrgIdUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/obs/findByOrgId/{orgId}'
}
export const getObsByOrgIdUsingPOST_TYPE = function() {
  return 'post'
}
export const getObsByOrgIdUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/obs/findByOrgId/{orgId}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{orgId}', `${parameters['orgId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getObs
 * request: getObsUsingGET
 * url: getObsUsingGETURL
 * method: getObsUsingGET_TYPE
 * raw_url: getObsUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getObsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/obs/get/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getObsUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/obs/get/{id}'
}
export const getObsUsingGET_TYPE = function() {
  return 'get'
}
export const getObsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/obs/get/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取岗位用户，getObsUsers
 * request: getObsUsersUsingGET
 * url: getObsUsersUsingGETURL
 * method: getObsUsersUsingGET_TYPE
 * raw_url: getObsUsersUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getObsUsersUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/obs/obsusers/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getObsUsersUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/obs/obsusers/{id}'
}
export const getObsUsersUsingGET_TYPE = function() {
  return 'get'
}
export const getObsUsersUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/obs/obsusers/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除岗位用户，removeObsUser
 * request: removeObsUserUsingPOST
 * url: removeObsUserUsingPOSTURL
 * method: removeObsUserUsingPOST_TYPE
 * raw_url: removeObsUserUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param user - user
 */
export const removeObsUserUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/obs/removeobsuser/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['user'] !== undefined) {
    body = parameters['user']
  }
  if (parameters['user'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: user'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const removeObsUserUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/obs/removeobsuser/{id}'
}
export const removeObsUserUsingPOST_TYPE = function() {
  return 'post'
}
export const removeObsUserUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/obs/removeobsuser/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateObs
 * request: updateObsUsingPOST
 * url: updateObsUsingPOSTURL
 * method: updateObsUsingPOST_TYPE
 * raw_url: updateObsUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param vo - vo
 */
export const updateObsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/obs/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateObsUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/obs/update/{id}'
}
export const updateObsUsingPOST_TYPE = function() {
  return 'post'
}
export const updateObsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/obs/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectOrganization
 * request: deleteSelectOrganizationUsingDELETE
 * url: deleteSelectOrganizationUsingDELETEURL
 * method: deleteSelectOrganizationUsingDELETE_TYPE
 * raw_url: deleteSelectOrganizationUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectOrganizationUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/organization/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectOrganizationUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/organization/'
}
export const deleteSelectOrganizationUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectOrganizationUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/organization/'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addOrganization
 * request: addOrganizationUsingPOST
 * url: addOrganizationUsingPOSTURL
 * method: addOrganizationUsingPOST_TYPE
 * raw_url: addOrganizationUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param orgvo - orgvo
 * @param prentid - prentid
 */
export const addOrganizationUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/organization/add/{prentid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['orgvo'] !== undefined) {
    body = parameters['orgvo']
  }
  if (parameters['orgvo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: orgvo'))
  }
  path = path.replace('{prentid}', `${parameters['prentid']}`)
  if (parameters['prentid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: prentid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addOrganizationUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/organization/add/{prentid}'
}
export const addOrganizationUsingPOST_TYPE = function() {
  return 'post'
}
export const addOrganizationUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/organization/add/{prentid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{prentid}', `${parameters['prentid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取部门子部门和用户，getOrgChildren
 * request: getOrgChildrenUsingGET
 * url: getOrgChildrenUsingGETURL
 * method: getOrgChildrenUsingGET_TYPE
 * raw_url: getOrgChildrenUsingGET_RAW_URL
 * @param modulename - modulename
 * @param orgid - orgid
 */
export const getOrgChildrenUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/organization/children/{orgid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{orgid}', `${parameters['orgid']}`)
  if (parameters['orgid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: orgid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getOrgChildrenUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/organization/children/{orgid}'
}
export const getOrgChildrenUsingGET_TYPE = function() {
  return 'get'
}
export const getOrgChildrenUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/organization/children/{orgid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{orgid}', `${parameters['orgid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getOrgs
 * request: getOrgsUsingGET
 * url: getOrgsUsingGETURL
 * method: getOrgsUsingGET_TYPE
 * raw_url: getOrgsUsingGET_RAW_URL
 * @param modulename - modulename
 * @param prentid - prentid
 */
export const getOrgsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/organization/find/{prentid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{prentid}', `${parameters['prentid']}`)
  if (parameters['prentid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: prentid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getOrgsUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/organization/find/{prentid}'
}
export const getOrgsUsingGET_TYPE = function() {
  return 'get'
}
export const getOrgsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/organization/find/{prentid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{prentid}', `${parameters['prentid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findOrgs
 * request: findOrgsUsingPOST
 * url: findOrgsUsingPOSTURL
 * method: findOrgsUsingPOST_TYPE
 * raw_url: findOrgsUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param orgvoparam - orgvoparam
 */
export const findOrgsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/organization/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['orgvoparam'] !== undefined) {
    body = parameters['orgvoparam']
  }
  if (parameters['orgvoparam'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: orgvoparam'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findOrgsUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/organization/getlist'
}
export const findOrgsUsingPOST_TYPE = function() {
  return 'post'
}
export const findOrgsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/organization/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getOrgsTree
 * request: getOrgsTreeUsingGET
 * url: getOrgsTreeUsingGETURL
 * method: getOrgsTreeUsingGET_TYPE
 * raw_url: getOrgsTreeUsingGET_RAW_URL
 * @param modulename - modulename
 * @param parentid - parentid
 */
export const getOrgsTreeUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/organization/gettree/{parentid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters['parentid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: parentid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getOrgsTreeUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/organization/gettree/{parentid}'
}
export const getOrgsTreeUsingGET_TYPE = function() {
  return 'get'
}
export const getOrgsTreeUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/organization/gettree/{parentid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateOrganization
 * request: updateOrganizationUsingPOST
 * url: updateOrganizationUsingPOSTURL
 * method: updateOrganizationUsingPOST_TYPE
 * raw_url: updateOrganizationUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param orgvo - orgvo
 */
export const updateOrganizationUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/organization/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['orgvo'] !== undefined) {
    body = parameters['orgvo']
  }
  if (parameters['orgvo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: orgvo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateOrganizationUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/organization/update/{id}'
}
export const updateOrganizationUsingPOST_TYPE = function() {
  return 'post'
}
export const updateOrganizationUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/organization/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取部门用户，getOrgUsers
 * request: getOrgUsersUsingGET_1
 * url: getOrgUsersUsingGET_1URL
 * method: getOrgUsersUsingGET_1_TYPE
 * raw_url: getOrgUsersUsingGET_1_RAW_URL
 * @param modulename - modulename
 * @param orgid - orgid
 */
export const getOrgUsersUsingGET_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/organization/users/{orgid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{orgid}', `${parameters['orgid']}`)
  if (parameters['orgid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: orgid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getOrgUsersUsingGET_1_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/organization/users/{orgid}'
}
export const getOrgUsersUsingGET_1_TYPE = function() {
  return 'get'
}
export const getOrgUsersUsingGET_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/organization/users/{orgid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{orgid}', `${parameters['orgid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getOrganization
 * request: getOrganizationUsingGET
 * url: getOrganizationUsingGETURL
 * method: getOrganizationUsingGET_TYPE
 * raw_url: getOrganizationUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getOrganizationUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/organization/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getOrganizationUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/organization/{id}'
}
export const getOrganizationUsingGET_TYPE = function() {
  return 'get'
}
export const getOrganizationUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/organization/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteOrganization
 * request: deleteOrganizationUsingDELETE
 * url: deleteOrganizationUsingDELETEURL
 * method: deleteOrganizationUsingDELETE_TYPE
 * raw_url: deleteOrganizationUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteOrganizationUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/organization/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteOrganizationUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/organization/{id}'
}
export const deleteOrganizationUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteOrganizationUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/organization/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addPrgType
 * request: addPrgTypeUsingPOST
 * url: addPrgTypeUsingPOSTURL
 * method: addPrgTypeUsingPOST_TYPE
 * raw_url: addPrgTypeUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param orgtype - orgtype
 */
export const addPrgTypeUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/orgtype'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['orgtype'] !== undefined) {
    body = parameters['orgtype']
  }
  if (parameters['orgtype'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: orgtype'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addPrgTypeUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/orgtype'
}
export const addPrgTypeUsingPOST_TYPE = function() {
  return 'post'
}
export const addPrgTypeUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/orgtype'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectOrgType
 * request: deleteSelectOrgTypeUsingDELETE
 * url: deleteSelectOrgTypeUsingDELETEURL
 * method: deleteSelectOrgTypeUsingDELETE_TYPE
 * raw_url: deleteSelectOrgTypeUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectOrgTypeUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/orgtype'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectOrgTypeUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/orgtype'
}
export const deleteSelectOrgTypeUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectOrgTypeUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/orgtype'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findOrgtypes
 * request: findOrgtypesUsingPOST
 * url: findOrgtypesUsingPOSTURL
 * method: findOrgtypesUsingPOST_TYPE
 * raw_url: findOrgtypesUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param orgtype - orgtype
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findOrgtypesUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/orgtype/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['orgtype'] !== undefined) {
    body = parameters['orgtype']
  }
  if (parameters['orgtype'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: orgtype'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findOrgtypesUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/orgtype/getlist'
}
export const findOrgtypesUsingPOST_TYPE = function() {
  return 'post'
}
export const findOrgtypesUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/orgtype/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getOrgType
 * request: getOrgTypeUsingGET
 * url: getOrgTypeUsingGETURL
 * method: getOrgTypeUsingGET_TYPE
 * raw_url: getOrgTypeUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getOrgTypeUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/orgtype/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getOrgTypeUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/orgtype/{id}'
}
export const getOrgTypeUsingGET_TYPE = function() {
  return 'get'
}
export const getOrgTypeUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/orgtype/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateOrgTye
 * request: updateOrgTyeUsingPOST
 * url: updateOrgTyeUsingPOSTURL
 * method: updateOrgTyeUsingPOST_TYPE
 * raw_url: updateOrgTyeUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param orgtype - orgtype
 */
export const updateOrgTyeUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/orgtype/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['orgtype'] !== undefined) {
    body = parameters['orgtype']
  }
  if (parameters['orgtype'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: orgtype'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateOrgTyeUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/orgtype/{id}'
}
export const updateOrgTyeUsingPOST_TYPE = function() {
  return 'post'
}
export const updateOrgTyeUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/orgtype/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteOrgType
 * request: deleteOrgTypeUsingDELETE
 * url: deleteOrgTypeUsingDELETEURL
 * method: deleteOrgTypeUsingDELETE_TYPE
 * raw_url: deleteOrgTypeUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteOrgTypeUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/orgtype/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteOrgTypeUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/orgtype/{id}'
}
export const deleteOrgTypeUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteOrgTypeUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/orgtype/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 粘贴节点,pasteBusinessCfg
 * request: pasteBusinessCfgUsingPOST
 * url: pasteBusinessCfgUsingPOSTURL
 * method: pasteBusinessCfgUsingPOST_TYPE
 * raw_url: pasteBusinessCfgUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param parentid - parentid
 * @param rootid - rootid
 */
export const pasteBusinessCfgUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/pastebusinesscfg/{id}/{parentid}/{rootid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters['parentid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: parentid'))
  }
  path = path.replace('{rootid}', `${parameters['rootid']}`)
  if (parameters['rootid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: rootid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const pasteBusinessCfgUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/pastebusinesscfg/{id}/{parentid}/{rootid}'
}
export const pasteBusinessCfgUsingPOST_TYPE = function() {
  return 'post'
}
export const pasteBusinessCfgUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/pastebusinesscfg/{id}/{parentid}/{rootid}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  path = path.replace('{rootid}', `${parameters['rootid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 粘贴节点,pasteMenu
 * request: pasteMenuUsingPOST
 * url: pasteMenuUsingPOSTURL
 * method: pasteMenuUsingPOST_TYPE
 * raw_url: pasteMenuUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 * @param parentid - parentid
 * @param rootid - rootid
 */
export const pasteMenuUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/pastemenu/{id}/{parentid}/{rootid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters['parentid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: parentid'))
  }
  path = path.replace('{rootid}', `${parameters['rootid']}`)
  if (parameters['rootid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: rootid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const pasteMenuUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/pastemenu/{id}/{parentid}/{rootid}'
}
export const pasteMenuUsingPOST_TYPE = function() {
  return 'post'
}
export const pasteMenuUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/pastemenu/{id}/{parentid}/{rootid}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  path = path.replace('{rootid}', `${parameters['rootid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addRole
 * request: addRoleUsingPOST
 * url: addRoleUsingPOSTURL
 * method: addRoleUsingPOST_TYPE
 * raw_url: addRoleUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param rolevo - rolevo
 */
export const addRoleUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/role/add'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['rolevo'] !== undefined) {
    body = parameters['rolevo']
  }
  if (parameters['rolevo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: rolevo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addRoleUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/role/add'
}
export const addRoleUsingPOST_TYPE = function() {
  return 'post'
}
export const addRoleUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/role/add'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectRole
 * request: deleteSelectRoleUsingDELETE
 * url: deleteSelectRoleUsingDELETEURL
 * method: deleteSelectRoleUsingDELETE_TYPE
 * raw_url: deleteSelectRoleUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectRoleUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/role/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectRoleUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/role/delete'
}
export const deleteSelectRoleUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectRoleUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/role/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteRole
 * request: deleteRoleUsingDELETE
 * url: deleteRoleUsingDELETEURL
 * method: deleteRoleUsingDELETE_TYPE
 * raw_url: deleteRoleUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteRoleUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/role/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteRoleUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/role/delete/{id}'
}
export const deleteRoleUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteRoleUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/role/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取所有角色，findRoleList
 * request: findRoleListUsingPOST
 * url: findRoleListUsingPOSTURL
 * method: findRoleListUsingPOST_TYPE
 * raw_url: findRoleListUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findRoleListUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/role/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findRoleListUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/role/getlist'
}
export const findRoleListUsingPOST_TYPE = function() {
  return 'post'
}
export const findRoleListUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/role/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getRoleList
 * request: getRoleListUsingGET
 * url: getRoleListUsingGETURL
 * method: getRoleListUsingGET_TYPE
 * raw_url: getRoleListUsingGET_RAW_URL
 * @param modulename - modulename
 */
export const getRoleListUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/role/list'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRoleListUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/role/list'
}
export const getRoleListUsingGET_TYPE = function() {
  return 'get'
}
export const getRoleListUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/role/list'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateRole
 * request: updateRoleUsingPOST
 * url: updateRoleUsingPOSTURL
 * method: updateRoleUsingPOST_TYPE
 * raw_url: updateRoleUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param rolevo - rolevo
 */
export const updateRoleUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/role/update'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['rolevo'] !== undefined) {
    body = parameters['rolevo']
  }
  if (parameters['rolevo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: rolevo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateRoleUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/role/update'
}
export const updateRoleUsingPOST_TYPE = function() {
  return 'post'
}
export const updateRoleUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/role/update'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getRole
 * request: getRoleUsingGET
 * url: getRoleUsingGETURL
 * method: getRoleUsingGET_TYPE
 * raw_url: getRoleUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getRoleUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/role/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRoleUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/role/{id}'
}
export const getRoleUsingGET_TYPE = function() {
  return 'get'
}
export const getRoleUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/role/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回角色关联的菜单，getrolemenus
 * request: getRolemenusUsingGET
 * url: getRolemenusUsingGETURL
 * method: getRolemenusUsingGET_TYPE
 * raw_url: getRolemenusUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getRolemenusUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/rolemenus/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRolemenusUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/rolemenus/{id}'
}
export const getRolemenusUsingGET_TYPE = function() {
  return 'get'
}
export const getRolemenusUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/rolemenus/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取模块的根businesscfg
 * request: getRootBusinessCfgUsingGET
 * url: getRootBusinessCfgUsingGETURL
 * method: getRootBusinessCfgUsingGET_TYPE
 * raw_url: getRootBusinessCfgUsingGET_RAW_URL
 * @param modulename - modulename
 */
export const getRootBusinessCfgUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/rootbusinesscfg/'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRootBusinessCfgUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/rootbusinesscfg/'
}
export const getRootBusinessCfgUsingGET_TYPE = function() {
  return 'get'
}
export const getRootBusinessCfgUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/rootbusinesscfg/'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取模块的根Menu
 * request: getRootMenusUsingGET
 * url: getRootMenusUsingGETURL
 * method: getRootMenusUsingGET_TYPE
 * raw_url: getRootMenusUsingGET_RAW_URL
 * @param modulename - modulename
 */
export const getRootMenusUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/rootmenu/'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRootMenusUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/rootmenu/'
}
export const getRootMenusUsingGET_TYPE = function() {
  return 'get'
}
export const getRootMenusUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/rootmenu/'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Up businessCfg,upBusinessCfg
 * request: upBusinessCfgUsingPOST
 * url: upBusinessCfgUsingPOSTURL
 * method: upBusinessCfgUsingPOST_TYPE
 * raw_url: upBusinessCfgUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const upBusinessCfgUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/upbusinesscfg/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const upBusinessCfgUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/upbusinesscfg/{id}'
}
export const upBusinessCfgUsingPOST_TYPE = function() {
  return 'post'
}
export const upBusinessCfgUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/upbusinesscfg/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 增删角色关联，updateRoleMenuOp
 * request: updateRoleMenuOpUsingPOST
 * url: updateRoleMenuOpUsingPOSTURL
 * method: updateRoleMenuOpUsingPOST_TYPE
 * raw_url: updateRoleMenuOpUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param operation - operation
 */
export const updateRoleMenuOpUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/updaterolemenus/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['operation'] !== undefined) {
    body = parameters['operation']
  }
  if (parameters['operation'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: operation'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateRoleMenuOpUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/updaterolemenus/{id}'
}
export const updateRoleMenuOpUsingPOST_TYPE = function() {
  return 'post'
}
export const updateRoleMenuOpUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/updaterolemenus/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Up Menu,upMenu
 * request: upMenuUsingPOST
 * url: upMenuUsingPOSTURL
 * method: upMenuUsingPOST_TYPE
 * raw_url: upMenuUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const upMenuUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/service/upmenu/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const upMenuUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/service/upmenu/{id}'
}
export const upMenuUsingPOST_TYPE = function() {
  return 'post'
}
export const upMenuUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/service/upmenu/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 设置模块用户属性，setModuleUserProps
 * request: setModuleUserPropsUsingPOST
 * url: setModuleUserPropsUsingPOSTURL
 * method: setModuleUserPropsUsingPOST_TYPE
 * raw_url: setModuleUserPropsUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param vo - vo
 */
export const setModuleUserPropsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/setModuleUserProps/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const setModuleUserPropsUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/setModuleUserProps/{id}'
}
export const setModuleUserPropsUsingPOST_TYPE = function() {
  return 'post'
}
export const setModuleUserPropsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/setModuleUserProps/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导入管理Page，findImpManagementPage
 * request: findImpManagementPageUsingPOST
 * url: findImpManagementPageUsingPOSTURL
 * method: findImpManagementPageUsingPOST_TYPE
 * raw_url: findImpManagementPageUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param projectId - projectId
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findImpManagementPageUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/{projectId}/impmanagement/datalist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findImpManagementPageUsingPOST_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/{projectId}/impmanagement/datalist'
}
export const findImpManagementPageUsingPOST_TYPE = function() {
  return 'post'
}
export const findImpManagementPageUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/{projectId}/impmanagement/datalist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除多选导入管理，deleteSelectImpManagement
 * request: deleteSelectImpManagementUsingDELETE
 * url: deleteSelectImpManagementUsingDELETEURL
 * method: deleteSelectImpManagementUsingDELETE_TYPE
 * raw_url: deleteSelectImpManagementUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 * @param projectId - projectId
 */
export const deleteSelectImpManagementUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/{projectId}/impmanagement/delete/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectImpManagementUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/{projectId}/impmanagement/delete/'
}
export const deleteSelectImpManagementUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectImpManagementUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/{projectId}/impmanagement/delete/'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除导入管理，deleteImpManagement
 * request: deleteImpManagementUsingDELETE
 * url: deleteImpManagementUsingDELETEURL
 * method: deleteImpManagementUsingDELETE_TYPE
 * raw_url: deleteImpManagementUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param projectId - projectId
 */
export const deleteImpManagementUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/{projectId}/impmanagement/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteImpManagementUsingDELETE_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/{projectId}/impmanagement/delete/{id}'
}
export const deleteImpManagementUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteImpManagementUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/{projectId}/impmanagement/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 查看导入管理，getImpManagement
 * request: getImpManagementUsingGET
 * url: getImpManagementUsingGETURL
 * method: getImpManagementUsingGET_TYPE
 * raw_url: getImpManagementUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param projectId - projectId
 */
export const getImpManagementUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/admin/{modulename}/{projectId}/impmanagement/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getImpManagementUsingGET_RAW_URL = function() {
  return '/api/v1/admin/{modulename}/{projectId}/impmanagement/{id}'
}
export const getImpManagementUsingGET_TYPE = function() {
  return 'get'
}
export const getImpManagementUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/admin/{modulename}/{projectId}/impmanagement/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 添加通知公告，addBulletin
 * request: addBulletinUsingPOST
 * url: addBulletinUsingPOSTURL
 * method: addBulletinUsingPOST_TYPE
 * raw_url: addBulletinUsingPOST_RAW_URL
 * @param bulletinVo - bulletinVo
 * @param name - 
 */
export const addBulletinUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/bulletin'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['bulletinVo'] !== undefined) {
    body = parameters['bulletinVo']
  }
  if (parameters['bulletinVo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: bulletinVo'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addBulletinUsingPOST_RAW_URL = function() {
  return '/api/v1/bulletin'
}
export const addBulletinUsingPOST_TYPE = function() {
  return 'post'
}
export const addBulletinUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/bulletin'
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除所选通知公告，deleteSelectBulletin
 * request: deleteSelectBulletinUsingDELETE
 * url: deleteSelectBulletinUsingDELETEURL
 * method: deleteSelectBulletinUsingDELETE_TYPE
 * raw_url: deleteSelectBulletinUsingDELETE_RAW_URL
 * @param ids - ids
 */
export const deleteSelectBulletinUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/bulletin/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectBulletinUsingDELETE_RAW_URL = function() {
  return '/api/v1/bulletin/delete'
}
export const deleteSelectBulletinUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectBulletinUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/bulletin/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除一条通知公告，deleteBulletin
 * request: deleteBulletinUsingDELETE
 * url: deleteBulletinUsingDELETEURL
 * method: deleteBulletinUsingDELETE_TYPE
 * raw_url: deleteBulletinUsingDELETE_RAW_URL
 * @param id - id
 */
export const deleteBulletinUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/bulletin/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteBulletinUsingDELETE_RAW_URL = function() {
  return '/api/v1/bulletin/delete/{id}'
}
export const deleteBulletinUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteBulletinUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/bulletin/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取要显示的通知公告，getBulletinByDate
 * request: getBulletinByDateUsingGET
 * url: getBulletinByDateUsingGETURL
 * method: getBulletinByDateUsingGET_TYPE
 * raw_url: getBulletinByDateUsingGET_RAW_URL
 */
export const getBulletinByDateUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/bulletin/getbulletinbydate'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getBulletinByDateUsingGET_RAW_URL = function() {
  return '/api/v1/bulletin/getbulletinbydate'
}
export const getBulletinByDateUsingGET_TYPE = function() {
  return 'get'
}
export const getBulletinByDateUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/bulletin/getbulletinbydate'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取要显示的通知公告，getBulletinByDate2
 * request: getBulletinByDate2UsingGET
 * url: getBulletinByDate2UsingGETURL
 * method: getBulletinByDate2UsingGET_TYPE
 * raw_url: getBulletinByDate2UsingGET_RAW_URL
 */
export const getBulletinByDate2UsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/bulletin/getbulletinbydate2'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getBulletinByDate2UsingGET_RAW_URL = function() {
  return '/api/v1/bulletin/getbulletinbydate2'
}
export const getBulletinByDate2UsingGET_TYPE = function() {
  return 'get'
}
export const getBulletinByDate2UsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/bulletin/getbulletinbydate2'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取通知公告列表（分页），getList
 * request: getListUsingPOST
 * url: getListUsingPOSTURL
 * method: getListUsingPOST_TYPE
 * raw_url: getListUsingPOST_RAW_URL
 * @param bulletin - bulletin
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const getListUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/bulletin/getlist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['bulletin'] !== undefined) {
    body = parameters['bulletin']
  }
  if (parameters['bulletin'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: bulletin'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getListUsingPOST_RAW_URL = function() {
  return '/api/v1/bulletin/getlist'
}
export const getListUsingPOST_TYPE = function() {
  return 'post'
}
export const getListUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/bulletin/getlist'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改一条通知公告，updateBulletin
 * request: updateBulletinUsingPOST
 * url: updateBulletinUsingPOSTURL
 * method: updateBulletinUsingPOST_TYPE
 * raw_url: updateBulletinUsingPOST_RAW_URL
 * @param bulletinVo - bulletinVo
 * @param id - id
 */
export const updateBulletinUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/bulletin/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['bulletinVo'] !== undefined) {
    body = parameters['bulletinVo']
  }
  if (parameters['bulletinVo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: bulletinVo'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateBulletinUsingPOST_RAW_URL = function() {
  return '/api/v1/bulletin/update/{id}'
}
export const updateBulletinUsingPOST_TYPE = function() {
  return 'post'
}
export const updateBulletinUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/bulletin/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据id获取一条通知公告，getBulletinById
 * request: getBulletinByIdUsingGET
 * url: getBulletinByIdUsingGETURL
 * method: getBulletinByIdUsingGET_TYPE
 * raw_url: getBulletinByIdUsingGET_RAW_URL
 * @param id - id
 */
export const getBulletinByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/bulletin/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getBulletinByIdUsingGET_RAW_URL = function() {
  return '/api/v1/bulletin/{id}'
}
export const getBulletinByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getBulletinByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/bulletin/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 添加批注，addAppendixRemarks
 * request: addAppendixRemarksUsingPOST
 * url: addAppendixRemarksUsingPOSTURL
 * method: addAppendixRemarksUsingPOST_TYPE
 * raw_url: addAppendixRemarksUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param vo - vo
 */
export const addAppendixRemarksUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/common/{modulename}/appendixremarks'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addAppendixRemarksUsingPOST_RAW_URL = function() {
  return '/api/v1/common/{modulename}/appendixremarks'
}
export const addAppendixRemarksUsingPOST_TYPE = function() {
  return 'post'
}
export const addAppendixRemarksUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/common/{modulename}/appendixremarks'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除一条批注，deleteAppendixRemarks
 * request: deleteAppendixRemarksUsingDELETE
 * url: deleteAppendixRemarksUsingDELETEURL
 * method: deleteAppendixRemarksUsingDELETE_TYPE
 * raw_url: deleteAppendixRemarksUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteAppendixRemarksUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/common/{modulename}/appendixremarks/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteAppendixRemarksUsingDELETE_RAW_URL = function() {
  return '/api/v1/common/{modulename}/appendixremarks/delete/{id}'
}
export const deleteAppendixRemarksUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteAppendixRemarksUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/common/{modulename}/appendixremarks/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据id获取一条批注，getAppendixRemarks
 * request: getAppendixRemarksUsingGET
 * url: getAppendixRemarksUsingGETURL
 * method: getAppendixRemarksUsingGET_TYPE
 * raw_url: getAppendixRemarksUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getAppendixRemarksUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/common/{modulename}/appendixremarks/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAppendixRemarksUsingGET_RAW_URL = function() {
  return '/api/v1/common/{modulename}/appendixremarks/{id}'
}
export const getAppendixRemarksUsingGET_TYPE = function() {
  return 'get'
}
export const getAppendixRemarksUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/common/{modulename}/appendixremarks/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * upload
 * request: uploadUsingPOST
 * url: uploadUsingPOSTURL
 * method: uploadUsingPOST_TYPE
 * raw_url: uploadUsingPOST_RAW_URL
 * @param attachtype - attachtype
 * @param entityid - entityid
 * @param entitytype - entitytype
 * @param file - file
 * @param modulename - modulename
 * @param name - 
 */
export const uploadUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/common/{modulename}/attach/upload/{entitytype}/{entityid}/{attachtype}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{attachtype}', `${parameters['attachtype']}`)
  if (parameters['attachtype'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: attachtype'))
  }
  path = path.replace('{entityid}', `${parameters['entityid']}`)
  if (parameters['entityid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entityid'))
  }
  path = path.replace('{entitytype}', `${parameters['entitytype']}`)
  if (parameters['entitytype'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entitytype'))
  }
  if (parameters['file'] !== undefined) {
    form['file'] = parameters['file']
  }
  if (parameters['file'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: file'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const uploadUsingPOST_RAW_URL = function() {
  return '/api/v1/common/{modulename}/attach/upload/{entitytype}/{entityid}/{attachtype}'
}
export const uploadUsingPOST_TYPE = function() {
  return 'post'
}
export const uploadUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/common/{modulename}/attach/upload/{entitytype}/{entityid}/{attachtype}'
  path = path.replace('{attachtype}', `${parameters['attachtype']}`)
  path = path.replace('{entityid}', `${parameters['entityid']}`)
  path = path.replace('{entitytype}', `${parameters['entitytype']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findByEntityid
 * request: findByEntityidUsingGET
 * url: findByEntityidUsingGETURL
 * method: findByEntityidUsingGET_TYPE
 * raw_url: findByEntityidUsingGET_RAW_URL
 * @param entityid - entityid
 * @param modulename - modulename
 */
export const findByEntityidUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/common/{modulename}/attach/{entityid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{entityid}', `${parameters['entityid']}`)
  if (parameters['entityid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entityid'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const findByEntityidUsingGET_RAW_URL = function() {
  return '/api/v1/common/{modulename}/attach/{entityid}'
}
export const findByEntityidUsingGET_TYPE = function() {
  return 'get'
}
export const findByEntityidUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/common/{modulename}/attach/{entityid}'
  path = path.replace('{entityid}', `${parameters['entityid']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * files
 * request: filesUsingGET
 * url: filesUsingGETURL
 * method: filesUsingGET_TYPE
 * raw_url: filesUsingGET_RAW_URL
 * @param attachtype - attachtype
 * @param entitytype - entitytype
 * @param id - id
 * @param modulename - modulename
 */
export const filesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/common/{modulename}/attach/{entitytype}/{id}/{attachtype}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{attachtype}', `${parameters['attachtype']}`)
  if (parameters['attachtype'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: attachtype'))
  }
  path = path.replace('{entitytype}', `${parameters['entitytype']}`)
  if (parameters['entitytype'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entitytype'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const filesUsingGET_RAW_URL = function() {
  return '/api/v1/common/{modulename}/attach/{entitytype}/{id}/{attachtype}'
}
export const filesUsingGET_TYPE = function() {
  return 'get'
}
export const filesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/common/{modulename}/attach/{entitytype}/{id}/{attachtype}'
  path = path.replace('{attachtype}', `${parameters['attachtype']}`)
  path = path.replace('{entitytype}', `${parameters['entitytype']}`)
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteAttachById
 * request: deleteAttachByIdUsingDELETE
 * url: deleteAttachByIdUsingDELETEURL
 * method: deleteAttachByIdUsingDELETE_TYPE
 * raw_url: deleteAttachByIdUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteAttachByIdUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/common/{modulename}/attach/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteAttachByIdUsingDELETE_RAW_URL = function() {
  return '/api/v1/common/{modulename}/attach/{id}'
}
export const deleteAttachByIdUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteAttachByIdUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/common/{modulename}/attach/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 下载图片附件，download/img
 * request: downloadUsingGET
 * url: downloadUsingGETURL
 * method: downloadUsingGET_TYPE
 * raw_url: downloadUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const downloadUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/common/{modulename}/download/img/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const downloadUsingGET_RAW_URL = function() {
  return '/api/v1/common/{modulename}/download/img/{id}'
}
export const downloadUsingGET_TYPE = function() {
  return 'get'
}
export const downloadUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/common/{modulename}/download/img/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * downloadGet
 * request: downloadGetUsingGET
 * url: downloadGetUsingGETURL
 * method: downloadGetUsingGET_TYPE
 * raw_url: downloadGetUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const downloadGetUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/common/{modulename}/download/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const downloadGetUsingGET_RAW_URL = function() {
  return '/api/v1/common/{modulename}/download/{id}'
}
export const downloadGetUsingGET_TYPE = function() {
  return 'get'
}
export const downloadGetUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/common/{modulename}/download/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * download
 * request: downloadUsingPOST
 * url: downloadUsingPOSTURL
 * method: downloadUsingPOST_TYPE
 * raw_url: downloadUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const downloadUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/common/{modulename}/download/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const downloadUsingPOST_RAW_URL = function() {
  return '/api/v1/common/{modulename}/download/{id}'
}
export const downloadUsingPOST_TYPE = function() {
  return 'post'
}
export const downloadUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/common/{modulename}/download/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * downloadGetThum
 * request: downloadGetThumUsingGET
 * url: downloadGetThumUsingGETURL
 * method: downloadGetThumUsingGET_TYPE
 * raw_url: downloadGetThumUsingGET_RAW_URL
 * @param fileext - fileext
 * @param id - id
 * @param modulename - modulename
 * @param thumb - thumb
 */
export const downloadGetThumUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/common/{modulename}/download/{id}/{fileext}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{fileext}', `${parameters['fileext']}`)
  if (parameters['fileext'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: fileext'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['thumb'] !== undefined) {
    queryParameters['thumb'] = parameters['thumb']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const downloadGetThumUsingGET_RAW_URL = function() {
  return '/api/v1/common/{modulename}/download/{id}/{fileext}'
}
export const downloadGetThumUsingGET_TYPE = function() {
  return 'get'
}
export const downloadGetThumUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/common/{modulename}/download/{id}/{fileext}'
  path = path.replace('{fileext}', `${parameters['fileext']}`)
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['thumb'] !== undefined) {
    queryParameters['thumb'] = parameters['thumb']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * downloadall
 * request: downloadallUsingPOST
 * url: downloadallUsingPOSTURL
 * method: downloadallUsingPOST_TYPE
 * raw_url: downloadallUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const downloadallUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/common/{modulename}/downloadall'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const downloadallUsingPOST_RAW_URL = function() {
  return '/api/v1/common/{modulename}/downloadall'
}
export const downloadallUsingPOST_TYPE = function() {
  return 'post'
}
export const downloadallUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/common/{modulename}/downloadall'
  if (parameters['id'] !== undefined) {
    queryParameters['id'] = parameters['id']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回所有的表信息
 * request: getTablesUsingGET
 * url: getTablesUsingGETURL
 * method: getTablesUsingGET_TYPE
 * raw_url: getTablesUsingGET_RAW_URL
 */
export const getTablesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/db'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTablesUsingGET_RAW_URL = function() {
  return '/api/v1/db'
}
export const getTablesUsingGET_TYPE = function() {
  return 'get'
}
export const getTablesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/db'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回表信息
 * request: getTableUsingGET
 * url: getTableUsingGETURL
 * method: getTableUsingGET_TYPE
 * raw_url: getTableUsingGET_RAW_URL
 * @param tablename - tablename
 */
export const getTableUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/db/{tablename}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{tablename}', `${parameters['tablename']}`)
  if (parameters['tablename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: tablename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTableUsingGET_RAW_URL = function() {
  return '/api/v1/db/{tablename}'
}
export const getTableUsingGET_TYPE = function() {
  return 'get'
}
export const getTableUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/db/{tablename}'
  path = path.replace('{tablename}', `${parameters['tablename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取导入导出的状态  getManagerState
 * request: getManagerStateUsingPOST
 * url: getManagerStateUsingPOSTURL
 * method: getManagerStateUsingPOST_TYPE
 * raw_url: getManagerStateUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getManagerStateUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/ds/{modulename}/state/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getManagerStateUsingPOST_RAW_URL = function() {
  return '/api/v1/ds/{modulename}/state/{id}'
}
export const getManagerStateUsingPOST_TYPE = function() {
  return 'post'
}
export const getManagerStateUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/ds/{modulename}/state/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除多条数据 deleteEntitys
 * request: deleteEntitysUsingDELETE
 * url: deleteEntitysUsingDELETEURL
 * method: deleteEntitysUsingDELETE_TYPE
 * raw_url: deleteEntitysUsingDELETE_RAW_URL
 * @param entrypoint - entrypoint
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteEntitysUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/ds/{modulename}/{entrypoint}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  if (parameters['entrypoint'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entrypoint'))
  }
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteEntitysUsingDELETE_RAW_URL = function() {
  return '/api/v1/ds/{modulename}/{entrypoint}'
}
export const deleteEntitysUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteEntitysUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/ds/{modulename}/{entrypoint}'
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导入数据标题校验 checkUploadExcel
 * request: checkUploadExcelUsingPOST
 * url: checkUploadExcelUsingPOSTURL
 * method: checkUploadExcelUsingPOST_TYPE
 * raw_url: checkUploadExcelUsingPOST_RAW_URL
 * @param attid - attid
 * @param entrypoint - entrypoint
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const checkUploadExcelUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/ds/{modulename}/{entrypoint}/checkupload/{attid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{attid}', `${parameters['attid']}`)
  if (parameters['attid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: attid'))
  }
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  if (parameters['entrypoint'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entrypoint'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const checkUploadExcelUsingPOST_RAW_URL = function() {
  return '/api/v1/ds/{modulename}/{entrypoint}/checkupload/{attid}'
}
export const checkUploadExcelUsingPOST_TYPE = function() {
  return 'post'
}
export const checkUploadExcelUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/ds/{modulename}/{entrypoint}/checkupload/{attid}'
  path = path.replace('{attid}', `${parameters['attid']}`)
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导出 downloadDatafile
 * request: downloadDatafileUsingPOST
 * url: downloadDatafileUsingPOSTURL
 * method: downloadDatafileUsingPOST_TYPE
 * raw_url: downloadDatafileUsingPOST_RAW_URL
 * @param data - data
 * @param entrypoint - entrypoint
 * @param ext - ext
 * @param filename - filename
 * @param modulename - modulename
 * @param name - 
 */
export const downloadDatafileUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/ds/{modulename}/{entrypoint}/download/{filename}.{ext}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    body = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  if (parameters['entrypoint'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entrypoint'))
  }
  path = path.replace('{ext}', `${parameters['ext']}`)
  if (parameters['ext'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: ext'))
  }
  path = path.replace('{filename}', `${parameters['filename']}`)
  if (parameters['filename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: filename'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const downloadDatafileUsingPOST_RAW_URL = function() {
  return '/api/v1/ds/{modulename}/{entrypoint}/download/{filename}.{ext}'
}
export const downloadDatafileUsingPOST_TYPE = function() {
  return 'post'
}
export const downloadDatafileUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/ds/{modulename}/{entrypoint}/download/{filename}.{ext}'
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  path = path.replace('{ext}', `${parameters['ext']}`)
  path = path.replace('{filename}', `${parameters['filename']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 查询 findEntitys
 * request: findEntitysUsingPOST
 * url: findEntitysUsingPOSTURL
 * method: findEntitysUsingPOST_TYPE
 * raw_url: findEntitysUsingPOST_RAW_URL
 * @param data - data
 * @param entrypoint - entrypoint
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findEntitysUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/ds/{modulename}/{entrypoint}/find'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    body = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  if (parameters['entrypoint'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entrypoint'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findEntitysUsingPOST_RAW_URL = function() {
  return '/api/v1/ds/{modulename}/{entrypoint}/find'
}
export const findEntitysUsingPOST_TYPE = function() {
  return 'post'
}
export const findEntitysUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/ds/{modulename}/{entrypoint}/find'
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 查询单条记录 findFirst
 * request: findFirstUsingPOST
 * url: findFirstUsingPOSTURL
 * method: findFirstUsingPOST_TYPE
 * raw_url: findFirstUsingPOST_RAW_URL
 * @param data - data
 * @param entrypoint - entrypoint
 * @param modulename - modulename
 */
export const findFirstUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/ds/{modulename}/{entrypoint}/first'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    body = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  if (parameters['entrypoint'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entrypoint'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findFirstUsingPOST_RAW_URL = function() {
  return '/api/v1/ds/{modulename}/{entrypoint}/first'
}
export const findFirstUsingPOST_TYPE = function() {
  return 'post'
}
export const findFirstUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/ds/{modulename}/{entrypoint}/first'
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 新增多个表数据 addEntitys
 * request: addEntitysUsingPOST
 * url: addEntitysUsingPOSTURL
 * method: addEntitysUsingPOST_TYPE
 * raw_url: addEntitysUsingPOST_RAW_URL
 * @param datalist - datalist
 * @param entrypoint - entrypoint
 * @param modulename - modulename
 */
export const addEntitysUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/ds/{modulename}/{entrypoint}/multi'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['datalist'] !== undefined) {
    body = parameters['datalist']
  }
  if (parameters['datalist'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: datalist'))
  }
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  if (parameters['entrypoint'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entrypoint'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addEntitysUsingPOST_RAW_URL = function() {
  return '/api/v1/ds/{modulename}/{entrypoint}/multi'
}
export const addEntitysUsingPOST_TYPE = function() {
  return 'post'
}
export const addEntitysUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/ds/{modulename}/{entrypoint}/multi'
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 查询多个表数据 getEntities
 * request: getEntitiesUsingPOST
 * url: getEntitiesUsingPOSTURL
 * method: getEntitiesUsingPOST_TYPE
 * raw_url: getEntitiesUsingPOST_RAW_URL
 * @param data - data
 * @param entrypoint - entrypoint
 * @param modulename - modulename
 */
export const getEntitiesUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/ds/{modulename}/{entrypoint}/multiple'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    body = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  if (parameters['entrypoint'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entrypoint'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getEntitiesUsingPOST_RAW_URL = function() {
  return '/api/v1/ds/{modulename}/{entrypoint}/multiple'
}
export const getEntitiesUsingPOST_TYPE = function() {
  return 'post'
}
export const getEntitiesUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/ds/{modulename}/{entrypoint}/multiple'
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 新增单个表数据 addEntity
 * request: addEntityUsingPOST
 * url: addEntityUsingPOSTURL
 * method: addEntityUsingPOST_TYPE
 * raw_url: addEntityUsingPOST_RAW_URL
 * @param data - data
 * @param entrypoint - entrypoint
 * @param modulename - modulename
 */
export const addEntityUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/ds/{modulename}/{entrypoint}/single'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    body = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  if (parameters['entrypoint'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entrypoint'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addEntityUsingPOST_RAW_URL = function() {
  return '/api/v1/ds/{modulename}/{entrypoint}/single'
}
export const addEntityUsingPOST_TYPE = function() {
  return 'post'
}
export const addEntityUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/ds/{modulename}/{entrypoint}/single'
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 基本的返回单个表数据 getEntity
 * request: getEntityUsingGET
 * url: getEntityUsingGETURL
 * method: getEntityUsingGET_TYPE
 * raw_url: getEntityUsingGET_RAW_URL
 * @param entrypoint - entrypoint
 * @param id - id
 * @param modulename - modulename
 */
export const getEntityUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/ds/{modulename}/{entrypoint}/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  if (parameters['entrypoint'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entrypoint'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getEntityUsingGET_RAW_URL = function() {
  return '/api/v1/ds/{modulename}/{entrypoint}/{id}'
}
export const getEntityUsingGET_TYPE = function() {
  return 'get'
}
export const getEntityUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/ds/{modulename}/{entrypoint}/{id}'
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改单个表数据 putEntity
 * request: putEntityUsingPUT
 * url: putEntityUsingPUTURL
 * method: putEntityUsingPUT_TYPE
 * raw_url: putEntityUsingPUT_RAW_URL
 * @param data - data
 * @param entrypoint - entrypoint
 * @param id - id
 * @param modulename - modulename
 */
export const putEntityUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/ds/{modulename}/{entrypoint}/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    body = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  if (parameters['entrypoint'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entrypoint'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const putEntityUsingPUT_RAW_URL = function() {
  return '/api/v1/ds/{modulename}/{entrypoint}/{id}'
}
export const putEntityUsingPUT_TYPE = function() {
  return 'put'
}
export const putEntityUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/ds/{modulename}/{entrypoint}/{id}'
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除数据 deleteEntity
 * request: deleteEntityUsingDELETE
 * url: deleteEntityUsingDELETEURL
 * method: deleteEntityUsingDELETE_TYPE
 * raw_url: deleteEntityUsingDELETE_RAW_URL
 * @param entrypoint - entrypoint
 * @param id - id
 * @param modulename - modulename
 */
export const deleteEntityUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/ds/{modulename}/{entrypoint}/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  if (parameters['entrypoint'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entrypoint'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteEntityUsingDELETE_RAW_URL = function() {
  return '/api/v1/ds/{modulename}/{entrypoint}/{id}'
}
export const deleteEntityUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteEntityUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/ds/{modulename}/{entrypoint}/{id}'
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导入数据 uploadExcel
 * request: uploadExcelUsingPOST
 * url: uploadExcelUsingPOSTURL
 * method: uploadExcelUsingPOST_TYPE
 * raw_url: uploadExcelUsingPOST_RAW_URL
 * @param attid - attid
 * @param entrypoint - entrypoint
 * @param modulename - modulename
 * @param name - 
 * @param projectId - projectId
 * @param vo - vo
 */
export const uploadExcelUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/ds/{modulename}/{projectId}/{entrypoint}/upload/{attid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{attid}', `${parameters['attid']}`)
  if (parameters['attid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: attid'))
  }
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  if (parameters['entrypoint'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: entrypoint'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const uploadExcelUsingPOST_RAW_URL = function() {
  return '/api/v1/ds/{modulename}/{projectId}/{entrypoint}/upload/{attid}'
}
export const uploadExcelUsingPOST_TYPE = function() {
  return 'post'
}
export const uploadExcelUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/ds/{modulename}/{projectId}/{entrypoint}/upload/{attid}'
  path = path.replace('{attid}', `${parameters['attid']}`)
  path = path.replace('{entrypoint}', `${parameters['entrypoint']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 添加审核矩阵, addReviewMatrix
 * request: addReviewMatrixUsingPOST
 * url: addReviewMatrixUsingPOSTURL
 * method: addReviewMatrixUsingPOST_TYPE
 * raw_url: addReviewMatrixUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param projectId - projectId
 * @param vo - vo
 */
export const addReviewMatrixUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/hse/{modulename}/{projectId}/ReviewMatrix/add'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addReviewMatrixUsingPOST_RAW_URL = function() {
  return '/api/v1/hse/{modulename}/{projectId}/ReviewMatrix/add'
}
export const addReviewMatrixUsingPOST_TYPE = function() {
  return 'post'
}
export const addReviewMatrixUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/hse/{modulename}/{projectId}/ReviewMatrix/add'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 审核矩阵列表, findMatDeclarationFormPage
 * request: findReviewMatrixPageUsingPOST
 * url: findReviewMatrixPageUsingPOSTURL
 * method: findReviewMatrixPageUsingPOST_TYPE
 * raw_url: findReviewMatrixPageUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param projectId - projectId
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findReviewMatrixPageUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/hse/{modulename}/{projectId}/ReviewMatrix/datalist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findReviewMatrixPageUsingPOST_RAW_URL = function() {
  return '/api/v1/hse/{modulename}/{projectId}/ReviewMatrix/datalist'
}
export const findReviewMatrixPageUsingPOST_TYPE = function() {
  return 'post'
}
export const findReviewMatrixPageUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/hse/{modulename}/{projectId}/ReviewMatrix/datalist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除审核矩阵, deleteReviewMatrix
 * request: deleteReviewMatrixUsingDELETE
 * url: deleteReviewMatrixUsingDELETEURL
 * method: deleteReviewMatrixUsingDELETE_TYPE
 * raw_url: deleteReviewMatrixUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 * @param projectId - projectId
 */
export const deleteReviewMatrixUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/hse/{modulename}/{projectId}/ReviewMatrix/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteReviewMatrixUsingDELETE_RAW_URL = function() {
  return '/api/v1/hse/{modulename}/{projectId}/ReviewMatrix/delete'
}
export const deleteReviewMatrixUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteReviewMatrixUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/hse/{modulename}/{projectId}/ReviewMatrix/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取审核矩阵, getReviewMatrix
 * request: getReviewMatrixUsingGET
 * url: getReviewMatrixUsingGETURL
 * method: getReviewMatrixUsingGET_TYPE
 * raw_url: getReviewMatrixUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param projectId - projectId
 */
export const getReviewMatrixUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/hse/{modulename}/{projectId}/ReviewMatrix/get/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getReviewMatrixUsingGET_RAW_URL = function() {
  return '/api/v1/hse/{modulename}/{projectId}/ReviewMatrix/get/{id}'
}
export const getReviewMatrixUsingGET_TYPE = function() {
  return 'get'
}
export const getReviewMatrixUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/hse/{modulename}/{projectId}/ReviewMatrix/get/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改审核矩阵, updateReviewMatrix
 * request: updateReviewMatrixUsingPOST
 * url: updateReviewMatrixUsingPOSTURL
 * method: updateReviewMatrixUsingPOST_TYPE
 * raw_url: updateReviewMatrixUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param projectId - projectId
 * @param vo - vo
 */
export const updateReviewMatrixUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/hse/{modulename}/{projectId}/ReviewMatrix/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateReviewMatrixUsingPOST_RAW_URL = function() {
  return '/api/v1/hse/{modulename}/{projectId}/ReviewMatrix/update/{id}'
}
export const updateReviewMatrixUsingPOST_TYPE = function() {
  return 'post'
}
export const updateReviewMatrixUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/hse/{modulename}/{projectId}/ReviewMatrix/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 添加流程表单配置，addWorkflowFormConfig
 * request: addWorkflowFormConfigUsingPOST
 * url: addWorkflowFormConfigUsingPOSTURL
 * method: addWorkflowFormConfigUsingPOST_TYPE
 * raw_url: addWorkflowFormConfigUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param projectId - projectId
 * @param vo - vo
 */
export const addWorkflowFormConfigUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/hse/{modulename}/{projectId}/workflowformconfig/add'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addWorkflowFormConfigUsingPOST_RAW_URL = function() {
  return '/api/v1/hse/{modulename}/{projectId}/workflowformconfig/add'
}
export const addWorkflowFormConfigUsingPOST_TYPE = function() {
  return 'post'
}
export const addWorkflowFormConfigUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/hse/{modulename}/{projectId}/workflowformconfig/add'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 流程表单配置列表，findWorkflowFormConfigPage
 * request: findWorkflowFormConfigPageUsingPOST
 * url: findWorkflowFormConfigPageUsingPOSTURL
 * method: findWorkflowFormConfigPageUsingPOST_TYPE
 * raw_url: findWorkflowFormConfigPageUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param projectId - projectId
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findWorkflowFormConfigPageUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/hse/{modulename}/{projectId}/workflowformconfig/datalist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findWorkflowFormConfigPageUsingPOST_RAW_URL = function() {
  return '/api/v1/hse/{modulename}/{projectId}/workflowformconfig/datalist'
}
export const findWorkflowFormConfigPageUsingPOST_TYPE = function() {
  return 'post'
}
export const findWorkflowFormConfigPageUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/hse/{modulename}/{projectId}/workflowformconfig/datalist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除流程表单配置，deleteWorkflowFormConfig
 * request: deleteWorkflowFormConfigUsingDELETE
 * url: deleteWorkflowFormConfigUsingDELETEURL
 * method: deleteWorkflowFormConfigUsingDELETE_TYPE
 * raw_url: deleteWorkflowFormConfigUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 * @param projectId - projectId
 */
export const deleteWorkflowFormConfigUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/hse/{modulename}/{projectId}/workflowformconfig/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteWorkflowFormConfigUsingDELETE_RAW_URL = function() {
  return '/api/v1/hse/{modulename}/{projectId}/workflowformconfig/delete'
}
export const deleteWorkflowFormConfigUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteWorkflowFormConfigUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/hse/{modulename}/{projectId}/workflowformconfig/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取流程表单配置，getWorkflowFormConfig
 * request: getWorkflowFormConfigUsingGET
 * url: getWorkflowFormConfigUsingGETURL
 * method: getWorkflowFormConfigUsingGET_TYPE
 * raw_url: getWorkflowFormConfigUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param projectId - projectId
 */
export const getWorkflowFormConfigUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/hse/{modulename}/{projectId}/workflowformconfig/get/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWorkflowFormConfigUsingGET_RAW_URL = function() {
  return '/api/v1/hse/{modulename}/{projectId}/workflowformconfig/get/{id}'
}
export const getWorkflowFormConfigUsingGET_TYPE = function() {
  return 'get'
}
export const getWorkflowFormConfigUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/hse/{modulename}/{projectId}/workflowformconfig/get/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改流程表单配置，updateWorkflowFormConfig
 * request: updateWorkflowFormConfigUsingPOST
 * url: updateWorkflowFormConfigUsingPOSTURL
 * method: updateWorkflowFormConfigUsingPOST_TYPE
 * raw_url: updateWorkflowFormConfigUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param projectId - projectId
 * @param vo - vo
 */
export const updateWorkflowFormConfigUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/hse/{modulename}/{projectId}/workflowformconfig/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateWorkflowFormConfigUsingPOST_RAW_URL = function() {
  return '/api/v1/hse/{modulename}/{projectId}/workflowformconfig/update/{id}'
}
export const updateWorkflowFormConfigUsingPOST_TYPE = function() {
  return 'post'
}
export const updateWorkflowFormConfigUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/hse/{modulename}/{projectId}/workflowformconfig/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findLoginDetails
 * request: findLoginDetailsUsingPOST
 * url: findLoginDetailsUsingPOSTURL
 * method: findLoginDetailsUsingPOST_TYPE
 * raw_url: findLoginDetailsUsingPOST_RAW_URL
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findLoginDetailsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/logindetails/getlist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findLoginDetailsUsingPOST_RAW_URL = function() {
  return '/api/v1/logindetails/getlist'
}
export const findLoginDetailsUsingPOST_TYPE = function() {
  return 'post'
}
export const findLoginDetailsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/logindetails/getlist'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * aaa
 * request: aaaUsingGET
 * url: aaaUsingGETURL
 * method: aaaUsingGET_TYPE
 * raw_url: aaaUsingGET_RAW_URL
 * @param token - token
 */
export const aaaUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/notify/aaa'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['token'] !== undefined) {
    body = parameters['token']
  }
  if (parameters['token'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: token'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const aaaUsingGET_RAW_URL = function() {
  return '/api/v1/notify/aaa'
}
export const aaaUsingGET_TYPE = function() {
  return 'get'
}
export const aaaUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/notify/aaa'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 分页显示用户的通知，getList
 * request: getUserNotifyUsingPOST
 * url: getUserNotifyUsingPOSTURL
 * method: getUserNotifyUsingPOST_TYPE
 * raw_url: getUserNotifyUsingPOST_RAW_URL
 * @param name - 
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const getUserNotifyUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/notify/getlist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getUserNotifyUsingPOST_RAW_URL = function() {
  return '/api/v1/notify/getlist'
}
export const getUserNotifyUsingPOST_TYPE = function() {
  return 'post'
}
export const getUserNotifyUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/notify/getlist'
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * BulletinRead
 * request: BulletinReadUsingPOST
 * url: BulletinReadUsingPOSTURL
 * method: BulletinReadUsingPOST_TYPE
 * raw_url: BulletinReadUsingPOST_RAW_URL
 * @param id - id
 * @param name - 
 */
export const BulletinReadUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/notify/read/bulletin/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const BulletinReadUsingPOST_RAW_URL = function() {
  return '/api/v1/notify/read/bulletin/{id}'
}
export const BulletinReadUsingPOST_TYPE = function() {
  return 'post'
}
export const BulletinReadUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/notify/read/bulletin/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * TaskRead
 * request: TaskReadUsingPOST
 * url: TaskReadUsingPOSTURL
 * method: TaskReadUsingPOST_TYPE
 * raw_url: TaskReadUsingPOST_RAW_URL
 * @param id - id
 * @param name - 
 */
export const TaskReadUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/notify/read/task/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const TaskReadUsingPOST_RAW_URL = function() {
  return '/api/v1/notify/read/task/{id}'
}
export const TaskReadUsingPOST_TYPE = function() {
  return 'post'
}
export const TaskReadUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/notify/read/task/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * test
 * request: testUsingGET_1
 * url: testUsingGET_1URL
 * method: testUsingGET_1_TYPE
 * raw_url: testUsingGET_1_RAW_URL
 */
export const testUsingGET_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/notify/test'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const testUsingGET_1_RAW_URL = function() {
  return '/api/v1/notify/test'
}
export const testUsingGET_1_TYPE = function() {
  return 'get'
}
export const testUsingGET_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/notify/test'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * unread
 * request: unreadUsingGET
 * url: unreadUsingGETURL
 * method: unreadUsingGET_TYPE
 * raw_url: unreadUsingGET_RAW_URL
 * @param name - 
 */
export const unreadUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/notify/unread'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const unreadUsingGET_RAW_URL = function() {
  return '/api/v1/notify/unread'
}
export const unreadUsingGET_TYPE = function() {
  return 'get'
}
export const unreadUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/notify/unread'
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * UnreadAllCount
 * request: UnreadAllCountUsingGET
 * url: UnreadAllCountUsingGETURL
 * method: UnreadAllCountUsingGET_TYPE
 * raw_url: UnreadAllCountUsingGET_RAW_URL
 * @param name - 
 */
export const UnreadAllCountUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/notify/unreadallcount'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const UnreadAllCountUsingGET_RAW_URL = function() {
  return '/api/v1/notify/unreadallcount'
}
export const UnreadAllCountUsingGET_TYPE = function() {
  return 'get'
}
export const UnreadAllCountUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/notify/unreadallcount'
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * UnreadAnnounceCount
 * request: UnreadAnnounceCountUsingGET
 * url: UnreadAnnounceCountUsingGETURL
 * method: UnreadAnnounceCountUsingGET_TYPE
 * raw_url: UnreadAnnounceCountUsingGET_RAW_URL
 * @param name - 
 */
export const UnreadAnnounceCountUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/notify/unreadannouncecount'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const UnreadAnnounceCountUsingGET_RAW_URL = function() {
  return '/api/v1/notify/unreadannouncecount'
}
export const UnreadAnnounceCountUsingGET_TYPE = function() {
  return 'get'
}
export const UnreadAnnounceCountUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/notify/unreadannouncecount'
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * UnreadBulletinCount
 * request: UnreadBulletinCountUsingGET
 * url: UnreadBulletinCountUsingGETURL
 * method: UnreadBulletinCountUsingGET_TYPE
 * raw_url: UnreadBulletinCountUsingGET_RAW_URL
 * @param name - 
 */
export const UnreadBulletinCountUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/notify/unreadbulletincount'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const UnreadBulletinCountUsingGET_RAW_URL = function() {
  return '/api/v1/notify/unreadbulletincount'
}
export const UnreadBulletinCountUsingGET_TYPE = function() {
  return 'get'
}
export const UnreadBulletinCountUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/notify/unreadbulletincount'
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * UnreadTaskCount
 * request: UnreadTaskCountUsingGET
 * url: UnreadTaskCountUsingGETURL
 * method: UnreadTaskCountUsingGET_TYPE
 * raw_url: UnreadTaskCountUsingGET_RAW_URL
 * @param name - 
 */
export const UnreadTaskCountUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/notify/unreadtaskcount'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const UnreadTaskCountUsingGET_RAW_URL = function() {
  return '/api/v1/notify/unreadtaskcount'
}
export const UnreadTaskCountUsingGET_TYPE = function() {
  return 'get'
}
export const UnreadTaskCountUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/notify/unreadtaskcount'
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 添加编码规则，addCodeRule
 * request: addCodeRuleUsingPOST
 * url: addCodeRuleUsingPOSTURL
 * method: addCodeRuleUsingPOST_TYPE
 * raw_url: addCodeRuleUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param principal - 
 * @param projectId - projectId
 * @param vo - vo
 */
export const addCodeRuleUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRule/add'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addCodeRuleUsingPOST_RAW_URL = function() {
  return '/api/v1/pg/{modulename}/{projectId}/CodeRule/add'
}
export const addCodeRuleUsingPOST_TYPE = function() {
  return 'post'
}
export const addCodeRuleUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRule/add'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 编码规则列表，findCodeRulePage
 * request: findCodeRulePageUsingPOST
 * url: findCodeRulePageUsingPOSTURL
 * method: findCodeRulePageUsingPOST_TYPE
 * raw_url: findCodeRulePageUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param projectId - projectId
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findCodeRulePageUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRule/datalist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findCodeRulePageUsingPOST_RAW_URL = function() {
  return '/api/v1/pg/{modulename}/{projectId}/CodeRule/datalist'
}
export const findCodeRulePageUsingPOST_TYPE = function() {
  return 'post'
}
export const findCodeRulePageUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRule/datalist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除编码规则，deleteCodeRule
 * request: deleteCodeRuleUsingDELETE
 * url: deleteCodeRuleUsingDELETEURL
 * method: deleteCodeRuleUsingDELETE_TYPE
 * raw_url: deleteCodeRuleUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 * @param projectId - projectId
 */
export const deleteCodeRuleUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRule/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteCodeRuleUsingDELETE_RAW_URL = function() {
  return '/api/v1/pg/{modulename}/{projectId}/CodeRule/delete'
}
export const deleteCodeRuleUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteCodeRuleUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRule/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取编码规则，getCodeRule
 * request: getCodeRuleUsingGET
 * url: getCodeRuleUsingGETURL
 * method: getCodeRuleUsingGET_TYPE
 * raw_url: getCodeRuleUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param projectId - projectId
 */
export const getCodeRuleUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRule/get/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCodeRuleUsingGET_RAW_URL = function() {
  return '/api/v1/pg/{modulename}/{projectId}/CodeRule/get/{id}'
}
export const getCodeRuleUsingGET_TYPE = function() {
  return 'get'
}
export const getCodeRuleUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRule/get/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Doc获取最大编号，getMaxCode
 * request: getDocMaxCodeUsingPOST
 * url: getDocMaxCodeUsingPOSTURL
 * method: getDocMaxCodeUsingPOST_TYPE
 * raw_url: getDocMaxCodeUsingPOST_RAW_URL
 * @param beanId - beanId
 * @param docFormId - docFormId
 * @param docTypeId - docTypeId
 * @param modulename - modulename
 * @param projectId - projectId
 * @param vo - vo
 */
export const getDocMaxCodeUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRule/getcode/{docFormId}/{docTypeId}/{beanId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{beanId}', `${parameters['beanId']}`)
  if (parameters['beanId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: beanId'))
  }
  path = path.replace('{docFormId}', `${parameters['docFormId']}`)
  if (parameters['docFormId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: docFormId'))
  }
  path = path.replace('{docTypeId}', `${parameters['docTypeId']}`)
  if (parameters['docTypeId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: docTypeId'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getDocMaxCodeUsingPOST_RAW_URL = function() {
  return '/api/v1/pg/{modulename}/{projectId}/CodeRule/getcode/{docFormId}/{docTypeId}/{beanId}'
}
export const getDocMaxCodeUsingPOST_TYPE = function() {
  return 'post'
}
export const getDocMaxCodeUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRule/getcode/{docFormId}/{docTypeId}/{beanId}'
  path = path.replace('{beanId}', `${parameters['beanId']}`)
  path = path.replace('{docFormId}', `${parameters['docFormId']}`)
  path = path.replace('{docTypeId}', `${parameters['docTypeId']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取最大编号，getMaxCode
 * request: getMaxCodeUsingPOST
 * url: getMaxCodeUsingPOSTURL
 * method: getMaxCodeUsingPOST_TYPE
 * raw_url: getMaxCodeUsingPOST_RAW_URL
 * @param beanId - beanId
 * @param modulename - modulename
 * @param projectId - projectId
 * @param ruleCode - ruleCode
 * @param vo - vo
 */
export const getMaxCodeUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRule/getcode/{ruleCode}/{beanId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{beanId}', `${parameters['beanId']}`)
  if (parameters['beanId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: beanId'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  path = path.replace('{ruleCode}', `${parameters['ruleCode']}`)
  if (parameters['ruleCode'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: ruleCode'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getMaxCodeUsingPOST_RAW_URL = function() {
  return '/api/v1/pg/{modulename}/{projectId}/CodeRule/getcode/{ruleCode}/{beanId}'
}
export const getMaxCodeUsingPOST_TYPE = function() {
  return 'post'
}
export const getMaxCodeUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRule/getcode/{ruleCode}/{beanId}'
  path = path.replace('{beanId}', `${parameters['beanId']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  path = path.replace('{ruleCode}', `${parameters['ruleCode']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改编码规则，updateCodeRule
 * request: updateCodeRuleUsingPOST
 * url: updateCodeRuleUsingPOSTURL
 * method: updateCodeRuleUsingPOST_TYPE
 * raw_url: updateCodeRuleUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param projectId - projectId
 * @param vo - vo
 */
export const updateCodeRuleUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRule/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateCodeRuleUsingPOST_RAW_URL = function() {
  return '/api/v1/pg/{modulename}/{projectId}/CodeRule/update/{id}'
}
export const updateCodeRuleUsingPOST_TYPE = function() {
  return 'post'
}
export const updateCodeRuleUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRule/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 添加编码规则明细，addCodeRuleItem
 * request: addCodeRuleItemUsingPOST
 * url: addCodeRuleItemUsingPOSTURL
 * method: addCodeRuleItemUsingPOST_TYPE
 * raw_url: addCodeRuleItemUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param mainId - mainId
 * @param modulename - modulename
 * @param principal - 
 * @param projectId - projectId
 * @param vo - vo
 */
export const addCodeRuleItemUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRuleItem/add/{mainId}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{mainId}', `${parameters['mainId']}`)
  if (parameters['mainId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mainId'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addCodeRuleItemUsingPOST_RAW_URL = function() {
  return '/api/v1/pg/{modulename}/{projectId}/CodeRuleItem/add/{mainId}'
}
export const addCodeRuleItemUsingPOST_TYPE = function() {
  return 'post'
}
export const addCodeRuleItemUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRuleItem/add/{mainId}'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{mainId}', `${parameters['mainId']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 编码规则明细列表，findCodeRuleItemPage
 * request: findCodeRuleItemPageUsingPOST
 * url: findCodeRuleItemPageUsingPOSTURL
 * method: findCodeRuleItemPageUsingPOST_TYPE
 * raw_url: findCodeRuleItemPageUsingPOST_RAW_URL
 * @param mainId - mainId
 * @param modulename - modulename
 * @param page - 请求页数
 * @param projectId - projectId
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findCodeRuleItemPageUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRuleItem/datalist/{mainId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{mainId}', `${parameters['mainId']}`)
  if (parameters['mainId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mainId'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findCodeRuleItemPageUsingPOST_RAW_URL = function() {
  return '/api/v1/pg/{modulename}/{projectId}/CodeRuleItem/datalist/{mainId}'
}
export const findCodeRuleItemPageUsingPOST_TYPE = function() {
  return 'post'
}
export const findCodeRuleItemPageUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRuleItem/datalist/{mainId}'
  path = path.replace('{mainId}', `${parameters['mainId']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除编码规则明细，deleteCodeRuleItem
 * request: deleteCodeRuleItemUsingDELETE
 * url: deleteCodeRuleItemUsingDELETEURL
 * method: deleteCodeRuleItemUsingDELETE_TYPE
 * raw_url: deleteCodeRuleItemUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 * @param projectId - projectId
 */
export const deleteCodeRuleItemUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRuleItem/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteCodeRuleItemUsingDELETE_RAW_URL = function() {
  return '/api/v1/pg/{modulename}/{projectId}/CodeRuleItem/delete'
}
export const deleteCodeRuleItemUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteCodeRuleItemUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRuleItem/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取编码规则明细，getCodeRuleItem
 * request: getCodeRuleItemUsingGET
 * url: getCodeRuleItemUsingGETURL
 * method: getCodeRuleItemUsingGET_TYPE
 * raw_url: getCodeRuleItemUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param projectId - projectId
 */
export const getCodeRuleItemUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRuleItem/get/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCodeRuleItemUsingGET_RAW_URL = function() {
  return '/api/v1/pg/{modulename}/{projectId}/CodeRuleItem/get/{id}'
}
export const getCodeRuleItemUsingGET_TYPE = function() {
  return 'get'
}
export const getCodeRuleItemUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRuleItem/get/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改编码规则明细，updateCodeRuleItem
 * request: updateCodeRuleItemUsingPOST
 * url: updateCodeRuleItemUsingPOSTURL
 * method: updateCodeRuleItemUsingPOST_TYPE
 * raw_url: updateCodeRuleItemUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param projectId - projectId
 * @param vo - vo
 */
export const updateCodeRuleItemUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRuleItem/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters['projectId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: projectId'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateCodeRuleItemUsingPOST_RAW_URL = function() {
  return '/api/v1/pg/{modulename}/{projectId}/CodeRuleItem/update/{id}'
}
export const updateCodeRuleItemUsingPOST_TYPE = function() {
  return 'post'
}
export const updateCodeRuleItemUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/pg/{modulename}/{projectId}/CodeRuleItem/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{projectId}', `${parameters['projectId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addDataDetails
 * request: addDataDetailsUsingPOST
 * url: addDataDetailsUsingPOSTURL
 * method: addDataDetailsUsingPOST_TYPE
 * raw_url: addDataDetailsUsingPOST_RAW_URL
 * @param datadetails - datadetails
 */
export const addDataDetailsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/adddatadetail'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['datadetails'] !== undefined) {
    body = parameters['datadetails']
  }
  if (parameters['datadetails'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: datadetails'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addDataDetailsUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/adddatadetail'
}
export const addDataDetailsUsingPOST_TYPE = function() {
  return 'post'
}
export const addDataDetailsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/adddatadetail'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addDataSummary
 * request: addDataSummaryUsingPOST_1
 * url: addDataSummaryUsingPOST_1URL
 * method: addDataSummaryUsingPOST_1_TYPE
 * raw_url: addDataSummaryUsingPOST_1_RAW_URL
 * @param chartid - chartid
 * @param map - map
 */
export const addDataSummaryUsingPOST_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/adddatasummary/{chartid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{chartid}', `${parameters['chartid']}`)
  if (parameters['chartid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: chartid'))
  }
  if (parameters['map'] !== undefined) {
    body = parameters['map']
  }
  if (parameters['map'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: map'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addDataSummaryUsingPOST_1_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/adddatasummary/{chartid}'
}
export const addDataSummaryUsingPOST_1_TYPE = function() {
  return 'post'
}
export const addDataSummaryUsingPOST_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/adddatasummary/{chartid}'
  path = path.replace('{chartid}', `${parameters['chartid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addResource
 * request: addResourceUsingPOST
 * url: addResourceUsingPOSTURL
 * method: addResourceUsingPOST_TYPE
 * raw_url: addResourceUsingPOST_RAW_URL
 * @param resource - resource
 */
export const addResourceUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/addresource'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['resource'] !== undefined) {
    body = parameters['resource']
  }
  if (parameters['resource'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: resource'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addResourceUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/addresource'
}
export const addResourceUsingPOST_TYPE = function() {
  return 'post'
}
export const addResourceUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/addresource'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addResourceDetails
 * request: addResourceDetailsUsingPOST
 * url: addResourceDetailsUsingPOSTURL
 * method: addResourceDetailsUsingPOST_TYPE
 * raw_url: addResourceDetailsUsingPOST_RAW_URL
 * @param resourceDetails - resourceDetails
 */
export const addResourceDetailsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/addresourcedetails'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['resourceDetails'] !== undefined) {
    body = parameters['resourceDetails']
  }
  if (parameters['resourceDetails'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: resourceDetails'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addResourceDetailsUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/addresourcedetails'
}
export const addResourceDetailsUsingPOST_TYPE = function() {
  return 'post'
}
export const addResourceDetailsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/addresourcedetails'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addChartDefine
 * request: addChartDefineUsingPOST
 * url: addChartDefineUsingPOSTURL
 * method: addChartDefineUsingPOST_TYPE
 * raw_url: addChartDefineUsingPOST_RAW_URL
 * @param chartdefine - chartdefine
 */
export const addChartDefineUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/chartdefine'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['chartdefine'] !== undefined) {
    body = parameters['chartdefine']
  }
  if (parameters['chartdefine'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: chartdefine'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addChartDefineUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/chartdefine'
}
export const addChartDefineUsingPOST_TYPE = function() {
  return 'post'
}
export const addChartDefineUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/chartdefine'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectChartDefine
 * request: deleteSelectChartDefineUsingDELETE
 * url: deleteSelectChartDefineUsingDELETEURL
 * method: deleteSelectChartDefineUsingDELETE_TYPE
 * raw_url: deleteSelectChartDefineUsingDELETE_RAW_URL
 * @param ids - ids
 */
export const deleteSelectChartDefineUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/chartdefine/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectChartDefineUsingDELETE_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/chartdefine/'
}
export const deleteSelectChartDefineUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectChartDefineUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/chartdefine/'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findChartDefines
 * request: findChartDefinesUsingPOST
 * url: findChartDefinesUsingPOSTURL
 * method: findChartDefinesUsingPOST_TYPE
 * raw_url: findChartDefinesUsingPOST_RAW_URL
 * @param chartdefineparam - chartdefineparam
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findChartDefinesUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/chartdefine/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['chartdefineparam'] !== undefined) {
    body = parameters['chartdefineparam']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findChartDefinesUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/chartdefine/search'
}
export const findChartDefinesUsingPOST_TYPE = function() {
  return 'post'
}
export const findChartDefinesUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/chartdefine/search'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getChartDefine
 * request: getChartDefineUsingGET
 * url: getChartDefineUsingGETURL
 * method: getChartDefineUsingGET_TYPE
 * raw_url: getChartDefineUsingGET_RAW_URL
 * @param id - id
 */
export const getChartDefineUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/chartdefine/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getChartDefineUsingGET_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/chartdefine/{id}'
}
export const getChartDefineUsingGET_TYPE = function() {
  return 'get'
}
export const getChartDefineUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/chartdefine/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateChartDefine
 * request: updateChartDefineUsingPOST
 * url: updateChartDefineUsingPOSTURL
 * method: updateChartDefineUsingPOST_TYPE
 * raw_url: updateChartDefineUsingPOST_RAW_URL
 * @param chartdefine - chartdefine
 * @param id - id
 */
export const updateChartDefineUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/chartdefine/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['chartdefine'] !== undefined) {
    body = parameters['chartdefine']
  }
  if (parameters['chartdefine'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: chartdefine'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateChartDefineUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/chartdefine/{id}'
}
export const updateChartDefineUsingPOST_TYPE = function() {
  return 'post'
}
export const updateChartDefineUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/chartdefine/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteChartDefine
 * request: deleteChartDefineUsingDELETE
 * url: deleteChartDefineUsingDELETEURL
 * method: deleteChartDefineUsingDELETE_TYPE
 * raw_url: deleteChartDefineUsingDELETE_RAW_URL
 * @param id - id
 */
export const deleteChartDefineUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/chartdefine/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteChartDefineUsingDELETE_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/chartdefine/{id}'
}
export const deleteChartDefineUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteChartDefineUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/chartdefine/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectDataDetails
 * request: deleteSelectDataDetailsUsingDELETE
 * url: deleteSelectDataDetailsUsingDELETEURL
 * method: deleteSelectDataDetailsUsingDELETE_TYPE
 * raw_url: deleteSelectDataDetailsUsingDELETE_RAW_URL
 * @param ids - ids
 */
export const deleteSelectDataDetailsUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/datadetail/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectDataDetailsUsingDELETE_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/datadetail/'
}
export const deleteSelectDataDetailsUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectDataDetailsUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/datadetail/'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findDataDetails
 * request: findDataDetailsUsingPOST
 * url: findDataDetailsUsingPOSTURL
 * method: findDataDetailsUsingPOST_TYPE
 * raw_url: findDataDetailsUsingPOST_RAW_URL
 * @param datadetailsparam - datadetailsparam
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findDataDetailsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/datadetail/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['datadetailsparam'] !== undefined) {
    body = parameters['datadetailsparam']
  }
  if (parameters['datadetailsparam'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: datadetailsparam'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findDataDetailsUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/datadetail/search'
}
export const findDataDetailsUsingPOST_TYPE = function() {
  return 'post'
}
export const findDataDetailsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/datadetail/search'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * vTos
 * request: vTosUsingGET
 * url: vTosUsingGETURL
 * method: vTosUsingGET_TYPE
 * raw_url: vTosUsingGET_RAW_URL
 * @param chartid - chartid
 * @param local - local
 * @param stype - stype
 */
export const vTosUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/datadetail/{chartid}/{stype}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{chartid}', `${parameters['chartid']}`)
  if (parameters['chartid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: chartid'))
  }
  if (parameters['local'] !== undefined) {
    queryParameters['local'] = parameters['local']
  }
  path = path.replace('{stype}', `${parameters['stype']}`)
  if (parameters['stype'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: stype'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const vTosUsingGET_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/datadetail/{chartid}/{stype}'
}
export const vTosUsingGET_TYPE = function() {
  return 'get'
}
export const vTosUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/datadetail/{chartid}/{stype}'
  path = path.replace('{chartid}', `${parameters['chartid']}`)
  if (parameters['local'] !== undefined) {
    queryParameters['local'] = parameters['local']
  }
  path = path.replace('{stype}', `${parameters['stype']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getDataDetailse
 * request: getDataDetailseUsingGET
 * url: getDataDetailseUsingGETURL
 * method: getDataDetailseUsingGET_TYPE
 * raw_url: getDataDetailseUsingGET_RAW_URL
 * @param id - id
 */
export const getDataDetailseUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/datadetail/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDataDetailseUsingGET_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/datadetail/{id}'
}
export const getDataDetailseUsingGET_TYPE = function() {
  return 'get'
}
export const getDataDetailseUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/datadetail/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteDataDetails
 * request: deleteDataDetailsUsingDELETE
 * url: deleteDataDetailsUsingDELETEURL
 * method: deleteDataDetailsUsingDELETE_TYPE
 * raw_url: deleteDataDetailsUsingDELETE_RAW_URL
 * @param id - id
 */
export const deleteDataDetailsUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/datadetail/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteDataDetailsUsingDELETE_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/datadetail/{id}'
}
export const deleteDataDetailsUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteDataDetailsUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/datadetail/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addDataSummary
 * request: addDataSummaryUsingPOST
 * url: addDataSummaryUsingPOSTURL
 * method: addDataSummaryUsingPOST_TYPE
 * raw_url: addDataSummaryUsingPOST_RAW_URL
 * @param datasummary - datasummary
 */
export const addDataSummaryUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/datasummary'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['datasummary'] !== undefined) {
    body = parameters['datasummary']
  }
  if (parameters['datasummary'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: datasummary'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addDataSummaryUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/datasummary'
}
export const addDataSummaryUsingPOST_TYPE = function() {
  return 'post'
}
export const addDataSummaryUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/datasummary'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectDataSummary
 * request: deleteSelectDataSummaryUsingDELETE
 * url: deleteSelectDataSummaryUsingDELETEURL
 * method: deleteSelectDataSummaryUsingDELETE_TYPE
 * raw_url: deleteSelectDataSummaryUsingDELETE_RAW_URL
 * @param ids - ids
 */
export const deleteSelectDataSummaryUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/datasummary/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectDataSummaryUsingDELETE_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/datasummary/'
}
export const deleteSelectDataSummaryUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectDataSummaryUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/datasummary/'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findDataSummary
 * request: findDataSummaryUsingPOST
 * url: findDataSummaryUsingPOSTURL
 * method: findDataSummaryUsingPOST_TYPE
 * raw_url: findDataSummaryUsingPOST_RAW_URL
 * @param datasummaryparam - datasummaryparam
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findDataSummaryUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/datasummary/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['datasummaryparam'] !== undefined) {
    body = parameters['datasummaryparam']
  }
  if (parameters['datasummaryparam'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: datasummaryparam'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findDataSummaryUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/datasummary/search'
}
export const findDataSummaryUsingPOST_TYPE = function() {
  return 'post'
}
export const findDataSummaryUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/datasummary/search'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getDataSummary
 * request: getDataSummaryUsingGET
 * url: getDataSummaryUsingGETURL
 * method: getDataSummaryUsingGET_TYPE
 * raw_url: getDataSummaryUsingGET_RAW_URL
 * @param id - id
 */
export const getDataSummaryUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/datasummary/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDataSummaryUsingGET_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/datasummary/{id}'
}
export const getDataSummaryUsingGET_TYPE = function() {
  return 'get'
}
export const getDataSummaryUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/datasummary/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateDataSummary
 * request: updateDataSummaryUsingPOST
 * url: updateDataSummaryUsingPOSTURL
 * method: updateDataSummaryUsingPOST_TYPE
 * raw_url: updateDataSummaryUsingPOST_RAW_URL
 * @param datasummary - datasummary
 * @param id - id
 */
export const updateDataSummaryUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/datasummary/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['datasummary'] !== undefined) {
    body = parameters['datasummary']
  }
  if (parameters['datasummary'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: datasummary'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateDataSummaryUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/datasummary/{id}'
}
export const updateDataSummaryUsingPOST_TYPE = function() {
  return 'post'
}
export const updateDataSummaryUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/datasummary/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteDataSummary
 * request: deleteDataSummaryUsingDELETE
 * url: deleteDataSummaryUsingDELETEURL
 * method: deleteDataSummaryUsingDELETE_TYPE
 * raw_url: deleteDataSummaryUsingDELETE_RAW_URL
 * @param id - id
 */
export const deleteDataSummaryUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/datasummary/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteDataSummaryUsingDELETE_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/datasummary/{id}'
}
export const deleteDataSummaryUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteDataSummaryUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/datasummary/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteResource
 * request: deleteResourceUsingDELETE
 * url: deleteResourceUsingDELETEURL
 * method: deleteResourceUsingDELETE_TYPE
 * raw_url: deleteResourceUsingDELETE_RAW_URL
 * @param id - id
 */
export const deleteResourceUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/deleteresource/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteResourceUsingDELETE_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/deleteresource/{id}'
}
export const deleteResourceUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteResourceUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/deleteresource/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteResourceDetails
 * request: deleteResourceDetailsUsingDELETE
 * url: deleteResourceDetailsUsingDELETEURL
 * method: deleteResourceDetailsUsingDELETE_TYPE
 * raw_url: deleteResourceDetailsUsingDELETE_RAW_URL
 * @param id - id
 */
export const deleteResourceDetailsUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/deleteresourcedetails/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteResourceDetailsUsingDELETE_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/deleteresourcedetails/{id}'
}
export const deleteResourceDetailsUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteResourceDetailsUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/deleteresourcedetails/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getOneResource
 * request: getOneResourceUsingGET
 * url: getOneResourceUsingGETURL
 * method: getOneResourceUsingGET_TYPE
 * raw_url: getOneResourceUsingGET_RAW_URL
 * @param id - id
 */
export const getOneResourceUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/getoneresource/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getOneResourceUsingGET_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/getoneresource/{id}'
}
export const getOneResourceUsingGET_TYPE = function() {
  return 'get'
}
export const getOneResourceUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/getoneresource/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * update
 * request: updateUsingPOST
 * url: updateUsingPOSTURL
 * method: updateUsingPOST_TYPE
 * raw_url: updateUsingPOST_RAW_URL
 * @param map - map
 */
export const updateUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/myset/update'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['map'] !== undefined) {
    body = parameters['map']
  }
  if (parameters['map'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: map'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/myset/update'
}
export const updateUsingPOST_TYPE = function() {
  return 'post'
}
export const updateUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/myset/update'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * servedetail
 * request: servedetailUsingGET_1
 * url: servedetailUsingGET_1URL
 * method: servedetailUsingGET_1_TYPE
 * raw_url: servedetailUsingGET_1_RAW_URL
 * @param chartid - chartid
 */
export const servedetailUsingGET_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/resource/{chartid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{chartid}', `${parameters['chartid']}`)
  if (parameters['chartid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: chartid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const servedetailUsingGET_1_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/resource/{chartid}'
}
export const servedetailUsingGET_1_TYPE = function() {
  return 'get'
}
export const servedetailUsingGET_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/resource/{chartid}'
  path = path.replace('{chartid}', `${parameters['chartid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * servedata
 * request: servedataUsingGET
 * url: servedataUsingGETURL
 * method: servedataUsingGET_TYPE
 * raw_url: servedataUsingGET_RAW_URL
 * @param chartid - chartid
 * @param local - local
 */
export const servedataUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/servedata/{chartid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{chartid}', `${parameters['chartid']}`)
  if (parameters['chartid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: chartid'))
  }
  if (parameters['local'] !== undefined) {
    queryParameters['local'] = parameters['local']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const servedataUsingGET_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/servedata/{chartid}'
}
export const servedataUsingGET_TYPE = function() {
  return 'get'
}
export const servedataUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/servedata/{chartid}'
  path = path.replace('{chartid}', `${parameters['chartid']}`)
  if (parameters['local'] !== undefined) {
    queryParameters['local'] = parameters['local']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * servedata2
 * request: servedata2UsingGET
 * url: servedata2UsingGETURL
 * method: servedata2UsingGET_TYPE
 * raw_url: servedata2UsingGET_RAW_URL
 * @param chartid - chartid
 */
export const servedata2UsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/servedata2/{chartid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{chartid}', `${parameters['chartid']}`)
  if (parameters['chartid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: chartid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const servedata2UsingGET_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/servedata2/{chartid}'
}
export const servedata2UsingGET_TYPE = function() {
  return 'get'
}
export const servedata2UsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/servedata2/{chartid}'
  path = path.replace('{chartid}', `${parameters['chartid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * servedetail
 * request: servedetailUsingGET
 * url: servedetailUsingGETURL
 * method: servedetailUsingGET_TYPE
 * raw_url: servedetailUsingGET_RAW_URL
 * @param chartid - chartid
 * @param dataindex - dataindex
 * @param stype - stype
 */
export const servedetailUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/servicedetails/{chartid}/{stype}/{dataindex}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{chartid}', `${parameters['chartid']}`)
  if (parameters['chartid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: chartid'))
  }
  path = path.replace('{dataindex}', `${parameters['dataindex']}`)
  if (parameters['dataindex'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dataindex'))
  }
  path = path.replace('{stype}', `${parameters['stype']}`)
  if (parameters['stype'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: stype'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const servedetailUsingGET_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/servicedetails/{chartid}/{stype}/{dataindex}'
}
export const servedetailUsingGET_TYPE = function() {
  return 'get'
}
export const servedetailUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/servicedetails/{chartid}/{stype}/{dataindex}'
  path = path.replace('{chartid}', `${parameters['chartid']}`)
  path = path.replace('{dataindex}', `${parameters['dataindex']}`)
  path = path.replace('{stype}', `${parameters['stype']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * servedetail2
 * request: servedetail2UsingPOST
 * url: servedetail2UsingPOSTURL
 * method: servedetail2UsingPOST_TYPE
 * raw_url: servedetail2UsingPOST_RAW_URL
 * @param dataDetails - dataDetails
 */
export const servedetail2UsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/servicedetails2'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['dataDetails'] !== undefined) {
    body = parameters['dataDetails']
  }
  if (parameters['dataDetails'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dataDetails'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const servedetail2UsingPOST_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/servicedetails2'
}
export const servedetail2UsingPOST_TYPE = function() {
  return 'post'
}
export const servedetail2UsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/servicedetails2'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateDataDetails
 * request: updateDataDetailsUsingPOST
 * url: updateDataDetailsUsingPOSTURL
 * method: updateDataDetailsUsingPOST_TYPE
 * raw_url: updateDataDetailsUsingPOST_RAW_URL
 * @param datadetails - datadetails
 * @param id - id
 */
export const updateDataDetailsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/updatedatadetail/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['datadetails'] !== undefined) {
    body = parameters['datadetails']
  }
  if (parameters['datadetails'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: datadetails'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateDataDetailsUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/updatedatadetail/{id}'
}
export const updateDataDetailsUsingPOST_TYPE = function() {
  return 'post'
}
export const updateDataDetailsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/updatedatadetail/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateResource
 * request: updateResourceUsingPOST
 * url: updateResourceUsingPOSTURL
 * method: updateResourceUsingPOST_TYPE
 * raw_url: updateResourceUsingPOST_RAW_URL
 * @param resource - resource
 */
export const updateResourceUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/updateresource/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['resource'] !== undefined) {
    body = parameters['resource']
  }
  if (parameters['resource'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: resource'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateResourceUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/updateresource/{id}'
}
export const updateResourceUsingPOST_TYPE = function() {
  return 'post'
}
export const updateResourceUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/updateresource/{id}'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateResourceDetails
 * request: updateResourceDetailsUsingPOST
 * url: updateResourceDetailsUsingPOSTURL
 * method: updateResourceDetailsUsingPOST_TYPE
 * raw_url: updateResourceDetailsUsingPOST_RAW_URL
 * @param resourceDetails - resourceDetails
 */
export const updateResourceDetailsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/updateresourcedetails/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['resourceDetails'] !== undefined) {
    body = parameters['resourceDetails']
  }
  if (parameters['resourceDetails'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: resourceDetails'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateResourceDetailsUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/updateresourcedetails/{id}'
}
export const updateResourceDetailsUsingPOST_TYPE = function() {
  return 'post'
}
export const updateResourceDetailsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/updateresourcedetails/{id}'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * uploadImage
 * request: uploadImageUsingPOST
 * url: uploadImageUsingPOSTURL
 * method: uploadImageUsingPOST_TYPE
 * raw_url: uploadImageUsingPOST_RAW_URL
 * @param file - file
 * @param id - id
 */
export const uploadImageUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/service/uploadimage/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['file'] !== undefined) {
    form['file'] = parameters['file']
  }
  if (parameters['file'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: file'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const uploadImageUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/marjan/service/uploadimage/{id}'
}
export const uploadImageUsingPOST_TYPE = function() {
  return 'post'
}
export const uploadImageUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/service/uploadimage/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * test
 * request: testUsingGET
 * url: testUsingGETURL
 * method: testUsingGET_TYPE
 * raw_url: testUsingGET_RAW_URL
 */
export const testUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/test'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const testUsingGET_RAW_URL = function() {
  return '/api/v1/portal/marjan/test'
}
export const testUsingGET_TYPE = function() {
  return 'get'
}
export const testUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/test'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * upload
 * request: uploadUsingPOST_1
 * url: uploadUsingPOST_1URL
 * method: uploadUsingPOST_1_TYPE
 * raw_url: uploadUsingPOST_1_RAW_URL
 * @param file - file
 * @param id - id
 */
export const uploadUsingPOST_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/marjan/upload/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['file'] !== undefined) {
    form['file'] = parameters['file']
  }
  if (parameters['file'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: file'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const uploadUsingPOST_1_RAW_URL = function() {
  return '/api/v1/portal/marjan/upload/{id}'
}
export const uploadUsingPOST_1_TYPE = function() {
  return 'post'
}
export const uploadUsingPOST_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/marjan/upload/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * helloluo
 * request: helloluoUsingPOST
 * url: helloluoUsingPOSTURL
 * method: helloluoUsingPOST_TYPE
 * raw_url: helloluoUsingPOST_RAW_URL
 * @param id - id
 */
export const helloluoUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/covid19/helloluo/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const helloluoUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/covid19/helloluo/{id}'
}
export const helloluoUsingPOST_TYPE = function() {
  return 'post'
}
export const helloluoUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/covid19/helloluo/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * helloluo2
 * request: helloluo2UsingPOST
 * url: helloluo2UsingPOSTURL
 * method: helloluo2UsingPOST_TYPE
 * raw_url: helloluo2UsingPOST_RAW_URL
 * @param id - id
 */
export const helloluo2UsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/covid19/helloluo2/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const helloluo2UsingPOST_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/covid19/helloluo2/{id}'
}
export const helloluo2UsingPOST_TYPE = function() {
  return 'post'
}
export const helloluo2UsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/covid19/helloluo2/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * helloluo3
 * request: helloluo3UsingPOST
 * url: helloluo3UsingPOSTURL
 * method: helloluo3UsingPOST_TYPE
 * raw_url: helloluo3UsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const helloluo3UsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/covid19/helloluo3/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const helloluo3UsingPOST_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/covid19/helloluo3/{id}'
}
export const helloluo3UsingPOST_TYPE = function() {
  return 'post'
}
export const helloluo3UsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/covid19/helloluo3/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * helloluo4
 * request: helloluo4UsingPOST
 * url: helloluo4UsingPOSTURL
 * method: helloluo4UsingPOST_TYPE
 * raw_url: helloluo4UsingPOST_RAW_URL
 * @param id - id
 */
export const helloluo4UsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/covid19/helloluo4/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const helloluo4UsingPOST_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/covid19/helloluo4/{id}'
}
export const helloluo4UsingPOST_TYPE = function() {
  return 'post'
}
export const helloluo4UsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/covid19/helloluo4/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * helloluo5
 * request: helloluo5UsingPOST
 * url: helloluo5UsingPOSTURL
 * method: helloluo5UsingPOST_TYPE
 * raw_url: helloluo5UsingPOST_RAW_URL
 * @param id - id
 */
export const helloluo5UsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/covid19/helloluo5/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const helloluo5UsingPOST_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/covid19/helloluo5/{id}'
}
export const helloluo5UsingPOST_TYPE = function() {
  return 'post'
}
export const helloluo5UsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/covid19/helloluo5/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 更新疫情信息，saveCOVID19
 * request: saveCOVID19UsingPOST
 * url: saveCOVID19UsingPOSTURL
 * method: saveCOVID19UsingPOST_TYPE
 * raw_url: saveCOVID19UsingPOST_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param volist - volist
 */
export const saveCOVID19UsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/covid19/save'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['volist'] !== undefined) {
    body = parameters['volist']
  }
  if (parameters['volist'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: volist'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const saveCOVID19UsingPOST_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/covid19/save'
}
export const saveCOVID19UsingPOST_TYPE = function() {
  return 'post'
}
export const saveCOVID19UsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/covid19/save'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 清空数据，deleteDocregisterAll
 * request: deleteDocregisterAllUsingDELETE
 * url: deleteDocregisterAllUsingDELETEURL
 * method: deleteDocregisterAllUsingDELETE_TYPE
 * raw_url: deleteDocregisterAllUsingDELETE_RAW_URL
 * @param modulename - modulename
 */
export const deleteDocregisterAllUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/docregister/deleteall'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteDocregisterAllUsingDELETE_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/docregister/deleteall'
}
export const deleteDocregisterAllUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteDocregisterAllUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/docregister/deleteall'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取列表（不分页），getDocregisterList
 * request: getDocregisterListUsingGET
 * url: getDocregisterListUsingGETURL
 * method: getDocregisterListUsingGET_TYPE
 * raw_url: getDocregisterListUsingGET_RAW_URL
 * @param modulename - modulename
 */
export const getDocregisterListUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/docregister/getdocregisterlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDocregisterListUsingGET_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/docregister/getdocregisterlist'
}
export const getDocregisterListUsingGET_TYPE = function() {
  return 'get'
}
export const getDocregisterListUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/docregister/getdocregisterlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导入数据，InputData
 * request: InputDataUsingGET
 * url: InputDataUsingGETURL
 * method: InputDataUsingGET_TYPE
 * raw_url: InputDataUsingGET_RAW_URL
 * @param file - file
 * @param modulename - modulename
 */
export const InputDataUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/docregister/inputdata'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['file'] !== undefined) {
    form['file'] = parameters['file']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const InputDataUsingGET_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/docregister/inputdata'
}
export const InputDataUsingGET_TYPE = function() {
  return 'get'
}
export const InputDataUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/docregister/inputdata'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改一条数据，updateDocregister
 * request: updateDocregisterUsingPOST
 * url: updateDocregisterUsingPOSTURL
 * method: updateDocregisterUsingPOST_TYPE
 * raw_url: updateDocregisterUsingPOST_RAW_URL
 * @param docregister - docregister
 * @param id - id
 * @param modulename - modulename
 */
export const updateDocregisterUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/docregister/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['docregister'] !== undefined) {
    body = parameters['docregister']
  }
  if (parameters['docregister'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: docregister'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateDocregisterUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/docregister/update/{id}'
}
export const updateDocregisterUsingPOST_TYPE = function() {
  return 'post'
}
export const updateDocregisterUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/docregister/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 添加一张图片，addHomeImageConfig
 * request: addHomeImageConfigUsingPOST
 * url: addHomeImageConfigUsingPOSTURL
 * method: addHomeImageConfigUsingPOST_TYPE
 * raw_url: addHomeImageConfigUsingPOST_RAW_URL
 * @param hic - hic
 * @param modulename - modulename
 * @param name - 
 */
export const addHomeImageConfigUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/homeimageconfig'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['hic'] !== undefined) {
    body = parameters['hic']
  }
  if (parameters['hic'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: hic'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addHomeImageConfigUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/homeimageconfig'
}
export const addHomeImageConfigUsingPOST_TYPE = function() {
  return 'post'
}
export const addHomeImageConfigUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/homeimageconfig'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取列表，findHomeImageConfig
 * request: findHomeImageConfigUsingPOST
 * url: findHomeImageConfigUsingPOSTURL
 * method: findHomeImageConfigUsingPOST_TYPE
 * raw_url: findHomeImageConfigUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param hic - hic
 * @param modulename - modulename
 * @param page - 请求页数
 * @param principal - 
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findHomeImageConfigUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/homeimageconfig/getlist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  if (parameters['hic'] !== undefined) {
    body = parameters['hic']
  }
  if (parameters['hic'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: hic'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findHomeImageConfigUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/homeimageconfig/getlist'
}
export const findHomeImageConfigUsingPOST_TYPE = function() {
  return 'post'
}
export const findHomeImageConfigUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/homeimageconfig/getlist'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据ID获取对象，getHomeImageConfig
 * request: getHomeImageConfigUsingGET
 * url: getHomeImageConfigUsingGETURL
 * method: getHomeImageConfigUsingGET_TYPE
 * raw_url: getHomeImageConfigUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getHomeImageConfigUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/homeimageconfig/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHomeImageConfigUsingGET_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/homeimageconfig/{id}'
}
export const getHomeImageConfigUsingGET_TYPE = function() {
  return 'get'
}
export const getHomeImageConfigUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/homeimageconfig/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除一张图片，deleteHomeImageConfig
 * request: deleteHomeImageConfigUsingDELETE
 * url: deleteHomeImageConfigUsingDELETEURL
 * method: deleteHomeImageConfigUsingDELETE_TYPE
 * raw_url: deleteHomeImageConfigUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteHomeImageConfigUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/homeimageconfig/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteHomeImageConfigUsingDELETE_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/homeimageconfig/{id}'
}
export const deleteHomeImageConfigUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteHomeImageConfigUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/homeimageconfig/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addHighRiskActivityAlert
 * request: addHighRiskActivityAlertUsingPOST
 * url: addHighRiskActivityAlertUsingPOSTURL
 * method: addHighRiskActivityAlertUsingPOST_TYPE
 * raw_url: addHighRiskActivityAlertUsingPOST_RAW_URL
 * @param hraa - hraa
 * @param modulename - modulename
 */
export const addHighRiskActivityAlertUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/hraa'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['hraa'] !== undefined) {
    body = parameters['hraa']
  }
  if (parameters['hraa'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: hraa'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addHighRiskActivityAlertUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/hraa'
}
export const addHighRiskActivityAlertUsingPOST_TYPE = function() {
  return 'post'
}
export const addHighRiskActivityAlertUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/hraa'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectHighRiskActivityAlert
 * request: deleteSelectHighRiskActivityAlertUsingDELETE
 * url: deleteSelectHighRiskActivityAlertUsingDELETEURL
 * method: deleteSelectHighRiskActivityAlertUsingDELETE_TYPE
 * raw_url: deleteSelectHighRiskActivityAlertUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectHighRiskActivityAlertUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/hraa/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectHighRiskActivityAlertUsingDELETE_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/hraa/delete'
}
export const deleteSelectHighRiskActivityAlertUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectHighRiskActivityAlertUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/hraa/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteHighRiskActivityAlert
 * request: deleteHighRiskActivityAlertUsingDELETE
 * url: deleteHighRiskActivityAlertUsingDELETEURL
 * method: deleteHighRiskActivityAlertUsingDELETE_TYPE
 * raw_url: deleteHighRiskActivityAlertUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteHighRiskActivityAlertUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/hraa/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteHighRiskActivityAlertUsingDELETE_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/hraa/delete/{id}'
}
export const deleteHighRiskActivityAlertUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteHighRiskActivityAlertUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/hraa/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getHighRiskActivityAlert
 * request: getHighRiskActivityAlertUsingGET
 * url: getHighRiskActivityAlertUsingGETURL
 * method: getHighRiskActivityAlertUsingGET_TYPE
 * raw_url: getHighRiskActivityAlertUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getHighRiskActivityAlertUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/hraa/get/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHighRiskActivityAlertUsingGET_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/hraa/get/{id}'
}
export const getHighRiskActivityAlertUsingGET_TYPE = function() {
  return 'get'
}
export const getHighRiskActivityAlertUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/hraa/get/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findHighRiskActivityAlert
 * request: findHighRiskActivityAlertUsingPOST
 * url: findHighRiskActivityAlertUsingPOSTURL
 * method: findHighRiskActivityAlertUsingPOST_TYPE
 * raw_url: findHighRiskActivityAlertUsingPOST_RAW_URL
 * @param hraa - hraa
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findHighRiskActivityAlertUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/hraa/getlist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['hraa'] !== undefined) {
    body = parameters['hraa']
  }
  if (parameters['hraa'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: hraa'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findHighRiskActivityAlertUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/hraa/getlist'
}
export const findHighRiskActivityAlertUsingPOST_TYPE = function() {
  return 'post'
}
export const findHighRiskActivityAlertUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/hraa/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateHighRiskActivityAlert
 * request: updateHighRiskActivityAlertUsingPOST
 * url: updateHighRiskActivityAlertUsingPOSTURL
 * method: updateHighRiskActivityAlertUsingPOST_TYPE
 * raw_url: updateHighRiskActivityAlertUsingPOST_RAW_URL
 * @param hraa - hraa
 * @param id - id
 * @param modulename - modulename
 */
export const updateHighRiskActivityAlertUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/hraa/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['hraa'] !== undefined) {
    body = parameters['hraa']
  }
  if (parameters['hraa'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: hraa'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateHighRiskActivityAlertUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/hraa/update/{id}'
}
export const updateHighRiskActivityAlertUsingPOST_TYPE = function() {
  return 'post'
}
export const updateHighRiskActivityAlertUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/hraa/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addHSEStatistics
 * request: addHSEStatisticsUsingPOST
 * url: addHSEStatisticsUsingPOSTURL
 * method: addHSEStatisticsUsingPOST_TYPE
 * raw_url: addHSEStatisticsUsingPOST_RAW_URL
 * @param hses - hses
 * @param modulename - modulename
 */
export const addHSEStatisticsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/hses'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['hses'] !== undefined) {
    body = parameters['hses']
  }
  if (parameters['hses'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: hses'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addHSEStatisticsUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/hses'
}
export const addHSEStatisticsUsingPOST_TYPE = function() {
  return 'post'
}
export const addHSEStatisticsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/hses'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectHSEStatistics
 * request: deleteSelectHSEStatisticsUsingDELETE
 * url: deleteSelectHSEStatisticsUsingDELETEURL
 * method: deleteSelectHSEStatisticsUsingDELETE_TYPE
 * raw_url: deleteSelectHSEStatisticsUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectHSEStatisticsUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/hses/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectHSEStatisticsUsingDELETE_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/hses/delete'
}
export const deleteSelectHSEStatisticsUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectHSEStatisticsUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/hses/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteHSEStatistics
 * request: deleteHSEStatisticsUsingDELETE
 * url: deleteHSEStatisticsUsingDELETEURL
 * method: deleteHSEStatisticsUsingDELETE_TYPE
 * raw_url: deleteHSEStatisticsUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteHSEStatisticsUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/hses/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteHSEStatisticsUsingDELETE_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/hses/delete/{id}'
}
export const deleteHSEStatisticsUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteHSEStatisticsUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/hses/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getHSEStatistics
 * request: getHSEStatisticsUsingGET
 * url: getHSEStatisticsUsingGETURL
 * method: getHSEStatisticsUsingGET_TYPE
 * raw_url: getHSEStatisticsUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getHSEStatisticsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/hses/get/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHSEStatisticsUsingGET_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/hses/get/{id}'
}
export const getHSEStatisticsUsingGET_TYPE = function() {
  return 'get'
}
export const getHSEStatisticsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/hses/get/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findHSEStatistics
 * request: findHSEStatisticsUsingPOST
 * url: findHSEStatisticsUsingPOSTURL
 * method: findHSEStatisticsUsingPOST_TYPE
 * raw_url: findHSEStatisticsUsingPOST_RAW_URL
 * @param hses - hses
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findHSEStatisticsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/hses/getlist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['hses'] !== undefined) {
    body = parameters['hses']
  }
  if (parameters['hses'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: hses'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findHSEStatisticsUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/hses/getlist'
}
export const findHSEStatisticsUsingPOST_TYPE = function() {
  return 'post'
}
export const findHSEStatisticsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/hses/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateHSEStatistics
 * request: updateHSEStatisticsUsingPOST
 * url: updateHSEStatisticsUsingPOSTURL
 * method: updateHSEStatisticsUsingPOST_TYPE
 * raw_url: updateHSEStatisticsUsingPOST_RAW_URL
 * @param hses - hses
 * @param id - id
 * @param modulename - modulename
 */
export const updateHSEStatisticsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/hses/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['hses'] !== undefined) {
    body = parameters['hses']
  }
  if (parameters['hses'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: hses'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateHSEStatisticsUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/hses/update/{id}'
}
export const updateHSEStatisticsUsingPOST_TYPE = function() {
  return 'post'
}
export const updateHSEStatisticsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/hses/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addHSESecurityIncidents
 * request: addHSESecurityIncidentsUsingPOST
 * url: addHSESecurityIncidentsUsingPOSTURL
 * method: addHSESecurityIncidentsUsingPOST_TYPE
 * raw_url: addHSESecurityIncidentsUsingPOST_RAW_URL
 * @param hsesi - hsesi
 * @param modulename - modulename
 */
export const addHSESecurityIncidentsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/hsesi'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['hsesi'] !== undefined) {
    body = parameters['hsesi']
  }
  if (parameters['hsesi'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: hsesi'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addHSESecurityIncidentsUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/hsesi'
}
export const addHSESecurityIncidentsUsingPOST_TYPE = function() {
  return 'post'
}
export const addHSESecurityIncidentsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/hsesi'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectHSESecurityIncidents
 * request: deleteSelectHSESecurityIncidentsUsingDELETE
 * url: deleteSelectHSESecurityIncidentsUsingDELETEURL
 * method: deleteSelectHSESecurityIncidentsUsingDELETE_TYPE
 * raw_url: deleteSelectHSESecurityIncidentsUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectHSESecurityIncidentsUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/hsesi/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectHSESecurityIncidentsUsingDELETE_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/hsesi/delete'
}
export const deleteSelectHSESecurityIncidentsUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectHSESecurityIncidentsUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/hsesi/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteHSESecurityIncidents
 * request: deleteHSESecurityIncidentsUsingDELETE
 * url: deleteHSESecurityIncidentsUsingDELETEURL
 * method: deleteHSESecurityIncidentsUsingDELETE_TYPE
 * raw_url: deleteHSESecurityIncidentsUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteHSESecurityIncidentsUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/hsesi/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteHSESecurityIncidentsUsingDELETE_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/hsesi/delete/{id}'
}
export const deleteHSESecurityIncidentsUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteHSESecurityIncidentsUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/hsesi/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getHSESecurityIncidents
 * request: getHSESecurityIncidentsUsingGET
 * url: getHSESecurityIncidentsUsingGETURL
 * method: getHSESecurityIncidentsUsingGET_TYPE
 * raw_url: getHSESecurityIncidentsUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getHSESecurityIncidentsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/hsesi/get/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHSESecurityIncidentsUsingGET_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/hsesi/get/{id}'
}
export const getHSESecurityIncidentsUsingGET_TYPE = function() {
  return 'get'
}
export const getHSESecurityIncidentsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/hsesi/get/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findHSESecurityIncidents
 * request: findHSESecurityIncidentsUsingPOST
 * url: findHSESecurityIncidentsUsingPOSTURL
 * method: findHSESecurityIncidentsUsingPOST_TYPE
 * raw_url: findHSESecurityIncidentsUsingPOST_RAW_URL
 * @param hsesi - hsesi
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findHSESecurityIncidentsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/hsesi/getlist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['hsesi'] !== undefined) {
    body = parameters['hsesi']
  }
  if (parameters['hsesi'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: hsesi'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findHSESecurityIncidentsUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/hsesi/getlist'
}
export const findHSESecurityIncidentsUsingPOST_TYPE = function() {
  return 'post'
}
export const findHSESecurityIncidentsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/hsesi/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateHSESecurityIncidents
 * request: updateHSESecurityIncidentsUsingPOST
 * url: updateHSESecurityIncidentsUsingPOSTURL
 * method: updateHSESecurityIncidentsUsingPOST_TYPE
 * raw_url: updateHSESecurityIncidentsUsingPOST_RAW_URL
 * @param hsesi - hsesi
 * @param id - id
 * @param modulename - modulename
 */
export const updateHSESecurityIncidentsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/hsesi/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['hsesi'] !== undefined) {
    body = parameters['hsesi']
  }
  if (parameters['hsesi'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: hsesi'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateHSESecurityIncidentsUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/hsesi/update/{id}'
}
export const updateHSESecurityIncidentsUsingPOST_TYPE = function() {
  return 'post'
}
export const updateHSESecurityIncidentsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/hsesi/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 清空数据，deleteScheduleEAll
 * request: deleteScheduleEAllUsingDELETE
 * url: deleteScheduleEAllUsingDELETEURL
 * method: deleteScheduleEAllUsingDELETE_TYPE
 * raw_url: deleteScheduleEAllUsingDELETE_RAW_URL
 * @param modulename - modulename
 */
export const deleteScheduleEAllUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/schedulee/deleteall'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteScheduleEAllUsingDELETE_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/schedulee/deleteall'
}
export const deleteScheduleEAllUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteScheduleEAllUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/schedulee/deleteall'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取列表（不分页），getScheduleEList
 * request: getScheduleEListUsingGET
 * url: getScheduleEListUsingGETURL
 * method: getScheduleEListUsingGET_TYPE
 * raw_url: getScheduleEListUsingGET_RAW_URL
 * @param modulename - modulename
 */
export const getScheduleEListUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/schedulee/getscheduleelist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getScheduleEListUsingGET_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/schedulee/getscheduleelist'
}
export const getScheduleEListUsingGET_TYPE = function() {
  return 'get'
}
export const getScheduleEListUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/schedulee/getscheduleelist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导入数据，InputData
 * request: InputDataUsingGET_1
 * url: InputDataUsingGET_1URL
 * method: InputDataUsingGET_1_TYPE
 * raw_url: InputDataUsingGET_1_RAW_URL
 * @param file - file
 * @param modulename - modulename
 */
export const InputDataUsingGET_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/schedulee/inputdata'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['file'] !== undefined) {
    form['file'] = parameters['file']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const InputDataUsingGET_1_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/schedulee/inputdata'
}
export const InputDataUsingGET_1_TYPE = function() {
  return 'get'
}
export const InputDataUsingGET_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/schedulee/inputdata'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改一条数据，updateScheduleE
 * request: updateScheduleEUsingPOST
 * url: updateScheduleEUsingPOSTURL
 * method: updateScheduleEUsingPOST_TYPE
 * raw_url: updateScheduleEUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param scheduleE - scheduleE
 */
export const updateScheduleEUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/portal/{modulename}/schedulee/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['scheduleE'] !== undefined) {
    body = parameters['scheduleE']
  }
  if (parameters['scheduleE'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: scheduleE'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateScheduleEUsingPOST_RAW_URL = function() {
  return '/api/v1/portal/{modulename}/schedulee/update/{id}'
}
export const updateScheduleEUsingPOST_TYPE = function() {
  return 'post'
}
export const updateScheduleEUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/portal/{modulename}/schedulee/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 激活流程实例，activeProcessInstanceById
 * request: activeProcessInstanceByIdUsingPUT
 * url: activeProcessInstanceByIdUsingPUTURL
 * method: activeProcessInstanceByIdUsingPUT_TYPE
 * raw_url: activeProcessInstanceByIdUsingPUT_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const activeProcessInstanceByIdUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/processinstance/{modulename}/active'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const activeProcessInstanceByIdUsingPUT_RAW_URL = function() {
  return '/api/v1/processinstance/{modulename}/active'
}
export const activeProcessInstanceByIdUsingPUT_TYPE = function() {
  return 'put'
}
export const activeProcessInstanceByIdUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/processinstance/{modulename}/active'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取所有任务节点，getAllUserTask
 * request: getAllUserTaskUsingGET
 * url: getAllUserTaskUsingGETURL
 * method: getAllUserTaskUsingGET_TYPE
 * raw_url: getAllUserTaskUsingGET_RAW_URL
 * @param modulename - modulename
 * @param taskId - taskId
 */
export const getAllUserTaskUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/processinstance/{modulename}/allUserTask/{taskId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{taskId}', `${parameters['taskId']}`)
  if (parameters['taskId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllUserTaskUsingGET_RAW_URL = function() {
  return '/api/v1/processinstance/{modulename}/allUserTask/{taskId}'
}
export const getAllUserTaskUsingGET_TYPE = function() {
  return 'get'
}
export const getAllUserTaskUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/processinstance/{modulename}/allUserTask/{taskId}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{taskId}', `${parameters['taskId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 流程跳转，jumpTask
 * request: jumpTaskUsingPOST
 * url: jumpTaskUsingPOSTURL
 * method: jumpTaskUsingPOST_TYPE
 * raw_url: jumpTaskUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param targetNodeId - targetNodeId
 * @param taskId - taskId
 * @param vo - vo
 */
export const jumpTaskUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/processinstance/{modulename}/jumpTask/{taskId}/{targetNodeId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{targetNodeId}', `${parameters['targetNodeId']}`)
  if (parameters['targetNodeId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: targetNodeId'))
  }
  path = path.replace('{taskId}', `${parameters['taskId']}`)
  if (parameters['taskId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskId'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const jumpTaskUsingPOST_RAW_URL = function() {
  return '/api/v1/processinstance/{modulename}/jumpTask/{taskId}/{targetNodeId}'
}
export const jumpTaskUsingPOST_TYPE = function() {
  return 'post'
}
export const jumpTaskUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/processinstance/{modulename}/jumpTask/{taskId}/{targetNodeId}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{targetNodeId}', `${parameters['targetNodeId']}`)
  path = path.replace('{taskId}', `${parameters['taskId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取流程实例任务节点，processInsTaskList
 * request: processInsTaskListUsingGET
 * url: processInsTaskListUsingGETURL
 * method: processInsTaskListUsingGET_TYPE
 * raw_url: processInsTaskListUsingGET_RAW_URL
 * @param modulename - modulename
 * @param offset - 
 * @param pageNumber - 
 * @param pageSize - 
 * @param paged - 
 * @param processInstId - processInstId
 * @param sortSorted - 
 * @param sortUnsorted - 
 * @param unpaged - 
 * @param vo - vo
 */
export const processInsTaskListUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/processinstance/{modulename}/processInsTaskList/{processInstId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['offset'] !== undefined) {
    queryParameters['offset'] = parameters['offset']
  }
  if (parameters['pageNumber'] !== undefined) {
    queryParameters['pageNumber'] = parameters['pageNumber']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['pageSize'] = parameters['pageSize']
  }
  if (parameters['paged'] !== undefined) {
    queryParameters['paged'] = parameters['paged']
  }
  path = path.replace('{processInstId}', `${parameters['processInstId']}`)
  if (parameters['processInstId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: processInstId'))
  }
  if (parameters['sortSorted'] !== undefined) {
    queryParameters['sort.sorted'] = parameters['sortSorted']
  }
  if (parameters['sortUnsorted'] !== undefined) {
    queryParameters['sort.unsorted'] = parameters['sortUnsorted']
  }
  if (parameters['unpaged'] !== undefined) {
    queryParameters['unpaged'] = parameters['unpaged']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const processInsTaskListUsingGET_RAW_URL = function() {
  return '/api/v1/processinstance/{modulename}/processInsTaskList/{processInstId}'
}
export const processInsTaskListUsingGET_TYPE = function() {
  return 'get'
}
export const processInsTaskListUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/processinstance/{modulename}/processInsTaskList/{processInstId}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['offset'] !== undefined) {
    queryParameters['offset'] = parameters['offset']
  }
  if (parameters['pageNumber'] !== undefined) {
    queryParameters['pageNumber'] = parameters['pageNumber']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['pageSize'] = parameters['pageSize']
  }
  if (parameters['paged'] !== undefined) {
    queryParameters['paged'] = parameters['paged']
  }
  path = path.replace('{processInstId}', `${parameters['processInstId']}`)
  if (parameters['sortSorted'] !== undefined) {
    queryParameters['sort.sorted'] = parameters['sortSorted']
  }
  if (parameters['sortUnsorted'] !== undefined) {
    queryParameters['sort.unsorted'] = parameters['sortUnsorted']
  }
  if (parameters['unpaged'] !== undefined) {
    queryParameters['unpaged'] = parameters['unpaged']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取流程实例，processInstanceList
 * request: processInstanceListUsingPOST
 * url: processInstanceListUsingPOSTURL
 * method: processInstanceListUsingPOST_TYPE
 * raw_url: processInstanceListUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param page - 请求页数
 * @param principal - 
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const processInstanceListUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/processinstance/{modulename}/processinstancelist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const processInstanceListUsingPOST_RAW_URL = function() {
  return '/api/v1/processinstance/{modulename}/processinstancelist'
}
export const processInstanceListUsingPOST_TYPE = function() {
  return 'post'
}
export const processInstanceListUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/processinstance/{modulename}/processinstancelist'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取所有可达任务节点，getReachableTasks
 * request: getReachableTasksUsingGET
 * url: getReachableTasksUsingGETURL
 * method: getReachableTasksUsingGET_TYPE
 * raw_url: getReachableTasksUsingGET_RAW_URL
 * @param modulename - modulename
 * @param taskId - taskId
 */
export const getReachableTasksUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/processinstance/{modulename}/reachableUserTask/{taskId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{taskId}', `${parameters['taskId']}`)
  if (parameters['taskId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getReachableTasksUsingGET_RAW_URL = function() {
  return '/api/v1/processinstance/{modulename}/reachableUserTask/{taskId}'
}
export const getReachableTasksUsingGET_TYPE = function() {
  return 'get'
}
export const getReachableTasksUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/processinstance/{modulename}/reachableUserTask/{taskId}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{taskId}', `${parameters['taskId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 挂起流程实例，suspendProcessInstanceById
 * request: suspendProcessInstanceByIdUsingPUT
 * url: suspendProcessInstanceByIdUsingPUTURL
 * method: suspendProcessInstanceByIdUsingPUT_TYPE
 * raw_url: suspendProcessInstanceByIdUsingPUT_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const suspendProcessInstanceByIdUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/processinstance/{modulename}/suspend'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const suspendProcessInstanceByIdUsingPUT_RAW_URL = function() {
  return '/api/v1/processinstance/{modulename}/suspend'
}
export const suspendProcessInstanceByIdUsingPUT_TYPE = function() {
  return 'put'
}
export const suspendProcessInstanceByIdUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/processinstance/{modulename}/suspend'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * aaa
 * request: aaaUsingPOST
 * url: aaaUsingPOSTURL
 * method: aaaUsingPOST_TYPE
 * raw_url: aaaUsingPOST_RAW_URL
 */
export const aaaUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/push/aa'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const aaaUsingPOST_RAW_URL = function() {
  return '/api/v1/push/aa'
}
export const aaaUsingPOST_TYPE = function() {
  return 'post'
}
export const aaaUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/push/aa'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 下载资源，download
 * request: downloadUsingGET_1
 * url: downloadUsingGET_1URL
 * method: downloadUsingGET_1_TYPE
 * raw_url: downloadUsingGET_1_RAW_URL
 * @param id - id
 */
export const downloadUsingGET_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/resourcetable/download/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const downloadUsingGET_1_RAW_URL = function() {
  return '/api/v1/resourcetable/download/{id}'
}
export const downloadUsingGET_1_TYPE = function() {
  return 'get'
}
export const downloadUsingGET_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/resourcetable/download/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 上传资源，upload
 * request: uploadUsingPOST_2
 * url: uploadUsingPOST_2URL
 * method: uploadUsingPOST_2_TYPE
 * raw_url: uploadUsingPOST_2_RAW_URL
 * @param file - file
 */
export const uploadUsingPOST_2 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/resourcetable/upload'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['file'] !== undefined) {
    form['file'] = parameters['file']
  }
  if (parameters['file'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: file'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const uploadUsingPOST_2_RAW_URL = function() {
  return '/api/v1/resourcetable/upload'
}
export const uploadUsingPOST_2_TYPE = function() {
  return 'post'
}
export const uploadUsingPOST_2URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/resourcetable/upload'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addCertificateInfo
 * request: addCertificateInfoUsingPOST
 * url: addCertificateInfoUsingPOSTURL
 * method: addCertificateInfoUsingPOST_TYPE
 * raw_url: addCertificateInfoUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const addCertificateInfoUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/certificateinfo/'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addCertificateInfoUsingPOST_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/certificateinfo/'
}
export const addCertificateInfoUsingPOST_TYPE = function() {
  return 'post'
}
export const addCertificateInfoUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/certificateinfo/'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findCertificateInfos
 * request: findCertificateInfosUsingPOST
 * url: findCertificateInfosUsingPOSTURL
 * method: findCertificateInfosUsingPOST_TYPE
 * raw_url: findCertificateInfosUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findCertificateInfosUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/certificateinfo/CertificateInfo/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findCertificateInfosUsingPOST_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/certificateinfo/CertificateInfo/getlist'
}
export const findCertificateInfosUsingPOST_TYPE = function() {
  return 'post'
}
export const findCertificateInfosUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/certificateinfo/CertificateInfo/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectCertificateInfo
 * request: deleteSelectCertificateInfoUsingDELETE
 * url: deleteSelectCertificateInfoUsingDELETEURL
 * method: deleteSelectCertificateInfoUsingDELETE_TYPE
 * raw_url: deleteSelectCertificateInfoUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectCertificateInfoUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/certificateinfo/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectCertificateInfoUsingDELETE_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/certificateinfo/delete'
}
export const deleteSelectCertificateInfoUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectCertificateInfoUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/certificateinfo/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteCertificateInfo
 * request: deleteCertificateInfoUsingDELETE
 * url: deleteCertificateInfoUsingDELETEURL
 * method: deleteCertificateInfoUsingDELETE_TYPE
 * raw_url: deleteCertificateInfoUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteCertificateInfoUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/certificateinfo/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteCertificateInfoUsingDELETE_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/certificateinfo/delete/{id}'
}
export const deleteCertificateInfoUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteCertificateInfoUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/certificateinfo/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导出 downloadCertificateInfoDatafile
 * request: downloadCertificateInfoDatafileUsingPOST
 * url: downloadCertificateInfoDatafileUsingPOSTURL
 * method: downloadCertificateInfoDatafileUsingPOST_TYPE
 * raw_url: downloadCertificateInfoDatafileUsingPOST_RAW_URL
 * @param ext - ext
 * @param filename - filename
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const downloadCertificateInfoDatafileUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/certificateinfo/download/{filename}.{ext}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{ext}', `${parameters['ext']}`)
  if (parameters['ext'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: ext'))
  }
  path = path.replace('{filename}', `${parameters['filename']}`)
  if (parameters['filename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: filename'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const downloadCertificateInfoDatafileUsingPOST_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/certificateinfo/download/{filename}.{ext}'
}
export const downloadCertificateInfoDatafileUsingPOST_TYPE = function() {
  return 'post'
}
export const downloadCertificateInfoDatafileUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/certificateinfo/download/{filename}.{ext}'
  path = path.replace('{ext}', `${parameters['ext']}`)
  path = path.replace('{filename}', `${parameters['filename']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateCertificateInfo
 * request: updateCertificateInfoUsingPOST
 * url: updateCertificateInfoUsingPOSTURL
 * method: updateCertificateInfoUsingPOST_TYPE
 * raw_url: updateCertificateInfoUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const updateCertificateInfoUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/certificateinfo/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateCertificateInfoUsingPOST_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/certificateinfo/update/{id}'
}
export const updateCertificateInfoUsingPOST_TYPE = function() {
  return 'post'
}
export const updateCertificateInfoUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/certificateinfo/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导入数据 uploadCertificateInfoExcel
 * request: uploadCertificateInfoExcelUsingPOST
 * url: uploadCertificateInfoExcelUsingPOSTURL
 * method: uploadCertificateInfoExcelUsingPOST_TYPE
 * raw_url: uploadCertificateInfoExcelUsingPOST_RAW_URL
 * @param attid - attid
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const uploadCertificateInfoExcelUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/certificateinfo/upload/{attid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{attid}', `${parameters['attid']}`)
  if (parameters['attid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: attid'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const uploadCertificateInfoExcelUsingPOST_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/certificateinfo/upload/{attid}'
}
export const uploadCertificateInfoExcelUsingPOST_TYPE = function() {
  return 'post'
}
export const uploadCertificateInfoExcelUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/certificateinfo/upload/{attid}'
  path = path.replace('{attid}', `${parameters['attid']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getCertificateInfo
 * request: getCertificateInfoUsingGET
 * url: getCertificateInfoUsingGETURL
 * method: getCertificateInfoUsingGET_TYPE
 * raw_url: getCertificateInfoUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getCertificateInfoUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/certificateinfo/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCertificateInfoUsingGET_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/certificateinfo/{id}'
}
export const getCertificateInfoUsingGET_TYPE = function() {
  return 'get'
}
export const getCertificateInfoUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/certificateinfo/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addPersonInfo
 * request: addPersonInfoUsingPOST
 * url: addPersonInfoUsingPOSTURL
 * method: addPersonInfoUsingPOST_TYPE
 * raw_url: addPersonInfoUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const addPersonInfoUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/personinfo/'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addPersonInfoUsingPOST_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/personinfo/'
}
export const addPersonInfoUsingPOST_TYPE = function() {
  return 'post'
}
export const addPersonInfoUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/personinfo/'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导入数据标题校验   checkUploadPersonInfoExcel
 * request: checkUploadPersonInfoExcelUsingPOST
 * url: checkUploadPersonInfoExcelUsingPOSTURL
 * method: checkUploadPersonInfoExcelUsingPOST_TYPE
 * raw_url: checkUploadPersonInfoExcelUsingPOST_RAW_URL
 * @param attid - attid
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const checkUploadPersonInfoExcelUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/personinfo/checkupload/{attid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{attid}', `${parameters['attid']}`)
  if (parameters['attid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: attid'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const checkUploadPersonInfoExcelUsingPOST_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/personinfo/checkupload/{attid}'
}
export const checkUploadPersonInfoExcelUsingPOST_TYPE = function() {
  return 'post'
}
export const checkUploadPersonInfoExcelUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/personinfo/checkupload/{attid}'
  path = path.replace('{attid}', `${parameters['attid']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deletePersonInfos
 * request: deletePersonInfosUsingDELETE
 * url: deletePersonInfosUsingDELETEURL
 * method: deletePersonInfosUsingDELETE_TYPE
 * raw_url: deletePersonInfosUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deletePersonInfosUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/personinfo/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deletePersonInfosUsingDELETE_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/personinfo/delete'
}
export const deletePersonInfosUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deletePersonInfosUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/personinfo/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deletePersonInfo
 * request: deletePersonInfoUsingDELETE
 * url: deletePersonInfoUsingDELETEURL
 * method: deletePersonInfoUsingDELETE_TYPE
 * raw_url: deletePersonInfoUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deletePersonInfoUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/personinfo/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deletePersonInfoUsingDELETE_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/personinfo/delete/{id}'
}
export const deletePersonInfoUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deletePersonInfoUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/personinfo/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导出 downloadPersonInfoDatafile
 * request: downloadPersonInfoDatafileUsingPOST
 * url: downloadPersonInfoDatafileUsingPOSTURL
 * method: downloadPersonInfoDatafileUsingPOST_TYPE
 * raw_url: downloadPersonInfoDatafileUsingPOST_RAW_URL
 * @param ext - ext
 * @param filename - filename
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const downloadPersonInfoDatafileUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/personinfo/download/{filename}.{ext}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{ext}', `${parameters['ext']}`)
  if (parameters['ext'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: ext'))
  }
  path = path.replace('{filename}', `${parameters['filename']}`)
  if (parameters['filename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: filename'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const downloadPersonInfoDatafileUsingPOST_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/personinfo/download/{filename}.{ext}'
}
export const downloadPersonInfoDatafileUsingPOST_TYPE = function() {
  return 'post'
}
export const downloadPersonInfoDatafileUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/personinfo/download/{filename}.{ext}'
  path = path.replace('{ext}', `${parameters['ext']}`)
  path = path.replace('{filename}', `${parameters['filename']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导出项目总体个人资料  downloadOverallDatafile
 * request: downloadOverallDatafileUsingPOST
 * url: downloadOverallDatafileUsingPOSTURL
 * method: downloadOverallDatafileUsingPOST_TYPE
 * raw_url: downloadOverallDatafileUsingPOST_RAW_URL
 * @param ext - ext
 * @param filename - filename
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const downloadOverallDatafileUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/personinfo/downloadoverall/{filename}.{ext}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{ext}', `${parameters['ext']}`)
  if (parameters['ext'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: ext'))
  }
  path = path.replace('{filename}', `${parameters['filename']}`)
  if (parameters['filename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: filename'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const downloadOverallDatafileUsingPOST_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/personinfo/downloadoverall/{filename}.{ext}'
}
export const downloadOverallDatafileUsingPOST_TYPE = function() {
  return 'post'
}
export const downloadOverallDatafileUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/personinfo/downloadoverall/{filename}.{ext}'
  path = path.replace('{ext}', `${parameters['ext']}`)
  path = path.replace('{filename}', `${parameters['filename']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 启用或注销用户   enablePersonInfo
 * request: enablePersonInfoUsingPOST
 * url: enablePersonInfoUsingPOSTURL
 * method: enablePersonInfoUsingPOST_TYPE
 * raw_url: enablePersonInfoUsingPOST_RAW_URL
 * @param enable - enable
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 */
export const enablePersonInfoUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/personinfo/enable/{id}/{enable}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{enable}', `${parameters['enable']}`)
  if (parameters['enable'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: enable'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const enablePersonInfoUsingPOST_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/personinfo/enable/{id}/{enable}'
}
export const enablePersonInfoUsingPOST_TYPE = function() {
  return 'post'
}
export const enablePersonInfoUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/personinfo/enable/{id}/{enable}'
  path = path.replace('{enable}', `${parameters['enable']}`)
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getAutoIdNoInfo
 * request: getAutoIdNoInfoUsingGET
 * url: getAutoIdNoInfoUsingGETURL
 * method: getAutoIdNoInfoUsingGET_TYPE
 * raw_url: getAutoIdNoInfoUsingGET_RAW_URL
 * @param idno - idno
 * @param modulename - modulename
 */
export const getAutoIdNoInfoUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/personinfo/idno/{idno}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{idno}', `${parameters['idno']}`)
  if (parameters['idno'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: idno'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAutoIdNoInfoUsingGET_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/personinfo/idno/{idno}'
}
export const getAutoIdNoInfoUsingGET_TYPE = function() {
  return 'get'
}
export const getAutoIdNoInfoUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/personinfo/idno/{idno}'
  path = path.replace('{idno}', `${parameters['idno']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getAutoInfo
 * request: getAutoInfoUsingGET
 * url: getAutoInfoUsingGETURL
 * method: getAutoInfoUsingGET_TYPE
 * raw_url: getAutoInfoUsingGET_RAW_URL
 * @param modulename - modulename
 * @param name - name
 */
export const getAutoInfoUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/personinfo/name/{name}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{name}', `${parameters['name']}`)
  if (parameters['name'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: name'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAutoInfoUsingGET_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/personinfo/name/{name}'
}
export const getAutoInfoUsingGET_TYPE = function() {
  return 'get'
}
export const getAutoInfoUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/personinfo/name/{name}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{name}', `${parameters['name']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findPersonInfos
 * request: findPersonInfosUsingPOST
 * url: findPersonInfosUsingPOSTURL
 * method: findPersonInfosUsingPOST_TYPE
 * raw_url: findPersonInfosUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findPersonInfosUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/personinfo/personinfo/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findPersonInfosUsingPOST_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/personinfo/personinfo/getlist'
}
export const findPersonInfosUsingPOST_TYPE = function() {
  return 'post'
}
export const findPersonInfosUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/personinfo/personinfo/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updatePersonInfo
 * request: updatePersonInfoUsingPOST
 * url: updatePersonInfoUsingPOSTURL
 * method: updatePersonInfoUsingPOST_TYPE
 * raw_url: updatePersonInfoUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const updatePersonInfoUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/personinfo/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updatePersonInfoUsingPOST_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/personinfo/update/{id}'
}
export const updatePersonInfoUsingPOST_TYPE = function() {
  return 'post'
}
export const updatePersonInfoUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/personinfo/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导入数据 uploadPersonInfoExcel
 * request: uploadPersonInfoExcelUsingPOST
 * url: uploadPersonInfoExcelUsingPOSTURL
 * method: uploadPersonInfoExcelUsingPOST_TYPE
 * raw_url: uploadPersonInfoExcelUsingPOST_RAW_URL
 * @param attid - attid
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const uploadPersonInfoExcelUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/personinfo/upload/{attid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{attid}', `${parameters['attid']}`)
  if (parameters['attid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: attid'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const uploadPersonInfoExcelUsingPOST_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/personinfo/upload/{attid}'
}
export const uploadPersonInfoExcelUsingPOST_TYPE = function() {
  return 'post'
}
export const uploadPersonInfoExcelUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/personinfo/upload/{attid}'
  path = path.replace('{attid}', `${parameters['attid']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getPersonInfo
 * request: getPersonInfoUsingGET
 * url: getPersonInfoUsingGETURL
 * method: getPersonInfoUsingGET_TYPE
 * raw_url: getPersonInfoUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getPersonInfoUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/sf/{modulename}/personinfo/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getPersonInfoUsingGET_RAW_URL = function() {
  return '/api/v1/sf/{modulename}/personinfo/{id}'
}
export const getPersonInfoUsingGET_TYPE = function() {
  return 'get'
}
export const getPersonInfoUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/sf/{modulename}/personinfo/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 添加模板，addTemplate
 * request: addTemplateUsingPOST
 * url: addTemplateUsingPOSTURL
 * method: addTemplateUsingPOST_TYPE
 * raw_url: addTemplateUsingPOST_RAW_URL
 * @param name - 
 * @param templateVo - templateVo
 */
export const addTemplateUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/template'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['templateVo'] !== undefined) {
    body = parameters['templateVo']
  }
  if (parameters['templateVo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: templateVo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addTemplateUsingPOST_RAW_URL = function() {
  return '/api/v1/template'
}
export const addTemplateUsingPOST_TYPE = function() {
  return 'post'
}
export const addTemplateUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/template'
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除所选模板，deleteSelectTemplate
 * request: deleteSelectTemplateUsingDELETE
 * url: deleteSelectTemplateUsingDELETEURL
 * method: deleteSelectTemplateUsingDELETE_TYPE
 * raw_url: deleteSelectTemplateUsingDELETE_RAW_URL
 * @param ids - ids
 */
export const deleteSelectTemplateUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/template/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectTemplateUsingDELETE_RAW_URL = function() {
  return '/api/v1/template/delete'
}
export const deleteSelectTemplateUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectTemplateUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/template/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除一条模板，deleteTemplate
 * request: deleteTemplateUsingDELETE
 * url: deleteTemplateUsingDELETEURL
 * method: deleteTemplateUsingDELETE_TYPE
 * raw_url: deleteTemplateUsingDELETE_RAW_URL
 * @param id - id
 */
export const deleteTemplateUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/template/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteTemplateUsingDELETE_RAW_URL = function() {
  return '/api/v1/template/delete/{id}'
}
export const deleteTemplateUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteTemplateUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/template/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取模板列表（分页），getList
 * request: getListUsingPOST_1
 * url: getListUsingPOST_1URL
 * method: getListUsingPOST_1_TYPE
 * raw_url: getListUsingPOST_1_RAW_URL
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param template - template
 */
export const getListUsingPOST_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/template/getlist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['template'] !== undefined) {
    body = parameters['template']
  }
  if (parameters['template'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: template'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getListUsingPOST_1_RAW_URL = function() {
  return '/api/v1/template/getlist'
}
export const getListUsingPOST_1_TYPE = function() {
  return 'post'
}
export const getListUsingPOST_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/template/getlist'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改一条模板，updateTemplate
 * request: updateTemplateUsingPOST
 * url: updateTemplateUsingPOSTURL
 * method: updateTemplateUsingPOST_TYPE
 * raw_url: updateTemplateUsingPOST_RAW_URL
 * @param id - id
 * @param templateVo - templateVo
 */
export const updateTemplateUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/template/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['templateVo'] !== undefined) {
    body = parameters['templateVo']
  }
  if (parameters['templateVo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: templateVo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateTemplateUsingPOST_RAW_URL = function() {
  return '/api/v1/template/update/{id}'
}
export const updateTemplateUsingPOST_TYPE = function() {
  return 'post'
}
export const updateTemplateUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/template/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据code下载模板，getTemplateAttByCode
 * request: getTemplateAttByCodeUsingPOST
 * url: getTemplateAttByCodeUsingPOSTURL
 * method: getTemplateAttByCodeUsingPOST_TYPE
 * raw_url: getTemplateAttByCodeUsingPOST_RAW_URL
 * @param code - code
 */
export const getTemplateAttByCodeUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/template/{code}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{code}', `${parameters['code']}`)
  if (parameters['code'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: code'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getTemplateAttByCodeUsingPOST_RAW_URL = function() {
  return '/api/v1/template/{code}'
}
export const getTemplateAttByCodeUsingPOST_TYPE = function() {
  return 'post'
}
export const getTemplateAttByCodeUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/template/{code}'
  path = path.replace('{code}', `${parameters['code']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据id获取一条模板，getTemplateById
 * request: getTemplateByIdUsingGET
 * url: getTemplateByIdUsingGETURL
 * method: getTemplateByIdUsingGET_TYPE
 * raw_url: getTemplateByIdUsingGET_RAW_URL
 * @param id - id
 */
export const getTemplateByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/template/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTemplateByIdUsingGET_RAW_URL = function() {
  return '/api/v1/template/{id}'
}
export const getTemplateByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getTemplateByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/template/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addProcessDefinition
 * request: addProcessDefinitionUsingPOST
 * url: addProcessDefinitionUsingPOSTURL
 * method: addProcessDefinitionUsingPOST_TYPE
 * raw_url: addProcessDefinitionUsingPOST_RAW_URL
 * @param pd - pd
 */
export const addProcessDefinitionUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/ProcessDefinition'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['pd'] !== undefined) {
    body = parameters['pd']
  }
  if (parameters['pd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: pd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addProcessDefinitionUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/ProcessDefinition'
}
export const addProcessDefinitionUsingPOST_TYPE = function() {
  return 'post'
}
export const addProcessDefinitionUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/ProcessDefinition'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteProcessDefinitions
 * request: deleteProcessDefinitionsUsingDELETE
 * url: deleteProcessDefinitionsUsingDELETEURL
 * method: deleteProcessDefinitionsUsingDELETE_TYPE
 * raw_url: deleteProcessDefinitionsUsingDELETE_RAW_URL
 * @param ids - ids
 */
export const deleteProcessDefinitionsUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/ProcessDefinition'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteProcessDefinitionsUsingDELETE_RAW_URL = function() {
  return '/api/v1/tr/ProcessDefinition'
}
export const deleteProcessDefinitionsUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteProcessDefinitionsUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/ProcessDefinition'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回工作项list getWorkItemsStringByDiscipline
 * request: getWorkItemsListUsingPOST
 * url: getWorkItemsListUsingPOSTURL
 * method: getWorkItemsListUsingPOST_TYPE
 * raw_url: getWorkItemsListUsingPOST_RAW_URL
 */
export const getWorkItemsListUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/ProcessDefinition/discipline/worktypelist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getWorkItemsListUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/ProcessDefinition/discipline/worktypelist'
}
export const getWorkItemsListUsingPOST_TYPE = function() {
  return 'post'
}
export const getWorkItemsListUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/ProcessDefinition/discipline/worktypelist'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据专业返回工序 getWorkStepsByDiscipline
 * request: getWorkStepsByDisciplineUsingPOST
 * url: getWorkStepsByDisciplineUsingPOSTURL
 * method: getWorkStepsByDisciplineUsingPOST_TYPE
 * raw_url: getWorkStepsByDisciplineUsingPOST_RAW_URL
 * @param discipline - discipline
 */
export const getWorkStepsByDisciplineUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/ProcessDefinition/discipline/ws/{discipline}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getWorkStepsByDisciplineUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/ProcessDefinition/discipline/ws/{discipline}'
}
export const getWorkStepsByDisciplineUsingPOST_TYPE = function() {
  return 'post'
}
export const getWorkStepsByDisciplineUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/ProcessDefinition/discipline/ws/{discipline}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据专业返回工作项 getWorkItemsStringByDiscipline
 * request: getWorkItemsStringByDisciplineUsingPOST
 * url: getWorkItemsStringByDisciplineUsingPOSTURL
 * method: getWorkItemsStringByDisciplineUsingPOST_TYPE
 * raw_url: getWorkItemsStringByDisciplineUsingPOST_RAW_URL
 * @param discipline - discipline
 */
export const getWorkItemsStringByDisciplineUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/ProcessDefinition/discipline/{discipline}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getWorkItemsStringByDisciplineUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/ProcessDefinition/discipline/{discipline}'
}
export const getWorkItemsStringByDisciplineUsingPOST_TYPE = function() {
  return 'post'
}
export const getWorkItemsStringByDisciplineUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/ProcessDefinition/discipline/{discipline}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 按照顺序码返回专业列表 getDisciplineBystepsEq
 * request: getDisciplineBystepsEqUsingGET
 * url: getDisciplineBystepsEqUsingGETURL
 * method: getDisciplineBystepsEqUsingGET_TYPE
 * raw_url: getDisciplineBystepsEqUsingGET_RAW_URL
 * @param stepeq - stepeq
 */
export const getDisciplineBystepsEqUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/ProcessDefinition/discipline/{stepeq}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{stepeq}', `${parameters['stepeq']}`)
  if (parameters['stepeq'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: stepeq'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDisciplineBystepsEqUsingGET_RAW_URL = function() {
  return '/api/v1/tr/ProcessDefinition/discipline/{stepeq}'
}
export const getDisciplineBystepsEqUsingGET_TYPE = function() {
  return 'get'
}
export const getDisciplineBystepsEqUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/ProcessDefinition/discipline/{stepeq}'
  path = path.replace('{stepeq}', `${parameters['stepeq']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findProcessDefinition
 * request: findProcessDefinitionUsingPOST
 * url: findProcessDefinitionUsingPOSTURL
 * method: findProcessDefinitionUsingPOST_TYPE
 * raw_url: findProcessDefinitionUsingPOST_RAW_URL
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findProcessDefinitionUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/ProcessDefinition/getlist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findProcessDefinitionUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/ProcessDefinition/getlist'
}
export const findProcessDefinitionUsingPOST_TYPE = function() {
  return 'post'
}
export const findProcessDefinitionUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/ProcessDefinition/getlist'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据工作项返回工序  getByName
 * request: getByWorkTypeUsingPOST
 * url: getByWorkTypeUsingPOSTURL
 * method: getByWorkTypeUsingPOST_TYPE
 * raw_url: getByWorkTypeUsingPOST_RAW_URL
 * @param name - name
 */
export const getByWorkTypeUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/ProcessDefinition/name/{name}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{name}', `${parameters['name']}`)
  if (parameters['name'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: name'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getByWorkTypeUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/ProcessDefinition/name/{name}'
}
export const getByWorkTypeUsingPOST_TYPE = function() {
  return 'post'
}
export const getByWorkTypeUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/ProcessDefinition/name/{name}'
  path = path.replace('{name}', `${parameters['name']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateProcessDefinition
 * request: updateProcessDefinitionUsingPOST
 * url: updateProcessDefinitionUsingPOSTURL
 * method: updateProcessDefinitionUsingPOST_TYPE
 * raw_url: updateProcessDefinitionUsingPOST_RAW_URL
 * @param id - id
 * @param pd - pd
 */
export const updateProcessDefinitionUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/ProcessDefinition/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['pd'] !== undefined) {
    body = parameters['pd']
  }
  if (parameters['pd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: pd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateProcessDefinitionUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/ProcessDefinition/update/{id}'
}
export const updateProcessDefinitionUsingPOST_TYPE = function() {
  return 'post'
}
export const updateProcessDefinitionUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/ProcessDefinition/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getProcessDefinition
 * request: getProcessDefinitionUsingGET
 * url: getProcessDefinitionUsingGETURL
 * method: getProcessDefinitionUsingGET_TYPE
 * raw_url: getProcessDefinitionUsingGET_RAW_URL
 * @param id - id
 */
export const getProcessDefinitionUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/ProcessDefinition/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProcessDefinitionUsingGET_RAW_URL = function() {
  return '/api/v1/tr/ProcessDefinition/{id}'
}
export const getProcessDefinitionUsingGET_TYPE = function() {
  return 'get'
}
export const getProcessDefinitionUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/ProcessDefinition/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteProcessDefinition
 * request: deleteProcessDefinitionUsingDELETE
 * url: deleteProcessDefinitionUsingDELETEURL
 * method: deleteProcessDefinitionUsingDELETE_TYPE
 * raw_url: deleteProcessDefinitionUsingDELETE_RAW_URL
 * @param id - id
 */
export const deleteProcessDefinitionUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/ProcessDefinition/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteProcessDefinitionUsingDELETE_RAW_URL = function() {
  return '/api/v1/tr/ProcessDefinition/{id}'
}
export const deleteProcessDefinitionUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteProcessDefinitionUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/ProcessDefinition/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addComponents
 * request: addComponentsUsingPOST
 * url: addComponentsUsingPOSTURL
 * method: addComponentsUsingPOST_TYPE
 * raw_url: addComponentsUsingPOST_RAW_URL
 * @param components - components
 * @param modulename - modulename
 * @param name - 
 */
export const addComponentsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/components'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['components'] !== undefined) {
    body = parameters['components']
  }
  if (parameters['components'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: components'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addComponentsUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/components'
}
export const addComponentsUsingPOST_TYPE = function() {
  return 'post'
}
export const addComponentsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/components'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteComponentss
 * request: deleteComponentssUsingDELETE
 * url: deleteComponentssUsingDELETEURL
 * method: deleteComponentssUsingDELETE_TYPE
 * raw_url: deleteComponentssUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteComponentssUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/components'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteComponentssUsingDELETE_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/components'
}
export const deleteComponentssUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteComponentssUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/components'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回所有的实物量给前端,结果为数组列表.drawingid-图纸号  lineno-线号  spoolno-管段号 objname-组件 materialtype-材料类型 comp_size-尺寸 thickness-厚度 quantity-数量
 * request: queryComponentsUsingPOST
 * url: queryComponentsUsingPOSTURL
 * method: queryComponentsUsingPOST_TYPE
 * raw_url: queryComponentsUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param pagemap - pagemap
 */
export const queryComponentsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/components/allcomponents'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['pagemap'] !== undefined) {
    body = parameters['pagemap']
  }
  if (parameters['pagemap'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: pagemap'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const queryComponentsUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/components/allcomponents'
}
export const queryComponentsUsingPOST_TYPE = function() {
  return 'post'
}
export const queryComponentsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/components/allcomponents'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findComponents
 * request: findComponentsUsingPOST
 * url: findComponentsUsingPOSTURL
 * method: findComponentsUsingPOST_TYPE
 * raw_url: findComponentsUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param params - params
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findComponentsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/components/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['params'] !== undefined) {
    body = parameters['params']
  }
  if (parameters['params'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: params'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findComponentsUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/components/getlist'
}
export const findComponentsUsingPOST_TYPE = function() {
  return 'post'
}
export const findComponentsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/components/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回构件数据最后更新时间
 * request: lastupdateUsingPOST
 * url: lastupdateUsingPOSTURL
 * method: lastupdateUsingPOST_TYPE
 * raw_url: lastupdateUsingPOST_RAW_URL
 * @param modulename - modulename
 */
export const lastupdateUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/components/lastupdate'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const lastupdateUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/components/lastupdate'
}
export const lastupdateUsingPOST_TYPE = function() {
  return 'post'
}
export const lastupdateUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/components/lastupdate'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateComponents
 * request: updateComponentsUsingPOST
 * url: updateComponentsUsingPOSTURL
 * method: updateComponentsUsingPOST_TYPE
 * raw_url: updateComponentsUsingPOST_RAW_URL
 * @param components - components
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 */
export const updateComponentsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/components/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['components'] !== undefined) {
    body = parameters['components']
  }
  if (parameters['components'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: components'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateComponentsUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/components/update/{id}'
}
export const updateComponentsUsingPOST_TYPE = function() {
  return 'post'
}
export const updateComponentsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/components/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getComponents
 * request: getComponentsUsingGET
 * url: getComponentsUsingGETURL
 * method: getComponentsUsingGET_TYPE
 * raw_url: getComponentsUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getComponentsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/components/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getComponentsUsingGET_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/components/{id}'
}
export const getComponentsUsingGET_TYPE = function() {
  return 'get'
}
export const getComponentsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/components/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteComponents
 * request: deleteComponentsUsingDELETE
 * url: deleteComponentsUsingDELETEURL
 * method: deleteComponentsUsingDELETE_TYPE
 * raw_url: deleteComponentsUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteComponentsUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/components/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteComponentsUsingDELETE_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/components/{id}'
}
export const deleteComponentsUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteComponentsUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/components/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addIWps
 * request: addIWpsUsingPOST
 * url: addIWpsUsingPOSTURL
 * method: addIWpsUsingPOST_TYPE
 * raw_url: addIWpsUsingPOST_RAW_URL
 * @param iwps - iwps
 * @param modulename - modulename
 * @param name - 
 */
export const addIWpsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/iwps'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['iwps'] !== undefined) {
    body = parameters['iwps']
  }
  if (parameters['iwps'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: iwps'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addIWpsUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/iwps'
}
export const addIWpsUsingPOST_TYPE = function() {
  return 'post'
}
export const addIWpsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/iwps'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteIWpss
 * request: deleteIWpssUsingDELETE
 * url: deleteIWpssUsingDELETEURL
 * method: deleteIWpssUsingDELETE_TYPE
 * raw_url: deleteIWpssUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteIWpssUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/iwps'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteIWpssUsingDELETE_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/iwps'
}
export const deleteIWpssUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteIWpssUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/iwps'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findIWps
 * request: findIWpsUsingPOST
 * url: findIWpsUsingPOSTURL
 * method: findIWpsUsingPOST_TYPE
 * raw_url: findIWpsUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findIWpsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/iwps/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findIWpsUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/iwps/getlist'
}
export const findIWpsUsingPOST_TYPE = function() {
  return 'post'
}
export const findIWpsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/iwps/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateIWps
 * request: updateIWpsUsingPOST
 * url: updateIWpsUsingPOSTURL
 * method: updateIWpsUsingPOST_TYPE
 * raw_url: updateIWpsUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const updateIWpsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/iwps/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateIWpsUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/iwps/update/{id}'
}
export const updateIWpsUsingPOST_TYPE = function() {
  return 'post'
}
export const updateIWpsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/iwps/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateIWpsWorkHours
 * request: updateIWpsWorkHoursUsingPOST
 * url: updateIWpsWorkHoursUsingPOSTURL
 * method: updateIWpsWorkHoursUsingPOST_TYPE
 * raw_url: updateIWpsWorkHoursUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const updateIWpsWorkHoursUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/iwps/updateworkhours/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateIWpsWorkHoursUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/iwps/updateworkhours/{id}'
}
export const updateIWpsWorkHoursUsingPOST_TYPE = function() {
  return 'post'
}
export const updateIWpsWorkHoursUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/iwps/updateworkhours/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getIWps
 * request: getIWpsUsingGET
 * url: getIWpsUsingGETURL
 * method: getIWpsUsingGET_TYPE
 * raw_url: getIWpsUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getIWpsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/iwps/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getIWpsUsingGET_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/iwps/{id}'
}
export const getIWpsUsingGET_TYPE = function() {
  return 'get'
}
export const getIWpsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/iwps/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteIWps
 * request: deleteIWpsUsingDELETE
 * url: deleteIWpsUsingDELETEURL
 * method: deleteIWpsUsingDELETE_TYPE
 * raw_url: deleteIWpsUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteIWpsUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/iwps/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteIWpsUsingDELETE_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/iwps/{id}'
}
export const deleteIWpsUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteIWpsUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/iwps/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addWorkHours
 * request: addWorkHoursUsingPOST
 * url: addWorkHoursUsingPOSTURL
 * method: addWorkHoursUsingPOST_TYPE
 * raw_url: addWorkHoursUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param workhours - workhours
 */
export const addWorkHoursUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/workhours'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['workhours'] !== undefined) {
    body = parameters['workhours']
  }
  if (parameters['workhours'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: workhours'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addWorkHoursUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/workhours'
}
export const addWorkHoursUsingPOST_TYPE = function() {
  return 'post'
}
export const addWorkHoursUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/workhours'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteWorkHourss
 * request: deleteWorkHourssUsingDELETE
 * url: deleteWorkHourssUsingDELETEURL
 * method: deleteWorkHourssUsingDELETE_TYPE
 * raw_url: deleteWorkHourssUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteWorkHourssUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/workhours'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteWorkHourssUsingDELETE_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/workhours'
}
export const deleteWorkHourssUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteWorkHourssUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/workhours'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findWorkHours
 * request: findWorkHoursUsingPOST
 * url: findWorkHoursUsingPOSTURL
 * method: findWorkHoursUsingPOST_TYPE
 * raw_url: findWorkHoursUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param params - params
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findWorkHoursUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/workhours/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['params'] !== undefined) {
    body = parameters['params']
  }
  if (parameters['params'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: params'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findWorkHoursUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/workhours/getlist'
}
export const findWorkHoursUsingPOST_TYPE = function() {
  return 'post'
}
export const findWorkHoursUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/workhours/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateWorkHours
 * request: updateWorkHoursUsingPOST
 * url: updateWorkHoursUsingPOSTURL
 * method: updateWorkHoursUsingPOST_TYPE
 * raw_url: updateWorkHoursUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 * @param workhours - workhours
 */
export const updateWorkHoursUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/workhours/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['workhours'] !== undefined) {
    body = parameters['workhours']
  }
  if (parameters['workhours'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: workhours'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateWorkHoursUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/workhours/update/{id}'
}
export const updateWorkHoursUsingPOST_TYPE = function() {
  return 'post'
}
export const updateWorkHoursUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/workhours/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getWorkHours
 * request: getWorkHoursUsingGET
 * url: getWorkHoursUsingGETURL
 * method: getWorkHoursUsingGET_TYPE
 * raw_url: getWorkHoursUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getWorkHoursUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/workhours/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWorkHoursUsingGET_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/workhours/{id}'
}
export const getWorkHoursUsingGET_TYPE = function() {
  return 'get'
}
export const getWorkHoursUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/workhours/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteWorkHours
 * request: deleteWorkHoursUsingDELETE
 * url: deleteWorkHoursUsingDELETEURL
 * method: deleteWorkHoursUsingDELETE_TYPE
 * raw_url: deleteWorkHoursUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteWorkHoursUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/workhours/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteWorkHoursUsingDELETE_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/workhours/{id}'
}
export const deleteWorkHoursUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteWorkHoursUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/workhours/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addWorkPermitArea
 * request: addWorkPermitAreaUsingPOST
 * url: addWorkPermitAreaUsingPOSTURL
 * method: addWorkPermitAreaUsingPOST_TYPE
 * raw_url: addWorkPermitAreaUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param workpermitarea - workpermitarea
 */
export const addWorkPermitAreaUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/workpermitarea'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['workpermitarea'] !== undefined) {
    body = parameters['workpermitarea']
  }
  if (parameters['workpermitarea'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: workpermitarea'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addWorkPermitAreaUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/workpermitarea'
}
export const addWorkPermitAreaUsingPOST_TYPE = function() {
  return 'post'
}
export const addWorkPermitAreaUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/workpermitarea'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteWorkPermitAreas
 * request: deleteWorkPermitAreasUsingDELETE
 * url: deleteWorkPermitAreasUsingDELETEURL
 * method: deleteWorkPermitAreasUsingDELETE_TYPE
 * raw_url: deleteWorkPermitAreasUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteWorkPermitAreasUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/workpermitarea'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteWorkPermitAreasUsingDELETE_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/workpermitarea'
}
export const deleteWorkPermitAreasUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteWorkPermitAreasUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/workpermitarea'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteAttachById
 * request: deleteAttachByIdUsingDELETE_1
 * url: deleteAttachByIdUsingDELETE_1URL
 * method: deleteAttachByIdUsingDELETE_1_TYPE
 * raw_url: deleteAttachByIdUsingDELETE_1_RAW_URL
 * @param attid - attid
 * @param modulename - modulename
 */
export const deleteAttachByIdUsingDELETE_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/workpermitarea/attach/{attid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{attid}', `${parameters['attid']}`)
  if (parameters['attid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: attid'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteAttachByIdUsingDELETE_1_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/workpermitarea/attach/{attid}'
}
export const deleteAttachByIdUsingDELETE_1_TYPE = function() {
  return 'delete'
}
export const deleteAttachByIdUsingDELETE_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/workpermitarea/attach/{attid}'
  path = path.replace('{attid}', `${parameters['attid']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findWorkPermitArea
 * request: findWorkPermitAreaUsingPOST
 * url: findWorkPermitAreaUsingPOSTURL
 * method: findWorkPermitAreaUsingPOST_TYPE
 * raw_url: findWorkPermitAreaUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param params - params
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findWorkPermitAreaUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/workpermitarea/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['params'] !== undefined) {
    body = parameters['params']
  }
  if (parameters['params'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: params'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findWorkPermitAreaUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/workpermitarea/getlist'
}
export const findWorkPermitAreaUsingPOST_TYPE = function() {
  return 'post'
}
export const findWorkPermitAreaUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/workpermitarea/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getWorkPermitAreaByName
 * request: getWorkPermitAreaByNameUsingGET
 * url: getWorkPermitAreaByNameUsingGETURL
 * method: getWorkPermitAreaByNameUsingGET_TYPE
 * raw_url: getWorkPermitAreaByNameUsingGET_RAW_URL
 * @param modulename - modulename
 * @param name - name
 */
export const getWorkPermitAreaByNameUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/workpermitarea/name/{name}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{name}', `${parameters['name']}`)
  if (parameters['name'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: name'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWorkPermitAreaByNameUsingGET_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/workpermitarea/name/{name}'
}
export const getWorkPermitAreaByNameUsingGET_TYPE = function() {
  return 'get'
}
export const getWorkPermitAreaByNameUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/workpermitarea/name/{name}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{name}', `${parameters['name']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateWorkPermitArea
 * request: updateWorkPermitAreaUsingPOST
 * url: updateWorkPermitAreaUsingPOSTURL
 * method: updateWorkPermitAreaUsingPOST_TYPE
 * raw_url: updateWorkPermitAreaUsingPOST_RAW_URL
 * @param workPermitArea - WorkPermitArea
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 */
export const updateWorkPermitAreaUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/workpermitarea/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['workPermitArea'] !== undefined) {
    body = parameters['workPermitArea']
  }
  if (parameters['workPermitArea'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: workPermitArea'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateWorkPermitAreaUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/workpermitarea/update/{id}'
}
export const updateWorkPermitAreaUsingPOST_TYPE = function() {
  return 'post'
}
export const updateWorkPermitAreaUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/workpermitarea/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getWorkPermitArea
 * request: getWorkPermitAreaUsingGET
 * url: getWorkPermitAreaUsingGETURL
 * method: getWorkPermitAreaUsingGET_TYPE
 * raw_url: getWorkPermitAreaUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getWorkPermitAreaUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/workpermitarea/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWorkPermitAreaUsingGET_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/workpermitarea/{id}'
}
export const getWorkPermitAreaUsingGET_TYPE = function() {
  return 'get'
}
export const getWorkPermitAreaUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/workpermitarea/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteWorkPermitArea
 * request: deleteWorkPermitAreaUsingDELETE
 * url: deleteWorkPermitAreaUsingDELETEURL
 * method: deleteWorkPermitAreaUsingDELETE_TYPE
 * raw_url: deleteWorkPermitAreaUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteWorkPermitAreaUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/workpermitarea/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteWorkPermitAreaUsingDELETE_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/workpermitarea/{id}'
}
export const deleteWorkPermitAreaUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteWorkPermitAreaUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/workpermitarea/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addWorkSteps
 * request: addWorkStepsUsingPOST
 * url: addWorkStepsUsingPOSTURL
 * method: addWorkStepsUsingPOST_TYPE
 * raw_url: addWorkStepsUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param worksteps - worksteps
 */
export const addWorkStepsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/worksteps'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['worksteps'] !== undefined) {
    body = parameters['worksteps']
  }
  if (parameters['worksteps'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: worksteps'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addWorkStepsUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/worksteps'
}
export const addWorkStepsUsingPOST_TYPE = function() {
  return 'post'
}
export const addWorkStepsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/worksteps'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteWorkStepss
 * request: deleteWorkStepssUsingDELETE
 * url: deleteWorkStepssUsingDELETEURL
 * method: deleteWorkStepssUsingDELETE_TYPE
 * raw_url: deleteWorkStepssUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteWorkStepssUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/worksteps'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteWorkStepssUsingDELETE_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/worksteps'
}
export const deleteWorkStepssUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteWorkStepssUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/worksteps'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 通过工单查询构件和工步  findComponentsByIwps
 * request: findComponentsByIwpsUsingPOST
 * url: findComponentsByIwpsUsingPOSTURL
 * method: findComponentsByIwpsUsingPOST_TYPE
 * raw_url: findComponentsByIwpsUsingPOST_RAW_URL
 * @param iwpsid - iwpsid
 * @param modulename - modulename
 */
export const findComponentsByIwpsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/worksteps/findcomsteps/{iwpsid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{iwpsid}', `${parameters['iwpsid']}`)
  if (parameters['iwpsid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: iwpsid'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findComponentsByIwpsUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/worksteps/findcomsteps/{iwpsid}'
}
export const findComponentsByIwpsUsingPOST_TYPE = function() {
  return 'post'
}
export const findComponentsByIwpsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/worksteps/findcomsteps/{iwpsid}'
  path = path.replace('{iwpsid}', `${parameters['iwpsid']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getComponentsStepsList
 * request: getComponentsStepsListUsingPOST
 * url: getComponentsStepsListUsingPOSTURL
 * method: getComponentsStepsListUsingPOST_TYPE
 * raw_url: getComponentsStepsListUsingPOST_RAW_URL
 * @param comids - comids
 * @param modulename - modulename
 */
export const getComponentsStepsListUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/worksteps/getcstepslist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['comids'] !== undefined) {
    body = parameters['comids']
  }
  if (parameters['comids'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: comids'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getComponentsStepsListUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/worksteps/getcstepslist'
}
export const getComponentsStepsListUsingPOST_TYPE = function() {
  return 'post'
}
export const getComponentsStepsListUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/worksteps/getcstepslist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findWorkSteps
 * request: findWorkStepsUsingPOST
 * url: findWorkStepsUsingPOSTURL
 * method: findWorkStepsUsingPOST_TYPE
 * raw_url: findWorkStepsUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param params - params
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findWorkStepsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/worksteps/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['params'] !== undefined) {
    body = parameters['params']
  }
  if (parameters['params'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: params'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findWorkStepsUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/worksteps/getlist'
}
export const findWorkStepsUsingPOST_TYPE = function() {
  return 'post'
}
export const findWorkStepsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/worksteps/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getComponentsStepsList
 * request: getWorkStepsListByWorkTypeUsingPOST
 * url: getWorkStepsListByWorkTypeUsingPOSTURL
 * method: getWorkStepsListByWorkTypeUsingPOST_TYPE
 * raw_url: getWorkStepsListByWorkTypeUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param worktype - worktype
 */
export const getWorkStepsListByWorkTypeUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/worksteps/getlistbyworktype/{worktype}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{worktype}', `${parameters['worktype']}`)
  if (parameters['worktype'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: worktype'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getWorkStepsListByWorkTypeUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/worksteps/getlistbyworktype/{worktype}'
}
export const getWorkStepsListByWorkTypeUsingPOST_TYPE = function() {
  return 'post'
}
export const getWorkStepsListByWorkTypeUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/worksteps/getlistbyworktype/{worktype}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{worktype}', `${parameters['worktype']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getComponentsStepsList
 * request: getWorkStepsListUsingPOST
 * url: getWorkStepsListUsingPOSTURL
 * method: getWorkStepsListUsingPOST_TYPE
 * raw_url: getWorkStepsListUsingPOST_RAW_URL
 * @param comids - comids
 * @param discipline - discipline
 * @param modulename - modulename
 * @param worktype - worktype
 */
export const getWorkStepsListUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/worksteps/getwstepslist/{discipline}/{worktype}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['comids'] !== undefined) {
    body = parameters['comids']
  }
  if (parameters['comids'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: comids'))
  }
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{worktype}', `${parameters['worktype']}`)
  if (parameters['worktype'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: worktype'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getWorkStepsListUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/worksteps/getwstepslist/{discipline}/{worktype}'
}
export const getWorkStepsListUsingPOST_TYPE = function() {
  return 'post'
}
export const getWorkStepsListUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/worksteps/getwstepslist/{discipline}/{worktype}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{worktype}', `${parameters['worktype']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * insertData
 * request: insertDataUsingPOST
 * url: insertDataUsingPOSTURL
 * method: insertDataUsingPOST_TYPE
 * raw_url: insertDataUsingPOST_RAW_URL
 * @param modulename - modulename
 */
export const insertDataUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/worksteps/insertTestData'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const insertDataUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/worksteps/insertTestData'
}
export const insertDataUsingPOST_TYPE = function() {
  return 'post'
}
export const insertDataUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/worksteps/insertTestData'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateWorkSteps
 * request: updateWorkStepsUsingPOST
 * url: updateWorkStepsUsingPOSTURL
 * method: updateWorkStepsUsingPOST_TYPE
 * raw_url: updateWorkStepsUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 * @param worksteps - worksteps
 */
export const updateWorkStepsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/worksteps/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['worksteps'] !== undefined) {
    body = parameters['worksteps']
  }
  if (parameters['worksteps'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: worksteps'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateWorkStepsUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/worksteps/update/{id}'
}
export const updateWorkStepsUsingPOST_TYPE = function() {
  return 'post'
}
export const updateWorkStepsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/worksteps/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * key:config, discipline, worktype, data. data=List<WorkSteps>
 * request: updateWorkStepsByWorkItemUsingPOST
 * url: updateWorkStepsByWorkItemUsingPOSTURL
 * method: updateWorkStepsByWorkItemUsingPOST_TYPE
 * raw_url: updateWorkStepsByWorkItemUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const updateWorkStepsByWorkItemUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/worksteps/updateworkitem'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateWorkStepsByWorkItemUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/worksteps/updateworkitem'
}
export const updateWorkStepsByWorkItemUsingPOST_TYPE = function() {
  return 'post'
}
export const updateWorkStepsByWorkItemUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/worksteps/updateworkitem'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * key:config, discipline, worktype, data. data=List<WorkSteps>
 * request: updateWorkStepsByWorkItemNameUsingPOST
 * url: updateWorkStepsByWorkItemNameUsingPOSTURL
 * method: updateWorkStepsByWorkItemNameUsingPOST_TYPE
 * raw_url: updateWorkStepsByWorkItemNameUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param vo - vo
 */
export const updateWorkStepsByWorkItemNameUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/worksteps/workitem'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateWorkStepsByWorkItemNameUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/worksteps/workitem'
}
export const updateWorkStepsByWorkItemNameUsingPOST_TYPE = function() {
  return 'post'
}
export const updateWorkStepsByWorkItemNameUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/worksteps/workitem'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getWorkSteps
 * request: getWorkStepsUsingGET
 * url: getWorkStepsUsingGETURL
 * method: getWorkStepsUsingGET_TYPE
 * raw_url: getWorkStepsUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getWorkStepsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/worksteps/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWorkStepsUsingGET_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/worksteps/{id}'
}
export const getWorkStepsUsingGET_TYPE = function() {
  return 'get'
}
export const getWorkStepsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/worksteps/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteWorkSteps
 * request: deleteWorkStepsUsingDELETE
 * url: deleteWorkStepsUsingDELETEURL
 * method: deleteWorkStepsUsingDELETE_TYPE
 * raw_url: deleteWorkStepsUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteWorkStepsUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/worksteps/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteWorkStepsUsingDELETE_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/worksteps/{id}'
}
export const deleteWorkStepsUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteWorkStepsUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/worksteps/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addWorkType
 * request: addWorkTypeUsingPOST
 * url: addWorkTypeUsingPOSTURL
 * method: addWorkTypeUsingPOST_TYPE
 * raw_url: addWorkTypeUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param worktype - worktype
 */
export const addWorkTypeUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/worktype'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['worktype'] !== undefined) {
    body = parameters['worktype']
  }
  if (parameters['worktype'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: worktype'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addWorkTypeUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/worktype'
}
export const addWorkTypeUsingPOST_TYPE = function() {
  return 'post'
}
export const addWorkTypeUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/worktype'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteWorkTypes
 * request: deleteWorkTypesUsingDELETE
 * url: deleteWorkTypesUsingDELETEURL
 * method: deleteWorkTypesUsingDELETE_TYPE
 * raw_url: deleteWorkTypesUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteWorkTypesUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/worktype'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteWorkTypesUsingDELETE_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/worktype'
}
export const deleteWorkTypesUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteWorkTypesUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/worktype'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findWorkType
 * request: findWorkTypeUsingPOST
 * url: findWorkTypeUsingPOSTURL
 * method: findWorkTypeUsingPOST_TYPE
 * raw_url: findWorkTypeUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findWorkTypeUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/worktype/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findWorkTypeUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/worktype/getlist'
}
export const findWorkTypeUsingPOST_TYPE = function() {
  return 'post'
}
export const findWorkTypeUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/worktype/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateWorkType
 * request: updateWorkTypeUsingPOST
 * url: updateWorkTypeUsingPOSTURL
 * method: updateWorkTypeUsingPOST_TYPE
 * raw_url: updateWorkTypeUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 * @param worktype - worktype
 */
export const updateWorkTypeUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/worktype/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['worktype'] !== undefined) {
    body = parameters['worktype']
  }
  if (parameters['worktype'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: worktype'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateWorkTypeUsingPOST_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/worktype/update/{id}'
}
export const updateWorkTypeUsingPOST_TYPE = function() {
  return 'post'
}
export const updateWorkTypeUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/worktype/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getWorkType
 * request: getWorkTypeUsingGET
 * url: getWorkTypeUsingGETURL
 * method: getWorkTypeUsingGET_TYPE
 * raw_url: getWorkTypeUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getWorkTypeUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/worktype/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWorkTypeUsingGET_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/worktype/{id}'
}
export const getWorkTypeUsingGET_TYPE = function() {
  return 'get'
}
export const getWorkTypeUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/worktype/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteWorkType
 * request: deleteWorkTypeUsingDELETE
 * url: deleteWorkTypeUsingDELETEURL
 * method: deleteWorkTypeUsingDELETE_TYPE
 * raw_url: deleteWorkTypeUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteWorkTypeUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/tr/{modulename}/worktype/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteWorkTypeUsingDELETE_RAW_URL = function() {
  return '/api/v1/tr/{modulename}/worktype/{id}'
}
export const deleteWorkTypeUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteWorkTypeUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/tr/{modulename}/worktype/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 部署工作流
 * request: saveWorkflowModuleUsingPOST
 * url: saveWorkflowModuleUsingPOSTURL
 * method: saveWorkflowModuleUsingPOST_TYPE
 * raw_url: saveWorkflowModuleUsingPOST_RAW_URL
 * @param bpmnName - bpmnName
 */
export const saveWorkflowModuleUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/deploy/offline/{bpmnName}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{bpmnName}', `${parameters['bpmnName']}`)
  if (parameters['bpmnName'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: bpmnName'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const saveWorkflowModuleUsingPOST_RAW_URL = function() {
  return '/api/v1/workflow/deploy/offline/{bpmnName}'
}
export const saveWorkflowModuleUsingPOST_TYPE = function() {
  return 'post'
}
export const saveWorkflowModuleUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/deploy/offline/{bpmnName}'
  path = path.replace('{bpmnName}', `${parameters['bpmnName']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 部署模型
 * request: deploymodelUsingPOST
 * url: deploymodelUsingPOSTURL
 * method: deploymodelUsingPOST_TYPE
 * raw_url: deploymodelUsingPOST_RAW_URL
 * @param modelId - modelId
 */
export const deploymodelUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/deploy/{modelId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modelId}', `${parameters['modelId']}`)
  if (parameters['modelId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modelId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const deploymodelUsingPOST_RAW_URL = function() {
  return '/api/v1/workflow/deploy/{modelId}'
}
export const deploymodelUsingPOST_TYPE = function() {
  return 'post'
}
export const deploymodelUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/deploy/{modelId}'
  path = path.replace('{modelId}', `${parameters['modelId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getProcessDefineXML
 * request: getProcessDefineXMLUsingGET
 * url: getProcessDefineXMLUsingGETURL
 * method: getProcessDefineXMLUsingGET_TYPE
 * raw_url: getProcessDefineXMLUsingGET_RAW_URL
 * @param deploymentId - deploymentId
 * @param resourceName - resourceName
 */
export const getProcessDefineXMLUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/getDefinitionXML'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['deploymentId'] !== undefined) {
    queryParameters['deploymentId'] = parameters['deploymentId']
  }
  if (parameters['deploymentId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: deploymentId'))
  }
  if (parameters['resourceName'] !== undefined) {
    queryParameters['resourceName'] = parameters['resourceName']
  }
  if (parameters['resourceName'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: resourceName'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProcessDefineXMLUsingGET_RAW_URL = function() {
  return '/api/v1/workflow/getDefinitionXML'
}
export const getProcessDefineXMLUsingGET_TYPE = function() {
  return 'get'
}
export const getProcessDefineXMLUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/getDefinitionXML'
  if (parameters['deploymentId'] !== undefined) {
    queryParameters['deploymentId'] = parameters['deploymentId']
  }
  if (parameters['resourceName'] !== undefined) {
    queryParameters['resourceName'] = parameters['resourceName']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取工作流状态
 * request: getApplyStatusUsingGET
 * url: getApplyStatusUsingGETURL
 * method: getApplyStatusUsingGET_TYPE
 * raw_url: getApplyStatusUsingGET_RAW_URL
 * @param instanceId - instanceId
 * @param name - 
 */
export const getApplyStatusUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/getWFStatus/{instanceId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{instanceId}', `${parameters['instanceId']}`)
  if (parameters['instanceId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: instanceId'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getApplyStatusUsingGET_RAW_URL = function() {
  return '/api/v1/workflow/getWFStatus/{instanceId}'
}
export const getApplyStatusUsingGET_TYPE = function() {
  return 'get'
}
export const getApplyStatusUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/getWFStatus/{instanceId}'
  path = path.replace('{instanceId}', `${parameters['instanceId']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取最新版本流程定义集合，lastVersionProcessDefinitionList
 * request: lastVersionProcessDefinitionListUsingPOST
 * url: lastVersionProcessDefinitionListUsingPOSTURL
 * method: lastVersionProcessDefinitionListUsingPOST_TYPE
 * raw_url: lastVersionProcessDefinitionListUsingPOST_RAW_URL
 * @param offset - 
 * @param page - 请求页数
 * @param pageNumber - 
 * @param pageSize - 
 * @param paged - 
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param sortSorted - 
 * @param sortUnsorted - 
 * @param unpaged - 
 * @param vo - vo
 */
export const lastVersionProcessDefinitionListUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/lastVersionProcessDefinitionList/list'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['offset'] !== undefined) {
    queryParameters['offset'] = parameters['offset']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['pageNumber'] !== undefined) {
    queryParameters['pageNumber'] = parameters['pageNumber']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['pageSize'] = parameters['pageSize']
  }
  if (parameters['paged'] !== undefined) {
    queryParameters['paged'] = parameters['paged']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['sortSorted'] !== undefined) {
    queryParameters['sort.sorted'] = parameters['sortSorted']
  }
  if (parameters['sortUnsorted'] !== undefined) {
    queryParameters['sort.unsorted'] = parameters['sortUnsorted']
  }
  if (parameters['unpaged'] !== undefined) {
    queryParameters['unpaged'] = parameters['unpaged']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const lastVersionProcessDefinitionListUsingPOST_RAW_URL = function() {
  return '/api/v1/workflow/lastVersionProcessDefinitionList/list'
}
export const lastVersionProcessDefinitionListUsingPOST_TYPE = function() {
  return 'post'
}
export const lastVersionProcessDefinitionListUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/lastVersionProcessDefinitionList/list'
  if (parameters['offset'] !== undefined) {
    queryParameters['offset'] = parameters['offset']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['pageNumber'] !== undefined) {
    queryParameters['pageNumber'] = parameters['pageNumber']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['pageSize'] = parameters['pageSize']
  }
  if (parameters['paged'] !== undefined) {
    queryParameters['paged'] = parameters['paged']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['sortSorted'] !== undefined) {
    queryParameters['sort.sorted'] = parameters['sortSorted']
  }
  if (parameters['sortUnsorted'] !== undefined) {
    queryParameters['sort.unsorted'] = parameters['sortUnsorted']
  }
  if (parameters['unpaged'] !== undefined) {
    queryParameters['unpaged'] = parameters['unpaged']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回所有定义的工作流模型
 * request: workflowmodellistUsingGET
 * url: workflowmodellistUsingGETURL
 * method: workflowmodellistUsingGET_TYPE
 * raw_url: workflowmodellistUsingGET_RAW_URL
 */
export const workflowmodellistUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/modellist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const workflowmodellistUsingGET_RAW_URL = function() {
  return '/api/v1/workflow/modellist'
}
export const workflowmodellistUsingGET_TYPE = function() {
  return 'get'
}
export const workflowmodellistUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/modellist'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取工作流定义，getDefinitionsByInstanceId
 * request: getDefinitionsByInstanceIdUsingGET
 * url: getDefinitionsByInstanceIdUsingGETURL
 * method: getDefinitionsByInstanceIdUsingGET_TYPE
 * raw_url: getDefinitionsByInstanceIdUsingGET_RAW_URL
 * @param instanceId - instanceId
 */
export const getDefinitionsByInstanceIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/processDefinition/getDefinitions/{instanceId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{instanceId}', `${parameters['instanceId']}`)
  if (parameters['instanceId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: instanceId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDefinitionsByInstanceIdUsingGET_RAW_URL = function() {
  return '/api/v1/workflow/processDefinition/getDefinitions/{instanceId}'
}
export const getDefinitionsByInstanceIdUsingGET_TYPE = function() {
  return 'get'
}
export const getDefinitionsByInstanceIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/processDefinition/getDefinitions/{instanceId}'
  path = path.replace('{instanceId}', `${parameters['instanceId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取流程定义集合，processDefinitionList
 * request: processDefinitionListUsingPOST
 * url: processDefinitionListUsingPOSTURL
 * method: processDefinitionListUsingPOST_TYPE
 * raw_url: processDefinitionListUsingPOST_RAW_URL
 * @param offset - 
 * @param page - 请求页数
 * @param pageNumber - 
 * @param pageSize - 
 * @param paged - 
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param sortSorted - 
 * @param sortUnsorted - 
 * @param unpaged - 
 * @param vo - vo
 */
export const processDefinitionListUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/processDefinition/list'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['offset'] !== undefined) {
    queryParameters['offset'] = parameters['offset']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['pageNumber'] !== undefined) {
    queryParameters['pageNumber'] = parameters['pageNumber']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['pageSize'] = parameters['pageSize']
  }
  if (parameters['paged'] !== undefined) {
    queryParameters['paged'] = parameters['paged']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['sortSorted'] !== undefined) {
    queryParameters['sort.sorted'] = parameters['sortSorted']
  }
  if (parameters['sortUnsorted'] !== undefined) {
    queryParameters['sort.unsorted'] = parameters['sortUnsorted']
  }
  if (parameters['unpaged'] !== undefined) {
    queryParameters['unpaged'] = parameters['unpaged']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const processDefinitionListUsingPOST_RAW_URL = function() {
  return '/api/v1/workflow/processDefinition/list'
}
export const processDefinitionListUsingPOST_TYPE = function() {
  return 'post'
}
export const processDefinitionListUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/processDefinition/list'
  if (parameters['offset'] !== undefined) {
    queryParameters['offset'] = parameters['offset']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['pageNumber'] !== undefined) {
    queryParameters['pageNumber'] = parameters['pageNumber']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['pageSize'] = parameters['pageSize']
  }
  if (parameters['paged'] !== undefined) {
    queryParameters['paged'] = parameters['paged']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['sortSorted'] !== undefined) {
    queryParameters['sort.sorted'] = parameters['sortSorted']
  }
  if (parameters['sortUnsorted'] !== undefined) {
    queryParameters['sort.unsorted'] = parameters['sortUnsorted']
  }
  if (parameters['unpaged'] !== undefined) {
    queryParameters['unpaged'] = parameters['unpaged']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 流程定义删除，delDefinition
 * request: delDefinitionUsingDELETE
 * url: delDefinitionUsingDELETEURL
 * method: delDefinitionUsingDELETE_TYPE
 * raw_url: delDefinitionUsingDELETE_RAW_URL
 * @param deploymentId - deploymentId
 */
export const delDefinitionUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/processDefinition/remove/{deploymentId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{deploymentId}', `${parameters['deploymentId']}`)
  if (parameters['deploymentId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: deploymentId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const delDefinitionUsingDELETE_RAW_URL = function() {
  return '/api/v1/workflow/processDefinition/remove/{deploymentId}'
}
export const delDefinitionUsingDELETE_TYPE = function() {
  return 'delete'
}
export const delDefinitionUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/processDefinition/remove/{deploymentId}'
  path = path.replace('{deploymentId}', `${parameters['deploymentId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取工作流定义，getProcessDefinition
 * request: getProcessDefinitionUsingGET_1
 * url: getProcessDefinitionUsingGET_1URL
 * method: getProcessDefinitionUsingGET_1_TYPE
 * raw_url: getProcessDefinitionUsingGET_1_RAW_URL
 * @param defineId - defineId
 */
export const getProcessDefinitionUsingGET_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/processDefinition/{defineId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{defineId}', `${parameters['defineId']}`)
  if (parameters['defineId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: defineId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProcessDefinitionUsingGET_1_RAW_URL = function() {
  return '/api/v1/workflow/processDefinition/{defineId}'
}
export const getProcessDefinitionUsingGET_1_TYPE = function() {
  return 'get'
}
export const getProcessDefinitionUsingGET_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/processDefinition/{defineId}'
  path = path.replace('{defineId}', `${parameters['defineId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 流程实例由我审批(已办)，processAssigneeByUser
 * request: processAssigneeByUserUsingGET
 * url: processAssigneeByUserUsingGETURL
 * method: processAssigneeByUserUsingGET_TYPE
 * raw_url: processAssigneeByUserUsingGET_RAW_URL
 * @param loginName - loginName
 * @param processDefKey - processDefKey
 */
export const processAssigneeByUserUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/processInstance/assigneeByMe/{loginName}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{loginName}', `${parameters['loginName']}`)
  if (parameters['loginName'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: loginName'))
  }
  path = path.replace('{processDefKey}', `${parameters['processDefKey']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const processAssigneeByUserUsingGET_RAW_URL = function() {
  return '/api/v1/workflow/processInstance/assigneeByMe/{loginName}'
}
export const processAssigneeByUserUsingGET_TYPE = function() {
  return 'get'
}
export const processAssigneeByUserUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/processInstance/assigneeByMe/{loginName}'
  path = path.replace('{loginName}', `${parameters['loginName']}`)
  path = path.replace('{processDefKey}', `${parameters['processDefKey']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 流程实例由我审批(已办)，processAssigneeByUser
 * request: processAssigneeByUserUsingGET_1
 * url: processAssigneeByUserUsingGET_1URL
 * method: processAssigneeByUserUsingGET_1_TYPE
 * raw_url: processAssigneeByUserUsingGET_1_RAW_URL
 * @param loginName - loginName
 * @param processDefKey - processDefKey
 */
export const processAssigneeByUserUsingGET_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/processInstance/assigneeByMe/{loginName}/{processDefKey}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{loginName}', `${parameters['loginName']}`)
  if (parameters['loginName'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: loginName'))
  }
  path = path.replace('{processDefKey}', `${parameters['processDefKey']}`)
  if (parameters['processDefKey'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: processDefKey'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const processAssigneeByUserUsingGET_1_RAW_URL = function() {
  return '/api/v1/workflow/processInstance/assigneeByMe/{loginName}/{processDefKey}'
}
export const processAssigneeByUserUsingGET_1_TYPE = function() {
  return 'get'
}
export const processAssigneeByUserUsingGET_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/processInstance/assigneeByMe/{loginName}/{processDefKey}'
  path = path.replace('{loginName}', `${parameters['loginName']}`)
  path = path.replace('{processDefKey}', `${parameters['processDefKey']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 流程实例删除，delProcessInstance
 * request: delProcessInstanceUsingDELETE
 * url: delProcessInstanceUsingDELETEURL
 * method: delProcessInstanceUsingDELETE_TYPE
 * raw_url: delProcessInstanceUsingDELETE_RAW_URL
 * @param processInsId - processInsId
 */
export const delProcessInstanceUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/processInstance/remove/{processInsId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{processInsId}', `${parameters['processInsId']}`)
  if (parameters['processInsId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: processInsId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const delProcessInstanceUsingDELETE_RAW_URL = function() {
  return '/api/v1/workflow/processInstance/remove/{processInsId}'
}
export const delProcessInstanceUsingDELETE_TYPE = function() {
  return 'delete'
}
export const delProcessInstanceUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/processInstance/remove/{processInsId}'
  path = path.replace('{processInsId}', `${parameters['processInsId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * bean相关流程实例删除，delProcessInstanceRelateBean
 * request: delProcessInstanceRelateBeanUsingDELETE
 * url: delProcessInstanceRelateBeanUsingDELETEURL
 * method: delProcessInstanceRelateBeanUsingDELETE_TYPE
 * raw_url: delProcessInstanceRelateBeanUsingDELETE_RAW_URL
 * @param beanId - beanId
 */
export const delProcessInstanceRelateBeanUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/processInstance/removeRelateBean/{beanId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{beanId}', `${parameters['beanId']}`)
  if (parameters['beanId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: beanId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const delProcessInstanceRelateBeanUsingDELETE_RAW_URL = function() {
  return '/api/v1/workflow/processInstance/removeRelateBean/{beanId}'
}
export const delProcessInstanceRelateBeanUsingDELETE_TYPE = function() {
  return 'delete'
}
export const delProcessInstanceRelateBeanUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/processInstance/removeRelateBean/{beanId}'
  path = path.replace('{beanId}', `${parameters['beanId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * suspendOrActiveApply
 * request: suspendOrActiveApplyUsingPOST
 * url: suspendOrActiveApplyUsingPOSTURL
 * method: suspendOrActiveApplyUsingPOST_TYPE
 * raw_url: suspendOrActiveApplyUsingPOST_RAW_URL
 * @param processDefinition - processDefinition
 */
export const suspendOrActiveApplyUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/suspendOrActiveApply'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['processDefinition'] !== undefined) {
    body = parameters['processDefinition']
  }
  if (parameters['processDefinition'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: processDefinition'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const suspendOrActiveApplyUsingPOST_RAW_URL = function() {
  return '/api/v1/workflow/suspendOrActiveApply'
}
export const suspendOrActiveApplyUsingPOST_TYPE = function() {
  return 'post'
}
export const suspendOrActiveApplyUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/suspendOrActiveApply'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取当前任务 的下个节点（多个），getCurrentNextTask
 * request: getCurrentNextTaskUsingGET
 * url: getCurrentNextTaskUsingGETURL
 * method: getCurrentNextTaskUsingGET_TYPE
 * raw_url: getCurrentNextTaskUsingGET_RAW_URL
 * @param processDefKey - processDefKey
 * @param taskId - taskId
 */
export const getCurrentNextTaskUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/task/nexTask/{processDefKey}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{processDefKey}', `${parameters['processDefKey']}`)
  if (parameters['processDefKey'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: processDefKey'))
  }
  path = path.replace('{taskId}', `${parameters['taskId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCurrentNextTaskUsingGET_RAW_URL = function() {
  return '/api/v1/workflow/task/nexTask/{processDefKey}'
}
export const getCurrentNextTaskUsingGET_TYPE = function() {
  return 'get'
}
export const getCurrentNextTaskUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/task/nexTask/{processDefKey}'
  path = path.replace('{processDefKey}', `${parameters['processDefKey']}`)
  path = path.replace('{taskId}', `${parameters['taskId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取当前任务 的下个节点（多个），getCurrentNextTask
 * request: getCurrentNextTaskUsingGET_1
 * url: getCurrentNextTaskUsingGET_1URL
 * method: getCurrentNextTaskUsingGET_1_TYPE
 * raw_url: getCurrentNextTaskUsingGET_1_RAW_URL
 * @param processDefKey - processDefKey
 * @param taskId - taskId
 */
export const getCurrentNextTaskUsingGET_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/task/nexTask/{taskId}/{processDefKey}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{processDefKey}', `${parameters['processDefKey']}`)
  if (parameters['processDefKey'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: processDefKey'))
  }
  path = path.replace('{taskId}', `${parameters['taskId']}`)
  if (parameters['taskId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCurrentNextTaskUsingGET_1_RAW_URL = function() {
  return '/api/v1/workflow/task/nexTask/{taskId}/{processDefKey}'
}
export const getCurrentNextTaskUsingGET_1_TYPE = function() {
  return 'get'
}
export const getCurrentNextTaskUsingGET_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/task/nexTask/{taskId}/{processDefKey}'
  path = path.replace('{processDefKey}', `${parameters['processDefKey']}`)
  path = path.replace('{taskId}', `${parameters['taskId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取当前任务 的下个节点（多个），getCurrentNextTaskMap
 * request: getCurrentNextTaskMapUsingGET
 * url: getCurrentNextTaskMapUsingGETURL
 * method: getCurrentNextTaskMapUsingGET_TYPE
 * raw_url: getCurrentNextTaskMapUsingGET_RAW_URL
 * @param processDefKey - processDefKey
 * @param taskId - taskId
 */
export const getCurrentNextTaskMapUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/task/nexTaskMap/{processDefKey}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{processDefKey}', `${parameters['processDefKey']}`)
  if (parameters['processDefKey'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: processDefKey'))
  }
  path = path.replace('{taskId}', `${parameters['taskId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCurrentNextTaskMapUsingGET_RAW_URL = function() {
  return '/api/v1/workflow/task/nexTaskMap/{processDefKey}'
}
export const getCurrentNextTaskMapUsingGET_TYPE = function() {
  return 'get'
}
export const getCurrentNextTaskMapUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/task/nexTaskMap/{processDefKey}'
  path = path.replace('{processDefKey}', `${parameters['processDefKey']}`)
  path = path.replace('{taskId}', `${parameters['taskId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取当前任务 的下个节点（多个），getCurrentNextTaskMap
 * request: getCurrentNextTaskMapUsingGET_1
 * url: getCurrentNextTaskMapUsingGET_1URL
 * method: getCurrentNextTaskMapUsingGET_1_TYPE
 * raw_url: getCurrentNextTaskMapUsingGET_1_RAW_URL
 * @param processDefKey - processDefKey
 * @param taskId - taskId
 */
export const getCurrentNextTaskMapUsingGET_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/task/nexTaskMap/{taskId}/{processDefKey}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{processDefKey}', `${parameters['processDefKey']}`)
  if (parameters['processDefKey'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: processDefKey'))
  }
  path = path.replace('{taskId}', `${parameters['taskId']}`)
  if (parameters['taskId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCurrentNextTaskMapUsingGET_1_RAW_URL = function() {
  return '/api/v1/workflow/task/nexTaskMap/{taskId}/{processDefKey}'
}
export const getCurrentNextTaskMapUsingGET_1_TYPE = function() {
  return 'get'
}
export const getCurrentNextTaskMapUsingGET_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/task/nexTaskMap/{taskId}/{processDefKey}'
  path = path.replace('{processDefKey}', `${parameters['processDefKey']}`)
  path = path.replace('{taskId}', `${parameters['taskId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取工作流历史，workflowCommentList
 * request: workflowCommentListUsingGET
 * url: workflowCommentListUsingGETURL
 * method: workflowCommentListUsingGET_TYPE
 * raw_url: workflowCommentListUsingGET_RAW_URL
 * @param beanid - beanid
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const workflowCommentListUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/workflowComment/{beanid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{beanid}', `${parameters['beanid']}`)
  if (parameters['beanid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: beanid'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const workflowCommentListUsingGET_RAW_URL = function() {
  return '/api/v1/workflow/workflowComment/{beanid}'
}
export const workflowCommentListUsingGET_TYPE = function() {
  return 'get'
}
export const workflowCommentListUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/workflowComment/{beanid}'
  path = path.replace('{beanid}', `${parameters['beanid']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取指定工作流历史，workflowCommentList
 * request: workflowCommentListUsingGET_1
 * url: workflowCommentListUsingGET_1URL
 * method: workflowCommentListUsingGET_1_TYPE
 * raw_url: workflowCommentListUsingGET_1_RAW_URL
 * @param beanid - beanid
 * @param instanceId - instanceId
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const workflowCommentListUsingGET_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/workflowComment/{instanceId}/{beanid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{beanid}', `${parameters['beanid']}`)
  if (parameters['beanid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: beanid'))
  }
  path = path.replace('{instanceId}', `${parameters['instanceId']}`)
  if (parameters['instanceId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: instanceId'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const workflowCommentListUsingGET_1_RAW_URL = function() {
  return '/api/v1/workflow/workflowComment/{instanceId}/{beanid}'
}
export const workflowCommentListUsingGET_1_TYPE = function() {
  return 'get'
}
export const workflowCommentListUsingGET_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/workflowComment/{instanceId}/{beanid}'
  path = path.replace('{beanid}', `${parameters['beanid']}`)
  path = path.replace('{instanceId}', `${parameters['instanceId']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取所有已办工作，allFinishedTaskList
 * request: allFinishedTaskListUsingPOST
 * url: allFinishedTaskListUsingPOSTURL
 * method: allFinishedTaskListUsingPOST_TYPE
 * raw_url: allFinishedTaskListUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param page - 请求页数
 * @param principal - 
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const allFinishedTaskListUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/allFinishedTaskList'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const allFinishedTaskListUsingPOST_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/allFinishedTaskList'
}
export const allFinishedTaskListUsingPOST_TYPE = function() {
  return 'post'
}
export const allFinishedTaskListUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/allFinishedTaskList'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取用户已办工作，finishedTaskList
 * request: finishedTaskListUsingPOST
 * url: finishedTaskListUsingPOSTURL
 * method: finishedTaskListUsingPOST_TYPE
 * raw_url: finishedTaskListUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param page - 请求页数
 * @param principal - 
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const finishedTaskListUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/finishedtasklist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const finishedTaskListUsingPOST_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/finishedtasklist'
}
export const finishedTaskListUsingPOST_TYPE = function() {
  return 'post'
}
export const finishedTaskListUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/finishedtasklist'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 保存实体
 * request: saveBeanUsingPOST
 * url: saveBeanUsingPOSTURL
 * method: saveBeanUsingPOST_TYPE
 * raw_url: saveBeanUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param principal - 
 * @param taskid - taskid
 * @param vo - vo
 */
export const saveBeanUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/onlySave/{taskid}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters['taskid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskid'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const saveBeanUsingPOST_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/onlySave/{taskid}'
}
export const saveBeanUsingPOST_TYPE = function() {
  return 'post'
}
export const saveBeanUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/onlySave/{taskid}'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取用户待办工作(可查询)，searchTaskList
 * request: searchTaskListUsingPOST
 * url: searchTaskListUsingPOSTURL
 * method: searchTaskListUsingPOST_TYPE
 * raw_url: searchTaskListUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param page - 请求页数
 * @param principal - 
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const searchTaskListUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/searchtasklist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchTaskListUsingPOST_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/searchtasklist'
}
export const searchTaskListUsingPOST_TYPE = function() {
  return 'post'
}
export const searchTaskListUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/searchtasklist'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 启动工作流
 * request: startWorkflowUsingPOST_2
 * url: startWorkflowUsingPOST_2URL
 * method: startWorkflowUsingPOST_2_TYPE
 * raw_url: startWorkflowUsingPOST_2_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 * @param workflowkey - workflowkey
 */
export const startWorkflowUsingPOST_2 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/startWorkflow/{workflowkey}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  path = path.replace('{workflowkey}', `${parameters['workflowkey']}`)
  if (parameters['workflowkey'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: workflowkey'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const startWorkflowUsingPOST_2_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/startWorkflow/{workflowkey}'
}
export const startWorkflowUsingPOST_2_TYPE = function() {
  return 'post'
}
export const startWorkflowUsingPOST_2URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/startWorkflow/{workflowkey}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  path = path.replace('{workflowkey}', `${parameters['workflowkey']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 启动工作流
 * request: startWorkflowAndSaveBeanUsingPOST
 * url: startWorkflowAndSaveBeanUsingPOSTURL
 * method: startWorkflowAndSaveBeanUsingPOST_TYPE
 * raw_url: startWorkflowAndSaveBeanUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 * @param workflowkey - workflowkey
 */
export const startWorkflowAndSaveBeanUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/startWorkflowAndSaveBean/{workflowkey}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  path = path.replace('{workflowkey}', `${parameters['workflowkey']}`)
  if (parameters['workflowkey'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: workflowkey'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const startWorkflowAndSaveBeanUsingPOST_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/startWorkflowAndSaveBean/{workflowkey}'
}
export const startWorkflowAndSaveBeanUsingPOST_TYPE = function() {
  return 'post'
}
export const startWorkflowAndSaveBeanUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/startWorkflowAndSaveBean/{workflowkey}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  path = path.replace('{workflowkey}', `${parameters['workflowkey']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 启动工作流,startWorkflowAndSaveBeanForConfigure
 * request: startWorkflowAndSaveBeanForConfigureUsingPOST
 * url: startWorkflowAndSaveBeanForConfigureUsingPOSTURL
 * method: startWorkflowAndSaveBeanForConfigureUsingPOST_TYPE
 * raw_url: startWorkflowAndSaveBeanForConfigureUsingPOST_RAW_URL
 * @param formDesignKey - formDesignKey
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 * @param workflowkey - workflowkey
 */
export const startWorkflowAndSaveBeanForConfigureUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/startWorkflowAndSaveBeanForConfigure/{workflowkey}/{formDesignKey}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{formDesignKey}', `${parameters['formDesignKey']}`)
  if (parameters['formDesignKey'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: formDesignKey'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  path = path.replace('{workflowkey}', `${parameters['workflowkey']}`)
  if (parameters['workflowkey'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: workflowkey'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const startWorkflowAndSaveBeanForConfigureUsingPOST_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/startWorkflowAndSaveBeanForConfigure/{workflowkey}/{formDesignKey}'
}
export const startWorkflowAndSaveBeanForConfigureUsingPOST_TYPE = function() {
  return 'post'
}
export const startWorkflowAndSaveBeanForConfigureUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/startWorkflowAndSaveBeanForConfigure/{workflowkey}/{formDesignKey}'
  path = path.replace('{formDesignKey}', `${parameters['formDesignKey']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  path = path.replace('{workflowkey}', `${parameters['workflowkey']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取用户指定待办工作信息
 * request: taskDetailUsingGET
 * url: taskDetailUsingGETURL
 * method: taskDetailUsingGET_TYPE
 * raw_url: taskDetailUsingGET_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param principal - 
 * @param taskid - taskid
 */
export const taskDetailUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/task/detail/{taskid}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters['taskid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const taskDetailUsingGET_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/task/detail/{taskid}'
}
export const taskDetailUsingGET_TYPE = function() {
  return 'get'
}
export const taskDetailUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/task/detail/{taskid}'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回任务的数据信息
 * request: taskformUsingPOST
 * url: taskformUsingPOSTURL
 * method: taskformUsingPOST_TYPE
 * raw_url: taskformUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param taskid - taskid
 * @param vo - vo
 */
export const taskformUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/task/form/{taskid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters['taskid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskid'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const taskformUsingPOST_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/task/form/{taskid}'
}
export const taskformUsingPOST_TYPE = function() {
  return 'post'
}
export const taskformUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/task/form/{taskid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回动态表单任务的数据信息
 * request: taskformForConfigUsingPOST
 * url: taskformForConfigUsingPOSTURL
 * method: taskformForConfigUsingPOST_TYPE
 * raw_url: taskformForConfigUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param taskid - taskid
 * @param vo - vo
 */
export const taskformForConfigUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/task/formforconfig/{taskid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters['taskid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskid'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const taskformForConfigUsingPOST_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/task/formforconfig/{taskid}'
}
export const taskformForConfigUsingPOST_TYPE = function() {
  return 'post'
}
export const taskformForConfigUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/task/formforconfig/{taskid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回任务步骤的候选人列表,taskAssigneeSelectList
 * request: taskAssigneeSelectListUsingPOST
 * url: taskAssigneeSelectListUsingPOSTURL
 * method: taskAssigneeSelectListUsingPOST_TYPE
 * raw_url: taskAssigneeSelectListUsingPOST_RAW_URL
 * @param decision - decision
 * @param modulename - modulename
 * @param processDefKey - processDefKey
 * @param taskid - taskid
 * @param vo - vo
 */
export const taskAssigneeSelectListUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/task/select/{processDefKey}/{taskid}/{decision}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{decision}', `${parameters['decision']}`)
  if (parameters['decision'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: decision'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{processDefKey}', `${parameters['processDefKey']}`)
  if (parameters['processDefKey'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: processDefKey'))
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters['taskid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskid'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const taskAssigneeSelectListUsingPOST_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/task/select/{processDefKey}/{taskid}/{decision}'
}
export const taskAssigneeSelectListUsingPOST_TYPE = function() {
  return 'post'
}
export const taskAssigneeSelectListUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/task/select/{processDefKey}/{taskid}/{decision}'
  path = path.replace('{decision}', `${parameters['decision']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{processDefKey}', `${parameters['processDefKey']}`)
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 任务转移，transferTask
 * request: transferTaskUsingPUT
 * url: transferTaskUsingPUTURL
 * method: transferTaskUsingPUT_TYPE
 * raw_url: transferTaskUsingPUT_RAW_URL
 * @param modulename - modulename
 * @param taskId - taskId
 * @param toUser - toUser
 */
export const transferTaskUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/task/transfer/{taskId}/{toUser}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{taskId}', `${parameters['taskId']}`)
  if (parameters['taskId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskId'))
  }
  path = path.replace('{toUser}', `${parameters['toUser']}`)
  if (parameters['toUser'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: toUser'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const transferTaskUsingPUT_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/task/transfer/{taskId}/{toUser}'
}
export const transferTaskUsingPUT_TYPE = function() {
  return 'put'
}
export const transferTaskUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/task/transfer/{taskId}/{toUser}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{taskId}', `${parameters['taskId']}`)
  path = path.replace('{toUser}', `${parameters['toUser']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回任务的数据信息
 * request: taskformUsingGET_2
 * url: taskformUsingGET_2URL
 * method: taskformUsingGET_2_TYPE
 * raw_url: taskformUsingGET_2_RAW_URL
 * @param modulename - modulename
 * @param taskid - taskid
 */
export const taskformUsingGET_2 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/task/{taskid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters['taskid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const taskformUsingGET_2_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/task/{taskid}'
}
export const taskformUsingGET_2_TYPE = function() {
  return 'get'
}
export const taskformUsingGET_2URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/task/{taskid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 完成任务
 * request: completeTaskUsingPOST_2
 * url: completeTaskUsingPOST_2URL
 * method: completeTaskUsingPOST_2_TYPE
 * raw_url: completeTaskUsingPOST_2_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param principal - 
 * @param taskid - taskid
 * @param vo - vo
 */
export const completeTaskUsingPOST_2 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/task/{taskid}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters['taskid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskid'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const completeTaskUsingPOST_2_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/task/{taskid}'
}
export const completeTaskUsingPOST_2_TYPE = function() {
  return 'post'
}
export const completeTaskUsingPOST_2URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/task/{taskid}'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 完成任务
 * request: completeTaskAndSaveBeanUsingPOST
 * url: completeTaskAndSaveBeanUsingPOSTURL
 * method: completeTaskAndSaveBeanUsingPOST_TYPE
 * raw_url: completeTaskAndSaveBeanUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param principal - 
 * @param taskid - taskid
 * @param vo - vo
 */
export const completeTaskAndSaveBeanUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/taskandsave/{taskid}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters['taskid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskid'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const completeTaskAndSaveBeanUsingPOST_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/taskandsave/{taskid}'
}
export const completeTaskAndSaveBeanUsingPOST_TYPE = function() {
  return 'post'
}
export const completeTaskAndSaveBeanUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/taskandsave/{taskid}'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 完成任务,completeTaskAndSaveBeanForConfigure
 * request: completeTaskAndSaveBeanForConfigureUsingPOST
 * url: completeTaskAndSaveBeanForConfigureUsingPOSTURL
 * method: completeTaskAndSaveBeanForConfigureUsingPOST_TYPE
 * raw_url: completeTaskAndSaveBeanForConfigureUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param formDesignKey - formDesignKey
 * @param modulename - modulename
 * @param principal - 
 * @param taskid - taskid
 * @param vo - vo
 */
export const completeTaskAndSaveBeanForConfigureUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/taskandsave/{taskid}/configure/{formDesignKey}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{formDesignKey}', `${parameters['formDesignKey']}`)
  if (parameters['formDesignKey'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: formDesignKey'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters['taskid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskid'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const completeTaskAndSaveBeanForConfigureUsingPOST_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/taskandsave/{taskid}/configure/{formDesignKey}'
}
export const completeTaskAndSaveBeanForConfigureUsingPOST_TYPE = function() {
  return 'post'
}
export const completeTaskAndSaveBeanForConfigureUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/taskandsave/{taskid}/configure/{formDesignKey}'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{formDesignKey}', `${parameters['formDesignKey']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取用户待办工作
 * request: tasklistUsingGET
 * url: tasklistUsingGETURL
 * method: tasklistUsingGET_TYPE
 * raw_url: tasklistUsingGET_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param page - 请求页数
 * @param principal - 
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const tasklistUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/tasklist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const tasklistUsingGET_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/tasklist'
}
export const tasklistUsingGET_TYPE = function() {
  return 'get'
}
export const tasklistUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/tasklist'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取用户针对某个业务数据的任务
 * request: getBusinessTaskUsingGET
 * url: getBusinessTaskUsingGETURL
 * method: getBusinessTaskUsingGET_TYPE
 * raw_url: getBusinessTaskUsingGET_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param businesskey - businesskey
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param principal - 
 * @param processdfkey - processdfkey
 */
export const getBusinessTaskUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/tasks/{processdfkey}/{businesskey}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  path = path.replace('{businesskey}', `${parameters['businesskey']}`)
  if (parameters['businesskey'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: businesskey'))
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{processdfkey}', `${parameters['processdfkey']}`)
  if (parameters['processdfkey'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: processdfkey'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getBusinessTaskUsingGET_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/tasks/{processdfkey}/{businesskey}'
}
export const getBusinessTaskUsingGET_TYPE = function() {
  return 'get'
}
export const getBusinessTaskUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/tasks/{processdfkey}/{businesskey}'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  path = path.replace('{businesskey}', `${parameters['businesskey']}`)
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{processdfkey}', `${parameters['processdfkey']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回开始任务的数据信息
 * request: startformUsingGET
 * url: startformUsingGETURL
 * method: startformUsingGET_TYPE
 * raw_url: startformUsingGET_RAW_URL
 * @param modulename - modulename
 * @param processDefKey - processDefKey
 */
export const startformUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/taskstart/{processDefKey}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{processDefKey}', `${parameters['processDefKey']}`)
  if (parameters['processDefKey'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: processDefKey'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const startformUsingGET_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/taskstart/{processDefKey}'
}
export const startformUsingGET_TYPE = function() {
  return 'get'
}
export const startformUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/taskstart/{processDefKey}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{processDefKey}', `${parameters['processDefKey']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回开始任务的数据信息
 * request: startformUsingPOST
 * url: startformUsingPOSTURL
 * method: startformUsingPOST_TYPE
 * raw_url: startformUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param processDefKey - processDefKey
 * @param vo - vo
 */
export const startformUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/taskstart/{processDefKey}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{processDefKey}', `${parameters['processDefKey']}`)
  if (parameters['processDefKey'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: processDefKey'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const startformUsingPOST_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/taskstart/{processDefKey}'
}
export const startformUsingPOST_TYPE = function() {
  return 'post'
}
export const startformUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/taskstart/{processDefKey}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{processDefKey}', `${parameters['processDefKey']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取用户针对某个业务步骤的
 * request: getBusinessTaskTasksUsingGET
 * url: getBusinessTaskTasksUsingGETURL
 * method: getBusinessTaskTasksUsingGET_TYPE
 * raw_url: getBusinessTaskTasksUsingGET_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param principal - 
 * @param processdfkey - processdfkey
 * @param taskdefinekey - taskdefinekey
 */
export const getBusinessTaskTasksUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflow/{modulename}/tasktasks/{processdfkey}/{taskdefinekey}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{processdfkey}', `${parameters['processdfkey']}`)
  if (parameters['processdfkey'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: processdfkey'))
  }
  path = path.replace('{taskdefinekey}', `${parameters['taskdefinekey']}`)
  if (parameters['taskdefinekey'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskdefinekey'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getBusinessTaskTasksUsingGET_RAW_URL = function() {
  return '/api/v1/workflow/{modulename}/tasktasks/{processdfkey}/{taskdefinekey}'
}
export const getBusinessTaskTasksUsingGET_TYPE = function() {
  return 'get'
}
export const getBusinessTaskTasksUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflow/{modulename}/tasktasks/{processdfkey}/{taskdefinekey}'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{processdfkey}', `${parameters['processdfkey']}`)
  path = path.replace('{taskdefinekey}', `${parameters['taskdefinekey']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 添加工作流定义模型，addWorkflowModel
 * request: addWorkflowModelUsingPOST
 * url: addWorkflowModelUsingPOSTURL
 * method: addWorkflowModelUsingPOST_TYPE
 * raw_url: addWorkflowModelUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param vo - vo
 */
export const addWorkflowModelUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflowmodel/{modulename}/add'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addWorkflowModelUsingPOST_RAW_URL = function() {
  return '/api/v1/workflowmodel/{modulename}/add'
}
export const addWorkflowModelUsingPOST_TYPE = function() {
  return 'post'
}
export const addWorkflowModelUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflowmodel/{modulename}/add'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 工作流定义模型Page，findWorkflowModel
 * request: findWorkflowModelUsingPOST
 * url: findWorkflowModelUsingPOSTURL
 * method: findWorkflowModelUsingPOST_TYPE
 * raw_url: findWorkflowModelUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findWorkflowModelUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflowmodel/{modulename}/datalist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findWorkflowModelUsingPOST_RAW_URL = function() {
  return '/api/v1/workflowmodel/{modulename}/datalist'
}
export const findWorkflowModelUsingPOST_TYPE = function() {
  return 'post'
}
export const findWorkflowModelUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflowmodel/{modulename}/datalist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除多选工作流定义模型，deleteSelectMatPsrBidder
 * request: deleteSelectWorkflowModelUsingDELETE
 * url: deleteSelectWorkflowModelUsingDELETEURL
 * method: deleteSelectWorkflowModelUsingDELETE_TYPE
 * raw_url: deleteSelectWorkflowModelUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectWorkflowModelUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflowmodel/{modulename}/delete/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectWorkflowModelUsingDELETE_RAW_URL = function() {
  return '/api/v1/workflowmodel/{modulename}/delete/'
}
export const deleteSelectWorkflowModelUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectWorkflowModelUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflowmodel/{modulename}/delete/'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除工作流定义模型，deleteWorkflowModel
 * request: deleteWorkflowModelUsingDELETE
 * url: deleteWorkflowModelUsingDELETEURL
 * method: deleteWorkflowModelUsingDELETE_TYPE
 * raw_url: deleteWorkflowModelUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteWorkflowModelUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflowmodel/{modulename}/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteWorkflowModelUsingDELETE_RAW_URL = function() {
  return '/api/v1/workflowmodel/{modulename}/delete/{id}'
}
export const deleteWorkflowModelUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteWorkflowModelUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflowmodel/{modulename}/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 部署工作流定义模型，deployWorkflowModel
 * request: deployWorkflowModelUsingPOST
 * url: deployWorkflowModelUsingPOSTURL
 * method: deployWorkflowModelUsingPOST_TYPE
 * raw_url: deployWorkflowModelUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deployWorkflowModelUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflowmodel/{modulename}/deploy/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const deployWorkflowModelUsingPOST_RAW_URL = function() {
  return '/api/v1/workflowmodel/{modulename}/deploy/{id}'
}
export const deployWorkflowModelUsingPOST_TYPE = function() {
  return 'post'
}
export const deployWorkflowModelUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflowmodel/{modulename}/deploy/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导出工作流定义模型，exportWorkflowModel
 * request: exportWorkflowModelUsingGET
 * url: exportWorkflowModelUsingGETURL
 * method: exportWorkflowModelUsingGET_TYPE
 * raw_url: exportWorkflowModelUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const exportWorkflowModelUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflowmodel/{modulename}/export/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const exportWorkflowModelUsingGET_RAW_URL = function() {
  return '/api/v1/workflowmodel/{modulename}/export/{id}'
}
export const exportWorkflowModelUsingGET_TYPE = function() {
  return 'get'
}
export const exportWorkflowModelUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflowmodel/{modulename}/export/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导入工作流定义模型，importWorkflowModel
 * request: importWorkflowModelUsingPOST
 * url: importWorkflowModelUsingPOSTURL
 * method: importWorkflowModelUsingPOST_TYPE
 * raw_url: importWorkflowModelUsingPOST_RAW_URL
 * @param attid - attid
 * @param modulename - modulename
 * @param vo - vo
 */
export const importWorkflowModelUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflowmodel/{modulename}/import/{attid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{attid}', `${parameters['attid']}`)
  if (parameters['attid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: attid'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const importWorkflowModelUsingPOST_RAW_URL = function() {
  return '/api/v1/workflowmodel/{modulename}/import/{attid}'
}
export const importWorkflowModelUsingPOST_TYPE = function() {
  return 'post'
}
export const importWorkflowModelUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflowmodel/{modulename}/import/{attid}'
  path = path.replace('{attid}', `${parameters['attid']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 保存并部署工作流定义模型，saveAndDeployWorkflowModel
 * request: saveAndDeployWorkflowModelUsingPOST
 * url: saveAndDeployWorkflowModelUsingPOSTURL
 * method: saveAndDeployWorkflowModelUsingPOST_TYPE
 * raw_url: saveAndDeployWorkflowModelUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param vo - vo
 */
export const saveAndDeployWorkflowModelUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflowmodel/{modulename}/saveanddeploy'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const saveAndDeployWorkflowModelUsingPOST_RAW_URL = function() {
  return '/api/v1/workflowmodel/{modulename}/saveanddeploy'
}
export const saveAndDeployWorkflowModelUsingPOST_TYPE = function() {
  return 'post'
}
export const saveAndDeployWorkflowModelUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflowmodel/{modulename}/saveanddeploy'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改工作流定义模型，updateWorkflowModel
 * request: updateWorkflowModelUsingPOST
 * url: updateWorkflowModelUsingPOSTURL
 * method: updateWorkflowModelUsingPOST_TYPE
 * raw_url: updateWorkflowModelUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param vo - vo
 */
export const updateWorkflowModelUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflowmodel/{modulename}/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateWorkflowModelUsingPOST_RAW_URL = function() {
  return '/api/v1/workflowmodel/{modulename}/update/{id}'
}
export const updateWorkflowModelUsingPOST_TYPE = function() {
  return 'post'
}
export const updateWorkflowModelUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflowmodel/{modulename}/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 查看工作流定义模型，getWorkflowModel
 * request: getWorkflowModelUsingGET
 * url: getWorkflowModelUsingGETURL
 * method: getWorkflowModelUsingGET_TYPE
 * raw_url: getWorkflowModelUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getWorkflowModelUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/workflowmodel/{modulename}/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWorkflowModelUsingGET_RAW_URL = function() {
  return '/api/v1/workflowmodel/{modulename}/{id}'
}
export const getWorkflowModelUsingGET_TYPE = function() {
  return 'get'
}
export const getWorkflowModelUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/workflowmodel/{modulename}/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 添加建造区域，addConstructionArea
 * request: addConstructionAreaUsingPOST
 * url: addConstructionAreaUsingPOSTURL
 * method: addConstructionAreaUsingPOST_TYPE
 * raw_url: addConstructionAreaUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const addConstructionAreaUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/constructionarea'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addConstructionAreaUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/constructionarea'
}
export const addConstructionAreaUsingPOST_TYPE = function() {
  return 'post'
}
export const addConstructionAreaUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/constructionarea'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除所选建造区域，deleteConstructionAreas
 * request: deleteConstructionAreasUsingDELETE
 * url: deleteConstructionAreasUsingDELETEURL
 * method: deleteConstructionAreasUsingDELETE_TYPE
 * raw_url: deleteConstructionAreasUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteConstructionAreasUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/constructionarea/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteConstructionAreasUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/constructionarea/delete'
}
export const deleteConstructionAreasUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteConstructionAreasUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/constructionarea/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除建造区域，deleteConstructionArea
 * request: deleteConstructionAreaUsingDELETE
 * url: deleteConstructionAreaUsingDELETEURL
 * method: deleteConstructionAreaUsingDELETE_TYPE
 * raw_url: deleteConstructionAreaUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteConstructionAreaUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/constructionarea/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteConstructionAreaUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/constructionarea/delete/{id}'
}
export const deleteConstructionAreaUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteConstructionAreaUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/constructionarea/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findConstructionArea
 * request: findConstructionAreaUsingPOST
 * url: findConstructionAreaUsingPOSTURL
 * method: findConstructionAreaUsingPOST_TYPE
 * raw_url: findConstructionAreaUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findConstructionAreaUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/constructionarea/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findConstructionAreaUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/constructionarea/getlist'
}
export const findConstructionAreaUsingPOST_TYPE = function() {
  return 'post'
}
export const findConstructionAreaUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/constructionarea/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改建造区域，updateConstructionArea
 * request: updateConstructionAreaUsingPOST
 * url: updateConstructionAreaUsingPOSTURL
 * method: updateConstructionAreaUsingPOST_TYPE
 * raw_url: updateConstructionAreaUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param vo - vo
 */
export const updateConstructionAreaUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/constructionarea/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateConstructionAreaUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/constructionarea/update/{id}'
}
export const updateConstructionAreaUsingPOST_TYPE = function() {
  return 'post'
}
export const updateConstructionAreaUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/constructionarea/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取建造区域，getConstructionArea
 * request: getConstructionAreaUsingGET
 * url: getConstructionAreaUsingGETURL
 * method: getConstructionAreaUsingGET_TYPE
 * raw_url: getConstructionAreaUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getConstructionAreaUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/constructionarea/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getConstructionAreaUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/constructionarea/{id}'
}
export const getConstructionAreaUsingGET_TYPE = function() {
  return 'get'
}
export const getConstructionAreaUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/constructionarea/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addDailyWeldInspectionItem
 * request: addDailyWeldInspectionItemUsingPOST
 * url: addDailyWeldInspectionItemUsingPOSTURL
 * method: addDailyWeldInspectionItemUsingPOST_TYPE
 * raw_url: addDailyWeldInspectionItemUsingPOST_RAW_URL
 * @param dwii - dwii
 * @param modulename - modulename
 */
export const addDailyWeldInspectionItemUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Item'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['dwii'] !== undefined) {
    body = parameters['dwii']
  }
  if (parameters['dwii'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dwii'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addDailyWeldInspectionItemUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/dailyweldinspection/Item'
}
export const addDailyWeldInspectionItemUsingPOST_TYPE = function() {
  return 'post'
}
export const addDailyWeldInspectionItemUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Item'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectDailyWeldInspectionItem
 * request: deleteSelectDailyWeldInspectionItemUsingDELETE
 * url: deleteSelectDailyWeldInspectionItemUsingDELETEURL
 * method: deleteSelectDailyWeldInspectionItemUsingDELETE_TYPE
 * raw_url: deleteSelectDailyWeldInspectionItemUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectDailyWeldInspectionItemUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Item/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectDailyWeldInspectionItemUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/dailyweldinspection/Item/delete'
}
export const deleteSelectDailyWeldInspectionItemUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectDailyWeldInspectionItemUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Item/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteDailyWeldInspectionItem
 * request: deleteDailyWeldInspectionItemUsingDELETE
 * url: deleteDailyWeldInspectionItemUsingDELETEURL
 * method: deleteDailyWeldInspectionItemUsingDELETE_TYPE
 * raw_url: deleteDailyWeldInspectionItemUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteDailyWeldInspectionItemUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Item/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteDailyWeldInspectionItemUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/dailyweldinspection/Item/delete/{id}'
}
export const deleteDailyWeldInspectionItemUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteDailyWeldInspectionItemUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Item/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findDailyWeldInspectionItem
 * request: findDailyWeldInspectionItemUsingPOST
 * url: findDailyWeldInspectionItemUsingPOSTURL
 * method: findDailyWeldInspectionItemUsingPOST_TYPE
 * raw_url: findDailyWeldInspectionItemUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param reportid - reportid
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findDailyWeldInspectionItemUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Item/getlist/{reportid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{reportid}', `${parameters['reportid']}`)
  if (parameters['reportid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: reportid'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findDailyWeldInspectionItemUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/dailyweldinspection/Item/getlist/{reportid}'
}
export const findDailyWeldInspectionItemUsingPOST_TYPE = function() {
  return 'post'
}
export const findDailyWeldInspectionItemUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Item/getlist/{reportid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{reportid}', `${parameters['reportid']}`)
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateDailyWeldInspectionItem
 * request: updateDailyWeldInspectionItemUsingPOST
 * url: updateDailyWeldInspectionItemUsingPOSTURL
 * method: updateDailyWeldInspectionItemUsingPOST_TYPE
 * raw_url: updateDailyWeldInspectionItemUsingPOST_RAW_URL
 * @param dwii - dwii
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 */
export const updateDailyWeldInspectionItemUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Item/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['dwii'] !== undefined) {
    body = parameters['dwii']
  }
  if (parameters['dwii'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dwii'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateDailyWeldInspectionItemUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/dailyweldinspection/Item/update/{id}'
}
export const updateDailyWeldInspectionItemUsingPOST_TYPE = function() {
  return 'post'
}
export const updateDailyWeldInspectionItemUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Item/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getDailyWeldInspectionItem
 * request: getDailyWeldInspectionItemUsingGET
 * url: getDailyWeldInspectionItemUsingGETURL
 * method: getDailyWeldInspectionItemUsingGET_TYPE
 * raw_url: getDailyWeldInspectionItemUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getDailyWeldInspectionItemUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Item/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDailyWeldInspectionItemUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/dailyweldinspection/Item/{id}'
}
export const getDailyWeldInspectionItemUsingGET_TYPE = function() {
  return 'get'
}
export const getDailyWeldInspectionItemUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Item/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectDailyWeldInspectionReport
 * request: deleteSelectDailyWeldInspectionReportUsingDELETE
 * url: deleteSelectDailyWeldInspectionReportUsingDELETEURL
 * method: deleteSelectDailyWeldInspectionReportUsingDELETE_TYPE
 * raw_url: deleteSelectDailyWeldInspectionReportUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectDailyWeldInspectionReportUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Repor/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectDailyWeldInspectionReportUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/dailyweldinspection/Repor/delete'
}
export const deleteSelectDailyWeldInspectionReportUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectDailyWeldInspectionReportUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Repor/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteDailyWeldInspectionReport
 * request: deleteDailyWeldInspectionReportUsingDELETE
 * url: deleteDailyWeldInspectionReportUsingDELETEURL
 * method: deleteDailyWeldInspectionReportUsingDELETE_TYPE
 * raw_url: deleteDailyWeldInspectionReportUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteDailyWeldInspectionReportUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Repor/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteDailyWeldInspectionReportUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/dailyweldinspection/Repor/delete/{id}'
}
export const deleteDailyWeldInspectionReportUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteDailyWeldInspectionReportUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Repor/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findDailyWeldInspectionReport
 * request: findDailyWeldInspectionReportUsingPOST
 * url: findDailyWeldInspectionReportUsingPOSTURL
 * method: findDailyWeldInspectionReportUsingPOST_TYPE
 * raw_url: findDailyWeldInspectionReportUsingPOST_RAW_URL
 * @param discipline - discipline
 * @param dwir - dwir
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findDailyWeldInspectionReportUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Repor/getlist/{discipline}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  if (parameters['dwir'] !== undefined) {
    body = parameters['dwir']
  }
  if (parameters['dwir'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dwir'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findDailyWeldInspectionReportUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/dailyweldinspection/Repor/getlist/{discipline}'
}
export const findDailyWeldInspectionReportUsingPOST_TYPE = function() {
  return 'post'
}
export const findDailyWeldInspectionReportUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Repor/getlist/{discipline}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateDailyWeldInspectionReport
 * request: updateDailyWeldInspectionReportUsingPOST
 * url: updateDailyWeldInspectionReportUsingPOSTURL
 * method: updateDailyWeldInspectionReportUsingPOST_TYPE
 * raw_url: updateDailyWeldInspectionReportUsingPOST_RAW_URL
 * @param dwir - dwir
 * @param id - id
 * @param modulename - modulename
 */
export const updateDailyWeldInspectionReportUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Repor/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['dwir'] !== undefined) {
    body = parameters['dwir']
  }
  if (parameters['dwir'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dwir'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateDailyWeldInspectionReportUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/dailyweldinspection/Repor/update/{id}'
}
export const updateDailyWeldInspectionReportUsingPOST_TYPE = function() {
  return 'post'
}
export const updateDailyWeldInspectionReportUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Repor/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addDailyWeldInspectionReport
 * request: addDailyWeldInspectionReportUsingPOST
 * url: addDailyWeldInspectionReportUsingPOSTURL
 * method: addDailyWeldInspectionReportUsingPOST_TYPE
 * raw_url: addDailyWeldInspectionReportUsingPOST_RAW_URL
 * @param discipline - discipline
 * @param dwir - dwir
 * @param modulename - modulename
 */
export const addDailyWeldInspectionReportUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Repor/{discipline}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  if (parameters['dwir'] !== undefined) {
    body = parameters['dwir']
  }
  if (parameters['dwir'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dwir'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addDailyWeldInspectionReportUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/dailyweldinspection/Repor/{discipline}'
}
export const addDailyWeldInspectionReportUsingPOST_TYPE = function() {
  return 'post'
}
export const addDailyWeldInspectionReportUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Repor/{discipline}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getDailyWeldInspectionReport
 * request: getDailyWeldInspectionReportUsingGET
 * url: getDailyWeldInspectionReportUsingGETURL
 * method: getDailyWeldInspectionReportUsingGET_TYPE
 * raw_url: getDailyWeldInspectionReportUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getDailyWeldInspectionReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Repor/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDailyWeldInspectionReportUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/dailyweldinspection/Repor/{id}'
}
export const getDailyWeldInspectionReportUsingGET_TYPE = function() {
  return 'get'
}
export const getDailyWeldInspectionReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/Repor/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findDailyWeldInspectionReport_APP
 * request: findDailyWeldInspectionReport_APPUsingPOST
 * url: findDailyWeldInspectionReport_APPUsingPOSTURL
 * method: findDailyWeldInspectionReport_APPUsingPOST_TYPE
 * raw_url: findDailyWeldInspectionReport_APPUsingPOST_RAW_URL
 * @param discipline - discipline
 * @param dwir - dwir
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findDailyWeldInspectionReport_APPUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/app/Repor/getlist/{discipline}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  if (parameters['dwir'] !== undefined) {
    body = parameters['dwir']
  }
  if (parameters['dwir'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dwir'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findDailyWeldInspectionReport_APPUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/dailyweldinspection/app/Repor/getlist/{discipline}'
}
export const findDailyWeldInspectionReport_APPUsingPOST_TYPE = function() {
  return 'post'
}
export const findDailyWeldInspectionReport_APPUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/app/Repor/getlist/{discipline}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 提交检验接口（app用），SubmitInspection
 * request: SubmitInspectionUsingPOST
 * url: SubmitInspectionUsingPOSTURL
 * method: SubmitInspectionUsingPOST_TYPE
 * raw_url: SubmitInspectionUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param rid - rid
 * @param sub - sub
 */
export const SubmitInspectionUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/app/submitinspection/{rid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  path = path.replace('{rid}', `${parameters['rid']}`)
  if (parameters['rid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: rid'))
  }
  if (parameters['sub'] !== undefined) {
    body = parameters['sub']
  }
  if (parameters['sub'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: sub'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const SubmitInspectionUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/dailyweldinspection/app/submitinspection/{rid}'
}
export const SubmitInspectionUsingPOST_TYPE = function() {
  return 'post'
}
export const SubmitInspectionUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/app/submitinspection/{rid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  path = path.replace('{rid}', `${parameters['rid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getDailyWeldInspectionReportByNo
 * request: getDailyWeldInspectionReportByNoUsingGET
 * url: getDailyWeldInspectionReportByNoUsingGETURL
 * method: getDailyWeldInspectionReportByNoUsingGET_TYPE
 * raw_url: getDailyWeldInspectionReportByNoUsingGET_RAW_URL
 * @param modulename - modulename
 * @param no - no
 */
export const getDailyWeldInspectionReportByNoUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/getDailyWeldInspectionReport/{no}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{no}', `${parameters['no']}`)
  if (parameters['no'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: no'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDailyWeldInspectionReportByNoUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/dailyweldinspection/getDailyWeldInspectionReport/{no}'
}
export const getDailyWeldInspectionReportByNoUsingGET_TYPE = function() {
  return 'get'
}
export const getDailyWeldInspectionReportByNoUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/dailyweldinspection/getDailyWeldInspectionReport/{no}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{no}', `${parameters['no']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addFitUpInspectionItem
 * request: addFitUpInspectionItemUsingPOST
 * url: addFitUpInspectionItemUsingPOSTURL
 * method: addFitUpInspectionItemUsingPOST_TYPE
 * raw_url: addFitUpInspectionItemUsingPOST_RAW_URL
 * @param fuii - fuii
 * @param modulename - modulename
 */
export const addFitUpInspectionItemUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/fitupinspection/Item'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['fuii'] !== undefined) {
    body = parameters['fuii']
  }
  if (parameters['fuii'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: fuii'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addFitUpInspectionItemUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/fitupinspection/Item'
}
export const addFitUpInspectionItemUsingPOST_TYPE = function() {
  return 'post'
}
export const addFitUpInspectionItemUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/fitupinspection/Item'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectFitUpInspectionItem
 * request: deleteSelectFitUpInspectionItemUsingDELETE
 * url: deleteSelectFitUpInspectionItemUsingDELETEURL
 * method: deleteSelectFitUpInspectionItemUsingDELETE_TYPE
 * raw_url: deleteSelectFitUpInspectionItemUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectFitUpInspectionItemUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/fitupinspection/Item/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectFitUpInspectionItemUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/fitupinspection/Item/delete'
}
export const deleteSelectFitUpInspectionItemUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectFitUpInspectionItemUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/fitupinspection/Item/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteFitUpInspectionItem
 * request: deleteFitUpInspectionItemUsingDELETE
 * url: deleteFitUpInspectionItemUsingDELETEURL
 * method: deleteFitUpInspectionItemUsingDELETE_TYPE
 * raw_url: deleteFitUpInspectionItemUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteFitUpInspectionItemUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/fitupinspection/Item/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteFitUpInspectionItemUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/fitupinspection/Item/delete/{id}'
}
export const deleteFitUpInspectionItemUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteFitUpInspectionItemUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/fitupinspection/Item/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findFitUpInspectionItem
 * request: findFitUpInspectionItemUsingPOST
 * url: findFitUpInspectionItemUsingPOSTURL
 * method: findFitUpInspectionItemUsingPOST_TYPE
 * raw_url: findFitUpInspectionItemUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param reportid - reportid
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findFitUpInspectionItemUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/fitupinspection/Item/getlist/{reportid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{reportid}', `${parameters['reportid']}`)
  if (parameters['reportid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: reportid'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findFitUpInspectionItemUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/fitupinspection/Item/getlist/{reportid}'
}
export const findFitUpInspectionItemUsingPOST_TYPE = function() {
  return 'post'
}
export const findFitUpInspectionItemUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/fitupinspection/Item/getlist/{reportid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{reportid}', `${parameters['reportid']}`)
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateFitUpInspectionItem
 * request: updateFitUpInspectionItemUsingPOST
 * url: updateFitUpInspectionItemUsingPOSTURL
 * method: updateFitUpInspectionItemUsingPOST_TYPE
 * raw_url: updateFitUpInspectionItemUsingPOST_RAW_URL
 * @param fuii - fuii
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 */
export const updateFitUpInspectionItemUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/fitupinspection/Item/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['fuii'] !== undefined) {
    body = parameters['fuii']
  }
  if (parameters['fuii'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: fuii'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateFitUpInspectionItemUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/fitupinspection/Item/update/{id}'
}
export const updateFitUpInspectionItemUsingPOST_TYPE = function() {
  return 'post'
}
export const updateFitUpInspectionItemUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/fitupinspection/Item/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getFitUpInspectionItem
 * request: getFitUpInspectionItemUsingGET
 * url: getFitUpInspectionItemUsingGETURL
 * method: getFitUpInspectionItemUsingGET_TYPE
 * raw_url: getFitUpInspectionItemUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getFitUpInspectionItemUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/fitupinspection/Item/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getFitUpInspectionItemUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/fitupinspection/Item/{id}'
}
export const getFitUpInspectionItemUsingGET_TYPE = function() {
  return 'get'
}
export const getFitUpInspectionItemUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/fitupinspection/Item/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectFitUpInspectionReport
 * request: deleteSelectFitUpInspectionReportUsingDELETE
 * url: deleteSelectFitUpInspectionReportUsingDELETEURL
 * method: deleteSelectFitUpInspectionReportUsingDELETE_TYPE
 * raw_url: deleteSelectFitUpInspectionReportUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectFitUpInspectionReportUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/fitupinspection/Repor/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectFitUpInspectionReportUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/fitupinspection/Repor/delete'
}
export const deleteSelectFitUpInspectionReportUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectFitUpInspectionReportUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/fitupinspection/Repor/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteFitUpInspectionReport
 * request: deleteFitUpInspectionReportUsingDELETE
 * url: deleteFitUpInspectionReportUsingDELETEURL
 * method: deleteFitUpInspectionReportUsingDELETE_TYPE
 * raw_url: deleteFitUpInspectionReportUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteFitUpInspectionReportUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/fitupinspection/Repor/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteFitUpInspectionReportUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/fitupinspection/Repor/delete/{id}'
}
export const deleteFitUpInspectionReportUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteFitUpInspectionReportUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/fitupinspection/Repor/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findFitUpInspectionReport
 * request: findFitUpInspectionReportUsingPOST
 * url: findFitUpInspectionReportUsingPOSTURL
 * method: findFitUpInspectionReportUsingPOST_TYPE
 * raw_url: findFitUpInspectionReportUsingPOST_RAW_URL
 * @param discipline - discipline
 * @param fuir - fuir
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findFitUpInspectionReportUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/fitupinspection/Repor/getlist/{discipline}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  if (parameters['fuir'] !== undefined) {
    body = parameters['fuir']
  }
  if (parameters['fuir'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: fuir'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findFitUpInspectionReportUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/fitupinspection/Repor/getlist/{discipline}'
}
export const findFitUpInspectionReportUsingPOST_TYPE = function() {
  return 'post'
}
export const findFitUpInspectionReportUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/fitupinspection/Repor/getlist/{discipline}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateFitUpInspectionReport
 * request: updateFitUpInspectionReportUsingPOST
 * url: updateFitUpInspectionReportUsingPOSTURL
 * method: updateFitUpInspectionReportUsingPOST_TYPE
 * raw_url: updateFitUpInspectionReportUsingPOST_RAW_URL
 * @param fuir - fuir
 * @param id - id
 * @param modulename - modulename
 */
export const updateFitUpInspectionReportUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/fitupinspection/Repor/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['fuir'] !== undefined) {
    body = parameters['fuir']
  }
  if (parameters['fuir'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: fuir'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateFitUpInspectionReportUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/fitupinspection/Repor/update/{id}'
}
export const updateFitUpInspectionReportUsingPOST_TYPE = function() {
  return 'post'
}
export const updateFitUpInspectionReportUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/fitupinspection/Repor/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addFitUpInspectionReport
 * request: addFitUpInspectionReportUsingPOST
 * url: addFitUpInspectionReportUsingPOSTURL
 * method: addFitUpInspectionReportUsingPOST_TYPE
 * raw_url: addFitUpInspectionReportUsingPOST_RAW_URL
 * @param discipline - discipline
 * @param fuir - fuir
 * @param modulename - modulename
 */
export const addFitUpInspectionReportUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/fitupinspection/Repor/{discipline}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  if (parameters['fuir'] !== undefined) {
    body = parameters['fuir']
  }
  if (parameters['fuir'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: fuir'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addFitUpInspectionReportUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/fitupinspection/Repor/{discipline}'
}
export const addFitUpInspectionReportUsingPOST_TYPE = function() {
  return 'post'
}
export const addFitUpInspectionReportUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/fitupinspection/Repor/{discipline}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getFitUpInspectionReport
 * request: getFitUpInspectionReportUsingGET
 * url: getFitUpInspectionReportUsingGETURL
 * method: getFitUpInspectionReportUsingGET_TYPE
 * raw_url: getFitUpInspectionReportUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getFitUpInspectionReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/fitupinspection/Repor/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getFitUpInspectionReportUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/fitupinspection/Repor/{id}'
}
export const getFitUpInspectionReportUsingGET_TYPE = function() {
  return 'get'
}
export const getFitUpInspectionReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/fitupinspection/Repor/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findFitUpInspectionReport_APP
 * request: findFitUpInspectionReport_APPUsingPOST
 * url: findFitUpInspectionReport_APPUsingPOSTURL
 * method: findFitUpInspectionReport_APPUsingPOST_TYPE
 * raw_url: findFitUpInspectionReport_APPUsingPOST_RAW_URL
 * @param discipline - discipline
 * @param fuir - fuir
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findFitUpInspectionReport_APPUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/fitupinspection/app/Repor/getlist/{discipline}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  if (parameters['fuir'] !== undefined) {
    body = parameters['fuir']
  }
  if (parameters['fuir'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: fuir'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findFitUpInspectionReport_APPUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/fitupinspection/app/Repor/getlist/{discipline}'
}
export const findFitUpInspectionReport_APPUsingPOST_TYPE = function() {
  return 'post'
}
export const findFitUpInspectionReport_APPUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/fitupinspection/app/Repor/getlist/{discipline}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 提交检验接口（app用），SubmitInspection
 * request: SubmitInspectionUsingPOST_1
 * url: SubmitInspectionUsingPOST_1URL
 * method: SubmitInspectionUsingPOST_1_TYPE
 * raw_url: SubmitInspectionUsingPOST_1_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param rid - rid
 * @param sub - sub
 */
export const SubmitInspectionUsingPOST_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/fitupinspection/app/submitinspection/{rid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  path = path.replace('{rid}', `${parameters['rid']}`)
  if (parameters['rid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: rid'))
  }
  if (parameters['sub'] !== undefined) {
    body = parameters['sub']
  }
  if (parameters['sub'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: sub'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const SubmitInspectionUsingPOST_1_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/fitupinspection/app/submitinspection/{rid}'
}
export const SubmitInspectionUsingPOST_1_TYPE = function() {
  return 'post'
}
export const SubmitInspectionUsingPOST_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/fitupinspection/app/submitinspection/{rid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  path = path.replace('{rid}', `${parameters['rid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getFitUpInspectionReportByNo
 * request: getFitUpInspectionReportByNoUsingGET
 * url: getFitUpInspectionReportByNoUsingGETURL
 * method: getFitUpInspectionReportByNoUsingGET_TYPE
 * raw_url: getFitUpInspectionReportByNoUsingGET_RAW_URL
 * @param modulename - modulename
 * @param no - no
 */
export const getFitUpInspectionReportByNoUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/fitupinspection/getFitUpInspectionReport/{no}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{no}', `${parameters['no']}`)
  if (parameters['no'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: no'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getFitUpInspectionReportByNoUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/fitupinspection/getFitUpInspectionReport/{no}'
}
export const getFitUpInspectionReportByNoUsingGET_TYPE = function() {
  return 'get'
}
export const getFitUpInspectionReportByNoUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/fitupinspection/getFitUpInspectionReport/{no}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{no}', `${parameters['no']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取加密后的字符串，getIdNoEncryptString
 * request: getIdNoEncryptStringUsingPOST
 * url: getIdNoEncryptStringUsingPOSTURL
 * method: getIdNoEncryptStringUsingPOST_TYPE
 * raw_url: getIdNoEncryptStringUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param vo - vo
 */
export const getIdNoEncryptStringUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hattag/getIdNoEncryptString'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getIdNoEncryptStringUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hattag/getIdNoEncryptString'
}
export const getIdNoEncryptStringUsingPOST_TYPE = function() {
  return 'post'
}
export const getIdNoEncryptStringUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hattag/getIdNoEncryptString'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取人员关联用户，getPersonInfoUsers
 * request: getPersonInfoUsersUsingGET
 * url: getPersonInfoUsersUsingGETURL
 * method: getPersonInfoUsersUsingGET_TYPE
 * raw_url: getPersonInfoUsersUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getPersonInfoUsersUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hattag/getPersonInfoUsers/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getPersonInfoUsersUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hattag/getPersonInfoUsers/{id}'
}
export const getPersonInfoUsersUsingGET_TYPE = function() {
  return 'get'
}
export const getPersonInfoUsersUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hattag/getPersonInfoUsers/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getHattagQRCode
 * request: getHattagQRCodeUsingPOST
 * url: getHattagQRCodeUsingPOSTURL
 * method: getHattagQRCodeUsingPOST_TYPE
 * raw_url: getHattagQRCodeUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param personid - personid
 */
export const getHattagQRCodeUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hattag/person/{personid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{personid}', `${parameters['personid']}`)
  if (parameters['personid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: personid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getHattagQRCodeUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hattag/person/{personid}'
}
export const getHattagQRCodeUsingPOST_TYPE = function() {
  return 'post'
}
export const getHattagQRCodeUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hattag/person/{personid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{personid}', `${parameters['personid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getHattagQRCodeStream
 * request: getHattagQRCodeStreamUsingPOST
 * url: getHattagQRCodeStreamUsingPOSTURL
 * method: getHattagQRCodeStreamUsingPOST_TYPE
 * raw_url: getHattagQRCodeStreamUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param personid - personid
 */
export const getHattagQRCodeStreamUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hattag/personstream/{personid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{personid}', `${parameters['personid']}`)
  if (parameters['personid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: personid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getHattagQRCodeStreamUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hattag/personstream/{personid}'
}
export const getHattagQRCodeStreamUsingPOST_TYPE = function() {
  return 'post'
}
export const getHattagQRCodeStreamUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hattag/personstream/{personid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{personid}', `${parameters['personid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * queryHattagMultiple
 * request: queryHattagMultipleUsingPOST
 * url: queryHattagMultipleUsingPOSTURL
 * method: queryHattagMultipleUsingPOST_TYPE
 * raw_url: queryHattagMultipleUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param vo - vo
 */
export const queryHattagMultipleUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hattag/queryhattag/multiple'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const queryHattagMultipleUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hattag/queryhattag/multiple'
}
export const queryHattagMultipleUsingPOST_TYPE = function() {
  return 'post'
}
export const queryHattagMultipleUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hattag/queryhattag/multiple'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除人员关联用户，removePersonInfoUser
 * request: removePersonInfoUserUsingPOST
 * url: removePersonInfoUserUsingPOSTURL
 * method: removePersonInfoUserUsingPOST_TYPE
 * raw_url: removePersonInfoUserUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param user - user
 */
export const removePersonInfoUserUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hattag/removePersonInfoUser/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['user'] !== undefined) {
    body = parameters['user']
  }
  if (parameters['user'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: user'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const removePersonInfoUserUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hattag/removePersonInfoUser/{id}'
}
export const removePersonInfoUserUsingPOST_TYPE = function() {
  return 'post'
}
export const removePersonInfoUserUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hattag/removePersonInfoUser/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 打印后设置时间，setIdNoPrintQRCode
 * request: setIdNoPrintQRCodeDateUsingPOST
 * url: setIdNoPrintQRCodeDateUsingPOSTURL
 * method: setIdNoPrintQRCodeDateUsingPOST_TYPE
 * raw_url: setIdNoPrintQRCodeDateUsingPOST_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const setIdNoPrintQRCodeDateUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hattag/setIdNoPrintQRCodeDate'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    body = parameters['ids']
  }
  if (parameters['ids'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: ids'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const setIdNoPrintQRCodeDateUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hattag/setIdNoPrintQRCodeDate'
}
export const setIdNoPrintQRCodeDateUsingPOST_TYPE = function() {
  return 'post'
}
export const setIdNoPrintQRCodeDateUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hattag/setIdNoPrintQRCodeDate'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * setUseridByid
 * request: setUseridByidUsingPOST
 * url: setUseridByidUsingPOSTURL
 * method: setUseridByidUsingPOST_TYPE
 * raw_url: setUseridByidUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param users - users
 */
export const setUseridByidUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hattag/setuser/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['users'] !== undefined) {
    body = parameters['users']
  }
  if (parameters['users'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: users'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const setUseridByidUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hattag/setuser/{id}'
}
export const setUseridByidUsingPOST_TYPE = function() {
  return 'post'
}
export const setUseridByidUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hattag/setuser/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addHdiManage
 * request: addHdiManageUsingPOST
 * url: addHdiManageUsingPOSTURL
 * method: addHdiManageUsingPOST_TYPE
 * raw_url: addHdiManageUsingPOST_RAW_URL
 * @param hdim - hdim
 * @param modulename - modulename
 * @param name - 
 */
export const addHdiManageUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['hdim'] !== undefined) {
    body = parameters['hdim']
  }
  if (parameters['hdim'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: hdim'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addHdiManageUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage'
}
export const addHdiManageUsingPOST_TYPE = function() {
  return 'post'
}
export const addHdiManageUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteHdiManages
 * request: deleteHdiManagesUsingDELETE
 * url: deleteHdiManagesUsingDELETEURL
 * method: deleteHdiManagesUsingDELETE_TYPE
 * raw_url: deleteHdiManagesUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteHdiManagesUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteHdiManagesUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage'
}
export const deleteHdiManagesUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteHdiManagesUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 我参与的
 * request: aboutmelistUsingPOST
 * url: aboutmelistUsingPOSTURL
 * method: aboutmelistUsingPOST_TYPE
 * raw_url: aboutmelistUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param page - 请求页数
 * @param principal - 
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const aboutmelistUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/aboutme'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const aboutmelistUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/aboutme'
}
export const aboutmelistUsingPOST_TYPE = function() {
  return 'post'
}
export const aboutmelistUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/aboutme'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回负责单位
 * request: findDeptOrgsUsingPOST
 * url: findDeptOrgsUsingPOSTURL
 * method: findDeptOrgsUsingPOST_TYPE
 * raw_url: findDeptOrgsUsingPOST_RAW_URL
 * @param modulename - modulename
 */
export const findDeptOrgsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/dept/organization/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findDeptOrgsUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/dept/organization/getlist'
}
export const findDeptOrgsUsingPOST_TYPE = function() {
  return 'post'
}
export const findDeptOrgsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/dept/organization/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回负责单位, 分包商
 * request: findDeptSCOrgsUsingPOST
 * url: findDeptSCOrgsUsingPOSTURL
 * method: findDeptSCOrgsUsingPOST_TYPE
 * raw_url: findDeptSCOrgsUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param orgtypecode - orgtypecode
 */
export const findDeptSCOrgsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/deptsc/organization/{orgtypecode}/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{orgtypecode}', `${parameters['orgtypecode']}`)
  if (parameters['orgtypecode'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: orgtypecode'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findDeptSCOrgsUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/deptsc/organization/{orgtypecode}/getlist'
}
export const findDeptSCOrgsUsingPOST_TYPE = function() {
  return 'post'
}
export const findDeptSCOrgsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/deptsc/organization/{orgtypecode}/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{orgtypecode}', `${parameters['orgtypecode']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 下载excel,exportExcel,
 * request: exportExcelUsingPOST
 * url: exportExcelUsingPOSTURL
 * method: exportExcelUsingPOST_TYPE
 * raw_url: exportExcelUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param vo - vo
 */
export const exportExcelUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/download'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const exportExcelUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/download'
}
export const exportExcelUsingPOST_TYPE = function() {
  return 'post'
}
export const exportExcelUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/download'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getHdiManage
 * request: getHdiManageUsingPOST
 * url: getHdiManageUsingPOSTURL
 * method: getHdiManageUsingPOST_TYPE
 * raw_url: getHdiManageUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param principal - 
 */
export const getHdiManageUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/gethdimanage'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getHdiManageUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/gethdimanage'
}
export const getHdiManageUsingPOST_TYPE = function() {
  return 'post'
}
export const getHdiManageUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/gethdimanage'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getHdnameDicByHdclassId
 * request: getHdnameDicByHdclassIdUsingGET
 * url: getHdnameDicByHdclassIdUsingGETURL
 * method: getHdnameDicByHdclassIdUsingGET_TYPE
 * raw_url: getHdnameDicByHdclassIdUsingGET_RAW_URL
 * @param hdclassid - hdclassid
 * @param modulename - modulename
 */
export const getHdnameDicByHdclassIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/gethdname/{hdclassid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{hdclassid}', `${parameters['hdclassid']}`)
  if (parameters['hdclassid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: hdclassid'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHdnameDicByHdclassIdUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/gethdname/{hdclassid}'
}
export const getHdnameDicByHdclassIdUsingGET_TYPE = function() {
  return 'get'
}
export const getHdnameDicByHdclassIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/gethdname/{hdclassid}'
  path = path.replace('{hdclassid}', `${parameters['hdclassid']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findHdiManage
 * request: findHdiManageUsingPOST
 * url: findHdiManageUsingPOSTURL
 * method: findHdiManageUsingPOST_TYPE
 * raw_url: findHdiManageUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param page - 请求页数
 * @param principal - 
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findHdiManageUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/getlist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findHdiManageUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/getlist'
}
export const findHdiManageUsingPOST_TYPE = function() {
  return 'post'
}
export const findHdiManageUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/getlist'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取部门用户，getOrgUsers
 * request: getOrgUsersUsingGET
 * url: getOrgUsersUsingGETURL
 * method: getOrgUsersUsingGET_TYPE
 * raw_url: getOrgUsersUsingGET_RAW_URL
 * @param modulename - modulename
 * @param orgid - orgid
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const getOrgUsersUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/getorgusers/{orgid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{orgid}', `${parameters['orgid']}`)
  if (parameters['orgid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: orgid'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getOrgUsersUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/getorgusers/{orgid}'
}
export const getOrgUsersUsingGET_TYPE = function() {
  return 'get'
}
export const getOrgUsersUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/getorgusers/{orgid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{orgid}', `${parameters['orgid']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 风险等级 getHdfxlevel
 * request: getHdfxlevelUsingGET
 * url: getHdfxlevelUsingGETURL
 * method: getHdfxlevelUsingGET_TYPE
 * raw_url: getHdfxlevelUsingGET_RAW_URL
 * @param fsjlname - 发生几率名称 ABCDE
 * @param modulename - modulename
 * @param yzcdname - 严重程度名称
 */
export const getHdfxlevelUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/hdfxlevel/{yzcdname}/{fsjlname}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{fsjlname}', `${parameters['fsjlname']}`)
  if (parameters['fsjlname'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: fsjlname'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{yzcdname}', `${parameters['yzcdname']}`)
  if (parameters['yzcdname'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: yzcdname'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHdfxlevelUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/hdfxlevel/{yzcdname}/{fsjlname}'
}
export const getHdfxlevelUsingGET_TYPE = function() {
  return 'get'
}
export const getHdfxlevelUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/hdfxlevel/{yzcdname}/{fsjlname}'
  path = path.replace('{fsjlname}', `${parameters['fsjlname']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{yzcdname}', `${parameters['yzcdname']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 整改及时性  getHdzgjsx
 * request: getHdzgjsxUsingGET
 * url: getHdzgjsxUsingGETURL
 * method: getHdzgjsxUsingGET_TYPE
 * raw_url: getHdzgjsxUsingGET_RAW_URL
 * @param data - data
 * @param fsjlname - 发生几率名称 ABCDE
 * @param modulename - modulename
 * @param yzcdname - 严重程度名称
 */
export const getHdzgjsxUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/hdzgjsx'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    body = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  if (parameters['fsjlname'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: fsjlname'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['yzcdname'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: yzcdname'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHdzgjsxUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/hdzgjsx'
}
export const getHdzgjsxUsingGET_TYPE = function() {
  return 'get'
}
export const getHdzgjsxUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/hdzgjsx'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取用户待办工作
 * request: myworklistUsingPOST
 * url: myworklistUsingPOSTURL
 * method: myworklistUsingPOST_TYPE
 * raw_url: myworklistUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param page - 请求页数
 * @param principal - 
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const myworklistUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/mywork'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const myworklistUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/mywork'
}
export const myworklistUsingPOST_TYPE = function() {
  return 'post'
}
export const myworklistUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/mywork'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 已驳回的
 * request: rejectedlistUsingPOST
 * url: rejectedlistUsingPOSTURL
 * method: rejectedlistUsingPOST_TYPE
 * raw_url: rejectedlistUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param page - 请求页数
 * @param principal - 
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const rejectedlistUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/rejected'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const rejectedlistUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/rejected'
}
export const rejectedlistUsingPOST_TYPE = function() {
  return 'post'
}
export const rejectedlistUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/rejected'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回分包商
 * request: findSCOrgsUsingPOST
 * url: findSCOrgsUsingPOSTURL
 * method: findSCOrgsUsingPOST_TYPE
 * raw_url: findSCOrgsUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param parentid - parentid
 */
export const findSCOrgsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/sc/organization/{parentid}/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters['parentid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: parentid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findSCOrgsUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/sc/organization/{parentid}/getlist'
}
export const findSCOrgsUsingPOST_TYPE = function() {
  return 'post'
}
export const findSCOrgsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/sc/organization/{parentid}/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{parentid}', `${parameters['parentid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 判断当前登录人员是否属于施工单位和整改部门
 * request: getSoscDeptUsingPOST
 * url: getSoscDeptUsingPOSTURL
 * method: getSoscDeptUsingPOST_TYPE
 * raw_url: getSoscDeptUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param userid - userid
 */
export const getSoscDeptUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/sc/{userid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{userid}', `${parameters['userid']}`)
  if (parameters['userid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: userid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getSoscDeptUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/sc/{userid}'
}
export const getSoscDeptUsingPOST_TYPE = function() {
  return 'post'
}
export const getSoscDeptUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/sc/{userid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{userid}', `${parameters['userid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 启动工作流
 * request: startWorkflowUsingPOST
 * url: startWorkflowUsingPOSTURL
 * method: startWorkflowUsingPOST_TYPE
 * raw_url: startWorkflowUsingPOST_RAW_URL
 * @param data - data
 * @param hdim - hdim
 * @param modulename - modulename
 * @param name - 
 */
export const startWorkflowUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/startWorkflow'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  if (parameters['hdim'] !== undefined) {
    body = parameters['hdim']
  }
  if (parameters['hdim'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: hdim'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const startWorkflowUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/startWorkflow'
}
export const startWorkflowUsingPOST_TYPE = function() {
  return 'post'
}
export const startWorkflowUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/startWorkflow'
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 我发起的
 * request: startermelistUsingPOST
 * url: startermelistUsingPOSTURL
 * method: startermelistUsingPOST_TYPE
 * raw_url: startermelistUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param page - 请求页数
 * @param principal - 
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const startermelistUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/starterme'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const startermelistUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/starterme'
}
export const startermelistUsingPOST_TYPE = function() {
  return 'post'
}
export const startermelistUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/starterme'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 隐患整改recti, 隐患发起人核实confirm2, 关闭隐患close
 * request: stepWorkflowUsingPOST
 * url: stepWorkflowUsingPOSTURL
 * method: stepWorkflowUsingPOST_TYPE
 * raw_url: stepWorkflowUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param data - data
 * @param details - 
 * @param hdim - hdim
 * @param id - id
 * @param modulename - modulename
 * @param principal - 
 * @param stepname - stepname
 * @param taskid - taskid
 */
export const stepWorkflowUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/stepWorkflow/{id}/{taskid}/{stepname}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  if (parameters['hdim'] !== undefined) {
    body = parameters['hdim']
  }
  if (parameters['hdim'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: hdim'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{stepname}', `${parameters['stepname']}`)
  if (parameters['stepname'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: stepname'))
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters['taskid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const stepWorkflowUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/stepWorkflow/{id}/{taskid}/{stepname}'
}
export const stepWorkflowUsingPOST_TYPE = function() {
  return 'post'
}
export const stepWorkflowUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/stepWorkflow/{id}/{taskid}/{stepname}'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{stepname}', `${parameters['stepname']}`)
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取实例任务
 * request: getbusinessTaskUsingPOST
 * url: getbusinessTaskUsingPOSTURL
 * method: getbusinessTaskUsingPOST_TYPE
 * raw_url: getbusinessTaskUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param businesskey - businesskey
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param principal - 
 * @param processInstanceId - processInstanceId
 */
export const getbusinessTaskUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/task/{processInstanceId}/{businesskey}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  path = path.replace('{businesskey}', `${parameters['businesskey']}`)
  if (parameters['businesskey'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: businesskey'))
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{processInstanceId}', `${parameters['processInstanceId']}`)
  if (parameters['processInstanceId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: processInstanceId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getbusinessTaskUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/task/{processInstanceId}/{businesskey}'
}
export const getbusinessTaskUsingPOST_TYPE = function() {
  return 'post'
}
export const getbusinessTaskUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/task/{processInstanceId}/{businesskey}'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  path = path.replace('{businesskey}', `${parameters['businesskey']}`)
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{processInstanceId}', `${parameters['processInstanceId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回任务的数据信息
 * request: taskformUsingGET
 * url: taskformUsingGETURL
 * method: taskformUsingGET_TYPE
 * raw_url: taskformUsingGET_RAW_URL
 * @param modulename - modulename
 * @param taskid - taskid
 */
export const taskformUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/task/{taskid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters['taskid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const taskformUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/task/{taskid}'
}
export const taskformUsingGET_TYPE = function() {
  return 'get'
}
export const taskformUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/task/{taskid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 完成任务
 * request: completeTaskUsingPOST
 * url: completeTaskUsingPOSTURL
 * method: completeTaskUsingPOST_TYPE
 * raw_url: completeTaskUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param data - data
 * @param details - 
 * @param hdim - hdim
 * @param id - id
 * @param modulename - modulename
 * @param principal - 
 * @param taskid - taskid
 */
export const completeTaskUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/task/{taskid}/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  if (parameters['hdim'] !== undefined) {
    body = parameters['hdim']
  }
  if (parameters['hdim'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: hdim'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters['taskid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const completeTaskUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/task/{taskid}/{id}'
}
export const completeTaskUsingPOST_TYPE = function() {
  return 'post'
}
export const completeTaskUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/task/{taskid}/{id}'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取用户待办工作
 * request: tasklistUsingPOST
 * url: tasklistUsingPOSTURL
 * method: tasklistUsingPOST_TYPE
 * raw_url: tasklistUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param page - 请求页数
 * @param principal - 
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const tasklistUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/tasklist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const tasklistUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/tasklist'
}
export const tasklistUsingPOST_TYPE = function() {
  return 'post'
}
export const tasklistUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/tasklist'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取用户针对某个业务数据的任务
 * request: getbusinessTasksUsingGET
 * url: getbusinessTasksUsingGETURL
 * method: getbusinessTasksUsingGET_TYPE
 * raw_url: getbusinessTasksUsingGET_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param businesskey - businesskey
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param principal - 
 * @param processdfid - processdfid
 */
export const getbusinessTasksUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/tasks/{processdfid}/{businesskey}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  path = path.replace('{businesskey}', `${parameters['businesskey']}`)
  if (parameters['businesskey'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: businesskey'))
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{processdfid}', `${parameters['processdfid']}`)
  if (parameters['processdfid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: processdfid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getbusinessTasksUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/tasks/{processdfid}/{businesskey}'
}
export const getbusinessTasksUsingGET_TYPE = function() {
  return 'get'
}
export const getbusinessTasksUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/tasks/{processdfid}/{businesskey}'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  path = path.replace('{businesskey}', `${parameters['businesskey']}`)
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{processdfid}', `${parameters['processdfid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateHdiManage
 * request: updateHdiManageUsingPOST
 * url: updateHdiManageUsingPOSTURL
 * method: updateHdiManageUsingPOST_TYPE
 * raw_url: updateHdiManageUsingPOST_RAW_URL
 * @param hdim - hdim
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 */
export const updateHdiManageUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['hdim'] !== undefined) {
    body = parameters['hdim']
  }
  if (parameters['hdim'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: hdim'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateHdiManageUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/update/{id}'
}
export const updateHdiManageUsingPOST_TYPE = function() {
  return 'post'
}
export const updateHdiManageUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 我整改的
 * request: izglistUsingPOST
 * url: izglistUsingPOSTURL
 * method: izglistUsingPOST_TYPE
 * raw_url: izglistUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param page - 请求页数
 * @param principal - 
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const izglistUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/zgbyme'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const izglistUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/zgbyme'
}
export const izglistUsingPOST_TYPE = function() {
  return 'post'
}
export const izglistUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/zgbyme'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getHdiManage
 * request: getHdiManageUsingGET
 * url: getHdiManageUsingGETURL
 * method: getHdiManageUsingGET_TYPE
 * raw_url: getHdiManageUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getHdiManageUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHdiManageUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/{id}'
}
export const getHdiManageUsingGET_TYPE = function() {
  return 'get'
}
export const getHdiManageUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteHdiManage
 * request: deleteHdiManageUsingDELETE
 * url: deleteHdiManageUsingDELETEURL
 * method: deleteHdiManageUsingDELETE_TYPE
 * raw_url: deleteHdiManageUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteHdiManageUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteHdiManageUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/{id}'
}
export const deleteHdiManageUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteHdiManageUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getFuHeUser
 * request: getFuHeUserUsingGET
 * url: getFuHeUserUsingGETURL
 * method: getFuHeUserUsingGET_TYPE
 * raw_url: getFuHeUserUsingGET_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param principal - 
 * @param taskid - taskid
 */
export const getFuHeUserUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/hdimanage/{taskid}/getfuheuser'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters['taskid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getFuHeUserUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/hdimanage/{taskid}/getfuheuser'
}
export const getFuHeUserUsingGET_TYPE = function() {
  return 'get'
}
export const getFuHeUserUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/hdimanage/{taskid}/getfuheuser'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectInProcessWeld
 * request: deleteSelectInProcessWeldUsingDELETE
 * url: deleteSelectInProcessWeldUsingDELETEURL
 * method: deleteSelectInProcessWeldUsingDELETE_TYPE
 * raw_url: deleteSelectInProcessWeldUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectInProcessWeldUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/inprocessweld/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectInProcessWeldUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/inprocessweld/delete'
}
export const deleteSelectInProcessWeldUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectInProcessWeldUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/inprocessweld/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteInProcessWeld
 * request: deleteInProcessWeldUsingDELETE
 * url: deleteInProcessWeldUsingDELETEURL
 * method: deleteInProcessWeldUsingDELETE_TYPE
 * raw_url: deleteInProcessWeldUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteInProcessWeldUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/inprocessweld/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteInProcessWeldUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/inprocessweld/delete/{id}'
}
export const deleteInProcessWeldUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteInProcessWeldUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/inprocessweld/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findInProcessWelds
 * request: findInProcessWeldsUsingPOST
 * url: findInProcessWeldsUsingPOSTURL
 * method: findInProcessWeldsUsingPOST_TYPE
 * raw_url: findInProcessWeldsUsingPOST_RAW_URL
 * @param discipline - discipline
 * @param ipweld - ipweld
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findInProcessWeldsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/inprocessweld/inprocessweld/{discipline}/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  if (parameters['ipweld'] !== undefined) {
    body = parameters['ipweld']
  }
  if (parameters['ipweld'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: ipweld'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findInProcessWeldsUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/inprocessweld/inprocessweld/{discipline}/getlist'
}
export const findInProcessWeldsUsingPOST_TYPE = function() {
  return 'post'
}
export const findInProcessWeldsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/inprocessweld/inprocessweld/{discipline}/getlist'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateInProcessWeld
 * request: updateInProcessWeldUsingPOST
 * url: updateInProcessWeldUsingPOSTURL
 * method: updateInProcessWeldUsingPOST_TYPE
 * raw_url: updateInProcessWeldUsingPOST_RAW_URL
 * @param id - id
 * @param ipweld - ipweld
 * @param modulename - modulename
 */
export const updateInProcessWeldUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/inprocessweld/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['ipweld'] !== undefined) {
    body = parameters['ipweld']
  }
  if (parameters['ipweld'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: ipweld'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateInProcessWeldUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/inprocessweld/update/{id}'
}
export const updateInProcessWeldUsingPOST_TYPE = function() {
  return 'post'
}
export const updateInProcessWeldUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/inprocessweld/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addInProcessWeld
 * request: addInProcessWeldUsingPOST
 * url: addInProcessWeldUsingPOSTURL
 * method: addInProcessWeldUsingPOST_TYPE
 * raw_url: addInProcessWeldUsingPOST_RAW_URL
 * @param discipline - discipline
 * @param ipweld - ipweld
 * @param modulename - modulename
 */
export const addInProcessWeldUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/inprocessweld/{discipline}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  if (parameters['ipweld'] !== undefined) {
    body = parameters['ipweld']
  }
  if (parameters['ipweld'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: ipweld'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addInProcessWeldUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/inprocessweld/{discipline}'
}
export const addInProcessWeldUsingPOST_TYPE = function() {
  return 'post'
}
export const addInProcessWeldUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/inprocessweld/{discipline}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getInProcessWeld
 * request: getInProcessWeldUsingGET
 * url: getInProcessWeldUsingGETURL
 * method: getInProcessWeldUsingGET_TYPE
 * raw_url: getInProcessWeldUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getInProcessWeldUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/inprocessweld/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getInProcessWeldUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/inprocessweld/{id}'
}
export const getInProcessWeldUsingGET_TYPE = function() {
  return 'get'
}
export const getInProcessWeldUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/inprocessweld/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addMaterialInspectionItem
 * request: addMaterialInspectionItemUsingPOST
 * url: addMaterialInspectionItemUsingPOSTURL
 * method: addMaterialInspectionItemUsingPOST_TYPE
 * raw_url: addMaterialInspectionItemUsingPOST_RAW_URL
 * @param mii - mii
 * @param modulename - modulename
 */
export const addMaterialInspectionItemUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialinspection/Item'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['mii'] !== undefined) {
    body = parameters['mii']
  }
  if (parameters['mii'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mii'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addMaterialInspectionItemUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialinspection/Item'
}
export const addMaterialInspectionItemUsingPOST_TYPE = function() {
  return 'post'
}
export const addMaterialInspectionItemUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialinspection/Item'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectMaterialInspectionItem
 * request: deleteSelectMaterialInspectionItemUsingDELETE
 * url: deleteSelectMaterialInspectionItemUsingDELETEURL
 * method: deleteSelectMaterialInspectionItemUsingDELETE_TYPE
 * raw_url: deleteSelectMaterialInspectionItemUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectMaterialInspectionItemUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialinspection/Item/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectMaterialInspectionItemUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialinspection/Item/delete'
}
export const deleteSelectMaterialInspectionItemUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectMaterialInspectionItemUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialinspection/Item/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteMaterialInspectionItem
 * request: deleteMaterialInspectionItemUsingDELETE
 * url: deleteMaterialInspectionItemUsingDELETEURL
 * method: deleteMaterialInspectionItemUsingDELETE_TYPE
 * raw_url: deleteMaterialInspectionItemUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteMaterialInspectionItemUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialinspection/Item/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteMaterialInspectionItemUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialinspection/Item/delete/{id}'
}
export const deleteMaterialInspectionItemUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteMaterialInspectionItemUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialinspection/Item/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findMaterialInspectionItem
 * request: findMaterialInspectionItemUsingPOST
 * url: findMaterialInspectionItemUsingPOSTURL
 * method: findMaterialInspectionItemUsingPOST_TYPE
 * raw_url: findMaterialInspectionItemUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param reportid - reportid
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findMaterialInspectionItemUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialinspection/Item/getlist/{reportid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{reportid}', `${parameters['reportid']}`)
  if (parameters['reportid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: reportid'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findMaterialInspectionItemUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialinspection/Item/getlist/{reportid}'
}
export const findMaterialInspectionItemUsingPOST_TYPE = function() {
  return 'post'
}
export const findMaterialInspectionItemUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialinspection/Item/getlist/{reportid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{reportid}', `${parameters['reportid']}`)
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateMaterialInspectionItem
 * request: updateMaterialInspectionItemUsingPOST
 * url: updateMaterialInspectionItemUsingPOSTURL
 * method: updateMaterialInspectionItemUsingPOST_TYPE
 * raw_url: updateMaterialInspectionItemUsingPOST_RAW_URL
 * @param id - id
 * @param mii - mii
 * @param modulename - modulename
 * @param name - 
 */
export const updateMaterialInspectionItemUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialinspection/Item/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['mii'] !== undefined) {
    body = parameters['mii']
  }
  if (parameters['mii'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mii'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateMaterialInspectionItemUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialinspection/Item/update/{id}'
}
export const updateMaterialInspectionItemUsingPOST_TYPE = function() {
  return 'post'
}
export const updateMaterialInspectionItemUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialinspection/Item/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getMaterialInspectionItem
 * request: getMaterialInspectionItemUsingGET
 * url: getMaterialInspectionItemUsingGETURL
 * method: getMaterialInspectionItemUsingGET_TYPE
 * raw_url: getMaterialInspectionItemUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getMaterialInspectionItemUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialinspection/Item/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getMaterialInspectionItemUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialinspection/Item/{id}'
}
export const getMaterialInspectionItemUsingGET_TYPE = function() {
  return 'get'
}
export const getMaterialInspectionItemUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialinspection/Item/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectMaterialInspectionReport
 * request: deleteSelectMaterialInspectionReportUsingDELETE
 * url: deleteSelectMaterialInspectionReportUsingDELETEURL
 * method: deleteSelectMaterialInspectionReportUsingDELETE_TYPE
 * raw_url: deleteSelectMaterialInspectionReportUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectMaterialInspectionReportUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialinspection/Repor/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectMaterialInspectionReportUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialinspection/Repor/delete'
}
export const deleteSelectMaterialInspectionReportUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectMaterialInspectionReportUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialinspection/Repor/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteMaterialInspectionReport
 * request: deleteMaterialInspectionReportUsingDELETE
 * url: deleteMaterialInspectionReportUsingDELETEURL
 * method: deleteMaterialInspectionReportUsingDELETE_TYPE
 * raw_url: deleteMaterialInspectionReportUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteMaterialInspectionReportUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialinspection/Repor/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteMaterialInspectionReportUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialinspection/Repor/delete/{id}'
}
export const deleteMaterialInspectionReportUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteMaterialInspectionReportUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialinspection/Repor/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findMaterialInspectionReport
 * request: findMaterialInspectionReportUsingPOST
 * url: findMaterialInspectionReportUsingPOSTURL
 * method: findMaterialInspectionReportUsingPOST_TYPE
 * raw_url: findMaterialInspectionReportUsingPOST_RAW_URL
 * @param discipline - discipline
 * @param mir - mir
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findMaterialInspectionReportUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialinspection/Repor/getlist/{discipline}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  if (parameters['mir'] !== undefined) {
    body = parameters['mir']
  }
  if (parameters['mir'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mir'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findMaterialInspectionReportUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialinspection/Repor/getlist/{discipline}'
}
export const findMaterialInspectionReportUsingPOST_TYPE = function() {
  return 'post'
}
export const findMaterialInspectionReportUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialinspection/Repor/getlist/{discipline}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateMaterialInspectionReport
 * request: updateMaterialInspectionReportUsingPOST
 * url: updateMaterialInspectionReportUsingPOSTURL
 * method: updateMaterialInspectionReportUsingPOST_TYPE
 * raw_url: updateMaterialInspectionReportUsingPOST_RAW_URL
 * @param id - id
 * @param mir - mir
 * @param modulename - modulename
 */
export const updateMaterialInspectionReportUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialinspection/Repor/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['mir'] !== undefined) {
    body = parameters['mir']
  }
  if (parameters['mir'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mir'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateMaterialInspectionReportUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialinspection/Repor/update/{id}'
}
export const updateMaterialInspectionReportUsingPOST_TYPE = function() {
  return 'post'
}
export const updateMaterialInspectionReportUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialinspection/Repor/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addMaterialInspectionReport
 * request: addMaterialInspectionReportUsingPOST
 * url: addMaterialInspectionReportUsingPOSTURL
 * method: addMaterialInspectionReportUsingPOST_TYPE
 * raw_url: addMaterialInspectionReportUsingPOST_RAW_URL
 * @param discipline - discipline
 * @param mir - mir
 * @param modulename - modulename
 */
export const addMaterialInspectionReportUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialinspection/Repor/{discipline}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  if (parameters['mir'] !== undefined) {
    body = parameters['mir']
  }
  if (parameters['mir'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mir'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addMaterialInspectionReportUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialinspection/Repor/{discipline}'
}
export const addMaterialInspectionReportUsingPOST_TYPE = function() {
  return 'post'
}
export const addMaterialInspectionReportUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialinspection/Repor/{discipline}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getMaterialInspectionReport
 * request: getMaterialInspectionReportUsingGET
 * url: getMaterialInspectionReportUsingGETURL
 * method: getMaterialInspectionReportUsingGET_TYPE
 * raw_url: getMaterialInspectionReportUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getMaterialInspectionReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialinspection/Repor/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getMaterialInspectionReportUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialinspection/Repor/{id}'
}
export const getMaterialInspectionReportUsingGET_TYPE = function() {
  return 'get'
}
export const getMaterialInspectionReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialinspection/Repor/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findMaterialInspectionReport_APP
 * request: findMaterialInspectionReport_APPUsingPOST
 * url: findMaterialInspectionReport_APPUsingPOSTURL
 * method: findMaterialInspectionReport_APPUsingPOST_TYPE
 * raw_url: findMaterialInspectionReport_APPUsingPOST_RAW_URL
 * @param discipline - discipline
 * @param mir - mir
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findMaterialInspectionReport_APPUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialinspection/app/Repor/getlist/{discipline}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  if (parameters['mir'] !== undefined) {
    body = parameters['mir']
  }
  if (parameters['mir'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mir'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findMaterialInspectionReport_APPUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialinspection/app/Repor/getlist/{discipline}'
}
export const findMaterialInspectionReport_APPUsingPOST_TYPE = function() {
  return 'post'
}
export const findMaterialInspectionReport_APPUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialinspection/app/Repor/getlist/{discipline}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 提交检验接口（app用），SubmitInspection
 * request: SubmitInspectionUsingPOST_2
 * url: SubmitInspectionUsingPOST_2URL
 * method: SubmitInspectionUsingPOST_2_TYPE
 * raw_url: SubmitInspectionUsingPOST_2_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param rid - rid
 * @param sub - sub
 */
export const SubmitInspectionUsingPOST_2 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialinspection/app/submitinspection/{rid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  path = path.replace('{rid}', `${parameters['rid']}`)
  if (parameters['rid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: rid'))
  }
  if (parameters['sub'] !== undefined) {
    body = parameters['sub']
  }
  if (parameters['sub'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: sub'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const SubmitInspectionUsingPOST_2_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialinspection/app/submitinspection/{rid}'
}
export const SubmitInspectionUsingPOST_2_TYPE = function() {
  return 'post'
}
export const SubmitInspectionUsingPOST_2URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialinspection/app/submitinspection/{rid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  path = path.replace('{rid}', `${parameters['rid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getMaterialInspectionReportByNo
 * request: getMaterialInspectionReportByNoUsingGET
 * url: getMaterialInspectionReportByNoUsingGETURL
 * method: getMaterialInspectionReportByNoUsingGET_TYPE
 * raw_url: getMaterialInspectionReportByNoUsingGET_RAW_URL
 * @param modulename - modulename
 * @param no - no
 */
export const getMaterialInspectionReportByNoUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialinspection/getMaterialInspectionReport/{no}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{no}', `${parameters['no']}`)
  if (parameters['no'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: no'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getMaterialInspectionReportByNoUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialinspection/getMaterialInspectionReport/{no}'
}
export const getMaterialInspectionReportByNoUsingGET_TYPE = function() {
  return 'get'
}
export const getMaterialInspectionReportByNoUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialinspection/getMaterialInspectionReport/{no}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{no}', `${parameters['no']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addMaterialTraceabilityItem
 * request: addMaterialTraceabilityItemUsingPOST
 * url: addMaterialTraceabilityItemUsingPOSTURL
 * method: addMaterialTraceabilityItemUsingPOST_TYPE
 * raw_url: addMaterialTraceabilityItemUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param mti - mti
 */
export const addMaterialTraceabilityItemUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialtraceability/Item'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['mti'] !== undefined) {
    body = parameters['mti']
  }
  if (parameters['mti'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mti'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addMaterialTraceabilityItemUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialtraceability/Item'
}
export const addMaterialTraceabilityItemUsingPOST_TYPE = function() {
  return 'post'
}
export const addMaterialTraceabilityItemUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialtraceability/Item'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectMaterialTraceabilityItem
 * request: deleteSelectMaterialTraceabilityItemUsingDELETE
 * url: deleteSelectMaterialTraceabilityItemUsingDELETEURL
 * method: deleteSelectMaterialTraceabilityItemUsingDELETE_TYPE
 * raw_url: deleteSelectMaterialTraceabilityItemUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectMaterialTraceabilityItemUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialtraceability/Item/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectMaterialTraceabilityItemUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialtraceability/Item/delete'
}
export const deleteSelectMaterialTraceabilityItemUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectMaterialTraceabilityItemUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialtraceability/Item/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteMaterialTraceabilityItem
 * request: deleteMaterialTraceabilityItemUsingDELETE
 * url: deleteMaterialTraceabilityItemUsingDELETEURL
 * method: deleteMaterialTraceabilityItemUsingDELETE_TYPE
 * raw_url: deleteMaterialTraceabilityItemUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteMaterialTraceabilityItemUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialtraceability/Item/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteMaterialTraceabilityItemUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialtraceability/Item/delete/{id}'
}
export const deleteMaterialTraceabilityItemUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteMaterialTraceabilityItemUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialtraceability/Item/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findMaterialTraceabilityItem
 * request: findMaterialTraceabilityItemUsingPOST
 * url: findMaterialTraceabilityItemUsingPOSTURL
 * method: findMaterialTraceabilityItemUsingPOST_TYPE
 * raw_url: findMaterialTraceabilityItemUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param reportid - reportid
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findMaterialTraceabilityItemUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialtraceability/Item/getlist/{reportid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{reportid}', `${parameters['reportid']}`)
  if (parameters['reportid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: reportid'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findMaterialTraceabilityItemUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialtraceability/Item/getlist/{reportid}'
}
export const findMaterialTraceabilityItemUsingPOST_TYPE = function() {
  return 'post'
}
export const findMaterialTraceabilityItemUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialtraceability/Item/getlist/{reportid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{reportid}', `${parameters['reportid']}`)
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateMaterialTraceabilityItem
 * request: updateMaterialTraceabilityItemUsingPOST
 * url: updateMaterialTraceabilityItemUsingPOSTURL
 * method: updateMaterialTraceabilityItemUsingPOST_TYPE
 * raw_url: updateMaterialTraceabilityItemUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param mti - mti
 * @param name - 
 */
export const updateMaterialTraceabilityItemUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialtraceability/Item/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['mti'] !== undefined) {
    body = parameters['mti']
  }
  if (parameters['mti'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mti'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateMaterialTraceabilityItemUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialtraceability/Item/update/{id}'
}
export const updateMaterialTraceabilityItemUsingPOST_TYPE = function() {
  return 'post'
}
export const updateMaterialTraceabilityItemUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialtraceability/Item/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getMaterialTraceabilityItem
 * request: getMaterialTraceabilityItemUsingGET
 * url: getMaterialTraceabilityItemUsingGETURL
 * method: getMaterialTraceabilityItemUsingGET_TYPE
 * raw_url: getMaterialTraceabilityItemUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getMaterialTraceabilityItemUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialtraceability/Item/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getMaterialTraceabilityItemUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialtraceability/Item/{id}'
}
export const getMaterialTraceabilityItemUsingGET_TYPE = function() {
  return 'get'
}
export const getMaterialTraceabilityItemUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialtraceability/Item/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectMaterialTraceabilityReport
 * request: deleteSelectMaterialTraceabilityReportUsingDELETE
 * url: deleteSelectMaterialTraceabilityReportUsingDELETEURL
 * method: deleteSelectMaterialTraceabilityReportUsingDELETE_TYPE
 * raw_url: deleteSelectMaterialTraceabilityReportUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectMaterialTraceabilityReportUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialtraceability/Repor/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectMaterialTraceabilityReportUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialtraceability/Repor/delete'
}
export const deleteSelectMaterialTraceabilityReportUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectMaterialTraceabilityReportUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialtraceability/Repor/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteMaterialTraceabilityReport
 * request: deleteMaterialTraceabilityReportUsingDELETE
 * url: deleteMaterialTraceabilityReportUsingDELETEURL
 * method: deleteMaterialTraceabilityReportUsingDELETE_TYPE
 * raw_url: deleteMaterialTraceabilityReportUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteMaterialTraceabilityReportUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialtraceability/Repor/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteMaterialTraceabilityReportUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialtraceability/Repor/delete/{id}'
}
export const deleteMaterialTraceabilityReportUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteMaterialTraceabilityReportUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialtraceability/Repor/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findMaterialTraceabilityReport
 * request: findMaterialTraceabilityReportUsingPOST
 * url: findMaterialTraceabilityReportUsingPOSTURL
 * method: findMaterialTraceabilityReportUsingPOST_TYPE
 * raw_url: findMaterialTraceabilityReportUsingPOST_RAW_URL
 * @param discipline - discipline
 * @param modulename - modulename
 * @param mtr - mtr
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findMaterialTraceabilityReportUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialtraceability/Repor/getlist/{discipline}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['mtr'] !== undefined) {
    body = parameters['mtr']
  }
  if (parameters['mtr'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mtr'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findMaterialTraceabilityReportUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialtraceability/Repor/getlist/{discipline}'
}
export const findMaterialTraceabilityReportUsingPOST_TYPE = function() {
  return 'post'
}
export const findMaterialTraceabilityReportUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialtraceability/Repor/getlist/{discipline}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateMaterialTraceabilityReport
 * request: updateMaterialTraceabilityReportUsingPOST
 * url: updateMaterialTraceabilityReportUsingPOSTURL
 * method: updateMaterialTraceabilityReportUsingPOST_TYPE
 * raw_url: updateMaterialTraceabilityReportUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param mtr - mtr
 */
export const updateMaterialTraceabilityReportUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialtraceability/Repor/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['mtr'] !== undefined) {
    body = parameters['mtr']
  }
  if (parameters['mtr'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mtr'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateMaterialTraceabilityReportUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialtraceability/Repor/update/{id}'
}
export const updateMaterialTraceabilityReportUsingPOST_TYPE = function() {
  return 'post'
}
export const updateMaterialTraceabilityReportUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialtraceability/Repor/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addMaterialTraceabilityReport
 * request: addMaterialTraceabilityReportUsingPOST
 * url: addMaterialTraceabilityReportUsingPOSTURL
 * method: addMaterialTraceabilityReportUsingPOST_TYPE
 * raw_url: addMaterialTraceabilityReportUsingPOST_RAW_URL
 * @param discipline - discipline
 * @param modulename - modulename
 * @param mtr - mtr
 */
export const addMaterialTraceabilityReportUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialtraceability/Repor/{discipline}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['mtr'] !== undefined) {
    body = parameters['mtr']
  }
  if (parameters['mtr'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mtr'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addMaterialTraceabilityReportUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialtraceability/Repor/{discipline}'
}
export const addMaterialTraceabilityReportUsingPOST_TYPE = function() {
  return 'post'
}
export const addMaterialTraceabilityReportUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialtraceability/Repor/{discipline}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getMaterialTraceabilityReport
 * request: getMaterialTraceabilityReportUsingGET
 * url: getMaterialTraceabilityReportUsingGETURL
 * method: getMaterialTraceabilityReportUsingGET_TYPE
 * raw_url: getMaterialTraceabilityReportUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getMaterialTraceabilityReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialtraceability/Repor/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getMaterialTraceabilityReportUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialtraceability/Repor/{id}'
}
export const getMaterialTraceabilityReportUsingGET_TYPE = function() {
  return 'get'
}
export const getMaterialTraceabilityReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialtraceability/Repor/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findMaterialTraceabilityReport_APP
 * request: findMaterialTraceabilityReport_APPUsingPOST
 * url: findMaterialTraceabilityReport_APPUsingPOSTURL
 * method: findMaterialTraceabilityReport_APPUsingPOST_TYPE
 * raw_url: findMaterialTraceabilityReport_APPUsingPOST_RAW_URL
 * @param discipline - discipline
 * @param modulename - modulename
 * @param mtr - mtr
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findMaterialTraceabilityReport_APPUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialtraceability/app/Repor/getlist/{discipline}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['mtr'] !== undefined) {
    body = parameters['mtr']
  }
  if (parameters['mtr'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mtr'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findMaterialTraceabilityReport_APPUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialtraceability/app/Repor/getlist/{discipline}'
}
export const findMaterialTraceabilityReport_APPUsingPOST_TYPE = function() {
  return 'post'
}
export const findMaterialTraceabilityReport_APPUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialtraceability/app/Repor/getlist/{discipline}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 提交检验接口（app用），SubmitInspection
 * request: SubmitInspectionUsingPOST_3
 * url: SubmitInspectionUsingPOST_3URL
 * method: SubmitInspectionUsingPOST_3_TYPE
 * raw_url: SubmitInspectionUsingPOST_3_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param rid - rid
 * @param sub - sub
 */
export const SubmitInspectionUsingPOST_3 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialtraceability/app/submitinspection/{rid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  path = path.replace('{rid}', `${parameters['rid']}`)
  if (parameters['rid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: rid'))
  }
  if (parameters['sub'] !== undefined) {
    body = parameters['sub']
  }
  if (parameters['sub'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: sub'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const SubmitInspectionUsingPOST_3_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialtraceability/app/submitinspection/{rid}'
}
export const SubmitInspectionUsingPOST_3_TYPE = function() {
  return 'post'
}
export const SubmitInspectionUsingPOST_3URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialtraceability/app/submitinspection/{rid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  path = path.replace('{rid}', `${parameters['rid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getMaterialTraceabilityReportByNo
 * request: getMaterialTraceabilityReportByNoUsingGET
 * url: getMaterialTraceabilityReportByNoUsingGETURL
 * method: getMaterialTraceabilityReportByNoUsingGET_TYPE
 * raw_url: getMaterialTraceabilityReportByNoUsingGET_RAW_URL
 * @param modulename - modulename
 * @param no - no
 */
export const getMaterialTraceabilityReportByNoUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/materialtraceability/getMaterialTraceabilityReport/{no}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{no}', `${parameters['no']}`)
  if (parameters['no'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: no'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getMaterialTraceabilityReportByNoUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/materialtraceability/getMaterialTraceabilityReport/{no}'
}
export const getMaterialTraceabilityReportByNoUsingGET_TYPE = function() {
  return 'get'
}
export const getMaterialTraceabilityReportByNoUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/materialtraceability/getMaterialTraceabilityReport/{no}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{no}', `${parameters['no']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addSafetyOBCard
 * request: addSafetyOBCardUsingPOST
 * url: addSafetyOBCardUsingPOSTURL
 * method: addSafetyOBCardUsingPOST_TYPE
 * raw_url: addSafetyOBCardUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param sobcard - sobcard
 */
export const addSafetyOBCardUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/safetyobcard'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['sobcard'] !== undefined) {
    body = parameters['sobcard']
  }
  if (parameters['sobcard'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: sobcard'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addSafetyOBCardUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/safetyobcard'
}
export const addSafetyOBCardUsingPOST_TYPE = function() {
  return 'post'
}
export const addSafetyOBCardUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/safetyobcard'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSafetyOBCards
 * request: deleteSafetyOBCardsUsingDELETE
 * url: deleteSafetyOBCardsUsingDELETEURL
 * method: deleteSafetyOBCardsUsingDELETE_TYPE
 * raw_url: deleteSafetyOBCardsUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSafetyOBCardsUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/safetyobcard'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSafetyOBCardsUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/safetyobcard'
}
export const deleteSafetyOBCardsUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSafetyOBCardsUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/safetyobcard'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findSafetyOBCard
 * request: findSafetyOBCardUsingPOST
 * url: findSafetyOBCardUsingPOSTURL
 * method: findSafetyOBCardUsingPOST_TYPE
 * raw_url: findSafetyOBCardUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param page - 请求页数
 * @param principal - 
 * @param size - 页记录数
 * @param sobcard - sobcard
 * @param sort - 排序字段
 */
export const findSafetyOBCardUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/safetyobcard/getlist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sobcard'] !== undefined) {
    body = parameters['sobcard']
  }
  if (parameters['sobcard'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: sobcard'))
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findSafetyOBCardUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/safetyobcard/getlist'
}
export const findSafetyOBCardUsingPOST_TYPE = function() {
  return 'post'
}
export const findSafetyOBCardUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/safetyobcard/getlist'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 启动工作流，startWorkflowSafetyOBCard
 * request: startWorkflowSafetyOBCardUsingPOST
 * url: startWorkflowSafetyOBCardUsingPOSTURL
 * method: startWorkflowSafetyOBCardUsingPOST_TYPE
 * raw_url: startWorkflowSafetyOBCardUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param sobcard - sobcard
 */
export const startWorkflowSafetyOBCardUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/safetyobcard/startWorkflow'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['sobcard'] !== undefined) {
    body = parameters['sobcard']
  }
  if (parameters['sobcard'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: sobcard'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const startWorkflowSafetyOBCardUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/safetyobcard/startWorkflow'
}
export const startWorkflowSafetyOBCardUsingPOST_TYPE = function() {
  return 'post'
}
export const startWorkflowSafetyOBCardUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/safetyobcard/startWorkflow'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回任务的数据信息
 * request: taskformUsingGET_1
 * url: taskformUsingGET_1URL
 * method: taskformUsingGET_1_TYPE
 * raw_url: taskformUsingGET_1_RAW_URL
 * @param modulename - modulename
 * @param taskid - taskid
 */
export const taskformUsingGET_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/safetyobcard/task/{taskid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters['taskid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const taskformUsingGET_1_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/safetyobcard/task/{taskid}'
}
export const taskformUsingGET_1_TYPE = function() {
  return 'get'
}
export const taskformUsingGET_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/safetyobcard/task/{taskid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 跟踪处理，trackProcessingSafetyOBCard
 * request: trackProcessingSafetyOBCardUsingPOST
 * url: trackProcessingSafetyOBCardUsingPOSTURL
 * method: trackProcessingSafetyOBCardUsingPOST_TYPE
 * raw_url: trackProcessingSafetyOBCardUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param data - data
 * @param details - 
 * @param id - id
 * @param modulename - modulename
 * @param principal - 
 * @param taskid - taskid
 */
export const trackProcessingSafetyOBCardUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/safetyobcard/task/{taskid}/{id}/track'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['data'] !== undefined) {
    body = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters['taskid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const trackProcessingSafetyOBCardUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/safetyobcard/task/{taskid}/{id}/track'
}
export const trackProcessingSafetyOBCardUsingPOST_TYPE = function() {
  return 'post'
}
export const trackProcessingSafetyOBCardUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/safetyobcard/task/{taskid}/{id}/track'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 核实，trackProcessingSafetyOBCard
 * request: verifySafetyOBCardUsingPOST
 * url: verifySafetyOBCardUsingPOSTURL
 * method: verifySafetyOBCardUsingPOST_TYPE
 * raw_url: verifySafetyOBCardUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param data - data
 * @param details - 
 * @param id - id
 * @param modulename - modulename
 * @param principal - 
 * @param taskid - taskid
 */
export const verifySafetyOBCardUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/safetyobcard/task/{taskid}/{id}/verify'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['data'] !== undefined) {
    body = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters['taskid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const verifySafetyOBCardUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/safetyobcard/task/{taskid}/{id}/verify'
}
export const verifySafetyOBCardUsingPOST_TYPE = function() {
  return 'post'
}
export const verifySafetyOBCardUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/safetyobcard/task/{taskid}/{id}/verify'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateSafetyOBCard
 * request: updateSafetyOBCardUsingPOST
 * url: updateSafetyOBCardUsingPOSTURL
 * method: updateSafetyOBCardUsingPOST_TYPE
 * raw_url: updateSafetyOBCardUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 * @param sobcard - sobcard
 */
export const updateSafetyOBCardUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/safetyobcard/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['sobcard'] !== undefined) {
    body = parameters['sobcard']
  }
  if (parameters['sobcard'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: sobcard'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateSafetyOBCardUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/safetyobcard/update/{id}'
}
export const updateSafetyOBCardUsingPOST_TYPE = function() {
  return 'post'
}
export const updateSafetyOBCardUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/safetyobcard/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getSafetyOBCard
 * request: getSafetyOBCardUsingGET
 * url: getSafetyOBCardUsingGETURL
 * method: getSafetyOBCardUsingGET_TYPE
 * raw_url: getSafetyOBCardUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getSafetyOBCardUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/safetyobcard/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSafetyOBCardUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/safetyobcard/{id}'
}
export const getSafetyOBCardUsingGET_TYPE = function() {
  return 'get'
}
export const getSafetyOBCardUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/safetyobcard/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSafetyOBCard
 * request: deleteSafetyOBCardUsingDELETE
 * url: deleteSafetyOBCardUsingDELETEURL
 * method: deleteSafetyOBCardUsingDELETE_TYPE
 * raw_url: deleteSafetyOBCardUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteSafetyOBCardUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/safetyobcard/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSafetyOBCardUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/safetyobcard/{id}'
}
export const deleteSafetyOBCardUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSafetyOBCardUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/safetyobcard/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 作废，cancelSafetyOBCard
 * request: cancelSafetyOBCardUsingPOST
 * url: cancelSafetyOBCardUsingPOSTURL
 * method: cancelSafetyOBCardUsingPOST_TYPE
 * raw_url: cancelSafetyOBCardUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const cancelSafetyOBCardUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/safetyobcard/{id}/cancel'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const cancelSafetyOBCardUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/safetyobcard/{id}/cancel'
}
export const cancelSafetyOBCardUsingPOST_TYPE = function() {
  return 'post'
}
export const cancelSafetyOBCardUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/safetyobcard/{id}/cancel'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 关闭，closeSafetyOBCard
 * request: closeSafetyOBCardUsingPOST
 * url: closeSafetyOBCardUsingPOSTURL
 * method: closeSafetyOBCardUsingPOST_TYPE
 * raw_url: closeSafetyOBCardUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const closeSafetyOBCardUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/safetyobcard/{id}/close'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const closeSafetyOBCardUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/safetyobcard/{id}/close'
}
export const closeSafetyOBCardUsingPOST_TYPE = function() {
  return 'post'
}
export const closeSafetyOBCardUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/safetyobcard/{id}/close'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addTrainingInfo
 * request: addTrainingInfoUsingPOST
 * url: addTrainingInfoUsingPOSTURL
 * method: addTrainingInfoUsingPOST_TYPE
 * raw_url: addTrainingInfoUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const addTrainingInfoUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/trainingInfo/'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addTrainingInfoUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/trainingInfo/'
}
export const addTrainingInfoUsingPOST_TYPE = function() {
  return 'post'
}
export const addTrainingInfoUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/trainingInfo/'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findTrainingInfos
 * request: findTrainingInfosUsingPOST
 * url: findTrainingInfosUsingPOSTURL
 * method: findTrainingInfosUsingPOST_TYPE
 * raw_url: findTrainingInfosUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findTrainingInfosUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/trainingInfo/TrainingInfo/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findTrainingInfosUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/trainingInfo/TrainingInfo/getlist'
}
export const findTrainingInfosUsingPOST_TYPE = function() {
  return 'post'
}
export const findTrainingInfosUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/trainingInfo/TrainingInfo/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectTrainingInfo
 * request: deleteSelectTrainingInfoUsingDELETE
 * url: deleteSelectTrainingInfoUsingDELETEURL
 * method: deleteSelectTrainingInfoUsingDELETE_TYPE
 * raw_url: deleteSelectTrainingInfoUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectTrainingInfoUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/trainingInfo/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectTrainingInfoUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/trainingInfo/delete'
}
export const deleteSelectTrainingInfoUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectTrainingInfoUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/trainingInfo/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteTrainingInfo
 * request: deleteTrainingInfoUsingDELETE
 * url: deleteTrainingInfoUsingDELETEURL
 * method: deleteTrainingInfoUsingDELETE_TYPE
 * raw_url: deleteTrainingInfoUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteTrainingInfoUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/trainingInfo/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteTrainingInfoUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/trainingInfo/delete/{id}'
}
export const deleteTrainingInfoUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteTrainingInfoUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/trainingInfo/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导出 downloadTrainingInfoDatafile
 * request: downloadTrainingInfoDatafileUsingPOST
 * url: downloadTrainingInfoDatafileUsingPOSTURL
 * method: downloadTrainingInfoDatafileUsingPOST_TYPE
 * raw_url: downloadTrainingInfoDatafileUsingPOST_RAW_URL
 * @param ext - ext
 * @param filename - filename
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const downloadTrainingInfoDatafileUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/trainingInfo/download/{filename}.{ext}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{ext}', `${parameters['ext']}`)
  if (parameters['ext'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: ext'))
  }
  path = path.replace('{filename}', `${parameters['filename']}`)
  if (parameters['filename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: filename'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const downloadTrainingInfoDatafileUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/trainingInfo/download/{filename}.{ext}'
}
export const downloadTrainingInfoDatafileUsingPOST_TYPE = function() {
  return 'post'
}
export const downloadTrainingInfoDatafileUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/trainingInfo/download/{filename}.{ext}'
  path = path.replace('{ext}', `${parameters['ext']}`)
  path = path.replace('{filename}', `${parameters['filename']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateTrainingInfo
 * request: updateTrainingInfoUsingPOST
 * url: updateTrainingInfoUsingPOSTURL
 * method: updateTrainingInfoUsingPOST_TYPE
 * raw_url: updateTrainingInfoUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const updateTrainingInfoUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/trainingInfo/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateTrainingInfoUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/trainingInfo/update/{id}'
}
export const updateTrainingInfoUsingPOST_TYPE = function() {
  return 'post'
}
export const updateTrainingInfoUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/trainingInfo/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导入数据 uploadTrainingInfoExcel
 * request: uploadTrainingInfoExcelUsingPOST
 * url: uploadTrainingInfoExcelUsingPOSTURL
 * method: uploadTrainingInfoExcelUsingPOST_TYPE
 * raw_url: uploadTrainingInfoExcelUsingPOST_RAW_URL
 * @param attid - attid
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const uploadTrainingInfoExcelUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/trainingInfo/upload/{attid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{attid}', `${parameters['attid']}`)
  if (parameters['attid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: attid'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const uploadTrainingInfoExcelUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/trainingInfo/upload/{attid}'
}
export const uploadTrainingInfoExcelUsingPOST_TYPE = function() {
  return 'post'
}
export const uploadTrainingInfoExcelUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/trainingInfo/upload/{attid}'
  path = path.replace('{attid}', `${parameters['attid']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getTrainingInfo
 * request: getTrainingInfoUsingGET
 * url: getTrainingInfoUsingGETURL
 * method: getTrainingInfoUsingGET_TYPE
 * raw_url: getTrainingInfoUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getTrainingInfoUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/trainingInfo/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTrainingInfoUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/trainingInfo/{id}'
}
export const getTrainingInfoUsingGET_TYPE = function() {
  return 'get'
}
export const getTrainingInfoUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/trainingInfo/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回所有的焊口给前端,结果为数组列表.[0] 是图纸号,  [1] 是焊口号, [2] 焊口id,[3]是material_class，[4]weld_size，[5]weld_vis_thickness,2.配管专业要求返回单管号
 * request: queryweldsUsingPOST
 * url: queryweldsUsingPOSTURL
 * method: queryweldsUsingPOST_TYPE
 * raw_url: queryweldsUsingPOST_RAW_URL
 * @param discipline - discipline
 * @param modulename - modulename
 * @param pagemap - pagemap
 */
export const queryweldsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weld/alljoint/{discipline}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['pagemap'] !== undefined) {
    body = parameters['pagemap']
  }
  if (parameters['pagemap'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: pagemap'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const queryweldsUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weld/alljoint/{discipline}'
}
export const queryweldsUsingPOST_TYPE = function() {
  return 'post'
}
export const queryweldsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weld/alljoint/{discipline}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回所有的焊口给前端,结果为数组列表，[0] 是图纸号  [1] 是焊口号 [2] 焊口id
 * request: querylayerweldsUsingGET
 * url: querylayerweldsUsingGETURL
 * method: querylayerweldsUsingGET_TYPE
 * raw_url: querylayerweldsUsingGET_RAW_URL
 * @param discipline - discipline
 * @param modulename - modulename
 * @param name - 
 * @param weldlayer - weldlayer
 */
export const querylayerweldsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weld/alljoint/{discipline}/{weldlayer}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  path = path.replace('{weldlayer}', `${parameters['weldlayer']}`)
  if (parameters['weldlayer'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: weldlayer'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const querylayerweldsUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weld/alljoint/{discipline}/{weldlayer}'
}
export const querylayerweldsUsingGET_TYPE = function() {
  return 'get'
}
export const querylayerweldsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weld/alljoint/{discipline}/{weldlayer}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  path = path.replace('{weldlayer}', `${parameters['weldlayer']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectWeld
 * request: deleteSelectWeldUsingDELETE
 * url: deleteSelectWeldUsingDELETEURL
 * method: deleteSelectWeldUsingDELETE_TYPE
 * raw_url: deleteSelectWeldUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectWeldUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weld/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectWeldUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weld/delete'
}
export const deleteSelectWeldUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectWeldUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weld/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteWeld
 * request: deleteWeldUsingDELETE
 * url: deleteWeldUsingDELETEURL
 * method: deleteWeldUsingDELETE_TYPE
 * raw_url: deleteWeldUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteWeldUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weld/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteWeldUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weld/delete/{id}'
}
export const deleteWeldUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteWeldUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weld/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回焊接基本信息，传入id为焊口id
 * request: getInProcessWeldUsingGET_1
 * url: getInProcessWeldUsingGET_1URL
 * method: getInProcessWeldUsingGET_1_TYPE
 * raw_url: getInProcessWeldUsingGET_1_RAW_URL
 * @param discipline - discipline
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 * @param weldlayer - weldlayer
 */
export const getInProcessWeldUsingGET_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weld/get/{id}/{discipline}/{weldlayer}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  path = path.replace('{weldlayer}', `${parameters['weldlayer']}`)
  if (parameters['weldlayer'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: weldlayer'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getInProcessWeldUsingGET_1_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weld/get/{id}/{discipline}/{weldlayer}'
}
export const getInProcessWeldUsingGET_1_TYPE = function() {
  return 'get'
}
export const getInProcessWeldUsingGET_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weld/get/{id}/{discipline}/{weldlayer}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  path = path.replace('{weldlayer}', `${parameters['weldlayer']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 提交焊接过程
 * request: inprocessUsingPOST
 * url: inprocessUsingPOSTURL
 * method: inprocessUsingPOST_TYPE
 * raw_url: inprocessUsingPOST_RAW_URL
 * @param inprocess - inprocess
 * @param modulename - modulename
 */
export const inprocessUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weld/inprocess'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['inprocess'] !== undefined) {
    body = parameters['inprocess']
  }
  if (parameters['inprocess'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: inprocess'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const inprocessUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weld/inprocess'
}
export const inprocessUsingPOST_TYPE = function() {
  return 'post'
}
export const inprocessUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weld/inprocess'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回焊口数据最后更新时间
 * request: lastupdateUsingPOST_1
 * url: lastupdateUsingPOST_1URL
 * method: lastupdateUsingPOST_1_TYPE
 * raw_url: lastupdateUsingPOST_1_RAW_URL
 * @param discipline - discipline
 * @param modulename - modulename
 */
export const lastupdateUsingPOST_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weld/lastupdate/{discipline}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  if (parameters['discipline'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: discipline'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const lastupdateUsingPOST_1_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weld/lastupdate/{discipline}'
}
export const lastupdateUsingPOST_1_TYPE = function() {
  return 'post'
}
export const lastupdateUsingPOST_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weld/lastupdate/{discipline}'
  path = path.replace('{discipline}', `${parameters['discipline']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addPIPWeld
 * request: addPIPWeldUsingPOST
 * url: addPIPWeldUsingPOSTURL
 * method: addPIPWeldUsingPOST_TYPE
 * raw_url: addPIPWeldUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param pipweld - pipweld
 */
export const addPIPWeldUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weld/pipweld'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['pipweld'] !== undefined) {
    body = parameters['pipweld']
  }
  if (parameters['pipweld'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: pipweld'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addPIPWeldUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weld/pipweld'
}
export const addPIPWeldUsingPOST_TYPE = function() {
  return 'post'
}
export const addPIPWeldUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weld/pipweld'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findPIPWelds
 * request: findPIPWeldsUsingPOST
 * url: findPIPWeldsUsingPOSTURL
 * method: findPIPWeldsUsingPOST_TYPE
 * raw_url: findPIPWeldsUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param pipweld - pipweld
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findPIPWeldsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weld/pipweld/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['pipweld'] !== undefined) {
    body = parameters['pipweld']
  }
  if (parameters['pipweld'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: pipweld'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findPIPWeldsUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weld/pipweld/getlist'
}
export const findPIPWeldsUsingPOST_TYPE = function() {
  return 'post'
}
export const findPIPWeldsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weld/pipweld/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updatePIPWeld
 * request: updatePIPWeldUsingPOST
 * url: updatePIPWeldUsingPOSTURL
 * method: updatePIPWeldUsingPOST_TYPE
 * raw_url: updatePIPWeldUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param pipweld - pipweld
 */
export const updatePIPWeldUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weld/pipweld/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['pipweld'] !== undefined) {
    body = parameters['pipweld']
  }
  if (parameters['pipweld'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: pipweld'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updatePIPWeldUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weld/pipweld/update/{id}'
}
export const updatePIPWeldUsingPOST_TYPE = function() {
  return 'post'
}
export const updatePIPWeldUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weld/pipweld/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getPIPWeld
 * request: getPIPWeldUsingGET
 * url: getPIPWeldUsingGETURL
 * method: getPIPWeldUsingGET_TYPE
 * raw_url: getPIPWeldUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getPIPWeldUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weld/pipweld/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getPIPWeldUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weld/pipweld/{id}'
}
export const getPIPWeldUsingGET_TYPE = function() {
  return 'get'
}
export const getPIPWeldUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weld/pipweld/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addSTRWeld
 * request: addSTRWeldUsingPOST
 * url: addSTRWeldUsingPOSTURL
 * method: addSTRWeldUsingPOST_TYPE
 * raw_url: addSTRWeldUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param strweld - strweld
 */
export const addSTRWeldUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weld/strweld'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['strweld'] !== undefined) {
    body = parameters['strweld']
  }
  if (parameters['strweld'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: strweld'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addSTRWeldUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weld/strweld'
}
export const addSTRWeldUsingPOST_TYPE = function() {
  return 'post'
}
export const addSTRWeldUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weld/strweld'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findSTRWelds
 * request: findSTRWeldsUsingPOST
 * url: findSTRWeldsUsingPOSTURL
 * method: findSTRWeldsUsingPOST_TYPE
 * raw_url: findSTRWeldsUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param strweld - strweld
 */
export const findSTRWeldsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weld/strweld/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['strweld'] !== undefined) {
    body = parameters['strweld']
  }
  if (parameters['strweld'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: strweld'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findSTRWeldsUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weld/strweld/getlist'
}
export const findSTRWeldsUsingPOST_TYPE = function() {
  return 'post'
}
export const findSTRWeldsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weld/strweld/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateSTRWeld
 * request: updateSTRWeldUsingPOST
 * url: updateSTRWeldUsingPOSTURL
 * method: updateSTRWeldUsingPOST_TYPE
 * raw_url: updateSTRWeldUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param strweld - strweld
 */
export const updateSTRWeldUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weld/strweld/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['strweld'] !== undefined) {
    body = parameters['strweld']
  }
  if (parameters['strweld'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: strweld'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateSTRWeldUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weld/strweld/update/{id}'
}
export const updateSTRWeldUsingPOST_TYPE = function() {
  return 'post'
}
export const updateSTRWeldUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weld/strweld/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getSTRWeld
 * request: getSTRWeldUsingGET
 * url: getSTRWeldUsingGETURL
 * method: getSTRWeldUsingGET_TYPE
 * raw_url: getSTRWeldUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getSTRWeldUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weld/strweld/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSTRWeldUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weld/strweld/{id}'
}
export const getSTRWeldUsingGET_TYPE = function() {
  return 'get'
}
export const getSTRWeldUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weld/strweld/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addWelder
 * request: addWelderUsingPOST
 * url: addWelderUsingPOSTURL
 * method: addWelderUsingPOST_TYPE
 * raw_url: addWelderUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param welder - welder
 */
export const addWelderUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welder'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['welder'] !== undefined) {
    body = parameters['welder']
  }
  if (parameters['welder'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: welder'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addWelderUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welder'
}
export const addWelderUsingPOST_TYPE = function() {
  return 'post'
}
export const addWelderUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welder'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectWelder
 * request: deleteSelectWelderUsingDELETE
 * url: deleteSelectWelderUsingDELETEURL
 * method: deleteSelectWelderUsingDELETE_TYPE
 * raw_url: deleteSelectWelderUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectWelderUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welder/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectWelderUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welder/delete'
}
export const deleteSelectWelderUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectWelderUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welder/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteWelder
 * request: deleteWelderUsingDELETE
 * url: deleteWelderUsingDELETEURL
 * method: deleteWelderUsingDELETE_TYPE
 * raw_url: deleteWelderUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteWelderUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welder/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteWelderUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welder/delete/{id}'
}
export const deleteWelderUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteWelderUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welder/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导出 downloadWelderDatafile
 * request: downloadWelderDatafileUsingPOST
 * url: downloadWelderDatafileUsingPOSTURL
 * method: downloadWelderDatafileUsingPOST_TYPE
 * raw_url: downloadWelderDatafileUsingPOST_RAW_URL
 * @param ext - ext
 * @param filename - filename
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const downloadWelderDatafileUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welder/download/{filename}.{ext}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{ext}', `${parameters['ext']}`)
  if (parameters['ext'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: ext'))
  }
  path = path.replace('{filename}', `${parameters['filename']}`)
  if (parameters['filename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: filename'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const downloadWelderDatafileUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welder/download/{filename}.{ext}'
}
export const downloadWelderDatafileUsingPOST_TYPE = function() {
  return 'post'
}
export const downloadWelderDatafileUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welder/download/{filename}.{ext}'
  path = path.replace('{ext}', `${parameters['ext']}`)
  path = path.replace('{filename}', `${parameters['filename']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findAreas
 * request: findAreasUsingPOST
 * url: findAreasUsingPOSTURL
 * method: findAreasUsingPOST_TYPE
 * raw_url: findAreasUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param welder - welder
 */
export const findAreasUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welder/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['welder'] !== undefined) {
    body = parameters['welder']
  }
  if (parameters['welder'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: welder'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findAreasUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welder/getlist'
}
export const findAreasUsingPOST_TYPE = function() {
  return 'post'
}
export const findAreasUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welder/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据登录名获取对应的焊工，getWelderByLoginName
 * request: getWelderByLoginNameUsingGET
 * url: getWelderByLoginNameUsingGETURL
 * method: getWelderByLoginNameUsingGET_TYPE
 * raw_url: getWelderByLoginNameUsingGET_RAW_URL
 * @param loginname - loginname
 * @param modulename - modulename
 */
export const getWelderByLoginNameUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welder/getwelderbyloginname/{loginname}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{loginname}', `${parameters['loginname']}`)
  if (parameters['loginname'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: loginname'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWelderByLoginNameUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welder/getwelderbyloginname/{loginname}'
}
export const getWelderByLoginNameUsingGET_TYPE = function() {
  return 'get'
}
export const getWelderByLoginNameUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welder/getwelderbyloginname/{loginname}'
  path = path.replace('{loginname}', `${parameters['loginname']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取焊工关联用户，getWelderUsers
 * request: getWelderUsersUsingGET
 * url: getWelderUsersUsingGETURL
 * method: getWelderUsersUsingGET_TYPE
 * raw_url: getWelderUsersUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getWelderUsersUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welder/getwelderuser/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWelderUsersUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welder/getwelderuser/{id}'
}
export const getWelderUsersUsingGET_TYPE = function() {
  return 'get'
}
export const getWelderUsersUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welder/getwelderuser/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getAreaByNo
 * request: getAreaByNoUsingGET
 * url: getAreaByNoUsingGETURL
 * method: getAreaByNoUsingGET_TYPE
 * raw_url: getAreaByNoUsingGET_RAW_URL
 * @param modulename - modulename
 * @param noid - noid
 */
export const getAreaByNoUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welder/noid/{noid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{noid}', `${parameters['noid']}`)
  if (parameters['noid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: noid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAreaByNoUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welder/noid/{noid}'
}
export const getAreaByNoUsingGET_TYPE = function() {
  return 'get'
}
export const getAreaByNoUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welder/noid/{noid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{noid}', `${parameters['noid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除焊工关联用户，removeWelderUser
 * request: removeWelderUserUsingPOST
 * url: removeWelderUserUsingPOSTURL
 * method: removeWelderUserUsingPOST_TYPE
 * raw_url: removeWelderUserUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param user - user
 */
export const removeWelderUserUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welder/removeroleuser/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['user'] !== undefined) {
    body = parameters['user']
  }
  if (parameters['user'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: user'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const removeWelderUserUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welder/removeroleuser/{id}'
}
export const removeWelderUserUsingPOST_TYPE = function() {
  return 'post'
}
export const removeWelderUserUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welder/removeroleuser/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * setUseridByid
 * request: setUseridByidUsingPOST_1
 * url: setUseridByidUsingPOST_1URL
 * method: setUseridByidUsingPOST_1_TYPE
 * raw_url: setUseridByidUsingPOST_1_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param users - users
 */
export const setUseridByidUsingPOST_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welder/setuser/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['users'] !== undefined) {
    body = parameters['users']
  }
  if (parameters['users'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: users'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const setUseridByidUsingPOST_1_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welder/setuser/{id}'
}
export const setUseridByidUsingPOST_1_TYPE = function() {
  return 'post'
}
export const setUseridByidUsingPOST_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welder/setuser/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateWelder
 * request: updateWelderUsingPOST
 * url: updateWelderUsingPOSTURL
 * method: updateWelderUsingPOST_TYPE
 * raw_url: updateWelderUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param welder - welder
 */
export const updateWelderUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welder/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['welder'] !== undefined) {
    body = parameters['welder']
  }
  if (parameters['welder'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: welder'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateWelderUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welder/update/{id}'
}
export const updateWelderUsingPOST_TYPE = function() {
  return 'post'
}
export const updateWelderUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welder/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateNoByid
 * request: updateNoByidUsingPOST
 * url: updateNoByidUsingPOSTURL
 * method: updateNoByidUsingPOST_TYPE
 * raw_url: updateNoByidUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param no - no
 */
export const updateNoByidUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welder/update/{no}/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{no}', `${parameters['no']}`)
  if (parameters['no'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: no'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateNoByidUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welder/update/{no}/{id}'
}
export const updateNoByidUsingPOST_TYPE = function() {
  return 'post'
}
export const updateNoByidUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welder/update/{no}/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{no}', `${parameters['no']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateUserWelder
 * request: updateUserWelderUsingPOST
 * url: updateUserWelderUsingPOSTURL
 * method: updateUserWelderUsingPOST_TYPE
 * raw_url: updateUserWelderUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param users - users
 */
export const updateUserWelderUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welder/updateuser/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['users'] !== undefined) {
    body = parameters['users']
  }
  if (parameters['users'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: users'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateUserWelderUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welder/updateuser/{id}'
}
export const updateUserWelderUsingPOST_TYPE = function() {
  return 'post'
}
export const updateUserWelderUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welder/updateuser/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 导入数据 uploadWelderExcel
 * request: uploadWelderExcelUsingPOST
 * url: uploadWelderExcelUsingPOSTURL
 * method: uploadWelderExcelUsingPOST_TYPE
 * raw_url: uploadWelderExcelUsingPOST_RAW_URL
 * @param attid - attid
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const uploadWelderExcelUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welder/upload/{attid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{attid}', `${parameters['attid']}`)
  if (parameters['attid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: attid'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const uploadWelderExcelUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welder/upload/{attid}'
}
export const uploadWelderExcelUsingPOST_TYPE = function() {
  return 'post'
}
export const uploadWelderExcelUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welder/upload/{attid}'
  path = path.replace('{attid}', `${parameters['attid']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getAreaById
 * request: getAreaByIdUsingGET
 * url: getAreaByIdUsingGETURL
 * method: getAreaByIdUsingGET_TYPE
 * raw_url: getAreaByIdUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getAreaByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welder/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAreaByIdUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welder/{id}'
}
export const getAreaByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getAreaByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welder/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除所选焊工资质，deleteSelectWelderQualification
 * request: deleteSelectWelderQualificationUsingDELETE
 * url: deleteSelectWelderQualificationUsingDELETEURL
 * method: deleteSelectWelderQualificationUsingDELETE_TYPE
 * raw_url: deleteSelectWelderQualificationUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 * @param welderid - welderid
 */
export const deleteSelectWelderQualificationUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welderqualification/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['welderid'] !== undefined) {
    queryParameters['welderid'] = parameters['welderid']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectWelderQualificationUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welderqualification/delete'
}
export const deleteSelectWelderQualificationUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectWelderQualificationUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welderqualification/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['welderid'] !== undefined) {
    queryParameters['welderid'] = parameters['welderid']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除焊工资质，deleteWelderQualification
 * request: deleteWelderQualificationUsingDELETE
 * url: deleteWelderQualificationUsingDELETEURL
 * method: deleteWelderQualificationUsingDELETE_TYPE
 * raw_url: deleteWelderQualificationUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteWelderQualificationUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welderqualification/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteWelderQualificationUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welderqualification/delete/{id}'
}
export const deleteWelderQualificationUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteWelderQualificationUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welderqualification/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据焊工id获取当前焊工的所有焊工资质，getWelderQualifications
 * request: getWelderQualificationsUsingGET
 * url: getWelderQualificationsUsingGETURL
 * method: getWelderQualificationsUsingGET_TYPE
 * raw_url: getWelderQualificationsUsingGET_RAW_URL
 * @param modulename - modulename
 * @param welderid - welderid
 */
export const getWelderQualificationsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welderqualification/getwelderQualifications/{welderid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{welderid}', `${parameters['welderid']}`)
  if (parameters['welderid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: welderid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWelderQualificationsUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welderqualification/getwelderQualifications/{welderid}'
}
export const getWelderQualificationsUsingGET_TYPE = function() {
  return 'get'
}
export const getWelderQualificationsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welderqualification/getwelderQualifications/{welderid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{welderid}', `${parameters['welderid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取一条焊工资质，getWelderQualification
 * request: getWelderQualificationUsingGET
 * url: getWelderQualificationUsingGETURL
 * method: getWelderQualificationUsingGET_TYPE
 * raw_url: getWelderQualificationUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getWelderQualificationUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welderqualification/getwelderqualification/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWelderQualificationUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welderqualification/getwelderqualification/{id}'
}
export const getWelderQualificationUsingGET_TYPE = function() {
  return 'get'
}
export const getWelderQualificationUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welderqualification/getwelderqualification/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改一条焊工资质，updateWelderQualification
 * request: updateWelderQualificationUsingPOST
 * url: updateWelderQualificationUsingPOSTURL
 * method: updateWelderQualificationUsingPOST_TYPE
 * raw_url: updateWelderQualificationUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param welderQualification - welderQualification
 * @param welderid - welderid
 */
export const updateWelderQualificationUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welderqualification/update/{id}/{welderid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['welderQualification'] !== undefined) {
    body = parameters['welderQualification']
  }
  if (parameters['welderQualification'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: welderQualification'))
  }
  path = path.replace('{welderid}', `${parameters['welderid']}`)
  if (parameters['welderid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: welderid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateWelderQualificationUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welderqualification/update/{id}/{welderid}'
}
export const updateWelderQualificationUsingPOST_TYPE = function() {
  return 'post'
}
export const updateWelderQualificationUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welderqualification/update/{id}/{welderid}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{welderid}', `${parameters['welderid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 添加一条焊工资质，addWelderQualification
 * request: addWelderQualificationUsingPOST
 * url: addWelderQualificationUsingPOSTURL
 * method: addWelderQualificationUsingPOST_TYPE
 * raw_url: addWelderQualificationUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param welderQualification - welderQualification
 * @param welderid - welderid
 */
export const addWelderQualificationUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/welderqualification/{welderid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['welderQualification'] !== undefined) {
    body = parameters['welderQualification']
  }
  if (parameters['welderQualification'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: welderQualification'))
  }
  path = path.replace('{welderid}', `${parameters['welderid']}`)
  if (parameters['welderid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: welderid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addWelderQualificationUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/welderqualification/{welderid}'
}
export const addWelderQualificationUsingPOST_TYPE = function() {
  return 'post'
}
export const addWelderQualificationUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/welderqualification/{welderid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{welderid}', `${parameters['welderid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 添加WPS，addWeldingProcedure
 * request: addWeldingProcedureUsingPOST
 * url: addWeldingProcedureUsingPOSTURL
 * method: addWeldingProcedureUsingPOST_TYPE
 * raw_url: addWeldingProcedureUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param weldingProcedure - weldingProcedure
 */
export const addWeldingProcedureUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weldingprocedure'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['weldingProcedure'] !== undefined) {
    body = parameters['weldingProcedure']
  }
  if (parameters['weldingProcedure'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: weldingProcedure'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addWeldingProcedureUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weldingprocedure'
}
export const addWeldingProcedureUsingPOST_TYPE = function() {
  return 'post'
}
export const addWeldingProcedureUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weldingprocedure'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除所选WPS，deleteSelectWeldingProcedure
 * request: deleteSelectWeldingProcedureUsingDELETE
 * url: deleteSelectWeldingProcedureUsingDELETEURL
 * method: deleteSelectWeldingProcedureUsingDELETE_TYPE
 * raw_url: deleteSelectWeldingProcedureUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectWeldingProcedureUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weldingprocedure/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectWeldingProcedureUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weldingprocedure/delete'
}
export const deleteSelectWeldingProcedureUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectWeldingProcedureUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weldingprocedure/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除一条WPS，deleteWeldingProcedure
 * request: deleteWeldingProcedureUsingDELETE
 * url: deleteWeldingProcedureUsingDELETEURL
 * method: deleteWeldingProcedureUsingDELETE_TYPE
 * raw_url: deleteWeldingProcedureUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteWeldingProcedureUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weldingprocedure/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteWeldingProcedureUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weldingprocedure/delete/{id}'
}
export const deleteWeldingProcedureUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteWeldingProcedureUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weldingprocedure/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * WPS分页列表，findWeldingProcedures
 * request: findWeldingProceduresUsingPOST
 * url: findWeldingProceduresUsingPOSTURL
 * method: findWeldingProceduresUsingPOST_TYPE
 * raw_url: findWeldingProceduresUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param weldingProcedure - weldingProcedure
 */
export const findWeldingProceduresUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weldingprocedure/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['weldingProcedure'] !== undefined) {
    body = parameters['weldingProcedure']
  }
  if (parameters['weldingProcedure'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: weldingProcedure'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findWeldingProceduresUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weldingprocedure/getlist'
}
export const findWeldingProceduresUsingPOST_TYPE = function() {
  return 'post'
}
export const findWeldingProceduresUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weldingprocedure/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取一条WPS，getWeldingProcedure
 * request: getWeldingProcedureUsingGET
 * url: getWeldingProcedureUsingGETURL
 * method: getWeldingProcedureUsingGET_TYPE
 * raw_url: getWeldingProcedureUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getWeldingProcedureUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weldingprocedure/getweldingprocedure/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWeldingProcedureUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weldingprocedure/getweldingprocedure/{id}'
}
export const getWeldingProcedureUsingGET_TYPE = function() {
  return 'get'
}
export const getWeldingProcedureUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weldingprocedure/getweldingprocedure/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改一条WPS，updateWeldingProcedure
 * request: updateWeldingProcedureUsingPOST
 * url: updateWeldingProcedureUsingPOSTURL
 * method: updateWeldingProcedureUsingPOST_TYPE
 * raw_url: updateWeldingProcedureUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param weldingProcedure - weldingProcedure
 */
export const updateWeldingProcedureUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/weldingprocedure/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['weldingProcedure'] !== undefined) {
    body = parameters['weldingProcedure']
  }
  if (parameters['weldingProcedure'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: weldingProcedure'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateWeldingProcedureUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/weldingprocedure/update/{id}'
}
export const updateWeldingProcedureUsingPOST_TYPE = function() {
  return 'post'
}
export const updateWeldingProcedureUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/weldingprocedure/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 添加作业许可，addWorkPermit
 * request: addWorkPermitUsingPOST
 * url: addWorkPermitUsingPOSTURL
 * method: addWorkPermitUsingPOST_TYPE
 * raw_url: addWorkPermitUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param wp - wp
 */
export const addWorkPermitUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['wp'] !== undefined) {
    body = parameters['wp']
  }
  if (parameters['wp'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: wp'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addWorkPermitUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit'
}
export const addWorkPermitUsingPOST_TYPE = function() {
  return 'post'
}
export const addWorkPermitUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除所选作业许可，deleteWorkPermits
 * request: deleteWorkPermitsUsingDELETE
 * url: deleteWorkPermitsUsingDELETEURL
 * method: deleteWorkPermitsUsingDELETE_TYPE
 * raw_url: deleteWorkPermitsUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteWorkPermitsUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteWorkPermitsUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit'
}
export const deleteWorkPermitsUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteWorkPermitsUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * aaa
 * request: aaaUsingPOST_1
 * url: aaaUsingPOST_1URL
 * method: aaaUsingPOST_1_TYPE
 * raw_url: aaaUsingPOST_1_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 */
export const aaaUsingPOST_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/abc/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const aaaUsingPOST_1_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/abc/{id}'
}
export const aaaUsingPOST_1_TYPE = function() {
  return 'post'
}
export const aaaUsingPOST_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/abc/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 我参与的
 * request: aboutmelistUsingPOST_1
 * url: aboutmelistUsingPOST_1URL
 * method: aboutmelistUsingPOST_1_TYPE
 * raw_url: aboutmelistUsingPOST_1_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param page - 请求页数
 * @param principal - 
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param wp - wp
 */
export const aboutmelistUsingPOST_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/aboutme'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['wp'] !== undefined) {
    body = parameters['wp']
  }
  if (parameters['wp'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: wp'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const aboutmelistUsingPOST_1_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/aboutme'
}
export const aboutmelistUsingPOST_1_TYPE = function() {
  return 'post'
}
export const aboutmelistUsingPOST_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/aboutme'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 重新提交工作流
 * request: againWorkflowUsingPOST
 * url: againWorkflowUsingPOSTURL
 * method: againWorkflowUsingPOST_TYPE
 * raw_url: againWorkflowUsingPOST_RAW_URL
 * @param data - data
 * @param modulename - modulename
 * @param name - 
 * @param wp - wp
 */
export const againWorkflowUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/againWorkflow'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['wp'] !== undefined) {
    body = parameters['wp']
  }
  if (parameters['wp'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: wp'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const againWorkflowUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/againWorkflow'
}
export const againWorkflowUsingPOST_TYPE = function() {
  return 'post'
}
export const againWorkflowUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/againWorkflow'
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 项目组审批
 * request: ApproverWorkflowUsingPOST
 * url: ApproverWorkflowUsingPOSTURL
 * method: ApproverWorkflowUsingPOST_TYPE
 * raw_url: ApproverWorkflowUsingPOST_RAW_URL
 * @param data - data
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 * @param wp - wp
 */
export const ApproverWorkflowUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/approverworkflow/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['wp'] !== undefined) {
    body = parameters['wp']
  }
  if (parameters['wp'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: wp'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const ApproverWorkflowUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/approverworkflow/{id}'
}
export const ApproverWorkflowUsingPOST_TYPE = function() {
  return 'post'
}
export const ApproverWorkflowUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/approverworkflow/{id}'
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取可以强制关闭作业许可列表，cancloselist
 * request: CanCloseWorkPermitUsingPOST
 * url: CanCloseWorkPermitUsingPOSTURL
 * method: CanCloseWorkPermitUsingPOST_TYPE
 * raw_url: CanCloseWorkPermitUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param page - 请求页数
 * @param principal - 
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param wp - wp
 */
export const CanCloseWorkPermitUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/cancloselist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['wp'] !== undefined) {
    body = parameters['wp']
  }
  if (parameters['wp'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: wp'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const CanCloseWorkPermitUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/cancloselist'
}
export const CanCloseWorkPermitUsingPOST_TYPE = function() {
  return 'post'
}
export const CanCloseWorkPermitUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/cancloselist'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 场地管理部核准（改为模块集成HSE核准）
 * request: CDGLWorkflowUsingPOST
 * url: CDGLWorkflowUsingPOSTURL
 * method: CDGLWorkflowUsingPOST_TYPE
 * raw_url: CDGLWorkflowUsingPOST_RAW_URL
 * @param data - data
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 * @param wp - wp
 */
export const CDGLWorkflowUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/cdglworkflow/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['wp'] !== undefined) {
    body = parameters['wp']
  }
  if (parameters['wp'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: wp'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const CDGLWorkflowUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/cdglworkflow/{id}'
}
export const CDGLWorkflowUsingPOST_TYPE = function() {
  return 'post'
}
export const CDGLWorkflowUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/cdglworkflow/{id}'
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 流程结束,workCancel:0-1,
 * request: completeTaskUsingPOST_1
 * url: completeTaskUsingPOST_1URL
 * method: completeTaskUsingPOST_1_TYPE
 * raw_url: completeTaskUsingPOST_1_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param data - data
 * @param details - 
 * @param id - id
 * @param modulename - modulename
 * @param principal - 
 * @param taskid - taskid
 */
export const completeTaskUsingPOST_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/completetask/{taskid}/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['data'] !== undefined) {
    body = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters['taskid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const completeTaskUsingPOST_1_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/completetask/{taskid}/{id}'
}
export const completeTaskUsingPOST_1_TYPE = function() {
  return 'post'
}
export const completeTaskUsingPOST_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/completetask/{taskid}/{id}'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 施工后现场确认
 * request: ConstructionAfterWorkflowUsingPOST
 * url: ConstructionAfterWorkflowUsingPOSTURL
 * method: ConstructionAfterWorkflowUsingPOST_TYPE
 * raw_url: ConstructionAfterWorkflowUsingPOST_RAW_URL
 * @param data - data
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 * @param wp - wp
 */
export const ConstructionAfterWorkflowUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/constructionafterworkflow/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['wp'] !== undefined) {
    body = parameters['wp']
  }
  if (parameters['wp'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: wp'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const ConstructionAfterWorkflowUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/constructionafterworkflow/{id}'
}
export const ConstructionAfterWorkflowUsingPOST_TYPE = function() {
  return 'post'
}
export const ConstructionAfterWorkflowUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/constructionafterworkflow/{id}'
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 施工前现场确认
 * request: ConstructionFrontWorkflowUsingPOST
 * url: ConstructionFrontWorkflowUsingPOSTURL
 * method: ConstructionFrontWorkflowUsingPOST_TYPE
 * raw_url: ConstructionFrontWorkflowUsingPOST_RAW_URL
 * @param data - data
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 * @param wp - wp
 */
export const ConstructionFrontWorkflowUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/constructionfrontworkflow/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['wp'] !== undefined) {
    body = parameters['wp']
  }
  if (parameters['wp'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: wp'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const ConstructionFrontWorkflowUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/constructionfrontworkflow/{id}'
}
export const ConstructionFrontWorkflowUsingPOST_TYPE = function() {
  return 'post'
}
export const ConstructionFrontWorkflowUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/constructionfrontworkflow/{id}'
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 现场负责人确认
 * request: ConstructionWorkflowUsingPOST
 * url: ConstructionWorkflowUsingPOSTURL
 * method: ConstructionWorkflowUsingPOST_TYPE
 * raw_url: ConstructionWorkflowUsingPOST_RAW_URL
 * @param data - data
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 * @param wp - wp
 */
export const ConstructionWorkflowUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/constructionworkflow/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['wp'] !== undefined) {
    body = parameters['wp']
  }
  if (parameters['wp'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: wp'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const ConstructionWorkflowUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/constructionworkflow/{id}'
}
export const ConstructionWorkflowUsingPOST_TYPE = function() {
  return 'post'
}
export const ConstructionWorkflowUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/constructionworkflow/{id}'
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 下载excel,downloadWorkPermit,
 * request: downloadWorkPermitUsingPOST
 * url: downloadWorkPermitUsingPOSTURL
 * method: downloadWorkPermitUsingPOST_TYPE
 * raw_url: downloadWorkPermitUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param vo - vo
 */
export const downloadWorkPermitUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/download'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const downloadWorkPermitUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/download'
}
export const downloadWorkPermitUsingPOST_TYPE = function() {
  return 'post'
}
export const downloadWorkPermitUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/download'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Download2
 * request: Download2UsingPOST
 * url: Download2UsingPOSTURL
 * method: Download2UsingPOST_TYPE
 * raw_url: Download2UsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const Download2UsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/download2/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Download2UsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/download2/{id}'
}
export const Download2UsingPOST_TYPE = function() {
  return 'post'
}
export const Download2UsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/download2/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 强制返回修改
 * request: forceReturnWorkflowUsingPOST
 * url: forceReturnWorkflowUsingPOSTURL
 * method: forceReturnWorkflowUsingPOST_TYPE
 * raw_url: forceReturnWorkflowUsingPOST_RAW_URL
 * @param data - data
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 */
export const forceReturnWorkflowUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/forcernworkflow/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    body = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const forceReturnWorkflowUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/forcernworkflow/{id}'
}
export const forceReturnWorkflowUsingPOST_TYPE = function() {
  return 'post'
}
export const forceReturnWorkflowUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/forcernworkflow/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 重新生成PDF,generatePDF,
 * request: GeneratePDFUsingPOST
 * url: GeneratePDFUsingPOSTURL
 * method: GeneratePDFUsingPOST_TYPE
 * raw_url: GeneratePDFUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const GeneratePDFUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/generatePDF/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const GeneratePDFUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/generatePDF/{id}'
}
export const GeneratePDFUsingPOST_TYPE = function() {
  return 'post'
}
export const GeneratePDFUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/generatePDF/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取作业许可列表，findWorkPermit
 * request: findWorkPermitUsingPOST
 * url: findWorkPermitUsingPOSTURL
 * method: findWorkPermitUsingPOST_TYPE
 * raw_url: findWorkPermitUsingPOST_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param page - 请求页数
 * @param principal - 
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param wp - wp
 */
export const findWorkPermitUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/getlist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['wp'] !== undefined) {
    body = parameters['wp']
  }
  if (parameters['wp'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: wp'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findWorkPermitUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/getlist'
}
export const findWorkPermitUsingPOST_TYPE = function() {
  return 'post'
}
export const findWorkPermitUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/getlist'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取施工后默认人
 * request: getsghmrrUsingGET
 * url: getsghmrrUsingGETURL
 * method: getsghmrrUsingGET_TYPE
 * raw_url: getsghmrrUsingGET_RAW_URL
 * @param modulename - modulename
 * @param taskid - taskid
 */
export const getsghmrrUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/getsghmrr/{taskid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters['taskid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: taskid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getsghmrrUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/getsghmrr/{taskid}'
}
export const getsghmrrUsingGET_TYPE = function() {
  return 'get'
}
export const getsghmrrUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/getsghmrr/{taskid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{taskid}', `${parameters['taskid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 项目组HSE部核准
 * request: HSEfzrWorkflowUsingPOST
 * url: HSEfzrWorkflowUsingPOSTURL
 * method: HSEfzrWorkflowUsingPOST_TYPE
 * raw_url: HSEfzrWorkflowUsingPOST_RAW_URL
 * @param data - data
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 * @param wp - wp
 */
export const HSEfzrWorkflowUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/hsefzrworkflow/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['wp'] !== undefined) {
    body = parameters['wp']
  }
  if (parameters['wp'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: wp'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const HSEfzrWorkflowUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/hsefzrworkflow/{id}'
}
export const HSEfzrWorkflowUsingPOST_TYPE = function() {
  return 'post'
}
export const HSEfzrWorkflowUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/hsefzrworkflow/{id}'
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 直管单位核准
 * request: InspectionWorkflowUsingPOST
 * url: InspectionWorkflowUsingPOSTURL
 * method: InspectionWorkflowUsingPOST_TYPE
 * raw_url: InspectionWorkflowUsingPOST_RAW_URL
 * @param data - data
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 * @param wp - wp
 */
export const InspectionWorkflowUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/inspectionworkflow/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['wp'] !== undefined) {
    body = parameters['wp']
  }
  if (parameters['wp'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: wp'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const InspectionWorkflowUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/inspectionworkflow/{id}'
}
export const InspectionWorkflowUsingPOST_TYPE = function() {
  return 'post'
}
export const InspectionWorkflowUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/inspectionworkflow/{id}'
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据区域名称，返回所有流程状态未完成的作业许可坐标,及作业许可id           findWPCoordinateInWorkflow
 * request: getWPCoordinateInWorkflowUsingGET
 * url: getWPCoordinateInWorkflowUsingGETURL
 * method: getWPCoordinateInWorkflowUsingGET_TYPE
 * raw_url: getWPCoordinateInWorkflowUsingGET_RAW_URL
 * @param areaname - areaname
 * @param modulename - modulename
 */
export const getWPCoordinateInWorkflowUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/inworkflow/{areaname}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{areaname}', `${parameters['areaname']}`)
  if (parameters['areaname'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: areaname'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWPCoordinateInWorkflowUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/inworkflow/{areaname}'
}
export const getWPCoordinateInWorkflowUsingGET_TYPE = function() {
  return 'get'
}
export const getWPCoordinateInWorkflowUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/inworkflow/{areaname}'
  path = path.replace('{areaname}', `${parameters['areaname']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取用户待办工作
 * request: myworklistUsingPOST_1
 * url: myworklistUsingPOST_1URL
 * method: myworklistUsingPOST_1_TYPE
 * raw_url: myworklistUsingPOST_1_RAW_URL
 * @param authenticated - 
 * @param authorities0Authority - 
 * @param credentials - 
 * @param details - 
 * @param modulename - modulename
 * @param page - 请求页数
 * @param principal - 
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const myworklistUsingPOST_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/mywork'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const myworklistUsingPOST_1_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/mywork'
}
export const myworklistUsingPOST_1_TYPE = function() {
  return 'post'
}
export const myworklistUsingPOST_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/mywork'
  if (parameters['authenticated'] !== undefined) {
    queryParameters['authenticated'] = parameters['authenticated']
  }
  if (parameters['authorities0Authority'] !== undefined) {
    queryParameters['authorities[0].authority'] = parameters['authorities0Authority']
  }
  if (parameters['credentials'] !== undefined) {
    queryParameters['credentials'] = parameters['credentials']
  }
  if (parameters['details'] !== undefined) {
    queryParameters['details'] = parameters['details']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['principal'] !== undefined) {
    queryParameters['principal'] = parameters['principal']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回申请人修改，就是工作流点否的时候
 * request: ReturnWorkflowUsingPOST
 * url: ReturnWorkflowUsingPOSTURL
 * method: ReturnWorkflowUsingPOST_TYPE
 * raw_url: ReturnWorkflowUsingPOST_RAW_URL
 * @param data - data
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 */
export const ReturnWorkflowUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/returnworkflow/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    body = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const ReturnWorkflowUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/returnworkflow/{id}'
}
export const ReturnWorkflowUsingPOST_TYPE = function() {
  return 'post'
}
export const ReturnWorkflowUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/returnworkflow/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 启动工作流
 * request: startWorkflowUsingPOST_1
 * url: startWorkflowUsingPOST_1URL
 * method: startWorkflowUsingPOST_1_TYPE
 * raw_url: startWorkflowUsingPOST_1_RAW_URL
 * @param data - data
 * @param modulename - modulename
 * @param name - 
 */
export const startWorkflowUsingPOST_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/startworkflow'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    body = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const startWorkflowUsingPOST_1_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/startworkflow'
}
export const startWorkflowUsingPOST_1_TYPE = function() {
  return 'post'
}
export const startWorkflowUsingPOST_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/startworkflow'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 启动工作流
 * request: startWorkflow2UsingPOST
 * url: startWorkflow2UsingPOSTURL
 * method: startWorkflow2UsingPOST_TYPE
 * raw_url: startWorkflow2UsingPOST_RAW_URL
 * @param data - data
 * @param modulename - modulename
 * @param name - 
 * @param wp - wp
 */
export const startWorkflow2UsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/startworkflow2'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['wp'] !== undefined) {
    body = parameters['wp']
  }
  if (parameters['wp'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: wp'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const startWorkflow2UsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/startworkflow2'
}
export const startWorkflow2UsingPOST_TYPE = function() {
  return 'post'
}
export const startWorkflow2UsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/startworkflow2'
  if (parameters['data'] !== undefined) {
    queryParameters['data'] = parameters['data']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 添加测爆记录，addTestBlastItem
 * request: addTestBlastItemUsingPOST
 * url: addTestBlastItemUsingPOSTURL
 * method: addTestBlastItemUsingPOST_TYPE
 * raw_url: addTestBlastItemUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param tbi - tbi
 */
export const addTestBlastItemUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/testblastitem'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['tbi'] !== undefined) {
    body = parameters['tbi']
  }
  if (parameters['tbi'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: tbi'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addTestBlastItemUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/testblastitem'
}
export const addTestBlastItemUsingPOST_TYPE = function() {
  return 'post'
}
export const addTestBlastItemUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/testblastitem'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除所选测爆纪录，deleteTestBlastItems
 * request: deleteTestBlastItemsUsingDELETE
 * url: deleteTestBlastItemsUsingDELETEURL
 * method: deleteTestBlastItemsUsingDELETE_TYPE
 * raw_url: deleteTestBlastItemsUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteTestBlastItemsUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/testblastitem'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteTestBlastItemsUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/testblastitem'
}
export const deleteTestBlastItemsUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteTestBlastItemsUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/testblastitem'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 测爆记录列表，findTestBlastItem
 * request: findTestBlastItemUsingPOST
 * url: findTestBlastItemUsingPOSTURL
 * method: findTestBlastItemUsingPOST_TYPE
 * raw_url: findTestBlastItemUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param tbi - tbi
 */
export const findTestBlastItemUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/testblastitem/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['tbi'] !== undefined) {
    body = parameters['tbi']
  }
  if (parameters['tbi'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: tbi'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findTestBlastItemUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/testblastitem/getlist'
}
export const findTestBlastItemUsingPOST_TYPE = function() {
  return 'post'
}
export const findTestBlastItemUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/testblastitem/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改测爆记录，updateTestBlastItem
 * request: updateTestBlastItemUsingPOST
 * url: updateTestBlastItemUsingPOSTURL
 * method: updateTestBlastItemUsingPOST_TYPE
 * raw_url: updateTestBlastItemUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param tbi - tbi
 */
export const updateTestBlastItemUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/testblastitem/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['tbi'] !== undefined) {
    body = parameters['tbi']
  }
  if (parameters['tbi'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: tbi'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateTestBlastItemUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/testblastitem/update/{id}'
}
export const updateTestBlastItemUsingPOST_TYPE = function() {
  return 'post'
}
export const updateTestBlastItemUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/testblastitem/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据ID获取测爆记录详情，getDailyWeldInspectionItem
 * request: getTestBlastItemUsingGET
 * url: getTestBlastItemUsingGETURL
 * method: getTestBlastItemUsingGET_TYPE
 * raw_url: getTestBlastItemUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getTestBlastItemUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/testblastitem/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTestBlastItemUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/testblastitem/{id}'
}
export const getTestBlastItemUsingGET_TYPE = function() {
  return 'get'
}
export const getTestBlastItemUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/testblastitem/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除测爆纪录，deleteTestBlastItem
 * request: deleteTestBlastItemUsingDELETE
 * url: deleteTestBlastItemUsingDELETEURL
 * method: deleteTestBlastItemUsingDELETE_TYPE
 * raw_url: deleteTestBlastItemUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteTestBlastItemUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/testblastitem/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteTestBlastItemUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/testblastitem/{id}'
}
export const deleteTestBlastItemUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteTestBlastItemUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/testblastitem/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改作业许可，updateWorkPermit
 * request: updateWorkPermitUsingPOST
 * url: updateWorkPermitUsingPOSTURL
 * method: updateWorkPermitUsingPOST_TYPE
 * raw_url: updateWorkPermitUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param wp - wp
 */
export const updateWorkPermitUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['wp'] !== undefined) {
    body = parameters['wp']
  }
  if (parameters['wp'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: wp'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateWorkPermitUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/update/{id}'
}
export const updateWorkPermitUsingPOST_TYPE = function() {
  return 'post'
}
export const updateWorkPermitUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 作业完成情况确认,workCompletion:0-1,alertRemove:0-1,workAreaClear:0-1
 * request: WorkSituationWorkflowUsingPOST
 * url: WorkSituationWorkflowUsingPOSTURL
 * method: WorkSituationWorkflowUsingPOST_TYPE
 * raw_url: WorkSituationWorkflowUsingPOST_RAW_URL
 * @param data - data
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 */
export const WorkSituationWorkflowUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/worksituationworkflow/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['data'] !== undefined) {
    body = parameters['data']
  }
  if (parameters['data'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: data'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const WorkSituationWorkflowUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/worksituationworkflow/{id}'
}
export const WorkSituationWorkflowUsingPOST_TYPE = function() {
  return 'post'
}
export const WorkSituationWorkflowUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/worksituationworkflow/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据ID获取作业许可详情，getWorkPermit
 * request: getWorkPermitUsingGET
 * url: getWorkPermitUsingGETURL
 * method: getWorkPermitUsingGET_TYPE
 * raw_url: getWorkPermitUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getWorkPermitUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWorkPermitUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/{id}'
}
export const getWorkPermitUsingGET_TYPE = function() {
  return 'get'
}
export const getWorkPermitUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除作业许可，deleteWorkPermit
 * request: deleteWorkPermitUsingDELETE
 * url: deleteWorkPermitUsingDELETEURL
 * method: deleteWorkPermitUsingDELETE_TYPE
 * raw_url: deleteWorkPermitUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteWorkPermitUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermit/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteWorkPermitUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermit/{id}'
}
export const deleteWorkPermitUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteWorkPermitUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermit/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addWorkPermitAuth
 * request: addWorkPermitAuthUsingPOST
 * url: addWorkPermitAuthUsingPOSTURL
 * method: addWorkPermitAuthUsingPOST_TYPE
 * raw_url: addWorkPermitAuthUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param wpavo - wpavo
 */
export const addWorkPermitAuthUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermitauth'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['wpavo'] !== undefined) {
    body = parameters['wpavo']
  }
  if (parameters['wpavo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: wpavo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addWorkPermitAuthUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermitauth'
}
export const addWorkPermitAuthUsingPOST_TYPE = function() {
  return 'post'
}
export const addWorkPermitAuthUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermitauth'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteWorkPermitAuths
 * request: deleteWorkPermitAuthsUsingDELETE
 * url: deleteWorkPermitAuthsUsingDELETEURL
 * method: deleteWorkPermitAuthsUsingDELETE_TYPE
 * raw_url: deleteWorkPermitAuthsUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteWorkPermitAuthsUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermitauth'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteWorkPermitAuthsUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermitauth'
}
export const deleteWorkPermitAuthsUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteWorkPermitAuthsUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermitauth'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findWorkPermitAuth
 * request: findWorkPermitAuthUsingPOST
 * url: findWorkPermitAuthUsingPOSTURL
 * method: findWorkPermitAuthUsingPOST_TYPE
 * raw_url: findWorkPermitAuthUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param wpavo - wpavo
 */
export const findWorkPermitAuthUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermitauth/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['wpavo'] !== undefined) {
    body = parameters['wpavo']
  }
  if (parameters['wpavo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: wpavo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findWorkPermitAuthUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermitauth/getlist'
}
export const findWorkPermitAuthUsingPOST_TYPE = function() {
  return 'post'
}
export const findWorkPermitAuthUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermitauth/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateWorkPermitAuth
 * request: updateWorkPermitAuthUsingPOST
 * url: updateWorkPermitAuthUsingPOSTURL
 * method: updateWorkPermitAuthUsingPOST_TYPE
 * raw_url: updateWorkPermitAuthUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param name - 
 * @param wpavo - wpavo
 */
export const updateWorkPermitAuthUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermitauth/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['wpavo'] !== undefined) {
    body = parameters['wpavo']
  }
  if (parameters['wpavo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: wpavo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateWorkPermitAuthUsingPOST_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermitauth/update/{id}'
}
export const updateWorkPermitAuthUsingPOST_TYPE = function() {
  return 'post'
}
export const updateWorkPermitAuthUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermitauth/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getUserPersonInfo
 * request: getUserPersonInfoUsingGET
 * url: getUserPersonInfoUsingGETURL
 * method: getUserPersonInfoUsingGET_TYPE
 * raw_url: getUserPersonInfoUsingGET_RAW_URL
 * @param modulename - modulename
 * @param userid - userid
 */
export const getUserPersonInfoUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermitauth/user/{userid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  path = path.replace('{userid}', `${parameters['userid']}`)
  if (parameters['userid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: userid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUserPersonInfoUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermitauth/user/{userid}'
}
export const getUserPersonInfoUsingGET_TYPE = function() {
  return 'get'
}
export const getUserPersonInfoUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermitauth/user/{userid}'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  path = path.replace('{userid}', `${parameters['userid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getWorkPermitAuth
 * request: getWorkPermitAuthUsingGET
 * url: getWorkPermitAuthUsingGETURL
 * method: getWorkPermitAuthUsingGET_TYPE
 * raw_url: getWorkPermitAuthUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getWorkPermitAuthUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermitauth/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWorkPermitAuthUsingGET_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermitauth/{id}'
}
export const getWorkPermitAuthUsingGET_TYPE = function() {
  return 'get'
}
export const getWorkPermitAuthUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermitauth/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteWorkPermitAuth
 * request: deleteWorkPermitAuthUsingDELETE
 * url: deleteWorkPermitAuthUsingDELETEURL
 * method: deleteWorkPermitAuthUsingDELETE_TYPE
 * raw_url: deleteWorkPermitAuthUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteWorkPermitAuthUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/wq/{modulename}/workpermitauth/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteWorkPermitAuthUsingDELETE_RAW_URL = function() {
  return '/api/v1/wq/{modulename}/workpermitauth/{id}'
}
export const deleteWorkPermitAuthUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteWorkPermitAuthUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/wq/{modulename}/workpermitauth/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findCommonFormList
 * request: findCommonFormListUsingPOST
 * url: findCommonFormListUsingPOSTURL
 * method: findCommonFormListUsingPOST_TYPE
 * raw_url: findCommonFormListUsingPOST_RAW_URL
 * @param key - key
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const findCommonFormListUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/commonform/table/getlist/key/{key}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findCommonFormListUsingPOST_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/commonform/table/getlist/key/{key}'
}
export const findCommonFormListUsingPOST_TYPE = function() {
  return 'post'
}
export const findCommonFormListUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/commonform/table/getlist/key/{key}'
  path = path.replace('{key}', `${parameters['key']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getInitTestForm
 * request: getInitTestFormUsingGET
 * url: getInitTestFormUsingGETURL
 * method: getInitTestFormUsingGET_TYPE
 * raw_url: getInitTestFormUsingGET_RAW_URL
 * @param key - key
 * @param modulename - modulename
 */
export const getInitTestFormUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/commonform/table/init/test/{key}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getInitTestFormUsingGET_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/commonform/table/init/test/{key}'
}
export const getInitTestFormUsingGET_TYPE = function() {
  return 'get'
}
export const getInitTestFormUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/commonform/table/init/test/{key}'
  path = path.replace('{key}', `${parameters['key']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getInitForm
 * request: getInitFormUsingGET
 * url: getInitFormUsingGETURL
 * method: getInitFormUsingGET_TYPE
 * raw_url: getInitFormUsingGET_RAW_URL
 * @param key - key
 * @param modulename - modulename
 */
export const getInitFormUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/commonform/table/init/{key}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getInitFormUsingGET_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/commonform/table/init/{key}'
}
export const getInitFormUsingGET_TYPE = function() {
  return 'get'
}
export const getInitFormUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/commonform/table/init/{key}'
  path = path.replace('{key}', `${parameters['key']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getDataSrcRoleUsersByCode
 * request: getDataSrcRoleUsersByCodeUsingGET
 * url: getDataSrcRoleUsersByCodeUsingGETURL
 * method: getDataSrcRoleUsersByCodeUsingGET_TYPE
 * raw_url: getDataSrcRoleUsersByCodeUsingGET_RAW_URL
 * @param code - code
 * @param modulename - modulename
 */
export const getDataSrcRoleUsersByCodeUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/commonform/table/roleusers/{code}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{code}', `${parameters['code']}`)
  if (parameters['code'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: code'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDataSrcRoleUsersByCodeUsingGET_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/commonform/table/roleusers/{code}'
}
export const getDataSrcRoleUsersByCodeUsingGET_TYPE = function() {
  return 'get'
}
export const getDataSrcRoleUsersByCodeUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/commonform/table/roleusers/{code}'
  path = path.replace('{code}', `${parameters['code']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * saveCommonForm
 * request: saveCommonFormUsingPOST
 * url: saveCommonFormUsingPOSTURL
 * method: saveCommonFormUsingPOST_TYPE
 * raw_url: saveCommonFormUsingPOST_RAW_URL
 * @param key - key
 * @param modulename - modulename
 * @param vo - vo
 */
export const saveCommonFormUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/commonform/table/{key}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const saveCommonFormUsingPOST_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/commonform/table/{key}'
}
export const saveCommonFormUsingPOST_TYPE = function() {
  return 'post'
}
export const saveCommonFormUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/commonform/table/{key}'
  path = path.replace('{key}', `${parameters['key']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteCommonForm
 * request: deleteCommonFormUsingDELETE
 * url: deleteCommonFormUsingDELETEURL
 * method: deleteCommonFormUsingDELETE_TYPE
 * raw_url: deleteCommonFormUsingDELETE_RAW_URL
 * @param ids - ids
 * @param key - key
 * @param modulename - modulename
 */
export const deleteCommonFormUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/commonform/table/{key}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteCommonFormUsingDELETE_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/commonform/table/{key}'
}
export const deleteCommonFormUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteCommonFormUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/commonform/table/{key}'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{key}', `${parameters['key']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getCommonForm
 * request: getCommonFormUsingGET
 * url: getCommonFormUsingGETURL
 * method: getCommonFormUsingGET_TYPE
 * raw_url: getCommonFormUsingGET_RAW_URL
 * @param id - id
 * @param key - key
 * @param modulename - modulename
 */
export const getCommonFormUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/commonform/table/{key}/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCommonFormUsingGET_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/commonform/table/{key}/{id}'
}
export const getCommonFormUsingGET_TYPE = function() {
  return 'get'
}
export const getCommonFormUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/commonform/table/{key}/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{key}', `${parameters['key']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateCommonForm
 * request: updateCommonFormUsingPOST
 * url: updateCommonFormUsingPOSTURL
 * method: updateCommonFormUsingPOST_TYPE
 * raw_url: updateCommonFormUsingPOST_RAW_URL
 * @param id - id
 * @param key - key
 * @param modulename - modulename
 * @param vo - vo
 */
export const updateCommonFormUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/commonform/table/{key}/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateCommonFormUsingPOST_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/commonform/table/{key}/{id}'
}
export const updateCommonFormUsingPOST_TYPE = function() {
  return 'post'
}
export const updateCommonFormUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/commonform/table/{key}/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{key}', `${parameters['key']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addFormdesign
 * request: addFormdesignUsingPOST
 * url: addFormdesignUsingPOSTURL
 * method: addFormdesignUsingPOST_TYPE
 * raw_url: addFormdesignUsingPOST_RAW_URL
 * @param formdesign - formdesign
 * @param modulename - modulename
 */
export const addFormdesignUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/formdesign/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['formdesign'] !== undefined) {
    body = parameters['formdesign']
  }
  if (parameters['formdesign'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: formdesign'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addFormdesignUsingPOST_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/formdesign/'
}
export const addFormdesignUsingPOST_TYPE = function() {
  return 'post'
}
export const addFormdesignUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/formdesign/'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteSelectFormdesign
 * request: deleteSelectFormdesignUsingDELETE
 * url: deleteSelectFormdesignUsingDELETEURL
 * method: deleteSelectFormdesignUsingDELETE_TYPE
 * raw_url: deleteSelectFormdesignUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectFormdesignUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/formdesign/'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectFormdesignUsingDELETE_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/formdesign/'
}
export const deleteSelectFormdesignUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectFormdesignUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/formdesign/'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * cloneFormdesign
 * request: cloneFormdesignUsingPOST
 * url: cloneFormdesignUsingPOSTURL
 * method: cloneFormdesignUsingPOST_TYPE
 * raw_url: cloneFormdesignUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const cloneFormdesignUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/formdesign/clone/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const cloneFormdesignUsingPOST_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/formdesign/clone/{id}'
}
export const cloneFormdesignUsingPOST_TYPE = function() {
  return 'post'
}
export const cloneFormdesignUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/formdesign/clone/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deployFormdesign
 * request: deployFormdesignUsingPOST
 * url: deployFormdesignUsingPOSTURL
 * method: deployFormdesignUsingPOST_TYPE
 * raw_url: deployFormdesignUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deployFormdesignUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/formdesign/deploy/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const deployFormdesignUsingPOST_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/formdesign/deploy/{id}'
}
export const deployFormdesignUsingPOST_TYPE = function() {
  return 'post'
}
export const deployFormdesignUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/formdesign/deploy/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getOnchangejsByKey
 * request: getOnchangejsByKeyUsingGET
 * url: getOnchangejsByKeyUsingGETURL
 * method: getOnchangejsByKeyUsingGET_TYPE
 * raw_url: getOnchangejsByKeyUsingGET_RAW_URL
 * @param key - key
 * @param modulename - modulename
 */
export const getOnchangejsByKeyUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/formdesign/key/onchangejs/{key}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getOnchangejsByKeyUsingGET_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/formdesign/key/onchangejs/{key}'
}
export const getOnchangejsByKeyUsingGET_TYPE = function() {
  return 'get'
}
export const getOnchangejsByKeyUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/formdesign/key/onchangejs/{key}'
  path = path.replace('{key}', `${parameters['key']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getFormdesignByKey
 * request: getFormdesignByKeyUsingGET
 * url: getFormdesignByKeyUsingGETURL
 * method: getFormdesignByKeyUsingGET_TYPE
 * raw_url: getFormdesignByKeyUsingGET_RAW_URL
 * @param key - key
 * @param modulename - modulename
 */
export const getFormdesignByKeyUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/formdesign/key/{key}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getFormdesignByKeyUsingGET_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/formdesign/key/{key}'
}
export const getFormdesignByKeyUsingGET_TYPE = function() {
  return 'get'
}
export const getFormdesignByKeyUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/formdesign/key/{key}'
  path = path.replace('{key}', `${parameters['key']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findFormdesigns
 * request: findFormdesignsUsingPOST
 * url: findFormdesignsUsingPOSTURL
 * method: findFormdesignsUsingPOST_TYPE
 * raw_url: findFormdesignsUsingPOST_RAW_URL
 * @param formdesignparam - formdesignparam
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const findFormdesignsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/formdesign/list'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['formdesignparam'] !== undefined) {
    body = parameters['formdesignparam']
  }
  if (parameters['formdesignparam'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: formdesignparam'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const findFormdesignsUsingPOST_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/formdesign/list'
}
export const findFormdesignsUsingPOST_TYPE = function() {
  return 'post'
}
export const findFormdesignsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/formdesign/list'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getFormdesign
 * request: getFormdesignUsingGET
 * url: getFormdesignUsingGETURL
 * method: getFormdesignUsingGET_TYPE
 * raw_url: getFormdesignUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getFormdesignUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/formdesign/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getFormdesignUsingGET_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/formdesign/{id}'
}
export const getFormdesignUsingGET_TYPE = function() {
  return 'get'
}
export const getFormdesignUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/formdesign/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateFormdesign
 * request: updateFormdesignUsingPOST
 * url: updateFormdesignUsingPOSTURL
 * method: updateFormdesignUsingPOST_TYPE
 * raw_url: updateFormdesignUsingPOST_RAW_URL
 * @param formdesign - formdesign
 * @param id - id
 * @param modulename - modulename
 */
export const updateFormdesignUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/formdesign/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['formdesign'] !== undefined) {
    body = parameters['formdesign']
  }
  if (parameters['formdesign'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: formdesign'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateFormdesignUsingPOST_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/formdesign/{id}'
}
export const updateFormdesignUsingPOST_TYPE = function() {
  return 'post'
}
export const updateFormdesignUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/formdesign/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateFormdesignJson
 * request: updateFormdesignJsonUsingPUT
 * url: updateFormdesignJsonUsingPUTURL
 * method: updateFormdesignJsonUsingPUT_TYPE
 * raw_url: updateFormdesignJsonUsingPUT_RAW_URL
 * @param formdesign - formdesign
 * @param id - id
 * @param modulename - modulename
 */
export const updateFormdesignJsonUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/formdesign/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['formdesign'] !== undefined) {
    body = parameters['formdesign']
  }
  if (parameters['formdesign'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: formdesign'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateFormdesignJsonUsingPUT_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/formdesign/{id}'
}
export const updateFormdesignJsonUsingPUT_TYPE = function() {
  return 'put'
}
export const updateFormdesignJsonUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/formdesign/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteFormdesign
 * request: deleteFormdesignUsingDELETE
 * url: deleteFormdesignUsingDELETEURL
 * method: deleteFormdesignUsingDELETE_TYPE
 * raw_url: deleteFormdesignUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteFormdesignUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/formdesign/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteFormdesignUsingDELETE_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/formdesign/{id}'
}
export const deleteFormdesignUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteFormdesignUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/formdesign/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 返回下拉框列表,getSelectUIList
 * request: getSelectUIListUsingPOST
 * url: getSelectUIListUsingPOSTURL
 * method: getSelectUIListUsingPOST_TYPE
 * raw_url: getSelectUIListUsingPOST_RAW_URL
 * @param key - key
 * @param model - model
 * @param modulename - modulename
 */
export const getSelectUIListUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/admin/formdesign/{key}/selectui/{model}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  path = path.replace('{model}', `${parameters['model']}`)
  if (parameters['model'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: model'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getSelectUIListUsingPOST_RAW_URL = function() {
  return '/api/v1/{modulename}/admin/formdesign/{key}/selectui/{model}'
}
export const getSelectUIListUsingPOST_TYPE = function() {
  return 'post'
}
export const getSelectUIListUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/admin/formdesign/{key}/selectui/{model}'
  path = path.replace('{key}', `${parameters['key']}`)
  path = path.replace('{model}', `${parameters['model']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 添加通知，addAnnounce
 * request: addAnnounceUsingPOST
 * url: addAnnounceUsingPOSTURL
 * method: addAnnounceUsingPOST_TYPE
 * raw_url: addAnnounceUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param name - 
 * @param vo - vo
 */
export const addAnnounceUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/announce'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addAnnounceUsingPOST_RAW_URL = function() {
  return '/api/v1/{modulename}/announce'
}
export const addAnnounceUsingPOST_TYPE = function() {
  return 'post'
}
export const addAnnounceUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/announce'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除所选通知，deleteSelectAnnounce
 * request: deleteSelectAnnounceUsingDELETE
 * url: deleteSelectAnnounceUsingDELETEURL
 * method: deleteSelectAnnounceUsingDELETE_TYPE
 * raw_url: deleteSelectAnnounceUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectAnnounceUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/announce/delete'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{ids}', `${parameters['ids']}`)
  if (parameters['ids'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: ids'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectAnnounceUsingDELETE_RAW_URL = function() {
  return '/api/v1/{modulename}/announce/delete'
}
export const deleteSelectAnnounceUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectAnnounceUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/announce/delete'
  path = path.replace('{ids}', `${parameters['ids']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除一条通知，deleteAnnounce
 * request: deleteAnnounceUsingDELETE
 * url: deleteAnnounceUsingDELETEURL
 * method: deleteAnnounceUsingDELETE_TYPE
 * raw_url: deleteAnnounceUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteAnnounceUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/announce/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteAnnounceUsingDELETE_RAW_URL = function() {
  return '/api/v1/{modulename}/announce/delete/{id}'
}
export const deleteAnnounceUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteAnnounceUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/announce/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取通知列表（分页），getList
 * request: getAnnounceListUsingPOST
 * url: getAnnounceListUsingPOSTURL
 * method: getAnnounceListUsingPOST_TYPE
 * raw_url: getAnnounceListUsingPOST_RAW_URL
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 * @param vo - vo
 */
export const getAnnounceListUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/announce/getlist'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getAnnounceListUsingPOST_RAW_URL = function() {
  return '/api/v1/{modulename}/announce/getlist'
}
export const getAnnounceListUsingPOST_TYPE = function() {
  return 'post'
}
export const getAnnounceListUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/announce/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改一条通知，updateAnnounce
 * request: updateAnnounceUsingPOST
 * url: updateAnnounceUsingPOSTURL
 * method: updateAnnounceUsingPOST_TYPE
 * raw_url: updateAnnounceUsingPOST_RAW_URL
 * @param id - id
 * @param modulename - modulename
 * @param vo - vo
 */
export const updateAnnounceUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/announce/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['vo'] !== undefined) {
    body = parameters['vo']
  }
  if (parameters['vo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: vo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateAnnounceUsingPOST_RAW_URL = function() {
  return '/api/v1/{modulename}/announce/update/{id}'
}
export const updateAnnounceUsingPOST_TYPE = function() {
  return 'post'
}
export const updateAnnounceUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/announce/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据id获取一条通知，getAnnounceById
 * request: getAnnounceByIdUsingGET
 * url: getAnnounceByIdUsingGETURL
 * method: getAnnounceByIdUsingGET_TYPE
 * raw_url: getAnnounceByIdUsingGET_RAW_URL
 * @param id - id
 */
export const getAnnounceByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/announce/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAnnounceByIdUsingGET_RAW_URL = function() {
  return '/api/v1/{modulename}/announce/{id}'
}
export const getAnnounceByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getAnnounceByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/announce/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 添加通知公告，addBulletinModulename
 * request: addBulletinModulenameUsingPOST
 * url: addBulletinModulenameUsingPOSTURL
 * method: addBulletinModulenameUsingPOST_TYPE
 * raw_url: addBulletinModulenameUsingPOST_RAW_URL
 * @param bulletinVo - bulletinVo
 * @param modulename - modulename
 * @param name - 
 */
export const addBulletinModulenameUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/bulletin'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['bulletinVo'] !== undefined) {
    body = parameters['bulletinVo']
  }
  if (parameters['bulletinVo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: bulletinVo'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addBulletinModulenameUsingPOST_RAW_URL = function() {
  return '/api/v1/{modulename}/bulletin'
}
export const addBulletinModulenameUsingPOST_TYPE = function() {
  return 'post'
}
export const addBulletinModulenameUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/bulletin'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除所选通知公告，deleteSelectBulletinModulename
 * request: deleteSelectBulletinModulenameUsingDELETE
 * url: deleteSelectBulletinModulenameUsingDELETEURL
 * method: deleteSelectBulletinModulenameUsingDELETE_TYPE
 * raw_url: deleteSelectBulletinModulenameUsingDELETE_RAW_URL
 * @param ids - ids
 * @param modulename - modulename
 */
export const deleteSelectBulletinModulenameUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/bulletin/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSelectBulletinModulenameUsingDELETE_RAW_URL = function() {
  return '/api/v1/{modulename}/bulletin/delete'
}
export const deleteSelectBulletinModulenameUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSelectBulletinModulenameUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/bulletin/delete'
  if (parameters['ids'] !== undefined) {
    queryParameters['ids'] = parameters['ids']
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 删除一条通知公告，deleteBulletinModulename
 * request: deleteBulletinModulenameUsingDELETE
 * url: deleteBulletinModulenameUsingDELETEURL
 * method: deleteBulletinModulenameUsingDELETE_TYPE
 * raw_url: deleteBulletinModulenameUsingDELETE_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const deleteBulletinModulenameUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/bulletin/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteBulletinModulenameUsingDELETE_RAW_URL = function() {
  return '/api/v1/{modulename}/bulletin/delete/{id}'
}
export const deleteBulletinModulenameUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteBulletinModulenameUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/bulletin/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取要显示的通知公告，getBulletinByDateModulename
 * request: getBulletinByDateModulenameUsingGET
 * url: getBulletinByDateModulenameUsingGETURL
 * method: getBulletinByDateModulenameUsingGET_TYPE
 * raw_url: getBulletinByDateModulenameUsingGET_RAW_URL
 * @param modulename - modulename
 */
export const getBulletinByDateModulenameUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/bulletin/getbulletinbydate'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getBulletinByDateModulenameUsingGET_RAW_URL = function() {
  return '/api/v1/{modulename}/bulletin/getbulletinbydate'
}
export const getBulletinByDateModulenameUsingGET_TYPE = function() {
  return 'get'
}
export const getBulletinByDateModulenameUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/bulletin/getbulletinbydate'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取要显示的通知公告，getBulletinByDate2Modulename
 * request: getBulletinByDate2ModulenameUsingGET
 * url: getBulletinByDate2ModulenameUsingGETURL
 * method: getBulletinByDate2ModulenameUsingGET_TYPE
 * raw_url: getBulletinByDate2ModulenameUsingGET_RAW_URL
 * @param modulename - modulename
 */
export const getBulletinByDate2ModulenameUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/bulletin/getbulletinbydate2'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getBulletinByDate2ModulenameUsingGET_RAW_URL = function() {
  return '/api/v1/{modulename}/bulletin/getbulletinbydate2'
}
export const getBulletinByDate2ModulenameUsingGET_TYPE = function() {
  return 'get'
}
export const getBulletinByDate2ModulenameUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/bulletin/getbulletinbydate2'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取当前用户要显示的通知公告，getBulletinByDate3Modulename
 * request: getBulletinByDate3ModulenameUsingGET
 * url: getBulletinByDate3ModulenameUsingGETURL
 * method: getBulletinByDate3ModulenameUsingGET_TYPE
 * raw_url: getBulletinByDate3ModulenameUsingGET_RAW_URL
 * @param modulename - modulename
 * @param name - 
 */
export const getBulletinByDate3ModulenameUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/bulletin/getbulletinbydate3'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getBulletinByDate3ModulenameUsingGET_RAW_URL = function() {
  return '/api/v1/{modulename}/bulletin/getbulletinbydate3'
}
export const getBulletinByDate3ModulenameUsingGET_TYPE = function() {
  return 'get'
}
export const getBulletinByDate3ModulenameUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/bulletin/getbulletinbydate3'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 获取通知公告列表（分页），getListModulename
 * request: getListModulenameUsingPOST
 * url: getListModulenameUsingPOSTURL
 * method: getListModulenameUsingPOST_TYPE
 * raw_url: getListModulenameUsingPOST_RAW_URL
 * @param bulletin - bulletin
 * @param modulename - modulename
 * @param page - 请求页数
 * @param size - 页记录数
 * @param sort - 排序字段
 */
export const getListModulenameUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/bulletin/getlist'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['bulletin'] !== undefined) {
    body = parameters['bulletin']
  }
  if (parameters['bulletin'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: bulletin'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getListModulenameUsingPOST_RAW_URL = function() {
  return '/api/v1/{modulename}/bulletin/getlist'
}
export const getListModulenameUsingPOST_TYPE = function() {
  return 'post'
}
export const getListModulenameUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/bulletin/getlist'
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 修改一条通知公告，updateBulletinModulename
 * request: updateBulletinModulenameUsingPOST
 * url: updateBulletinModulenameUsingPOSTURL
 * method: updateBulletinModulenameUsingPOST_TYPE
 * raw_url: updateBulletinModulenameUsingPOST_RAW_URL
 * @param bulletinVo - bulletinVo
 * @param id - id
 * @param modulename - modulename
 */
export const updateBulletinModulenameUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/bulletin/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['bulletinVo'] !== undefined) {
    body = parameters['bulletinVo']
  }
  if (parameters['bulletinVo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: bulletinVo'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const updateBulletinModulenameUsingPOST_RAW_URL = function() {
  return '/api/v1/{modulename}/bulletin/update/{id}'
}
export const updateBulletinModulenameUsingPOST_TYPE = function() {
  return 'post'
}
export const updateBulletinModulenameUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/bulletin/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 根据id获取一条通知公告，getBulletinByIdModulename
 * request: getBulletinByIdModulenameUsingGET
 * url: getBulletinByIdModulenameUsingGETURL
 * method: getBulletinByIdModulenameUsingGET_TYPE
 * raw_url: getBulletinByIdModulenameUsingGET_RAW_URL
 * @param id - id
 * @param modulename - modulename
 */
export const getBulletinByIdModulenameUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/v1/{modulename}/bulletin/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters['modulename'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: modulename'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getBulletinByIdModulenameUsingGET_RAW_URL = function() {
  return '/api/v1/{modulename}/bulletin/{id}'
}
export const getBulletinByIdModulenameUsingGET_TYPE = function() {
  return 'get'
}
export const getBulletinByIdModulenameUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/v1/{modulename}/bulletin/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{modulename}', `${parameters['modulename']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 下载,downloadGet
 * request: downloadGetUsingGET_1
 * url: downloadGetUsingGET_1URL
 * method: downloadGetUsingGET_1_TYPE
 * raw_url: downloadGetUsingGET_1_RAW_URL
 * @param id - id
 */
export const downloadGetUsingGET_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/onlyoffice/download/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const downloadGetUsingGET_1_RAW_URL = function() {
  return '/onlyoffice/download/{id}'
}
export const downloadGetUsingGET_1_TYPE = function() {
  return 'get'
}
export const downloadGetUsingGET_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/onlyoffice/download/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 打开在线编辑,onlineEditor
 * request: onlineEditorUsingGET
 * url: onlineEditorUsingGETURL
 * method: onlineEditorUsingGET_TYPE
 * raw_url: onlineEditorUsingGET_RAW_URL
 * @param fileId - fileId
 * @param lang - lang
 * @param mode - mode
 * @param type - type
 */
export const onlineEditorUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/onlyoffice/onlineEditor/{fileId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{fileId}', `${parameters['fileId']}`)
  if (parameters['fileId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: fileId'))
  }
  if (parameters['lang'] !== undefined) {
    queryParameters['lang'] = parameters['lang']
  }
  if (parameters['mode'] !== undefined) {
    queryParameters['mode'] = parameters['mode']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const onlineEditorUsingGET_RAW_URL = function() {
  return '/onlyoffice/onlineEditor/{fileId}'
}
export const onlineEditorUsingGET_TYPE = function() {
  return 'get'
}
export const onlineEditorUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/onlyoffice/onlineEditor/{fileId}'
  path = path.replace('{fileId}', `${parameters['fileId']}`)
  if (parameters['lang'] !== undefined) {
    queryParameters['lang'] = parameters['lang']
  }
  if (parameters['mode'] !== undefined) {
    queryParameters['mode'] = parameters['mode']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * vue在线编辑info,onlineInfoForVUE
 * request: onlineInfoForVUEUsingGET
 * url: onlineInfoForVUEUsingGETURL
 * method: onlineInfoForVUEUsingGET_TYPE
 * raw_url: onlineInfoForVUEUsingGET_RAW_URL
 * @param fileId - fileId
 * @param lang - lang
 * @param mode - mode
 * @param type - type
 */
export const onlineInfoForVUEUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/onlyoffice/onlineInfoForVUE/{fileId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{fileId}', `${parameters['fileId']}`)
  if (parameters['fileId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: fileId'))
  }
  if (parameters['lang'] !== undefined) {
    queryParameters['lang'] = parameters['lang']
  }
  if (parameters['mode'] !== undefined) {
    queryParameters['mode'] = parameters['mode']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const onlineInfoForVUEUsingGET_RAW_URL = function() {
  return '/onlyoffice/onlineInfoForVUE/{fileId}'
}
export const onlineInfoForVUEUsingGET_TYPE = function() {
  return 'get'
}
export const onlineInfoForVUEUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/onlyoffice/onlineInfoForVUE/{fileId}'
  path = path.replace('{fileId}', `${parameters['fileId']}`)
  if (parameters['lang'] !== undefined) {
    queryParameters['lang'] = parameters['lang']
  }
  if (parameters['mode'] !== undefined) {
    queryParameters['mode'] = parameters['mode']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 打开在线查看,onlineView
 * request: onlineViewUsingGET
 * url: onlineViewUsingGETURL
 * method: onlineViewUsingGET_TYPE
 * raw_url: onlineViewUsingGET_RAW_URL
 * @param fileId - fileId
 * @param lang - lang
 * @param type - type
 */
export const onlineViewUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/onlyoffice/onlineView/{fileId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{fileId}', `${parameters['fileId']}`)
  if (parameters['fileId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: fileId'))
  }
  if (parameters['lang'] !== undefined) {
    queryParameters['lang'] = parameters['lang']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const onlineViewUsingGET_RAW_URL = function() {
  return '/onlyoffice/onlineView/{fileId}'
}
export const onlineViewUsingGET_TYPE = function() {
  return 'get'
}
export const onlineViewUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/onlyoffice/onlineView/{fileId}'
  path = path.replace('{fileId}', `${parameters['fileId']}`)
  if (parameters['lang'] !== undefined) {
    queryParameters['lang'] = parameters['lang']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 在线编辑保存,Track
 * request: TrackUsingPOST
 * url: TrackUsingPOSTURL
 * method: TrackUsingPOST_TYPE
 * raw_url: TrackUsingPOST_RAW_URL
 * @param attachId - attachId
 */
export const TrackUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/onlyoffice/track/{attachId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{attachId}', `${parameters['attachId']}`)
  if (parameters['attachId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: attachId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const TrackUsingPOST_RAW_URL = function() {
  return '/onlyoffice/track/{attachId}'
}
export const TrackUsingPOST_TYPE = function() {
  return 'post'
}
export const TrackUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/onlyoffice/track/{attachId}'
  path = path.replace('{attachId}', `${parameters['attachId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}